webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1);
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _videogular = __webpack_require__(8);
	
	var _videogular2 = _interopRequireDefault(_videogular);
	
	var _videogularControls = __webpack_require__(12);
	
	var _videogularControls2 = _interopRequireDefault(_videogularControls);
	
	var _videogularPoster = __webpack_require__(14);
	
	var _videogularPoster2 = _interopRequireDefault(_videogularPoster);
	
	var _videogularBuffering = __webpack_require__(16);
	
	var _videogularBuffering2 = _interopRequireDefault(_videogularBuffering);
	
	var _commonCommon = __webpack_require__(18);
	
	var _commonCommon2 = _interopRequireDefault(_commonCommon);
	
	var _componentsComponents = __webpack_require__(31);
	
	var _componentsComponents2 = _interopRequireDefault(_componentsComponents);
	
	__webpack_require__(194);
	
	__webpack_require__(195);
	
	__webpack_require__(230);
	
	__webpack_require__(231);
	
	__webpack_require__(232);
	
	var _servicesServices = __webpack_require__(233);
	
	var _servicesServices2 = _interopRequireDefault(_servicesServices);
	
	var _appComponent = __webpack_require__(237);
	
	var _appComponent2 = _interopRequireDefault(_appComponent);
	
	_angular2['default'].module('app', [_angularUiRouter2['default'], _commonCommon2['default'].name, _componentsComponents2['default'].name, _servicesServices2['default'].name, 'remote', 'navigation', 'mockservices', 'labox.sse.api', 'storage', "com.2fdevs.videogular", "com.2fdevs.videogular.plugins.controls", "com.2fdevs.videogular.plugins.poster", "com.2fdevs.videogular.plugins.buffering"]).config(["$locationProvider", function ($locationProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	  $locationProvider.html5Mode(true).hashPrefix('!');
	}]).run(['$rootScope', '$window', '$state', function ($rootScope, $window, $state) {
	  $rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
	    // save the previous state in a rootScope variable so that it's accessible from everywhere
	    $rootScope.previousState = from;
	  });
	}]).component('app', _appComponent2['default']);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _appheaderAppheader = __webpack_require__(19);
	
	var _appheaderAppheader2 = _interopRequireDefault(_appheaderAppheader);
	
	var _appfooterAppfooter = __webpack_require__(25);
	
	var _appfooterAppfooter2 = _interopRequireDefault(_appfooterAppfooter);
	
	var commonModule = _angular2['default'].module('app.common', [_appheaderAppheader2['default'].name, _appfooterAppfooter2['default'].name]);
	
	exports['default'] = commonModule;
	module.exports = exports['default'];

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appheaderComponent = __webpack_require__(20);
	
	var _appheaderComponent2 = _interopRequireDefault(_appheaderComponent);
	
	var appheaderModule = _angular2['default'].module('appheader', [_angularUiRouter2['default']]).component('appheader', _appheaderComponent2['default']);
	
	exports['default'] = appheaderModule;
	module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appheaderHtml = __webpack_require__(21);
	
	var _appheaderHtml2 = _interopRequireDefault(_appheaderHtml);
	
	var _appheaderController = __webpack_require__(22);
	
	var _appheaderController2 = _interopRequireDefault(_appheaderController);
	
	__webpack_require__(23);
	
	var appheaderComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _appheaderHtml2['default'],
	  controller: _appheaderController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = appheaderComponent;
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"headerMain\">\n\t<div>\n\t\t<span ng-show=\"vm.$rootScope.myAccount\" class=\"myAccount\">My Account</span>\n\t\t<span ng-show=\"!vm.$rootScope.myAccount\" class=\"myAccount myAccount-grey\">My Account</span>\n\t\t<!--<img ng-show=\"vm.$rootScope.myAccount\" class=\"account-icon\" src=\"./assets/account_icon.png\" />-->\n\t\t<!--<img ng-show=\"!vm.$rootScope.myAccount\" class=\"account-icon\" src=\"./assets/account_icon_gray.png\" />-->\n\t</div>\n\t<!--<span class=\"user-name\">Hi, Joeuser!</span>-->\n\t<div class=\"date-section\">\n\t  \t<span class=\"current-date\"><span class=\"currentDay\">{{vm.currentDay}}</span> <span>{{vm.currentDate}}</span>/<span>{{vm.currentMonth}}</span></span>\n\t    <div class=\"current-time\"><span>{{vm.currunttime}}</span>{{vm.ampm_marker}}</div>\n\t</div>\n</div>\n</div>\n"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AppheaderController = (function () {
	  function AppheaderController($timeout, $filter, $interval, $rootScope) {
	    var _this = this;
	
	    _classCallCheck(this, AppheaderController);
	
	    this.name = 'appheader';
	
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	
	    var timer;
	    var now = new Date();
	    this.currentDay = $filter('date')(now, 'EEE');
	    this.currentDate = $filter('date')(now, 'M');
	    this.currentMonth = $filter('date')(now, 'd');
	    this.ampm_marker = $filter('date')(now, 'a');
	
	    this.currunttime = this.getTime();
	
	    /*************************************************************/
	    /*    This block updates the code in real-time                                                       */
	    /*************************************************************/
	
	    $interval(function () {
	      console.log("i m coming here in appHeader to get the time");
	      var now = new Date();
	      _this.currentDay = $filter('date')(now, 'EEE');
	      _this.currentDate = $filter('date')(now, 'M');
	      _this.currentMonth = $filter('date')(now, 'd');
	      _this.ampm_marker = $filter('date')(now, 'a');
	      _this.currunttime = _this.getTime();
	      _this.$rootScope.currunttime = _this.currunttime;
	    }, 60000);
	  }
	
	  _createClass(AppheaderController, [{
	    key: 'getTime',
	    value: function getTime() {
	      var date = date = new Date();
	      var hours = date.getHours();
	      var minutes = date.getMinutes();
	      var ampm = hours >= 12 ? 'pm' : 'am';
	      hours = hours % 12;
	      hours = hours ? hours : 12;
	      minutes = minutes < 10 ? '0' + minutes : minutes;
	      //var strTime = hours + ':' + minutes + ' ' + ampm;
	      var strTime = hours + ':' + minutes;
	      return strTime;
	    }
	  }]);
	
	  return AppheaderController;
	})();
	
	AppheaderController.$inject = ['$timeout', '$filter', '$interval', '$rootScope'];
	
	exports['default'] = AppheaderController;
	module.exports = exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(24);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./appheader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./appheader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".headerMain{margin:5.6vh 4.91vw 0 5vw;min-height:8.34vh}.headerMain .date-section{margin-top:0;margin-left:84.2vw}.headerMain p{text-align:center;font-size:20px}.headerMain .account-icon{float:left;height:6.4vh}.headerMain .myAccount{color:#f1f1f1;font-weight:800;line-height:1;position:absolute;padding-left:1.15vw;font-size:2.03vw;top:6.25vh;left:4vw;font-family:Open Sans Bold}.headerMain .myAccount-grey{color:#9ea6a8}.headerMain .user-name{padding-left:1.15vw;font-weight:700;font-style:normal;font-size:1.5vw}", ""]);
	
	// exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _appfooterComponent = __webpack_require__(26);
	
	var _appfooterComponent2 = _interopRequireDefault(_appfooterComponent);
	
	var appfooterModule = _angular2['default'].module('appfooter', [_angularUiRouter2['default']]).component('appfooter', _appfooterComponent2['default']);
	
	exports['default'] = appfooterModule;
	module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appfooterHtml = __webpack_require__(27);
	
	var _appfooterHtml2 = _interopRequireDefault(_appfooterHtml);
	
	var _appfooterController = __webpack_require__(28);
	
	var _appfooterController2 = _interopRequireDefault(_appfooterController);
	
	__webpack_require__(29);
	
	var appfooterComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _appfooterHtml2['default'],
	  controller: _appfooterController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = appfooterComponent;
	module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"footerMain\">\n  <!--<p>User Account Information</p>-->\n</div>\n"

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AppfooterController = function AppfooterController() {
	  _classCallCheck(this, AppfooterController);
	
	  this.name = 'appfooter';
	};
	
	exports['default'] = AppfooterController;
	module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(30);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./appfooter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./appfooter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".footerMain p{text-align:center;font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _homeHome = __webpack_require__(32);
	
	var _homeHome2 = _interopRequireDefault(_homeHome);
	
	var _landingpageLandingpage = __webpack_require__(38);
	
	var _landingpageLandingpage2 = _interopRequireDefault(_landingpageLandingpage);
	
	var _viewpaybillViewpaybill = __webpack_require__(45);
	
	var _viewpaybillViewpaybill2 = _interopRequireDefault(_viewpaybillViewpaybill);
	
	var _scrollingListScrollingList = __webpack_require__(54);
	
	var _scrollingListScrollingList2 = _interopRequireDefault(_scrollingListScrollingList);
	
	var _subnavSubnav = __webpack_require__(60);
	
	var _subnavSubnav2 = _interopRequireDefault(_subnavSubnav);
	
	var _landingpageViewpaybilllandingViewpaybilllanding = __webpack_require__(66);
	
	var _landingpageViewpaybilllandingViewpaybilllanding2 = _interopRequireDefault(_landingpageViewpaybilllandingViewpaybilllanding);
	
	var _landingpageVideobilllandingVideobilllanding = __webpack_require__(72);
	
	var _landingpageVideobilllandingVideobilllanding2 = _interopRequireDefault(_landingpageVideobilllandingVideobilllanding);
	
	var _landingpagePaperlessbillinglandingPaperlessbillinglanding = __webpack_require__(78);
	
	var _landingpagePaperlessbillinglandingPaperlessbillinglanding2 = _interopRequireDefault(_landingpagePaperlessbillinglandingPaperlessbillinglanding);
	
	var _landingpageOptimumidslandingOptimumidslanding = __webpack_require__(84);
	
	var _landingpageOptimumidslandingOptimumidslanding2 = _interopRequireDefault(_landingpageOptimumidslandingOptimumidslanding);
	
	var _landingpageTutorialslandingTutorialslanding = __webpack_require__(90);
	
	var _landingpageTutorialslandingTutorialslanding2 = _interopRequireDefault(_landingpageTutorialslandingTutorialslanding);
	
	var _landingpageSuddenlinkidslandingSuddenlinkidslanding = __webpack_require__(96);
	
	var _landingpageSuddenlinkidslandingSuddenlinkidslanding2 = _interopRequireDefault(_landingpageSuddenlinkidslandingSuddenlinkidslanding);
	
	var _paperlessbillingPaperlessbilling = __webpack_require__(102);
	
	var _paperlessbillingPaperlessbilling2 = _interopRequireDefault(_paperlessbillingPaperlessbilling);
	
	var _keyboardKeyboard = __webpack_require__(108);
	
	var _keyboardKeyboard2 = _interopRequireDefault(_keyboardKeyboard);
	
	var _optimumidsOptimumids = __webpack_require__(125);
	
	var _optimumidsOptimumids2 = _interopRequireDefault(_optimumidsOptimumids);
	
	var _suddenlinkidsSuddenlinkids = __webpack_require__(131);
	
	var _suddenlinkidsSuddenlinkids2 = _interopRequireDefault(_suddenlinkidsSuddenlinkids);
	
	var _optimumidlistOptimumidlist = __webpack_require__(137);
	
	var _optimumidlistOptimumidlist2 = _interopRequireDefault(_optimumidlistOptimumidlist);
	
	var _tutorialsTutorials = __webpack_require__(143);
	
	var _tutorialsTutorials2 = _interopRequireDefault(_tutorialsTutorials);
	
	var _tutoriallistTutoriallist = __webpack_require__(149);
	
	var _tutoriallistTutoriallist2 = _interopRequireDefault(_tutoriallistTutoriallist);
	
	var _videotutorialsVideotutorials = __webpack_require__(155);
	
	var _videotutorialsVideotutorials2 = _interopRequireDefault(_videotutorialsVideotutorials);
	
	var _faqFaq = __webpack_require__(161);
	
	var _faqFaq2 = _interopRequireDefault(_faqFaq);
	
	var _landingpageFaqlandingFaqlanding = __webpack_require__(167);
	
	var _landingpageFaqlandingFaqlanding2 = _interopRequireDefault(_landingpageFaqlandingFaqlanding);
	
	var _faqtemplateFaqtemplate = __webpack_require__(173);
	
	var _faqtemplateFaqtemplate2 = _interopRequireDefault(_faqtemplateFaqtemplate);
	
	var _videoplayerVideoplayer = __webpack_require__(179);
	
	var _videoplayerVideoplayer2 = _interopRequireDefault(_videoplayerVideoplayer);
	
	var _playerPlayer = __webpack_require__(188);
	
	var _playerPlayer2 = _interopRequireDefault(_playerPlayer);
	
	var componentModule = _angular2['default'].module('app.components', [_homeHome2['default'].name, _landingpageLandingpage2['default'].name, _viewpaybillViewpaybill2['default'].name, _scrollingListScrollingList2['default'].name, _subnavSubnav2['default'].name, _landingpageViewpaybilllandingViewpaybilllanding2['default'].name, _landingpageVideobilllandingVideobilllanding2['default'].name, _landingpagePaperlessbillinglandingPaperlessbillinglanding2['default'].name, _landingpageOptimumidslandingOptimumidslanding2['default'].name, _landingpageTutorialslandingTutorialslanding2['default'].name, _landingpageSuddenlinkidslandingSuddenlinkidslanding2['default'].name, _paperlessbillingPaperlessbilling2['default'].name, _keyboardKeyboard2['default'].name, _optimumidsOptimumids2['default'].name, _suddenlinkidsSuddenlinkids2['default'].name, _optimumidlistOptimumidlist2['default'].name, _tutorialsTutorials2['default'].name, _tutoriallistTutoriallist2['default'].name, _videotutorialsVideotutorials2['default'].name, _faqFaq2['default'].name, _landingpageFaqlandingFaqlanding2['default'].name, _faqtemplateFaqtemplate2['default'].name, _videoplayerVideoplayer2['default'].name, _playerPlayer2['default'].name]);
	
	exports['default'] = componentModule;
	module.exports = exports['default'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _homeComponent = __webpack_require__(33);
	
	var _homeComponent2 = _interopRequireDefault(_homeComponent);
	
	var homeModule = _angular2['default'].module('home', [_angularUiRouter2['default']]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('');
	
	  $stateProvider.state('home', {
	    url: '',
	    template: '<home></home>'
	  })
	  /*.state('home.landing', {
	    url: '/',
	    template: '<landingpage></landingpage>',
	    redirectTo: 'home.landingpage.viewpaybilllanding'
	  })*/
	  .state('home.landingpage', {
	    url: '/landingpage',
	    template: '<landingpage></landingpage>',
	    params: {
	      home_id: undefined,
	      plant_id: undefined,
	      casn: undefined,
	      option: undefined
	    } //,
	    //redirectTo: 'home.landingpage.viewpaybilllanding'
	  }).state('home.landingpage.viewpaybilllanding', {
	    url: '/viewpaybilllanding',
	    template: '<viewpaybilllanding></viewpaybilllanding>'
	  }).state('home.landingpage.videobilllanding', {
	    url: '/videobilllanding',
	    template: '<videobilllanding></videobilllanding>'
	  }).state('home.landingpage.paperlessbillinglanding', {
	    url: '/paperlessbillinglanding',
	    template: '<paperlessbillinglanding></paperlessbillinglanding>'
	  }).state('home.landingpage.optimumidslanding', {
	    url: '/optimumidslanding',
	    template: '<optimumidslanding></optimumidslanding>'
	  }).state('home.landingpage.tutorialslanding', {
	    url: '/tutorialslanding',
	    template: '<tutorialslanding></tutorialslanding>'
	  }).state('home.landingpage.faqlanding', {
	    url: '/faqlanding',
	    template: '<faqlanding></faqlanding>'
	  }).state('home.landingpage.suddenlinkidslanding', {
	    url: '/suddenlinkidslanding',
	    template: '<suddenlinkidslanding></suddenlinkidslanding>'
	  }).state('home.viewpaybill', {
	    url: '/viewpaybill',
	    template: '<viewpaybill></viewpaybill>'
	  }).state('home.paperlessbilling', {
	    url: '/paperlessbilling',
	    template: '<paperlessbilling></paperlessbilling>'
	  }).state('home.keyboard', {
	    url: '/keyboard',
	    template: '<keyboard></keyboard>'
	  }).state('home.optimumids', {
	    url: '/optimumids',
	    template: '<optimumids></optimumids>'
	  }).state('home.suddenlinkids', {
	    url: '/suddenlinkids',
	    template: '<suddenlinkids></suddenlinkids>'
	  }).state('home.tutorials', {
	    url: '/tutorials',
	    template: '<tutorials></tutorials>'
	  }).state('home.faq', {
	    url: '/faq',
	    template: '<faq></faq>'
	  }).state('home.faqtemplate', {
	    url: '/faqtemplate',
	    template: '<faqtemplate></faqtemplate>'
	  });
	}]).run(['$state', function ($state) {
	  $state.transitionTo('home.landingpage');
	}]).component('home', _homeComponent2['default']);
	
	exports['default'] = homeModule;
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _homeHtml = __webpack_require__(34);
	
	var _homeHtml2 = _interopRequireDefault(_homeHtml);
	
	var _homeController = __webpack_require__(35);
	
	var _homeController2 = _interopRequireDefault(_homeController);
	
	__webpack_require__(36);
	
	var homeComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _homeHtml2['default'],
	  controller: _homeController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = homeComponent;
	module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = "<header>\n  <appheader></appheader>\n</header>\n\n<main>\n  <div class=\"container\">\n      <div ui-view></div>\n  </div>\n</main>\n\n<footer>\n  <appfooter></appfooter>\n</footer>\n"

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var HomeController = function HomeController($state, $rootScope, storage) {
	  _classCallCheck(this, HomeController);
	
	  this.name = 'home';
	  this.$state = $state;
	
	  //setup for Dev, Stage and Prod.
	  if (location.hostname.includes('dev.') || location.hostname.includes('localhost')) {
	    // || location.hostname.includes('localhost')
	    console.log('DEV PROFILE');
	    storage.setItem('session', 'env', 'dev');
	    //storage.setItem('session', 'env', 'prod');
	  } else if (location.hostname.includes('stage.')) {
	      console.log('STAGE PROFILE');
	      storage.setItem('session', 'env', 'stage');
	    } else {
	      console.log('PROD PROFILE');
	      storage.setItem('session', 'env', 'prod');
	    }
	
	  /*this.$rootScope = $rootScope;
	  console.log("my previous state is:",this.$rootScope.previousState);*/
	};
	
	HomeController.$inject = ['$state', '$rootScope', 'storage'];
	
	exports['default'] = HomeController;
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(37);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".home{color:red}", ""]);
	
	// exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _landingpageComponent = __webpack_require__(39);
	
	var _landingpageComponent2 = _interopRequireDefault(_landingpageComponent);
	
	var landingpageModule = _angular2['default'].module('landingpage', [_angularUiRouter2['default']]).component('landingpage', _landingpageComponent2['default']);
	
	exports['default'] = landingpageModule;
	module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _landingpageHtml = __webpack_require__(40);
	
	var _landingpageHtml2 = _interopRequireDefault(_landingpageHtml);
	
	var _landingpageController = __webpack_require__(41);
	
	var _landingpageController2 = _interopRequireDefault(_landingpageController);
	
	__webpack_require__(42);
	
	var LandingpageComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _landingpageHtml2['default'],
	  controller: _landingpageController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = LandingpageComponent;
	module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"landingpage\" ng-show=\"!vm.landingPageLoader\">\n  <!--<div class=\"explore-header\">\n    <div id=\"exploreOptimumCablevision\" ng-show=\"vm.isCablevision\">\n        <span>EXPLORE OPTIMUM LOREM</span>\n    </div>\n    <div id=\"exploreOptimumCablevision\" ng-show=\"vm.isSuddenlink\">\n        <span>EXPLORE LOREM</span>\n    </div>\n  </div>-->\n  <!-- Error alert. -->\n  <div class=\"msgAlertBox\" id=\"msgAlertBoxId\">\n    <div class=\"errorAlertBox\" ng-show=\"vm.errorPay\">\n      <div class=\"errorSym\">\n        <span class=\"fa-stack fa-lg errorMsg\"></span>\n      </div>\n      <div class=\"errorMsgDesc\">\n        <span>{{vm.paymentAlertMsg}}</span>\n      </div>\n    </div>\n    <div class=\"successAlertBox\"  ng-show=\"vm.enrollSuccess\">\n      <div class=\"successSym\">\n        <span class=\"fa-stack fa-lg successMsg\"></span>\n      </div>\n      <div class=\"successMsgDesc\">\n        <span>You're now enrolled in paperless billing.</span>\n      </div>\n    </div>\n    <!--This is ppv inhibit alert -->\n    <div class=\"errorAlertBox\" ng-show=\"vm.PPVInhibit\">\n      <div class=\"errorSym\">\n        <span class=\"fa-stack fa-lg errorMsg\"></span>\n      </div>\n      <div class=\"errorMsgDesc\">\n        <span>Pay Per View and On Demand services on your account have been suspended as you’ve exceeded your ordering limit.</span>\n      </div>\n    </div>\n  </div>\n\n  <!--This block of code is for Optimum Footprint-->\n  <div class=\"landingbg\" id=\"landingBg\" ng-if=\"vm.isCablevision\">\n       <div class=\"content-left\">\n         <div class=\"tempmenu\">\n          <subnav list-id=\"navigation\" items=\"vm.menuitems\" btn-class=\"btn btn-main-nav btn-subnav\" item-click-handler=\"vm.itemClickHandler\" next-component-handler=\"vm.nextComponentHandler\" prev-component-handler=\"vm.prevComponentHandler\">\n          </subnav>\n         </div>\n       </div>\n       <div class=\"content-right\">\n            <div ui-view>\n\n            </div>\n       </div>\n       <div class=\"clearfix\"></div>\n  </div>\n  <!--This block of code is for Suddenlink Footprint-->\n  <div class=\"landingbg\" id=\"landingBg\" ng-if=\"vm.isSuddenlink\">\n       <div class=\"content-left\">\n         <div class=\"tempmenu\">\n          <subnav list-id=\"suddenlink-navigation\" items=\"vm.menuitems\" btn-class=\"btn btn-main-nav btn-subnav\" item-click-handler=\"vm.itemClickHandler\" next-component-handler=\"vm.nextComponentHandler\" prev-component-handler=\"vm.prevComponentHandler\">\n          </subnav>\n         </div>\n       </div>\n       <div class=\"content-right\">\n            <div ui-view>\n\n            </div>\n       </div>\n       <div class=\"clearfix\"></div>\n  </div>\n\n  <div id=\"accountFooter\">\n      <span ng-show=\"vm.account_number\" class=\"accountNumber\">Account ID: {{vm.account_number}}</span>\n      <span ng-show=\"vm.sdl_account_number\" class=\"accountNumber\">Account Number: {{vm.sdl_account_number}}</span>\n      <!--<span class=\"accountNumber\">Account ID: 1234-567890-23</span>-->\n      <!--<span class=\"serialNumber\">CASN: 12.3e.44.5e.6f.88</span>-->\n      <span ng-show=\"vm.serial_number\" class=\"serialNumber\">CASN: {{vm.serial_number}}</span>\n  </div>\n\n</div>\n\n<!-- This is loader will be true once customer defined and firest required call will be done.-->\n<div ng-show=\"vm.landingPageLoader\" style=\"margin-left: 47%;margin-top: 17%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n\n<div class=\"landing-alert-modal\" ng-if=\"vm.displayAlertModal\">\n  <div id=\"alertModal\" class=\"modal\">\n    <div class=\"modal-content\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-header\"><h1>Make a Payment</h1></div>\n        <div class=\"payment-details\">\n\n          <div class=\"alert-msg-one\">\n            <div class=\"errorMsgAlertBox\">\n              <div class=\"errorSym\">\n                <span class=\"fa-stack fa-lg errorMsg\"></span>\n              </div>\n              <div class=\"errorMsgOne\">\n                <span>Account past due. Please make a payment to avoid late fees or service interruptions.</span>\n              </div>\n            </div>\n\n            <div class=\"errorMsgAlertBox\">\n              <div class=\"errorMsgTwo\">\n                <span>{{vm.alertMsgTwo}}</span>\n              </div>\n            </div>\n\n          </div>\n\n          <div class=\"btn-group\">\n            <button id=\"cancel-btn\" class=\"cancel-payment-btn\" ng-click=\"vm.cancel()\">Pay Later</button>\n            <button id=\"confirm-btn\" class=\"confirm-payment-btn\" ng-click=\"vm.goPayBill()\">Pay Now</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<!-- Generic alert -->\n<div class=\"landing-alert-modal\" ng-if=\"vm.displayGenericAlertModal\">\n  <div id=\"genericalertModal\" class=\"modal\">\n    <div class=\"modal-content\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-header\"><h1>Generic Alert</h1></div>\n        <div class=\"payment-details\">\n\n          <div class=\"alert-msg-one\">\n            <div class=\"errorMsgAlertBox\">\n              <div class=\"errorSym\">\n                <span class=\"fa-stack fa-lg errorMsg\"></span>\n              </div>\n              <div class=\"errorMsgOne\">\n                <span>{{vm.genericAlertMsg}}</span>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"btn-group\">\n            <button id=\"cancel-btn\" class=\"cancel-payment-btn\" ng-click=\"vm.cancelGenericAlert()\">Gotcha</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function parseQuery(qstr) {
	  var query = {};
	  if (qstr.length < 2) {
	    return null;
	  }
	  var params = qstr.substr(1).split('&');
	  for (var i = 0; i < params.length; i++) {
	    var parts = params[i].split('=');
	    var key = parts.shift();
	    query[decodeURIComponent(key)] = decodeURIComponent(parts.join('=') || '');
	  }
	  return query;
	}
	
	var LandingpageController = (function () {
	  function LandingpageController($state, $window, storage, billingService, $rootScope, $filter, $timeout, navigationManager, $scope, laboxSSapi, analyticsService) {
	    var _this2 = this;
	
	    _classCallCheck(this, LandingpageController);
	
	    this.name = 'landingpage';
	    this.state = $state;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.$scope = $scope;
	    //keep content hidden until get data from backend.
	    this.landingPageLoader = true;
	    this.$rootScope.analytics = {
	      "omniturePath": $window.location.protocol + '//' + $window.location.hostname + ':' + $window.location.port
	    };
	
	    $scope.pageName = null;
	    $scope.event = 'event1';
	    $scope.billingStatus = this.$rootScope.omnitureBillingStatus || null;
	    $scope.paperlessbill = this.$rootScope.omniturePaperlessbill || null;
	    $scope.omnitureLinkUrl = null;
	
	    //customer cable-vision and suddenlink
	    this.isCablevision = false;
	    this.isSuddenlink = false;
	    this.hasSuddenlinkId = true;
	    this.menuitems = [];
	
	    //bp-global parameters
	    this.bpGlobalInfo = null;
	    this.amountTestDue = 0;
	    this.isPPVProd = false;
	    this.PPVInhibitBalance = 0;
	    this.PPVInhibit = false;
	    this.amountDueDate = '';
	    this.creditBalance = false;
	    this.creditAmount = 0;
	    this.noPaymentDuewithAccBalance = false;
	    this.noPaymentDue = false;
	    this.hasOptimumId = false;
	    this.currentAccount = null;
	    this.items = [];
	    this.deAuthInfo = null;
	    this.errorPay = false;
	    this.isPreDAuthTwo = false;
	    this.isPreDAuthOne = false;
	    this.paymentAlertMsg = '';
	    this.genericAlertMsg = '';
	    this.isPastDue = false;
	    this.paymentDue = false;
	    this.displayAlertModal = false;
	    this.displayGenericAlertModal = false;
	
	    this.enrollSuccess = false;
	    this.fromOptIdsPage = false;
	    this.fromPaperlessPage = false;
	    this.working_link = '';
	
	    //alert popup
	    this.alertMsgTwo = null;
	
	    var accNum;
	
	    navigationManager.registerViewComponent(this, $scope, 'home.landingpage');
	
	    this.enrollSuccess = this.$rootScope.enrollValue;
	    this.fromOptIdsPage = this.$rootScope.fromOptimumIdPage;
	    this.fromSdlIdsPage = this.$rootScope.fromSdlIdsPage;
	    this.fromPaperlessPage = this.$rootScope.fromPaperlessBillingPage;
	    this.fromTutorialPage = this.$rootScope.fromTutorialPage;
	    this.fromVideoBillPage = this.$rootScope.fromVideoBillPage;
	    this.fromFaqPage = this.$rootScope.fromFaqPage;
	
	    //setting up global parameter for app.
	    this.$onInit = function () {
	      var _this = this;
	
	      this.$rootScope.myAccount = true;
	
	      // omniture for first load when no option or when coming back from any of the page
	      console.log('!! omniture for first load when no option or when coming back from any of the page !!');
	      // var queryParams = parseQuery($window.location.search);
	      // if(queryParams.option === null) {
	      switch (true) {
	        case this.viewpaybillPage:
	          $scope.pageName = 'mybill';
	          $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding';
	          break;
	        case this.fromPaperlessPage:
	          $scope.pageName = 'paperless billing';
	          $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/paperlessbillinglanding';
	          break;
	        case this.fromOptIdsPage:
	          $scope.pageName = 'ids';
	          $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/optimumidslanding';
	          break;
	        case this.fromTutorialPage:
	          $scope.pageName = 'tutorial';
	          $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/tutorialslanding';
	          break;
	        case this.fromFaqPage:
	          $scope.pageName = 'quick tips';
	          $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/faqlanding';
	          break;
	        default:
	          $scope.pageName = 'my account';
	          $scope.pageUrl = this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding';
	      }
	      console.log('omniture page is : ' + $scope.pageName);
	      this.$timeout(function () {
	        _this.$rootScope.omnitureBillingStatus = $scope.billingStatus;
	        _this.$rootScope.omniturePaperlessbill = $scope.paperlessbill;
	      }, 5000);
	    };
	
	    this.$onDestroy = function () {
	      this.$rootScope.myAccount = false;
	    };
	
	    $scope.$watch('[pageName, event, billingStatus, paperlessbill]', function (newValue, oldValue) {
	      console.log('!! omniture watch variables ' + 'pagename : ' + $scope.pageName + 'event : ' + $scope.event + 'billingStatus : ' + $scope.billingStatus + 'paperlessbill : ' + $scope.paperlessbill);
	      if ($scope.pageName && $scope.billingStatus && $scope.paperlessbill !== null) {
	        console.log('!! omniture watch inside if');
	        // $rootScope.omnitureBillingStatus = $scope.billingStatus;
	        // $rootScope.omniturePaperlessbill = $scope.paperlessbill;
	        analyticsService.sendReport('home', $scope.pageName, $scope.event, null, null, null, null, $scope.omnitureLinkUrl, $scope.billingStatus, $scope.paperlessbill, $scope.pageUrl);
	      }
	    });
	    var queryParams = parseQuery($window.location.search);
	    if (queryParams) {
	      storage.setItem('session', 'home_id', queryParams.home_id);
	      storage.setItem('session', 'plant_id', queryParams.plant_id);
	      storage.setItem('session', 'casn', queryParams.casn);
	      storage.setItem('session', 'option', queryParams.option);
	      storage.setItem('session', 'showFaqTutorials', queryParams.showFaqTutorials);
	      // this.$rootScope.analytics.balance === null ? this.$rootScope.analytics.balance = 'cur' : this.$rootScope.analytics.balance = this.$rootScope.analytics.balance;
	
	      if (queryParams.option === "quicktips") {
	        // omniture for first load when load on quicktips
	        console.log('!!omniture for first load when quick tips!!');
	        $scope.pageName = 'quick tips';
	        $scope.event = 'event1';
	        this.fromFaqPage = true;
	      } else if (queryParams.option === "tutorials") {
	        // omniture for first load when load on tutorials
	        console.log('!!omniture for first load when tutorials!!');
	        $scope.pageName = 'tutorial';
	        $scope.event = 'event1';
	        this.fromTutorialPage = true;
	      } else if (queryParams.option === "ids") {
	        // omniture for first load when load on ids
	        console.log('!!omniture for first load when ids!!');
	        $scope.pageName = 'ids';
	        $scope.event = 'event1';
	        this.fromOptIdsPage = true;
	      } else if (queryParams.option === "paperlessbilling") {
	        // omniture for first load when load on mybill or myaccount
	        console.log('!!omniture for first load when paperless billing!!');
	        $scope.pageName = 'paperless billing';
	        $scope.event = 'event1';
	        this.fromPaperlessPage = true;
	      } else if (queryParams.option === "myAccount" || queryParams.option === "mybill") {
	        // omniture for first load when load on mybill or myaccount
	        console.log('!!omniture for first load when mybill or myaccount!!');
	        $scope.pageName = 'my account';
	        $scope.event = 'event1';
	        this.viewpaybillPage = true;
	      }
	    }
	
	    if (this.$rootScope.previousState === 'home.paperlessbilling') {
	      console.log("my previous state is:", this.$rootScope.previousState);
	    }
	
	    if (this.enrollSuccess) {
	      if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
	        this.isCablevision = true;
	        this.$rootScope.isCablevision = this.isCablevision;
	        // omniture if already enrolled in paperlessbill
	        $scope.paperlessbill = true;
	        console.log('!! omniture setting paperless true from enroll success!!');
	        console.log('showFaqTutorials: ', +storage.getItem('session', 'showFaqTutorials'));
	
	        if (storage.getItem('session', 'showFaqTutorials') && storage.getItem('session', 'showFaqTutorials') === "1") {
	          this.menuitems = [{
	            label: 'View & Pay My Bill',
	            state: 'home.landingpage.viewpaybilllanding'
	          }, {
	            label: 'Paperless Billing',
	            state: 'home.landingpage.paperlessbillinglanding'
	          }, {
	            label: 'Optimum IDs',
	            state: 'home.landingpage.optimumidslanding'
	          }, {
	            label: 'Tutorials',
	            state: 'home.landingpage.tutorialslanding'
	          }, {
	            label: 'Quick Tips',
	            state: 'home.landingpage.faqlanding'
	          }];
	        } else {
	          $scope.pageName = 'my account';
	          $scope.event = 'event1';
	          this.viewpaybillPage = true;
	          this.fromFaqPage = false;
	
	          this.menuitems = [{
	            label: 'View & Pay My Bill',
	            state: 'home.landingpage.viewpaybilllanding'
	          }, {
	            label: 'Paperless Billing',
	            state: 'home.landingpage.paperlessbillinglanding'
	          }, {
	            label: 'Optimum IDs',
	            state: 'home.landingpage.optimumidslanding'
	          }];
	        }
	        if (storage.getItem('session', 'accno')) {
	          accNum = storage.getItem('session', 'accno');
	          accNum = accNum.slice(0, 5) + "-" + accNum.slice(5, 11) + "-" + accNum.slice(11, 13);
	          this.account_number = accNum;
	        }
	
	        if (storage.getItem('session', 'casn')) {
	          var casnNum,
	              casnNum1,
	              i,
	              tempVar = "",
	              j;
	          casnNum = storage.getItem('session', 'casn');
	          casnNum1 = storage.getItem('session', 'casn');
	          console.log("Casn 1 is:", casnNum1.length);
	          for (i = 0; i < casnNum1.length; i++) {
	            j = i + 2;
	            if (i === casnNum1.length - 2 || i === casnNum1.length - 1) {
	              tempVar = tempVar + casnNum1.slice(i, j);
	            } else {
	              tempVar = tempVar + casnNum1.slice(i, j) + ":";
	            }
	            i = i + 1;
	          }
	          casnNum1 = tempVar;
	          this.serial_number = casnNum;
	          console.log("this.serial_number:", this.serial_number);
	        }
	
	        console.log("menu items Cablevision:", this.menuitems);
	        this.landingPageLoader = false;
	        setTimeout(function () {
	          /*document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';*/
	          document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
	          document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
	          /*document.getElementById('landingBg').style.marginTop = '0vh';*/
	        }, 1000);
	
	        this.focus('navigation_btn1');
	        this.$rootScope.enrollValue = false;
	      }
	    } else {
	      //based on plant id will determine customer.
	      if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
	        //cablevision customer
	        this.isCablevision = true;
	        this.$rootScope.isCablevision = this.isCablevision;
	        setTimeout(function () {
	          if ($scope.paperlessbill === null) {
	            //omniture if not enrolled in paperlessbill
	            $scope.paperlessbill = false;
	            console.log('!! omniture setting paperless false from enroll success else!!');
	          }
	        }, 3000);
	
	        console.log('showFaqTutorials: ', +storage.getItem('session', 'showFaqTutorials'));
	        var showFaqTutorialsVal = storage.getItem('session', 'showFaqTutorials');
	
	        if (showFaqTutorialsVal && showFaqTutorialsVal === "1") {
	          console.log('i am coming here');
	          this.menuitems = [{
	            label: 'View & Pay My Bill',
	            state: 'home.landingpage.viewpaybilllanding'
	          }, {
	            label: 'Paperless Billing',
	            state: 'home.landingpage.paperlessbillinglanding'
	          }, {
	            label: 'Optimum IDs',
	            state: 'home.landingpage.optimumidslanding'
	          }, {
	            label: 'Tutorials',
	            state: 'home.landingpage.tutorialslanding'
	          }, {
	            label: 'Quick Tips',
	            state: 'home.landingpage.faqlanding'
	          }];
	        } else {
	          console.log('actually i am coming here');
	          $scope.pageName = 'my account';
	          $scope.event = 'event1';
	          this.viewpaybillPage = true;
	          this.fromFaqPage = false;
	
	          this.menuitems = [{
	            label: 'View & Pay My Bill',
	            state: 'home.landingpage.viewpaybilllanding'
	          }, {
	            label: 'Paperless Billing',
	            state: 'home.landingpage.paperlessbillinglanding'
	          }, {
	            label: 'Optimum IDs',
	            state: 'home.landingpage.optimumidslanding'
	          }];
	        }
	
	        console.log("menu items Cablevision:", this.menuitems);
	        if (storage.getItem('session', 'casn')) {
	          var casnNum,
	              casnNum1,
	              i,
	              tempVar = "",
	              j;
	          casnNum = storage.getItem('session', 'casn');
	          casnNum1 = storage.getItem('session', 'casn');
	          console.log("Casn 1 is:", casnNum1.length);
	          for (i = 0; i < casnNum1.length; i++) {
	            j = i + 2;
	            if (i === casnNum1.length - 2 || i === casnNum1.length - 1) {
	              tempVar = tempVar + casnNum1.slice(i, j);
	            } else {
	              tempVar = tempVar + casnNum1.slice(i, j) + ":";
	            }
	            i = i + 1;
	          }
	          casnNum1 = tempVar;
	          this.serial_number = casnNum;
	          console.log("this.serial_number from 1st block:", this.serial_number);
	        }
	
	        //getting bp global data for
	        billingService.getBpGlobalData().then(function (res) {
	          console.log('this is bp global information from landing page.--> ', res);
	          if (res && res.data && res.data.status && res.data.status.statusCode === "00000") {
	            console.log("view bpGlobalInfo on landing page: ", res.data);
	            if (storage.getItem('session', 'accno')) {
	              accNum = storage.getItem('session', 'accno');
	              accNum = accNum.slice(0, 5) + "-" + accNum.slice(5, 11) + "-" + accNum.slice(11, 13);
	              _this2.account_number = accNum;
	              console.log("Account Number is:", _this2.account_number);
	            }
	            _this2.bpGlobalInfo = res.data;
	            _this2.amountTestDue = res.data.amountDue;
	            _this2.PPVInhibitBalance = res.data.billPayCache.ppvinhibitBalance;
	            console.log("this.PPVInhibitBalance is " + _this2.PPVInhibitBalance);
	            console.log("this.bpGlobalInfo.currentBalance is " + _this2.bpGlobalInfo.currentBalance);
	            console.log("this.bpGlobalInfo.amountDue is " + _this2.bpGlobalInfo.amountDue);
	
	            if (_this2.bpGlobalInfo.dueDate !== null) {
	              var myDate = _this2.bpGlobalInfo.dueDate;
	              var parts = myDate.split('/');
	              myDate = parts[0] + '/' + parts[1];
	              _this2.amountDueDate = myDate;
	            }
	            // checking amount due in different phases
	            //cur
	            if (_this2.bpGlobalInfo.currentBalance < 0) {
	              // omniture I have current balance < 0 my state is current
	              console.log('!! omniture I have current balance < 0 my state is current !!');
	              // this.$rootScope.analytics.balance = 'cur';
	              $scope.billingStatus = 'cur';
	              _this2.creditBalance = true;
	              _this2.creditAmount = _this2.bpGlobalInfo.currentBalance * -1;
	
	              /**************************************************************/
	              /*   This is to be run to change the paperless billing        */
	              /**************************************************************/
	              billingService.getCurrectAcc().then(function (resp) {
	                console.log("resp of current account on landing page.:", resp);
	                if (resp && resp.email && resp.isPaperBill === "false") {
	                  _this2.menuitems[1].label = "Paperless Billing";
	                  $scope.paperlessbill = true;
	                  console.log('!! omniture setting paperless true from billing service call 1!!');
	                }
	              });
	              _this2.landingPageLoader = false;
	              if (_this2.fromOptIdsPage) {
	                _this2.focus('navigation_btn2');
	                _this2.$rootScope.fromOptimumIdPage = false;
	              } else if (_this2.fromPaperlessPage) {
	                _this2.focus('navigation_btn1');
	                _this2.$rootScope.fromPaperlessBillingPage = false;
	              }
	              // else if(this.fromVideoBillPage){
	              //     this.focus('navigation_btn1');
	              //     this.$rootScope.fromVideoBillPage = false;
	              // }
	              else if (_this2.fromTutorialPage) {
	                  _this2.focus('navigation_btn3');
	                  _this2.$rootScope.fromTutorialPage = false;
	                } else if (_this2.fromFaqPage) {
	                  _this2.focus('navigation_btn4');
	                  _this2.$rootScope.fromFaqPage = false;
	                } else {
	                  _this2.focus('navigation_btn0');
	                }
	            }
	            //cur
	            else if (_this2.bpGlobalInfo.amountDue <= 0) {
	                // omniture I have amount due zero and current balance > 0 my state is current
	                console.log('!! omniture I have amount due zero and current balance > 0 my state is current !!');
	                $scope.billingStatus = 'cur';
	
	                if (_this2.bpGlobalInfo.currentBalance > 0) {
	                  _this2.noPaymentDuewithAccBalance = true;
	                } else {
	                  _this2.noPaymentDue = true;
	                }
	                /**************************************************************/
	                /*This is to be run to change the paperless billing menu item */
	                /**************************************************************/
	                billingService.getCurrectAcc().then(function (resp) {
	                  console.log("resp of current account on landing page.:", resp);
	                  if (resp && resp.email && resp.isPaperBill === "false") {
	                    _this2.menuitems[1].label = "Paperless Billing";
	                    $scope.paperlessbill = true;
	                    console.log('!! omniture setting paperless true from billing service call 2!!');
	                  }
	                });
	                _this2.landingPageLoader = false;
	                if (_this2.fromOptIdsPage) {
	                  _this2.focus('navigation_btn2');
	                  _this2.$rootScope.fromOptimumIdPage = false;
	                }
	                // else if(this.fromVideoBillPage){
	                //     this.focus('navigation_btn1');
	                //     this.$rootScope.fromVideoBillPage = false;
	                // }
	                else if (_this2.fromPaperlessPage) {
	                    _this2.focus('navigation_btn1');
	                    _this2.$rootScope.fromPaperlessBillingPage = false;
	                  } else if (_this2.fromTutorialPage) {
	                    _this2.focus('navigation_btn3');
	                    _this2.$rootScope.fromTutorialPage = false;
	                  } else if (_this2.fromFaqPage) {
	                    _this2.focus('navigation_btn4');
	                    _this2.$rootScope.fromFaqPage = false;
	                  } else {
	                    _this2.focus('navigation_btn0');
	                  }
	                //this.focus('navigation_btn0');
	              }
	              //pastdue or deauth
	              else if (_this2.bpGlobalInfo.amountDue > 0) {
	
	                  //verifying from where bp global coming
	                  if (storage.getItem('session', 'hasOptimumId')) {
	                    _this2.hasOptimumId = true;
	                  }
	                  // first we will get list of cards by getCurracc
	                  billingService.getCurrectAcc().then(function (resp) {
	                    console.log("resp of current account on landing page.:", resp);
	                    if (resp && resp.email && resp.isPaperBill === "false") {
	                      _this2.menuitems[1].label = "Paperless Billing";
	                      $scope.paperlessbill = true;
	                      console.log('!! omniture setting paperless true from another billing service call 4!!');
	                    }
	                    if (resp && resp.paymentMethods) {
	                      console.log("This is Currect Account ebillInformationOutputs from landing page.---> ", resp.paymentMethods);
	                      _this2.currentAccount = resp;
	                      _this2.items = resp.paymentMethods;
	                      console.log("this.items in landing page:", _this2.items);
	                    } else {
	                      _this2.items = [];
	                      console.log("this.items in landing page:", _this2.items);
	                    }
	                  }).then(function () {
	                    //this block plays pre-de auth one or two
	                    // deauth
	                    if (_this2.bpGlobalInfo.billPayCache && _this2.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && _this2.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0) {
	                      _this2.deAuthInfo = billingService.deauthInfo(_this2.bpGlobalInfo.billPayCache);
	                      //here we know we have deauth so now determining one or two so set text for alert and other msg.
	                      _this2.errorPay = true;
	                      document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
	                      document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
	                      /*document.getElementById('landingBg').style.marginTop = '0vh';*/
	                      if (_this2.deAuthInfo.isDeauthTwo) {
	                        // omniture I have amount due > zero my state is deauth2
	                        console.log('!! omniture I have amount due > zero my state is deauth2 !!');
	                        // this.$rootScope.analytics.balance = 'deauth2';
	                        $scope.pageName = 'deauth2';
	                        $scope.event = 'event1';
	                        $scope.billingStatus = 'deauth2';
	                        $scope.popup = true;
	                        _this2.isPreDAuthTwo = true;
	                        _this2.paymentAlertMsg = 'Your account is past due. Make a payment now to avoid service interruptions.';
	                        _this2.alertMsgTwo = 'Please pay ' + $filter('currency')(_this2.bpGlobalInfo.amountDue, '$', 2) + ' immediately to keep your service & avoid late or restore service fees.';
	                      } else if (_this2.deAuthInfo.isDeauthOne) {
	                        // omniture I have amount due > zero my state is deauth1
	                        console.log('!! omniture I have amount due > zero my state is deauth1 !!');
	                        // this.$rootScope.analytics.balance = 'deauth1';
	                        $scope.pageName = 'deauth1';
	                        $scope.event = 'event1';
	                        $scope.billingStatus = 'deauth1';
	                        $scope.popup = true;
	
	                        _this2.isPreDAuthOne = true;
	                        _this2.paymentAlertMsg = 'Your account is past due. Please make a payment by ' + _this2.deAuthInfo.startDate + ' to avoid late fees or service interruptions.';
	                        _this2.alertMsgTwo = 'Please pay ' + $filter('currency')(_this2.bpGlobalInfo.amountDue, '$', 2) + ' by ' + _this2.deAuthInfo.startDate + ' to keep your service & avoid late or restore service fees.';
	                      }
	                      // else if (this.PPVInhibitBalance > 0) {
	                      //     this.PPVInhibit = true;
	                      // }
	                      _this2.landingPageLoader = false;
	                      //code for alert
	                      if (storage.getItem('session', 'showLandingPopup')) {
	                        console.log('Coming here');
	                        //this.displayAlertModal = false;
	                        //this.focus('navigation_btn0');
	                        if (_this2.fromOptIdsPage) {
	                          _this2.focus('navigation_btn2');
	                          _this2.$rootScope.fromOptimumIdPage = false;
	                        } else if (_this2.fromPaperlessPage) {
	                          _this2.focus('navigation_btn1');
	                          _this2.$rootScope.fromPaperlessBillingPage = false;
	                        }
	                        // else if(this.fromVideoBillPage){
	                        //     this.focus('navigation_btn2');
	                        //     this.$rootScope.fromVideoBillPage = false;
	                        // }
	                        else if (_this2.fromTutorialPage) {
	                            _this2.focus('navigation_btn3');
	                            _this2.$rootScope.fromTutorialPage = false;
	                          } else if (_this2.fromFaqPage) {
	                            _this2.focus('navigation_btn4');
	                            _this2.$rootScope.fromFaqPage = false;
	                          } else {
	                            _this2.focus('navigation_btn0');
	                          }
	                      } else {
	                        console.log('!!omniture deauth popup is here!!');
	                        storage.setItem('session', 'showLandingPopup', true);
	                        _this2.displayAlertModal = true;
	                        _this2.focusItem('confirm-btn');
	
	                        setTimeout(function () {
	                          //navigation setup
	                          navigationManager.registerNavigate('confirm-btn', 'down');
	                          navigationManager.registerNavigate('confirm-btn', 'left', 'cancel-btn');
	                          navigationManager.registerNavigate('confirm-btn', 'up');
	                          navigationManager.registerNavigate('confirm-btn', 'right');
	                          navigationManager.registerNavigate('cancel-btn', 'down');
	                          navigationManager.registerNavigate('cancel-btn', 'right', 'confirm-btn');
	                          navigationManager.registerNavigate('cancel-btn', 'up');
	                          navigationManager.registerNavigate('cancel-btn', 'left');
	                          //end navigation setup
	                        }, 1000);
	                      }
	                    }
	                    ///this block plays pastdue stuff
	                    //pastdue
	                    else if (_this2.bpGlobalInfo.pastDueAmount > 0) {
	                        // omniture I have amount due > zero my state is pastdue
	                        console.log('!! omniture I have amount due > zero my state is pastdue !!');
	                        $scope.billingStatus = _this2.bpGlobalInfo.pastDue;
	                        console.log('!! omniture balance : ' + $scope.billingStatus);
	                        _this2.errorPay = true;
	                        _this2.paymentAlertMsg = 'Your account is past due. Please make a payment to avoid late fees or service interruptions.';
	                        document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
	                        document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
	                        /*document.getElementById('landingBg').style.marginTop = '0vh';*/
	                        _this2.isPastDue = true;
	                        _this2.landingPageLoader = false;
	                        //this.focus('navigation_btn0');
	                        if (_this2.fromOptIdsPage) {
	                          _this2.focus('navigation_btn2');
	                          _this2.$rootScope.fromOptimumIdPage = false;
	                        } else if (_this2.fromPaperlessPage) {
	                          _this2.focus('navigation_btn1');
	                          _this2.$rootScope.fromPaperlessBillingPage = false;
	                        }
	                        // else if(this.fromVideoBillPage){
	                        //     this.focus('navigation_btn1');
	                        //     this.$rootScope.fromVideoBillPage = false;
	                        // }
	                        else if (_this2.fromTutorialPage) {
	                            _this2.focus('navigation_btn3');
	                            _this2.$rootScope.fromTutorialPage = false;
	                          } else if (_this2.fromFaqPage) {
	                            _this2.focus('navigation_btn4');
	                            _this2.$rootScope.fromFaqPage = false;
	                          } else {
	                            _this2.focus('navigation_btn0');
	                          }
	                      } else if (_this2.PPVInhibitBalance != null && _this2.PPVInhibitBalance > 0 && _this2.isPPVProd) {
	                        _this2.PPVInhibit = true;
	                        _this2.landingPageLoader = false;
	                        if (_this2.fromOptIdsPage) {
	                          _this2.focus('navigation_btn2');
	                          _this2.$rootScope.fromOptimumIdPage = false;
	                        } else if (_this2.fromPaperlessPage) {
	                          _this2.focus('navigation_btn1');
	                          _this2.$rootScope.fromPaperlessBillingPage = false;
	                        }
	                        // else if(this.fromVideoBillPage){
	                        //     this.focus('navigation_btn1');
	                        //     this.$rootScope.fromVideoBillPage = false;
	                        // }
	                        else if (_this2.fromTutorialPage) {
	                            _this2.focus('navigation_btn3');
	                            _this2.$rootScope.fromTutorialPage = false;
	                          } else if (_this2.fromFaqPage) {
	                            _this2.focus('navigation_btn4');
	                            _this2.$rootScope.fromFaqPage = false;
	                          } else {
	                            _this2.focus('navigation_btn0');
	                          }
	                        //this.focus('navigation_btn0');
	                      }
	                      //if nothings remain and only amount due
	                      // if none of above it is current state
	                      else {
	                          // omniture I have amount due = zero my state is current
	                          console.log('!! omniture I have amount due = zero my state is current !!');
	                          $scope.billingStatus = 'cur';
	
	                          _this2.paymentDue = true;
	                          _this2.landingPageLoader = false;
	                          if (_this2.fromOptIdsPage) {
	                            _this2.focus('navigation_btn2');
	                            _this2.$rootScope.fromOptimumIdPage = false;
	                          } else if (_this2.fromPaperlessPage) {
	                            _this2.focus('navigation_btn1');
	                            _this2.$rootScope.fromPaperlessBillingPage = false;
	                          }
	                          // else if(this.fromVideoBillPage){
	                          //     this.focus('navigation_btn1');
	                          //     this.$rootScope.fromVideoBillPage = false;
	                          // }
	                          else if (_this2.fromTutorialPage) {
	                              _this2.focus('navigation_btn3');
	                              _this2.$rootScope.fromTutorialPage = false;
	                            } else if (_this2.fromFaqPage) {
	                              _this2.focus('navigation_btn4');
	                              _this2.$rootScope.fromFaqPage = false;
	                            } else {
	                              _this2.focus('navigation_btn0');
	                            }
	                          //this.focus('navigation_btn0');
	                        }
	                  });
	                }
	          } else {
	              if (storage.getItem('session', 'accno')) {
	                accNum = storage.getItem('session', 'accno');
	                accNum = accNum.slice(0, 5) + "-" + accNum.slice(5, 11) + "-" + accNum.slice(11, 13);
	                _this2.account_number = accNum;
	              }
	              billingService.getCurrectAcc().then(function (resp) {
	                console.log("resp of current account on landing page.:", resp);
	                if (resp && resp.email && resp.isPaperBill === "false") {
	                  _this2.menuitems[1].label = "Paperless Billing";
	                  $scope.paperlessbill = true;
	                  console.log('!! omniture setting paperless true from another billing service call 5!!');
	                }
	              });
	
	              _this2.landingPageLoader = false;
	              if (_this2.fromOptIdsPage) {
	                _this2.focus('navigation_btn2');
	                _this2.$rootScope.fromOptimumIdPage = false;
	              } else if (_this2.fromPaperlessPage) {
	                _this2.focus('navigation_btn1');
	                _this2.$rootScope.fromPaperlessBillingPage = false;
	              }
	              // else if(this.fromVideoBillPage){
	              //     this.focus('navigation_btn1');
	              //     this.$rootScope.fromVideoBillPage = false;
	              // }
	              else if (_this2.fromTutorialPage) {
	                  _this2.focus('navigation_btn3');
	                  _this2.$rootScope.fromTutorialPage = false;
	                } else if (_this2.fromFaqPage) {
	                  _this2.focus('navigation_btn4');
	                  _this2.$rootScope.fromFaqPage = false;
	                } else {
	                  _this2.focus('navigation_btn0');
	                }
	              //this.focus('navigation_btn0');
	            }
	        }, function () {
	          _this2.landingPageLoader = false;
	          if (_this2.fromOptIdsPage) {
	            _this2.focus('navigation_btn2');
	            _this2.$rootScope.fromOptimumIdPage = false;
	          }
	          // else if(this.fromVideoBillPage){
	          //     this.focus('navigation_btn2');
	          //     this.$rootScope.fromVideoBillPage = false;
	          // }
	          else if (_this2.fromPaperlessPage) {
	              _this2.focus('navigation_btn1');
	              _this2.$rootScope.fromPaperlessBillingPage = false;
	            } else if (_this2.fromTutorialPage) {
	              _this2.focus('navigation_btn3');
	              _this2.$rootScope.fromTutorialPage = false;
	            } else if (_this2.fromFaqPage) {
	              _this2.focus('navigation_btn4');
	              _this2.$rootScope.fromFaqPage = false;
	            } else {
	              _this2.focus('navigation_btn0');
	            }
	
	          if (storage.getItem('session', 'casn')) {
	            var casnNum,
	                casnNum1,
	                i,
	                tempVar = "",
	                j;
	            casnNum = storage.getItem('session', 'casn');
	            casnNum1 = storage.getItem('session', 'casn');
	            console.log("Casn 1 is:", casnNum1.length);
	            for (i = 0; i < casnNum1.length; i++) {
	              j = i + 2;
	              if (i === casnNum1.length - 2 || i === casnNum1.length - 1) {
	                tempVar = tempVar + casnNum1.slice(i, j);
	              } else {
	                tempVar = tempVar + casnNum1.slice(i, j) + ":";
	              }
	              i = i + 1;
	            }
	            casnNum1 = tempVar;
	            _this2.serial_number = casnNum1;
	            console.log("this.serial_number:", _this2.serial_number);
	          }
	          console.log('Something wrong with all call and bpglobal fail.');
	        });
	      } else if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 2) {
	        //suddenlink customer
	        this.isSuddenlink = true;
	        this.$rootScope.isSuddenlink = this.isSuddenlink;
	        if (storage.getItem('session', 'showFaqTutorials') && storage.getItem('session', 'showFaqTutorials') === "1") {
	          this.menuitems = [{
	            label: 'Usernames',
	            state: 'home.landingpage.suddenlinkidslanding'
	          }, {
	            label: 'Tutorials',
	            state: 'home.landingpage.tutorialslanding'
	          }, {
	            label: 'Quick Tips',
	            state: 'home.landingpage.faqlanding'
	          }];
	        } else {
	          this.viewpaybillPage = true;
	          this.fromFaqPage = false;
	          this.fromTutorialPage = false;
	          this.menuitems = [{
	            label: 'Usernames',
	            state: 'home.landingpage.suddenlinkidslanding'
	          }];
	        }
	
	        console.log("menu items SuddenLink:", this.menuitems);
	
	        laboxSSapi.getAllSuddenlinkIds().then(function (res) {
	          if (res && res.data && res.data.accountSummaryResponse.statusDescription && res.data.accountSummaryResponse.statusDescription == "Success") {
	            _this2.unregUser = res.data.accountSummaryResponse.users[0].userName.search("unreg:") + 1;
	            console.log('this.unregUser is ' + _this2.unregUser);
	            if (_this2.unregUser === 1) {
	              _this2.hasSuddenlinkId = false;
	            } else {
	              _this2.hasSuddenlinkId = true;
	            }
	            if (storage.getItem('session', 'sdl_acc_no') && storage.getItem('session', 'sdl_acc_no') != null) {
	              _this2.AccountArray = storage.getItem('session', 'sdl_acc_no');
	            } else {
	              if (res.data.accountSummaryResponse.statementAccountNumbers != null) {
	                storage.setItem('session', 'sdl_acc_no', res.data.accountSummaryResponse.statementAccountNumbers);
	              }
	              _this2.AccountArray = res.data.accountSummaryResponse.statementAccountNumbers;
	            }
	            _this2.oldaccount_number = Math.min.apply(Math, _this2.AccountArray);
	            console.log('this.oldaccount_number ' + _this2.oldaccount_number.toString());
	            console.log('this.oldaccount_number.length ' + _this2.oldaccount_number.toString().length);
	            _this2.new_account_number = _this2.oldaccount_number.toString();
	            while (_this2.new_account_number.length < 16) {
	              console.log('in while loop');
	              _this2.new_account_number = "0" + _this2.new_account_number;
	            }
	            _this2.sdl_account_number = _this2.new_account_number.slice(0, 3) + "-" + _this2.new_account_number.slice(3, 7) + "-" + _this2.new_account_number.slice(7, 16);
	            console.log('this.AccountArray is ' + _this2.sdl_account_number);
	          } else {
	            console.log('there is no account number');
	          }
	        });
	
	        this.landingPageLoader = false;
	        if (this.fromTutorialPage) {
	          this.focus('suddenlink-navigation_btn1');
	          this.$rootScope.fromTutorialPage = false;
	        } else if (this.fromFaqPage) {
	          this.focus('suddenlink-navigation_btn2');
	          this.$rootScope.fromFaqPage = false;
	        } else if (this.fromSdlIdsPage) {
	          this.focus('suddenlink-navigation_btn2');
	          this.$rootScope.fromSdlIdsPage = false;
	        } else {
	          this.focus('suddenlink-navigation_btn0');
	        }
	        if (storage.getItem('session', 'casn')) {
	          var casnNum,
	              casnNum1,
	              i,
	              tempVar = "",
	              j;
	          casnNum = storage.getItem('session', 'casn');
	          casnNum1 = storage.getItem('session', 'casn');
	          console.log("Casn 1 is:", casnNum1.length);
	          for (i = 0; i < casnNum1.length; i++) {
	            j = i + 2;
	            if (i === casnNum1.length - 2 || i === casnNum1.length - 1) {
	              tempVar = tempVar + casnNum1.slice(i, j);
	            } else {
	              tempVar = tempVar + casnNum1.slice(i, j) + ":";
	            }
	            i = i + 1;
	          }
	          casnNum1 = tempVar;
	          this.serial_number = casnNum1;
	          console.log("this.serial_number:", this.serial_number);
	        }
	        // this.focus('suddenlink-navigation_btn0');
	      } else {
	          // alert('customer is neither from cable-vision nor from sudden-link.');
	          if (storage.getItem('session', 'casn')) {
	            var casnNum,
	                casnNum1,
	                i,
	                tempVar = "",
	                j;
	            casnNum = storage.getItem('session', 'casn');
	            casnNum1 = storage.getItem('session', 'casn');
	            console.log("Casn 1 is:", casnNum1.length);
	            for (i = 0; i < casnNum1.length; i++) {
	              j = i + 2;
	              if (i === casnNum1.length - 2 || i === casnNum1.length - 1) {
	                tempVar = tempVar + casnNum1.slice(i, j);
	              } else {
	                tempVar = tempVar + casnNum1.slice(i, j) + ":";
	              }
	              i = i + 1;
	            }
	            casnNum1 = tempVar;
	            this.serial_number = casnNum1;
	            console.log("this.serial_number:", this.serial_number);
	          } else {
	            console.log('no casn');
	          }
	          if (storage.getItem('session', 'home_id')) {
	            var cidx = storage.getItem('session', 'home_id');
	            this.cidx = cidx;
	          } else {
	            console.log('no home id');
	          }
	          this.displayGenericAlertModal = true;
	          this.genericAlertMsg = 'There is no plant_id option, casn = ' + this.serial_number + ' the home id is = ' + this.cidx;
	          this.focusItem('cancel-btn');
	        }
	    }
	
	    //this.account_number=storage.getItem('session', 'accno');//
	
	    this.goPayBill = function () {
	      // omniture deauth pay now event
	      console.log('!!omniture deauth pay Now');
	      console.log('billing status : ' + $scope.billingStatus);
	      if ($scope.popup) {
	        console.log('!!omniture pay now after popup');
	        analyticsService.sendReport('home', $scope.pageName, 'event2', null, null, null, 'Pay Now', this.$rootScope.analytics.omniturePath + '/viewpaybill', $scope.billingStatus, $scope.paperlessbill, this.$rootScope.analytics.omniturePath + '/landingpage');
	      } else {
	        console.log('!!omniture pay now from landingpage');
	        analyticsService.sendReport('home', $scope.pageName, 'event2', null, null, null, 'Pay Now', this.$rootScope.analytics.omniturePath + '/viewpaybill', $scope.billingStatus, $scope.paperlessbillsl, this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding');
	      }
	
	      $scope.popup = false;
	      this.displayAlertModal = false;
	
	      this.state.go('home.viewpaybill');
	    };
	
	    this.cancel = function () {
	      // omniture deauth pay later event
	      console.log('!!omniture deauth pay later');
	      analyticsService.sendReport('home', $scope.pageName, null, null, null, null, 'Pay Later', this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding', $scope.billingStatus, $scope.paperlessbill, this.$rootScope.analytics.omniturePath + '/landingpage');
	
	      console.log('!!omniture landing page tag after deauth pay later');
	      analyticsService.sendReport('home', 'my account', 'event1', null, null, null, null, null, $scope.billingStatus, $scope.paperlessbill, this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding');
	
	      this.displayAlertModal = false;
	      this.focusItem('navigation_btn0');
	    };
	    this.cancelGenericAlert = function () {
	      this.displayGenericAlertModal = false;
	      this.focusItem('navigation_btn0');
	    };
	    this.itemClickHandler = function (event) {
	      //console.log("Event:", event);
	      if (event.item.label === "View & Pay My Bill") {
	        //omniture when click view & pay my bill from landingpage
	        console.log('!!omniture when click view & pay my bill from landingpage');
	        analyticsService.sendReport('home', 'my account', 'event2', null, null, null, 'view & pay my bill', _this2.$rootScope.analytics.omniturePath + '/viewpaybill', _this2.$rootScope.omnitureBillingStatus, _this2.$rootScope.omniturePaperlessbill, _this2.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding');
	
	        _this2.state.go('home.viewpaybill');
	      } else if (event.item.label === "Understanding My Bill") {
	        // if(skylink != null){
	        //         this.$rootScope.fromLandingPage = true;
	        //         this.$rootScope.title = "My Bill Explained";
	        //         this.state.go('videoplayer', {
	        //           back: true,
	        //           url: skylink
	        //           });
	        //       } else {
	        //         console.log('error fetching video bill');
	        //       }
	        if (storage.getItem('session', 'home_id') == "36063655" || storage.getItem('session', 'home_id') == "36071973") {
	          console.log('specific case where it should polay the default video and get no api response');
	          _this2.$rootScope.fromLandingPage = true;
	          _this2.$rootScope.title = "My Bill Explained";
	          _this2.state.go('videoplayer', {
	            back: true,
	            url: "https://player.sundaysky.com/customers/optimum/optimum_fallback.mp4"
	          });
	        } else {
	          laboxSSapi.getVideoBill().then(function (res) {
	            console.log('calling video bill api');
	            if (res && res.data._links) {
	              _this2.working_link = res.data._links['video-stream'][0].href;
	              console.log('res.data["_links"]["video-stream"].href is ' + res.data._links['video-stream'][0].href);
	              console.log('working link is ' + _this2.working_link);
	              if (_this2.working_link != null && storage.getItem('session', 'home_id') != "40520101") {
	                console.log('res.data is ' + res.data);
	                console.log('res.data["_links"]["video-stream"].href is ' + res.data._links['video-stream'][0].href);
	                _this2.$rootScope.fromLandingPage = true;
	                _this2.$rootScope.title = _this2.working_link;
	                _this2.state.go('player', {
	                  back: true,
	                  url: _this2.working_link
	                });
	              } else {
	                console.log('response from video bill but has no link');
	                _this2.$rootScope.fromLandingPage = true;
	                _this2.$rootScope.title = "My Bill Explained";
	                _this2.state.go('videoplayer', {
	                  back: true,
	                  url: res.data.fallback.video.href
	                });
	              }
	            } else {
	              console.log('no response from videobill');
	              console.log('res.data is ' + res.data);
	              _this2.$rootScope.fromLandingPage = true;
	              _this2.$rootScope.title = "My Bill Explained";
	              _this2.state.go('videoplayer', {
	                back: true,
	                url: "https://player.sundaysky.com/customers/optimum/optimum_fallback.mp4"
	              });
	            }
	          });
	        }
	      } else if (event.item.label === "Go Paperless") {
	        // omniture when click paperlessbilling from landingpage
	        console.log('!!omniture when click paperlessbilling from landingpage!!');
	        analyticsService.sendReport('home', 'paperless billing', null, null, null, null, 'Go Paperless', _this2.$rootScope.analytics.omniturePath + '/paperlessbilling', _this2.$rootScope.omnitureBillingStatus, _this2.$rootScope.omniturePaperlessbill, _this2.$rootScope.analytics.omniturePath + '/landingpage/paperlessbillinglanding');
	
	        if (storage.getItem('session', 'hasOptimumId')) {
	          _this2.state.go('home.paperlessbilling');
	        }
	      } else if (event.item.label === "Optimum IDs") {
	        // omniture when click ids from landingpage
	        console.log('!!omniture when click ids from landingpage!!');
	        analyticsService.sendReport('home', 'ids', null, null, null, null, 'IDs', _this2.$rootScope.analytics.omniturePath + '/optimumids', _this2.$rootScope.omnitureBillingStatus, _this2.$rootScope.omniturePaperlessbill, _this2.$rootScope.analytics.omniturePath + '/landingpage/optimumidslanding');
	
	        if (storage.getItem('session', 'hasOptimumId')) {
	          _this2.state.go('home.optimumids');
	        }
	      } else if (event.item.label === "Usernames") {
	        console.log('this.hasSuddenlinkId is ' + _this2.hasSuddenlinkId);
	        if (_this2.hasSuddenlinkId === true) {
	          _this2.state.go('home.suddenlinkids');
	        }
	      } else if (event.item.label === "Tutorials") {
	        // omniture when click tutorials from landingpage
	        console.log('!!omniture when click tutorials from landingpage!!');
	        analyticsService.sendReport('home', 'tutorial', null, null, null, null, 'Tutorials', _this2.$rootScope.analytics.omniturePath + '/tutorials', _this2.$rootScope.omnitureBillingStatus, _this2.$rootScope.omniturePaperlessbill, _this2.$rootScope.analytics.omniturePath + '/landingpage/tutorialslanding');
	        _this2.state.go('home.tutorials');
	      } else if (event.item.label === "Quick Tips") {
	        // omniture when click faq from landingpage
	        console.log('!!omniture when click faq from landingpage!!');
	        analyticsService.sendReport('home', 'quick tips', null, null, null, null, 'Quick Tips', _this2.$rootScope.analytics.omniturePath + '/faq', _this2.$rootScope.omnitureBillingStatus, _this2.$rootScope.omniturePaperlessbill, _this2.$rootScope.analytics.omniturePath + '/landingpage/faqlanding');
	        _this2.state.go('home.faq');
	      } else {
	        //this.state.go('home.keyboard');
	        console.log("");
	      }
	    };
	
	    this.nextComponentHandler = function (index) {};
	
	    this.prevComponentHandler = function (event) {};
	  }
	
	  /*$postLink() {
	    //this.focus('navigation_btn0');
	  }
	   focus(fromState) {
	      var ix;
	       if (fromState) {
	          this.items.forEach((item, _ix) => {
	              if (item.state === fromState) {
	                  ix = _ix;
	                  return 0;
	              }
	          });
	      }
	       this.$scope.$broadcast('focus', {
	          id: 'navigation',
	          index: ix
	      });
	  }*/
	
	  _createClass(LandingpageController, [{
	    key: 'focus',
	    value: function focus(id) {
	      console.log("id in focus:", id);
	      setTimeout(function () {
	        document.getElementById(id).focus();
	      }, 150);
	    }
	  }, {
	    key: 'focusItem',
	    value: function focusItem(id) {
	      var el = document.getElementById(id);
	      if (el) {
	        el.focus();
	      } else {
	        this.$timeout(this.focusItem.bind(this, id));
	      }
	    }
	  }]);
	
	  return LandingpageController;
	})();
	
	LandingpageController.$inject = ['$state', '$window', 'storage', 'billingService', '$rootScope', '$filter', '$timeout', 'navigationManager', '$scope', 'laboxSSapi', 'analyticsService'];
	exports['default'] = LandingpageController;
	module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(43);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./landingpage.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./landingpage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".landingpage .msgAlertBox{font-size:1.6vw;text-align:left;min-height:1px;margin:0 9.2vw 4.63vh 8.97vw}.landingpage .msgAlertBox .errorAlertBox{display:table}.landingpage .msgAlertBox .errorAlertBox .errorSym{display:table-cell}.landingpage .msgAlertBox .errorAlertBox .errorSym .errorMsg{background:url(" + __webpack_require__(44) + ") no-repeat 50%}.landingpage .msgAlertBox .errorAlertBox .errorMsgDesc{display:table-cell;vertical-align:middle}.landingpage .explore-header span{margin:6.63vh 9.2vw 0 8.97vw;font-size:4.06vw;font-weight:800}.landingbg{margin:3.63vh 9.2vw 0 8.97vw;background-color:hsla(0,0%,40%,.4);min-height:270px;overflow:hidden}.landingbg .content-left{float:left;width:40.91vw;padding-top:28px;padding-bottom:30px}.landingbg .content-right{float:left;width:38.5vw;min-height:30.86vh;padding-top:5px}.landingbg .content-right .landingDueBox{display:table;width:100%;margin-top:3vh;font-size:2.5vw;font-weight:800}.landingbg .content-right .landingDueBox .left-text,.landingbg .content-right .landingDueBox .right-text{display:table-cell;white-space:nowrap}.landingbg .content-right .landingDueBox .left-text{padding-right:8px}.landingbg .content-right .landingDueBox .right-text{text-align:right;padding-left:8px}.landingbg .content-right .landingDueBox .date_due,.landingbg .content-right .landingDueBox .other-info{display:table-row;color:#9ea6a8;font-weight:400;font-size:1.8vw}.landingbg .content-right .landingDueBox .other-info{font-family:Open Sans Regular}.landingbg .content-right .textHigh{color:#e22d02;font-family:Open Sans Bold}.landingbg .content-right .textLow{color:#fff;font-family:Open Sans Bold}.landingbg .content-right .textSecondVerbiage{color:#f1f1f1;font-weight:400;font-size:1.72vw}.landingbg .content-right .verbiagePadding{padding-top:2.2vh}.landingbg .content-right .text-optimum-link{color:#f1f1f1;font-weight:300;font-size:1.72vw}.accountNumber{margin:4.45vh 4.91vw 0 4.95vw}.accountNumber,.serialNumber{position:absolute;bottom:6vh;font-size:1.72vw}.serialNumber{right:.25vw;margin:4.45vh 4.7vw 0 4.4vw}.clearfix{visibility:hidden;display:block;content:\" \";clear:both;height:0}.tempmenu .tempbtn{padding:10px;background-color:#007cb4;min-width:30vw;font-size:4vh;margin-bottom:1vh}.tempmenu .tempbtn:focus{border:2px solid #f1f1f1;background:linear-gradient(45deg,#87b8cf,#007cb4)}.landing-alert-modal{position:absolute;left:0;top:0;width:100%;height:100%;animation-duration:1s;animation-name:slidein}.landing-alert-modal .modal{width:100%;height:100%;overflow:auto;padding:0;background-color:rgba(40,40,40,.95);margin:0}.landing-alert-modal .modal .modal-content{width:46.5vw;background-color:#000;height:45vh;color:gray;margin:16% 0 0 30%;padding:0;font-size:2.8vmin;animation:animatetop .7s}.landing-alert-modal .modal .modal-content .modal-wrapper{margin-top:-3%}.landing-alert-modal .modal .modal-content .modal-wrapper .modal-header{height:5%;display:block;text-align:left;color:#e22d02;font-size:2vmin;padding:28px;background-color:#3c3c3c;font-family:Open Sans Bold}.landing-alert-modal .modal .modal-content .modal-wrapper .modal-header h1{margin:0;font-size:26px}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details{display:block}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one{margin:3.1vw 2.35vw 0 2.25vw;color:#fff}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox{display:table}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorSym{display:table-cell;padding-right:1.5vw}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorSym .errorMsg{background:url(" + __webpack_require__(44) + ") no-repeat 50%}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorMsgOne{display:table-cell;vertical-align:middle}.landing-alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorMsgTwo{padding-left:5.57813vw;padding-top:2vh;color:#e22d02}.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group{float:right;margin:2.25vw;font-family:Open Sans Bold}.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group .cancel-payment-btn{border-radius:2px;background-color:#3e3e3e;width:16vw;color:#aeb4b5;height:5.65vh;border:#3b494d;margin-right:5px;font-size:20px;font-weight:700}.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group .cancel-payment-btn:focus,.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group .cancel-payment-btn:hover{background-color:#fff;color:#000;border:none}.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group .confirm-payment-btn{border-radius:2px;background-color:#3b494d;width:16vw;color:#aeb4b5;height:5.65vh;border:#f1f1f1;font-size:20px;font-weight:700}.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group .confirm-payment-btn:focus,.landing-alert-modal .modal .modal-content .modal-wrapper .btn-group .confirm-payment-btn:hover{background-color:#f1f1f1;color:#000;border:none}@keyframes slidein{0%{opacity:0}to{opacity:1}}", ""]);
	
	// exports


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _viewpaybillComponent = __webpack_require__(46);
	
	var _viewpaybillComponent2 = _interopRequireDefault(_viewpaybillComponent);
	
	var viewpaybillModule = _angular2['default'].module('viewpaybill', [_angularUiRouter2['default']]).component('viewpaybill', _viewpaybillComponent2['default']);
	
	exports['default'] = viewpaybillModule;
	module.exports = exports['default'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _viewpaybillHtml = __webpack_require__(47);
	
	var _viewpaybillHtml2 = _interopRequireDefault(_viewpaybillHtml);
	
	var _viewpaybillController = __webpack_require__(48);
	
	var _viewpaybillController2 = _interopRequireDefault(_viewpaybillController);
	
	__webpack_require__(51);
	
	var viewPayComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _viewpaybillHtml2['default'],
	  controller: _viewpaybillController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = viewPayComponent;
	module.exports = exports['default'];

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"breadcrumb\" class=\"menu-name\" ng-show=\"!vm.bpGlobalDataLoader\">\n    <span class=\"myAccount\">/</span>\n    <span>{{vm.name}}</span>\n</div>\n<!-- Moved to the appHeader common component so moved out\n<div class=\"date-section\" ng-show=\"!vm.bpGlobalDataLoader\">\n    <span class=\"current-date\"><span class=\"currentDay\">{{vm.currentDay}}</span> <span>{{vm.currentDate}}</span>/<span>{{vm.currentMonth}}</span></span>\n    <div class=\"current-time\"><span>{{vm.currunttime}}</span></div>\n</div>-->\n<div id=\"viewpaybillcontainer\" ng-init=\"vm.keyWatch($event)\">\n  <div id=\"mainInfoDiv\">\n\n    <div ng-show=\"!vm.bpGlobalDataLoader\">\n\n      <!-- this is common for all -->\n      <div class=\"msgAlertBox\" id=\"msgAlertBoxId\" ng-show=\"vm.successPay || vm.errorPay\">\n        <div class=\"successAlertBox\"  ng-show=\"vm.successPay\">\n          <div class=\"successSym\">\n            <span class=\"fa-stack fa-lg successMsg\"></span>\n          </div>\n          <div class=\"successMsgDesc\">\n            <span>Thank you. Your payment of {{vm.bpGlobalInfo.recentPayAmount | currency}} with {{vm.paymentMethodUsed}} has been received.</span>\n          </div>\n        </div>\n        <div class=\"errorAlertBox\"  ng-show=\"vm.errorPay\">\n          <div class=\"errorSym\">\n            <span class=\"fa-stack fa-lg errorMsg\"></span>\n          </div>\n          <div class=\"errorMsgDesc\">\n            <span>{{vm.paymentAlertMsg}}</span>\n          </div>\n        </div>\n      </div>\n\n      <!-- this is based on amount dues -->\n        <div class=\"viewpaymain\" ng-if=\"vm.paymentDue\">\n            <div class=\"vpcontent-left\">\n                <div class=\"payinfo\">\n                    <table class=\"tblamttext\">\n                        <tr ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">\n                            <td>Payment received {{vm.recentPaymentDate}}*</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.recentPayAmount | currency}}</td>\n                        </tr>\n                        <tr>\n                            <td>Account balance</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.currentBalance | currency}}</td>\n                        </tr>\n                    </table>\n                </div>\n                <div class=\"paymentbox\">\n                    <div class=\"amounduebox\">\n                        <div class=\"textamountduebox\">\n                          <div class=\"amountdue\" ng-class=\"{'multiVersionDeauthandDue' : vm.multiVersionDeauth}\">Amount due</div>\n                          <div class=\"dottedc\">\n                            <div class=\"dotted\"></div>\n                          </div>\n                          <div class=\"price\" ng-class=\"{'multiVersionDeauthandDue' : vm.multiVersionDeauth}\">{{vm.bpGlobalInfo.amountDue | currency}}</div>\n                          <div class=\"date_due\" ng-show=\"!vm.multiVersionDeauth\">on {{vm.amountDueDate}}</div>\n                          <div class=\"pastdueReplaceDate\" ng-show=\"vm.multiVersionDeauth\">Your account is past due.</div>\n                        </div>\n                    </div>\n                    <div class=\"paymethodbox\">\n                        <scrolling-list items=\"vm.items\" on-select=\"vm.paymentModalHandler(item)\" ng-if=\"vm.items.length>0\"></scrolling-list>\n                        <div ng-if=\"vm.items.length=='0' && !vm.isBlockedCustomer\" class=\"noPaymentMethod\">Visit optimum.net/pay-bill to pay your bill</div>\n                        <div ng-if=\"vm.items.length=='0' && vm.isBlockedCustomer\" class=\"noPaymentMethod blockedUser\">Visit your nearest Optimum store to make a payment</div>\n                    </div>\n                </div>\n                <div class=\"payinfoSchedule\" ng-if=\"vm.schedulePayment\">\n                  {{vm.schedulePayment}}\n                </div>\n            </div>\n            <div ng-if=\"vm.items.length=='0' && !vm.isBlockedCustomer\" class=\"vpcontent-right\">\n                <p class=\"msgwithnoSavedPayment\" ng-show=\"!vm.defaultExpiredPaymentText && vm.hasOptimumId && !vm.onlyOnePaymentMethodAfterError\">There are no payment methods associated with this account. Go to <span>optimum.net/pay-bill</span> to add a payment method.</p>\n                <p class=\"msgwithnoSavedPayment\" ng-show=\"vm.defaultExpiredPaymentText && !vm.onlyOnePaymentMethodAfterError\">Visit <span>optimum.net/pay-bill</span> to manage your payment methods, view account activity and more.</p>\n                <p class=\"msgwithnoSavedPayment\" ng-if=\"!vm.hasOptimumId && !vm.onlyOnePaymentMethodAfterError\">\n                  There isn't an Optimum ID associated with this account. Go to <span>optimum.net/pay-bill</span> to create an Optimum ID and add a payment method.</p>\n                <p class=\"msgwithnoSavedPayment\" ng-show=\"vm.onlyOnePaymentMethodAfterError\">Visit <span>optimum.net/pay-bill</span> to manage your payment methods, view account activity and more.</p>\n            </div>\n            <div class=\"vpcontent-right\">\n                <p class=\"msgwithdue\">{{vm.msgString}}</p>\n            </div>\n            <div class=\"clearfix\"></div>\n        </div>\n        <div class=\"viewpaymain\" ng-if=\"vm.noPaymentDuewithAccBalance\">\n            <div class=\"vpcontent-left\">\n                <div class=\"payinfo\">\n                    <table class=\"tblamttext\">\n                        <tr ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">\n                            <td>Payment received {{vm.recentPaymentDate}}*</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.recentPayAmount | currency}}</td>\n                        </tr>\n                        <tr>\n                            <td>Account balance</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.currentBalance | currency}}</td>\n                        </tr>\n                    </table>\n                </div>\n                <div class=\"paymentbox\">\n                    <div class=\"amounduebox\">\n                        <div class=\"textamountduebox\">\n                          <div class=\"amountdue\">Amount due</div>\n                          <div class=\"dottedc\">\n                            <div class=\"dotted\"></div>\n                          </div>\n                          <div class=\"price\">$0.00</div>\n                        </div>\n                    </div>\n                    <div class=\"paymethodbox\">\n                        <div class=\"noPaymentDue\">No payment is due at this time</div>\n                    </div>\n                </div>\n                <div class=\"payinfoSchedule\" ng-if=\"vm.schedulePayment\">\n                  {{vm.schedulePayment}}\n                </div>\n            </div>\n            <div class=\"vpcontent-right\">\n                <p class=\"msgwithdue noDuePay\">{{vm.paymentSuccessString}}</p>\n            </div>\n            <div class=\"clearfix\"></div>\n        </div>\n        <div class=\"viewpaymain\" ng-if=\"vm.showAlert\">\n            <div class=\"vpcontent-left\">\n                <div class=\"payinfo\">\n                    <table class=\"tblamttext\">\n                        <tr ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">\n                            <td>Payment received {{vm.recentPaymentDate}}*</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.recentPayAmount | currency}}</td>\n                        </tr>\n                    </table>\n                </div>\n                <div class=\"paymentbox\">\n                    <div class=\"amounduebox\">\n                        <div class=\"textamountduebox\">\n                          <div class=\"amountdue\">Account balance</div>\n                          <div class=\"dottedc\">\n                            <div class=\"dotted\"></div>\n                          </div>\n                          <div class=\"price\">{{vm.bpGlobalInfo.currentBalance | currency}}</div>\n                        </div>\n                    </div>\n                    <div class=\"paymethodbox\">\n                        <div class=\"noPaymentDue\">No payment is due at this time</div>\n                    </div>\n                </div>\n                <div class=\"payinfoSchedule\" ng-if=\"vm.schedulePayment\">\n                  {{vm.schedulePayment}}\n                </div>\n            </div>\n            <div class=\"vpcontent-right\">\n                <p class=\"msgwithsuccess\">{{vm.paymentSuccessString}}</p>\n            </div>\n            <div class=\"clearfix\"></div>\n        </div>\n\n        <div class=\"viewpaymain\" ng-if=\"vm.noPaymentDue\">\n            <div class=\"vpcontent-left\">\n                <div class=\"payinfo\">\n                    <table class=\"tblamttext\">\n                        <tr ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">\n                            <td>Payment received {{vm.recentPaymentDate}}*</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.recentPayAmount | currency}}</td>\n                        </tr>\n                    </table>\n                </div>\n                <div class=\"paymentbox\">\n                    <div class=\"amounduebox\">\n                        <div class=\"textamountduebox\">\n                          <div class=\"amountdue\">Account balance</div>\n                          <div class=\"dottedc\">\n                            <div class=\"dotted\"></div>\n                          </div>\n                          <div class=\"price\">{{vm.bpGlobalInfo.currentBalance | currency}}</div>\n                        </div>\n                    </div>\n                    <div class=\"paymethodbox\">\n                        <div class=\"noPaymentDue\">No payment is due at this time</div>\n                    </div>\n                </div>\n                <div class=\"payinfoSchedule\" ng-if=\"vm.schedulePayment\">\n                  {{vm.schedulePayment}}\n                </div>\n            </div>\n            <div class=\"vpcontent-right\">\n                <p class=\"msgwithnoPaymentDue\">{{vm.paymentSuccessString}}</p>\n            </div>\n            <div class=\"clearfix\"></div>\n        </div>\n\n        <div class=\"viewpaymain\" ng-if=\"vm.creditBalance\">\n            <div class=\"vpcontent-left\">\n                <div class=\"payinfo\">\n                    <table class=\"tblamttext\">\n                        <tr ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">\n                            <td>Payment received {{vm.recentPaymentDate}}*</td>\n                            <td class=\"tbltdright\">{{vm.bpGlobalInfo.recentPayAmount | currency}}</td>\n                        </tr>\n                    </table>\n                </div>\n                <div class=\"paymentbox\">\n                    <div class=\"amounduebox\">\n                        <table class=\"textamountduebox\">\n                            <tr>\n                                <td class=\"creditBal\">You have a credit of {{vm.creditAmount | currency}}</td>\n                                <!--<td class=\"textamountdueboxright\">${{vm.bpGlobalInfo.currentBalance}}</td>-->\n                            </tr>\n                        </table>\n                    </div>\n                    <div class=\"paymethodbox\">\n                        <div class=\"noPaymentDue\">No payment is due at this time</div>\n                    </div>\n                </div>\n                <div class=\"payinfoSchedule\" ng-if=\"vm.schedulePayment\">\n                  {{vm.schedulePayment}}\n                </div>\n            </div>\n            <div class=\"vpcontent-right\">\n                <p class=\"msgwithnoPaymentDue\">{{vm.paymentSuccessString}}</p>\n            </div>\n            <div class=\"clearfix\"></div>\n        </div>\n\n       <!-- this blocks are for pre deauth and 30/60 day past dues-->\n       <div class=\"viewpaymain\" ng-if=\"vm.isPastDue || vm.isPreDAuthTwo || vm.isPreDAuthOne\">\n        <div class=\"vpcontent-left\">\n          <div class=\"payinfo\">\n            <table class=\"tblamttext\">\n              <tr ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">\n                <td>Payment received {{vm.recentPaymentDate}}*</td>\n                <td class=\"tbltdright\">{{vm.bpGlobalInfo.recentPayAmount | currency}}</td>\n              </tr>\n              <tr>\n                <td>Account balance</td>\n                <td class=\"tbltdright\">{{vm.bpGlobalInfo.currentBalance | currency}}</td>\n              </tr>\n            </table>\n          </div>\n          <div class=\"paymentbox\">\n            <div class=\"amounduebox\">\n              <div class=\"textamountduebox\">\n                <div class=\"amountdue\" id=\"deorpastAmountDue\">Amount due</div>\n                <div class=\"dottedc\">\n                  <div class=\"dotted\"></div>\n                </div>\n                <div class=\"price\" id=\"deorpastAmount\">{{vm.bpGlobalInfo.amountDue | currency}}</div>\n                <div class=\"pastdueReplaceDate\">\n                  Your account is past due.\n                </div>\n              </div>\n            </div>\n            <div class=\"paymethodbox\">\n              <scrolling-list items=\"vm.items\" on-select=\"vm.paymentModalHandler(item)\" ng-if=\"vm.items.length>0\"></scrolling-list>\n              <div ng-if=\"vm.items.length=='0'\" class=\"noPaymentMethod\">Visit optimum.net/pay-bill to pay your bill</div>\n            </div>\n          </div>\n          <div class=\"payinfoSchedule\" ng-if=\"vm.schedulePayment\">\n            {{vm.schedulePayment}}\n          </div>\n        </div>\n        <div ng-if=\"vm.items.length=='0'\" class=\"vpcontent-right\">\n          <p class=\"msgwithnoSavedPayment\" ng-if=\"vm.hasOptimumId && !vm.onlyOnePaymentMethodAfterError\">\n            There are no payment methods associated with this account. Go to <span>optimum.net/pay-bill</span> to add a payment method.</p>\n          <p class=\"msgwithnoSavedPayment\" ng-if=\"!vm.hasOptimumId && !vm.onlyOnePaymentMethodAfterError\">\n            There isn't an Optimum ID associated with this account. Go to <span>optimum.net/pay-bill</span> to create an Optimum ID and add a payment method.</p>\n          <p class=\"msgwithnoSavedPayment\" ng-show=\"vm.onlyOnePaymentMethodAfterError\">Visit <span>optimum.net/pay-bill</span> to manage your payment methods, view account activity and more.</p>\n        </div>\n        <div class=\"vpcontent-right\">\n          <p class=\"msgwithdue\">{{vm.msgString}}</p>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n\n        <!-- this is common for all -->\n        <div class=\"paymentDue-bottom-text\" ng-show =\"vm.paymentDue || vm.showAlert || vm.noPaymentDue || vm.creditBalance || vm.noPaymentDuewithAccBalance || vm.isPastDue || vm.isPreDAuthTwo || vm.isPreDAuthOne\">\n          <p class=\"managePayText\" ng-if=\"vm.items.length!='0'\">To manage your payment methods, view account activity and more, visit: optimum.net/pay-bill</p>\n          <p class=\"managePayText\" ng-show = \"vm.showAlert || vm.noPaymentDue || vm.creditBalance || vm.noPaymentDuewithAccBalance\">To manage your payment methods, view account activity and more, visit: optimum.net/pay-bill</p>\n          <span ng-if=\"vm.bpGlobalInfo.hasRecentPayment == 'Y'\">*Payments may take up to 24 hours to appear here.</span>\n        </div>\n    </div>\n    <div ng-show=\"vm.bpGlobalDataLoader\" style=\"margin-left: 47%;margin-top: 17%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n    </div>\n\n  </div>\n\n\n  <div class=\"payment-modal\" ng-show=\"vm.displayPaymentModal\">\n    <div id=\"confirmModal\" class=\"modal\">\n      <div class=\"modal-content\" ng-show=\"vm.displayModalContent\">\n        <div class=\"modal-wrapper\">\n          <div class=\"modal-header\"><h1>Please Confirm Your Payment</h1></div>\n          <div class=\"payment-details\">\n            <table class=\"confirm-table\">\n              <tbody>\n                <tr class=\"payment-border\">\n                  <td class=\"payment-title\">Payment Method</td>\n                  <td class=\"payment-value\">{{vm.paymentMethodUsed}}</td>\n                </tr>\n                <tr>\n                  <td class=\"payment-title\">Payment Amount</td>\n                  <td class=\"payment-value\">{{vm.bpGlobalInfo.amountDue | currency}}</td>\n                </tr>\n              </tbody>\n            </table>\n            <div class=\"btn-group\">\n              <button id=\"cancel-btn\" class=\"cancel-payment-btn\" ng-click=\"vm.cancel()\">Cancel</button>\n              <button id=\"confirm-btn\" class=\"confirm-payment-btn\" ng-click=\"vm.confirm(vm.paymentMethodUsed, vm.bpGlobalInfo.amountDue)\">Confirm</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"vm.loading\" style=\"margin-left: 45%;margin-top: 25%;\">\n          <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"alert-modal\" ng-show=\"vm.displayAlertModal\">\n    <div id=\"alertModal\" class=\"modal\">\n      <div class=\"modal-content\">\n        <div class=\"modal-wrapper\">\n          <div class=\"modal-header\"><h1>Payment Error</h1></div>\n\n          <div class=\"payment-details\">\n\n            <div class=\"alert-msg-one\">\n              <div class=\"errorMsgAlertBox\">\n                <div class=\"errorSym\">\n                  <span class=\"fa-stack fa-lg errorMsg\"></span>\n                </div>\n                <div class=\"errorMsgOne\">\n                  <span>{{vm.alertMsgOne}}</span>\n                </div>\n              </div>\n\n              <div class=\"errorMsgAlertBox\">\n                <div class=\"errorMsgTwo\" ng-if=\"!vm.isRoutingOne && !vm.isTechFailureAlert && !vm.isValidDecline && !vm.isInvalidCC && !vm.isInvalidCCExDate\">\n                  <span>You can also make a payment by signing into your account at: </span><span class=\"linkText\">optimum.net/pay-bill</span>\n                </div>\n                <div class=\"errorMsgTwo\" ng-if=\"vm.isRoutingOne\">\n                  <span>Please visit <span class=\"linkText\">optimum.net/pay-bill</span> to update your preferred payment method and/or to make a payment.</span>\n                </div>\n                <div class=\"errorMsgTwo\" ng-if=\"vm.isTechFailureAlert\">\n                  <span>You can also make a payment at: </span><span class=\"linkText\">optimum.net/pay-bill</span>\n                </div>\n                <div class=\"errorMsgTwo\" ng-if=\"vm.isValidDecline || vm.isInvalidCC || vm.isInvalidCCExDate\">\n                  <span>Go to <span class=\"linkText\">optimum.net/pay-bill</span> to manage your payment method or make a payment.</span>\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"btn-alert\">\n              <button id=\"alert-confirm-btn\" class=\"confirm-payment-btn\" ng-click=\"vm.alertDone()\">Ok</button>\n            </div>\n          </div>\n\n        </div>\n      </div>\n      <div ng-show=\"vm.loading\" style=\"margin-left: 45%;margin-top: 25%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var ViewpaybillController = (function () {
	  function ViewpaybillController($timeout, $scope, navigationManager, mockService, authService, billingService, $filter, storage, $state, $rootScope, $interval, $window, analyticsService) {
	    var _this = this;
	
	    _classCallCheck(this, ViewpaybillController);
	
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	    this.name = 'View & Pay My Bill';
	
	    var now = new Date();
	    this.currentDay = $filter('date')(now, 'EEE');
	    this.currentDate = $filter('date')(now, 'MM');
	    this.currentMonth = $filter('date')(now, 'dd');
	
	    this.currunttime = this._getTime();
	    this.msgString = "This is your total amount due. This includes all activity processed up to " + this.currunttime + ", today.";
	    this.paymentSuccessString = "This is the most current information available to both our systems and customer service agents. It includes all credits and payments processed up through " + this.currunttime + ", today.";
	    this.lastPaymentDate = '';
	    this.paymentAlertMsg = 'ERROR!';
	
	    this.$scope = $scope;
	
	    this.paymentMethodUsed = '';
	
	    this.amountTestDue = 0;
	    this.paymentMethodList = [];
	    this.items = [];
	    this.bpGlobalInfo = null;
	    this.currentPaymentMethod = '';
	    this.amountDueDate = '';
	
	    /*************************************************************************/
	    /*   The below block is to set the flags on the basis of bpglobal call    */
	    /*************************************************************************/
	
	    this.displayPaymentModal = false;
	    this.showAlert = false;
	    this.loading = false;
	    this.paymentDue = false;
	    this.noPaymentDue = false;
	    this.creditBalance = false;
	    this.noPaymentDuewithAccBalance = false;
	    this.successPay = false;
	    this.errorPay = false;
	    this.isPastDue = false;
	    this.isPreDAuthOne = false;
	    this.isPreDAuthTwo = false;
	    this.defaultExpiredPaymentText = false;
	    this.deAuthInfo = null;
	    this.currentAccount = null;
	    this.isBlockedCustomer = false;
	    /* */
	    this.displayModalContent = true;
	    this.bpGlobalDataLoader = true;
	
	    //this is for alert box
	    this.displayAlertModal = false;
	    this.alertMsgTwo = '';
	    this.alertMsgOne = '';
	    this.alertMsgTitle = '';
	    this.isTechFailureAlert = false;
	    this.isRoutingOne = false;
	    this.isValidDecline = false;
	    this.isInvalidCC = false;
	    this.isInvalidCCExDate = false;
	    this.onlyOnePaymentMethodAfterError = false;
	    this.multiVersionDeauth = false;
	
	    //scheduling
	    this.schedulePayment = null;
	
	    //bpglobal with or without optimumid
	    this.hasOptimumId = false;
	
	    // omniture on view pay bill
	    $scope.linkURL = null;
	    $scope.event = null;
	    $scope.channelName = 'my bill';
	    $scope.pageName = null;
	    $scope.linkName = null;
	    $scope.omnitureBillingStatus = this.$rootScope.omnitureBillingStatus;
	    $scope.omniturePaperlessbill = this.$rootScope.omniturePaperlessbill;
	    $scope.omnitureErrorMsg = null;
	    this.popup = true;
	
	    this.$onInit = function () {
	      this.totalPaymentMethod = this.$rootScope.totalPaymentMethod;
	    };
	
	    this.$onDestroy = function () {
	      this.$rootScope.totalPaymentMethod = this.totalPaymentMethod;
	    };
	
	    $scope.$watch('[pageName, event]', function (newValue, oldValue) {
	      console.log('!! omniture watch variables from view pay bill, event : ' + $scope.event + ' pageName : ' + $scope.pageName + ' linkName : ' + $scope.linkName + ' error message : ' + $scope.omnitureErrorMsg);
	      if ($scope.pageName) {
	        console.log('inside if viewpaybill watch variables');
	        analyticsService.sendReport('my bill', $scope.pageName, $scope.event, $scope.omnitureErrorMsg, null, null, $scope.linkName, $scope.linkURL, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill);
	        $scope.linkName = null;
	        $scope.linkURL = null;
	        $scope.omnitureErrorMsg = null;
	      }
	    });
	
	    this.keyWatch = function (event) {
	      window.addEventListener('keydown', _this.keydown, false);
	    };
	
	    this.keydown = function (event) {
	      event.stopPropagation();
	      if (!_this.displayAlertModal && !_this.displayPaymentModal) {
	        if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	          window.removeEventListener('keydown', _this.keydown);
	          _this.$state.go('home.landingpage');
	        }
	      } else {
	        console.log("Back button should not work");
	      }
	    };
	
	    billingService.getBpGlobalData().then(function (res) {
	      if (res && res.data && res.data.status && res.data.status.statusCode === "00000") {
	        console.log("view bpGlobalInfo: ", res.data);
	        _this.bpGlobalInfo = res.data;
	        _this.amountTestDue = res.data.amountDue;
	
	        if (_this.bpGlobalInfo.dueDate !== null) {
	          var myDate = _this.bpGlobalInfo.dueDate;
	          var parts = myDate.split('/');
	          myDate = parts[0] + '/' + parts[1];
	          _this.amountDueDate = myDate;
	        }
	
	        if (_this.bpGlobalInfo.recentPayDate !== null) {
	          var recentDate = _this.bpGlobalInfo.recentPayDate;
	          var parts1 = recentDate.split('/');
	          recentDate = parts1[0] + '/' + parts1[1];
	          _this.recentPaymentDate = recentDate;
	        }
	
	        // checking amount due in different phases
	        if (_this.bpGlobalInfo.currentBalance < 0) {
	          _this.creditBalance = true;
	          _this.creditAmount = _this.bpGlobalInfo.currentBalance * -1;
	          //this block is just to check for schedule payment
	          billingService.getCurrectAcc().then(function (resp) {
	            if (resp) {
	              _this.currentAccount = resp;
	              //code for schedule payment
	              var autoPay = _this.createScheduledPayData(resp.scheduledAutoDate, resp.scheduledAutoAmount);
	              var oTPay = _this.createScheduledPayData(resp.scheduledOTDate, resp.scheduledOTAmount);
	              var scheduleTrue = _this.getScheduledPay(autoPay, oTPay);
	              if (scheduleTrue) {
	                _this.schedulePayment = 'Your next payment is scheduled on ' + scheduleTrue.getFormattedDate() + ' for ' + $filter('currency')(scheduleTrue.amount, '$', 2);
	              }
	              //end schedule payment
	            }
	          }).then(function () {
	            _this.bpGlobalDataLoader = false;
	          });
	          //end of schedule payment block
	        } else if (_this.bpGlobalInfo.amountDue <= 0) {
	
	            if (_this.bpGlobalInfo.currentBalance > 0) {
	              _this.noPaymentDuewithAccBalance = true;
	            } else {
	              _this.noPaymentDue = true;
	            }
	
	            //omniture when pay my bill loaded with no payment due
	            console.log('!!omniture when pay my bill loaded with no payment due');
	            analyticsService.sendReport($scope.channelName, 'view & pay my bill', 'event1, event3', null, null, null, null, null, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, _this.$rootScope.analytics.omniturePath + '/viewpaybill');
	            //this block is just to check for schedule payment
	            billingService.getCurrectAcc().then(function (resp) {
	              if (resp) {
	                _this.currentAccount = resp;
	                //code for schedule payment
	                var autoPay = _this.createScheduledPayData(resp.scheduledAutoDate, resp.scheduledAutoAmount);
	                var oTPay = _this.createScheduledPayData(resp.scheduledOTDate, resp.scheduledOTAmount);
	                var scheduleTrue = _this.getScheduledPay(autoPay, oTPay);
	                if (scheduleTrue) {
	                  _this.schedulePayment = 'Your next payment is scheduled on ' + scheduleTrue.getFormattedDate() + ' for ' + $filter('currency')(scheduleTrue.amount, '$', 2);
	                }
	                //end schedule payment
	              }
	            }).then(function () {
	              _this.bpGlobalDataLoader = false;
	            });
	            //end of schedule payment block
	          } else if (_this.bpGlobalInfo.amountDue > 0) {
	
	              //verifying from where bp global coming
	              if (storage.getItem('session', 'hasOptimumId')) {
	                _this.hasOptimumId = true;
	              } else {
	                //!!omniture no id associated
	                $scope.event = 'event1, event3, event10';
	                $scope.pageName = 'view & pay my bill';
	                $scope.omnitureErrorMsg = 'no associated id';
	                console.log('!!omniture no id associated : ' + $scope.event + ' Error msg : ' + $scope.omnitureErrorMsg);
	              }
	
	              // first we will get list of cards by getCurracc
	              billingService.getCurrectAcc().then(function (resp) {
	                console.log("resp:", resp);
	                if (resp && resp.paymentMethods) {
	
	                  if (resp.paymentMethods.length === 0 || _this.totalPaymentMethod === 0) {
	                    //!!omniture no payment method
	                    $scope.event = 'event1, event3, event10';
	                    $scope.pageName = 'view & pay my bill';
	                    $scope.omnitureErrorMsg = 'no payment method';
	                    console.log('!!omniture no payment method : ' + $scope.event + ' Error msg : ' + $scope.omnitureErrorMsg);
	                  } else if (_this.hasOptimumId = true && resp.paymentMethods.length !== 0) {
	                    //omniture when pay my bill loaded with optimum id and payment method
	                    console.log('!!omniture when pay my bill loaded with optimum id and payment method');
	                    analyticsService.sendReport($scope.channelName, 'view & pay my bill', 'event1, event3', null, null, null, null, null, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, _this.$rootScope.analytics.omniturePath + '/viewpaybill');
	                  }
	
	                  _this.totalPaymentMethod = resp.paymentMethods.length;
	                  _this.currentAccount = resp;
	                  var tempItems = _lodash2['default'].map(resp.paymentMethods, 'payMethodName');
	                  for (var i in tempItems) {
	                    var testString = 'Pay ' + $filter('currency')(_this.amountTestDue, '$', 2) + ' with ' + tempItems[i];
	                    var testObj = {
	                      'title': testString,
	                      'payment_method': tempItems[i],
	                      'amount_due': _this.amountTestDue
	                    };
	                    _this.paymentMethodList.push(testObj);
	                  }
	                  if (storage.getItem('session', 'paymentMethods')) {
	                    _this.items = storage.getItem('session', 'paymentMethods');
	                  } else {
	                    _this.items = _this.paymentMethodList;
	                    storage.setItem('session', 'paymentMethods', _this.items);
	                  }
	                  //code for schedule payment
	                  var autoPay = _this.createScheduledPayData(resp.scheduledAutoDate, resp.scheduledAutoAmount);
	                  var oTPay = _this.createScheduledPayData(resp.scheduledOTDate, resp.scheduledOTAmount);
	                  var scheduleTrue = _this.getScheduledPay(autoPay, oTPay);
	                  if (scheduleTrue) {
	                    _this.schedulePayment = 'Your next payment is scheduled on ' + scheduleTrue.getFormattedDate() + ' for ' + $filter('currency')(scheduleTrue.amount, '$', 2);
	                  }
	                  //end schedule payment
	                } else {
	                    _this.items = [];
	                  }
	              }).then(function () {
	                //blocked customer
	                // this is for test blocked one if(true){
	                if (_this.currentAccount && _this.currentAccount.manualBlockInd === "true") {
	                  //!!omniture payment blocker
	                  $scope.event = 'event1, event3, event10';
	                  console.log('!!omniture payment blocker : ' + $scope.event);
	                  _this.errorPay = true;
	                  _this.successPay = false;
	                  // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
	                  document.getElementById('msgAlertBoxId').classList.add('styleAlert');
	                  _this.items = [];
	                  _this.isBlockedCustomer = true;
	                  _this.paymentAlertMsg = "Please visit your nearest Optimum store to make a cash-only payment on your account.";
	                  //this is for format amount box if it is in amount
	                  if (_this.bpGlobalInfo.billPayCache && (_this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && _this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0 || _this.bpGlobalInfo.pastDueAmount > 0)) {
	                    _this.multiVersionDeauth = true;
	                  }
	                  _this.paymentDue = true;
	                  _this.bpGlobalDataLoader = false;
	                }
	                //default card is expired
	                else if (_this.currentAccount && _this.currentAccount.defaultPaymentExpired) {
	                    _this.errorPay = true;
	                    _this.successPay = false;
	                    // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
	                    document.getElementById('msgAlertBoxId').classList.add('styleAlert');
	                    /*document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';
	                    document.getElementById('msgAlertBoxId').style.marginTop = '3.4vh';*/
	                    if (_this.items.length > 0) {
	                      //!!omniture payment method expired
	                      if (_this.totalPaymentMethod > 1) {
	                        $scope.event = 'event1, event3';
	                        _this.totalPaymentMethod--;
	                      } else {
	                        $scope.event = 'event1, event3, event10';
	                        _this.totalPaymentMethod--;
	                      }
	                      console.log('!!omniture payment method expired : ' + $scope.event);
	                      _this.paymentAlertMsg = _this.currentAccount.defaultPaymentName + ' has expired. Please select another payment method to continue.';
	                    } else {
	                      _this.paymentAlertMsg = _this.currentAccount.defaultPaymentName + ' has expired.';
	                      _this.defaultExpiredPaymentText = true;
	                    }
	                    //this is for format amount box if it is in amount
	                    if (_this.bpGlobalInfo.billPayCache && (_this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && _this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0 || _this.bpGlobalInfo.pastDueAmount > 0)) {
	                      _this.multiVersionDeauth = true;
	                    }
	                    _this.paymentDue = true;
	                    _this.bpGlobalDataLoader = false;
	                  }
	                  //this block plays pre-de auth one or two
	                  else if (_this.bpGlobalInfo.billPayCache && _this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && _this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0) {
	                      _this.deAuthInfo = billingService.deauthInfo(_this.bpGlobalInfo.billPayCache);
	                      //here we know we have deauth so now determining one or two so set text for alert and other msg.
	                      _this.errorPay = true;
	                      _this.successPay = false;
	                      //document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';
	                      // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
	                      document.getElementById('msgAlertBoxId').classList.add('styleAlert');
	                      _this.msgString = 'Pay now or go to optimum.net/pay-bill to pay your bill.';
	                      if (_this.deAuthInfo.isDeauthTwo) {
	                        _this.isPreDAuthTwo = true;
	                        _this.paymentAlertMsg = 'Your account is past due. Make a payment now to avoid service interruptions.';
	                      } else if (_this.deAuthInfo.isDeauthOne) {
	                        _this.isPreDAuthOne = true;
	                        _this.paymentAlertMsg = 'Your account is past due.  Please make a payment by ' + _this.deAuthInfo.startDate + ' to avoid late fees or service interruptions.';
	                      }
	                      _this.bpGlobalDataLoader = false;
	                    }
	                    ///this block plays pastdue stuff
	                    else if (_this.bpGlobalInfo.pastDueAmount > 0) {
	                        _this.errorPay = true;
	                        _this.successPay = false;
	                        _this.paymentAlertMsg = 'Your account is past due. Please make a payment to avoid late fees or service interruptions.';
	                        //document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';
	                        // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
	                        document.getElementById('msgAlertBoxId').classList.add('styleAlert');
	                        _this.msgString = 'Pay now or go to optimum.net/pay-bill to pay your bill.';
	                        _this.isPastDue = true;
	                        _this.bpGlobalDataLoader = false;
	                      }
	                      //if nothings remain and only amount due
	                      else {
	                          _this.paymentDue = true;
	                          _this.bpGlobalDataLoader = false;
	                        }
	
	                //focus the carousel
	                if (_this.items.length > 0) {
	                  _this.focusItem('btn-scrolling-list');
	                }
	              });
	            }
	      } else {
	        _this.$state.go('home.landingpage');
	      }
	    }, function () {
	      console.log('Something wrong with all call and bpglobal fail.');
	    });
	
	    /*************************************************************************/
	    /*   The below block is to set the flagson the basis of bpglobal call    */
	    /*************************************************************************/
	
	    navigationManager.registerViewComponent(this, $scope, 'home.viewpaybill');
	    navigationManager.registerNavigate('confirm-btn', 'down');
	    navigationManager.registerNavigate('confirm-btn', 'left', 'cancel-btn');
	    navigationManager.registerNavigate('confirm-btn', 'up');
	    navigationManager.registerNavigate('confirm-btn', 'right');
	    navigationManager.registerNavigate('cancel-btn', 'down');
	    navigationManager.registerNavigate('cancel-btn', 'right', 'confirm-btn');
	    navigationManager.registerNavigate('cancel-btn', 'up');
	    navigationManager.registerNavigate('cancel-btn', 'left');
	
	    this.paymentModalHandler = function (item) {
	      if (_this.popup) {
	        $scope.pageName = 'review';
	        $scope.event = 'event1, event4';
	        console.log('!!omniture mybill review : ' + $scope.event);
	      }
	      _this.displayPaymentModal = true;
	      _this.displayModalContent = true;
	      console.log("item:", item);
	      _this.paymentMethodUsed = item.payment_method;
	      setTimeout(function () {
	        document.getElementById('confirm-btn').focus();
	      }, 100);
	    };
	
	    this.cancel = function (_) {
	      //!!omniture mybill review cancel
	      _this.popup = false;
	      $scope.event = null;
	      $scope.linkName = 'cancel';
	      $scope.linkURL = _this.$rootScope.analytics.omniturePath + '/viewpaybill';
	      $scope.pageName = 'review';
	      console.log('!!omniture mybill review, cancel : ' + $scope.event + ' , link Name : ' + $scope.linkName);
	      _this.displayPaymentModal = false;
	      _this.focusItem('btn-scrolling-list');
	    };
	
	    this.confirm = function (pmName, amtDue) {
	      //!!omniture mybill review confirm TODO: only tag once per flow
	      _this.popup = false;
	      $scope.event = 'event5';
	      $scope.linkName = 'confirm';
	      $scope.linkURL = _this.$rootScope.analytics.omniturePath + '/viewpaybill';
	      $scope.pageName = 'review';
	      console.log('!!omniture mybill review, confirm : ' + $scope.event + ' , link Name : ' + $scope.linkName);
	      _this.displayModalContent = false;
	      _this.loading = true;
	
	      // The api here is being called just to mock the submit response
	      billingService.submitotpayment(pmName, amtDue).then(function (res) {
	        console.log(res.data.confirmNumber);
	        if (res.data !== null) {
	          if (res.data.confirmNumber) {
	            billingService.getBpGlobalData().then(function (res) {
	              if (res && res.data && res.data.status && res.data.status.statusCode === "00000") {
	                console.log("view bpGlobalInfo: ", res.data);
	                _this.bpGlobalInfo = res.data;
	                console.log("bpGlobalInfo.hasRecentPayment", _this.bpGlobalInfo.hasRecentPayment);
	                _this.amountTestDue = res.data.amountDue;
	
	                if (_this.bpGlobalInfo.recentPayDate !== null) {
	                  var recentDate = _this.bpGlobalInfo.recentPayDate;
	                  var parts1 = recentDate.split('/');
	                  recentDate = parts1[0] + '/' + parts1[1];
	                  _this.recentPaymentDate = recentDate;
	                }
	
	                if (_this.bpGlobalInfo.amountDue === 0 && _this.bpGlobalInfo.currentBalance > 0) {
	                  _this.noPaymentDuewithAccBalance = true;
	                  //omniture when pay my bill loaded with no payment due
	                  console.log('!!omniture when pay my bill loaded with no payment due');
	                  analyticsService.sendReport($scope.channelName, 'view & pay my bill', 'event1, event3', null, null, null, null, null, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, _this.$rootScope.analytics.omniturePath + '/viewpaybill');
	                  _this.items = [];
	                } else if (_this.bpGlobalInfo.amountDue <= 0 && _this.bpGlobalInfo.currentBalance === 0) {
	                  _this.showAlert = true;
	                  _this.items = [];
	                }
	
	                _this.displayPaymentModal = mockService.getFalsevalue();
	                _this.loading = mockService.getFalsevalue();
	                //false all the state after successful payment
	                _this.isPastDue = false;
	                _this.isPreDAuthOne = false;
	                _this.isPreDAuthTwo = false;
	                _this.paymentDue = false;
	                //this.showAlert = mockService.getTruevalue();
	                _this.errorPay = false;
	                _this.successPay = true;
	                //omniture order success
	                $scope.event = 'event6';
	                $scope.pageName = 'order success';
	                _this.$rootScope.omnitureBillingStatus = 'cur';
	                $scope.omnitureBillingStatus = 'cur';
	                console.log('!! omniture BillingStatus : ' + _this.$rootScope.omnitureBillingStatus);
	                console.log('!!omniture order success event aaray is : ' + $scope.event);
	                //document.getElementById('msgAlertBoxId').style.marginBottom = '3.3vh';
	                // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
	                document.getElementById('msgAlertBoxId').classList.add('styleAlert');
	              } else {
	                _this.$state.go('home.landingpage');
	              }
	            });
	          } else {
	            // first clean model and it's data
	            _this.displayPaymentModal = false;
	            _this.loading = false;
	
	            //error list
	            var VALID_DECLINE = ["Do Not Honor", "Processor Decline", "Credit Floor", "Excessive PIN try", "Exceeded payment limit", "Insufficient fund", "Lost/Stolen", "Pickup", "Restraint", "Invalid Field Data", "Call", "Suspected Fraud", "Over the limit", "Over Limit Frequency", "No Account", "Revocation of Authorization"];
	            var INVALID_CC = ["Invalid CC Number", "Invalid Credit Card Number", "Invalid Transaction Type", "Invalid Institution Code", "Invalid Card Holders Name", "Invalid Card Holder", "Invalid Encryption Format", "Invalid Merchant", "Payment Type Not Supported by Merchant"];
	            var INVALID_EXPIRY_DATE = ["Invalid Expiry Date"];
	            var INVALID_BA = ["xml tag eftt_bacct should be numeric", "Numeric value out of range for xml tag eftt_bacct", "Input length error for xml tag eftt_bacct"];
	            var INVALID_ROUTING_NUMBER = ["Invalid Bank or Finbr", "xml tag eftt_bank is required"];
	            var TECHNICAL_FAILURE = ["Message Timed-out at Host", "Error : Send_Terminal_Request", "Issuer unavailable", "Violation: cannot complete", "No Answer", "Batch XXXX not open for operator", "Batch XXXX already open", "Invalid Amount", "Bad Amount", "Other Error", "Process Unavailable", "Error : Conf M_P_A_OK"];
	            //end of error list
	            if (res.data.responseInfo && res.data.responseInfo.statusCode) {
	              var errorStatusCode = res.data.responseInfo.statusCode;
	              console.log("errorStatusCode:", errorStatusCode);
	            }
	
	            if (VALID_DECLINE.indexOf(errorStatusCode) != -1) {
	              //!!omniture order failed valid decline
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Valid Decline';
	              console.log('!!omniture order failed, valid decline event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              _this.isValidDecline = true;
	              if (_this.items.length === 1) {
	                _this.alertMsgOne = 'The payment method for your account was declined.';
	              } else {
	                _this.alertMsgOne = 'The payment method for your account was declined. Please select another payment method to continue.';
	              }
	              _this.displayAlertModal = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            } else if (INVALID_CC.indexOf(errorStatusCode) != -1) {
	              //!!omniture order failed invalid CC
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Invalid CC#';
	              console.log('!!omniture order failed, invalid CC event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              _this.isInvalidCC = true;
	              if (_this.items.length === 1) {
	                _this.alertMsgOne = 'The payment method for your account  is invalid.';
	              } else {
	                _this.alertMsgOne = 'The payment method for your account is invalid. Please select another payment method to continue.';
	              }
	              _this.displayAlertModal = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            } else if (INVALID_EXPIRY_DATE.indexOf(errorStatusCode) != -1) {
	              //!!omniture order failed invalid Expiry date
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Invalid Expiry Date';
	              console.log('!!omniture order failed, invalid Expiry date event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              _this.isInvalidCCExDate = true;
	              if (_this.items.length === 1) {
	                _this.alertMsgOne = 'The payment method for your account  is invalid.';
	              } else {
	                _this.alertMsgOne = 'The payment method for your account is invalid. Please select another payment method to continue.';
	              }
	              _this.displayAlertModal = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            } else if (INVALID_BA.indexOf(errorStatusCode) != -1) {
	              //!!omniture order failed invalid Bank Account Number
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Invalid Bank account number';
	              console.log('!!omniture order failed, invalid Bank Account number event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              if (_this.items.length === 1) {
	                _this.alertMsgOne = 'The account number you specified is invalid.';
	              } else {
	                _this.alertMsgOne = 'The account number you specified is invalid. Please select another payment method to continue.';
	              }
	              _this.displayAlertModal = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            } else if (INVALID_ROUTING_NUMBER.indexOf(errorStatusCode) != -1) {
	              //!!omniture order failed, invalid Routing Number
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Invalid Routing number';
	              console.log('!!omniture order failed, invalid Routing Number event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              if (_this.items.length === 1) {
	                _this.isRoutingOne = true;
	                _this.alertMsgOne = 'The routing number you specified is invalid.';
	              } else {
	                _this.alertMsgOne = 'The routing number you specified is invalid. Please select another payment method to continue.';
	              }
	              _this.displayAlertModal = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            } else if (TECHNICAL_FAILURE.indexOf(errorStatusCode) != -1) {
	              //!!omniture order failed Technical Failure
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Technical Failure';
	              console.log('!!omniture order failed, Technical Failure event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              _this.alertMsgOne = 'Sorry, it looks like there is a problem processing your payment right now. Please try again later.';
	              _this.displayAlertModal = true;
	              _this.isTechFailureAlert = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            } else {
	              if (_this.totalPaymentMethod > 1) {
	                $scope.event = 'event11';
	                _this.totalPaymentMethod--;
	              } else {
	                $scope.event = 'event11, event10';
	                _this.totalPaymentMethod--;
	              }
	              $scope.pageName = 'order failed';
	              $scope.omnitureErrorMsg = 'Technical Failure';
	              console.log('!!omniture order failed, Technical Failure event is : ' + $scope.event);
	              _this.bpGlobalDataLoader = false;
	              _this.alertMsgOne = 'Sorry, it looks like there is a problem processing your payment right now. Please try again later.';
	              _this.displayAlertModal = true;
	              _this.isTechFailureAlert = true;
	              setTimeout(function () {
	                document.getElementById('alert-confirm-btn').focus();
	              }, 100);
	            }
	          }
	        }
	      });
	    };
	
	    this.alertDone = function () {
	      if (!_this.isTechFailureAlert) {
	        _this.bpGlobalDataLoader = true;
	        var newPaymentMethodList = [];
	        var allpaymentMethods = storage.getItem('session', 'paymentMethods');
	        allpaymentMethods.forEach(function (method) {
	          if (method.payment_method != _this.paymentMethodUsed) {
	            newPaymentMethodList.push(method);
	          }
	        });
	        storage.setItem('session', 'paymentMethods', newPaymentMethodList);
	        _this.items = storage.getItem('session', 'paymentMethods');
	      }
	      _this.displayAlertModal = false;
	      _this.bpGlobalDataLoader = false;
	      _this.isValidDecline = false;
	      _this.isInvalidCC = false;
	      _this.isInvalidCCExDate = false;
	      _this.isRoutingOne = false;
	      _this.isTechFailureAlert = false;
	      if (_this.items.length > 0) {
	        _this.focusItem('btn-scrolling-list');
	      } else if (_this.items.length === 0) {
	        _this.onlyOnePaymentMethodAfterError = true;
	
	        /* ****************************************************************************************************************/
	        /*This should be added in case we need to restrict the alert to not show the user to select another payment method
	        /* ****************************************************************************************************************/
	        if (_this.currentAccount.defaultPaymentExpired) {
	          //!!omniture payment method expired
	          if (_this.totalPaymentMethod > 1) {
	            $scope.event = 'event1, event3';
	            _this.totalPaymentMethod--;
	          } else {
	            $scope.event = 'event1, event3, event10';
	            _this.totalPaymentMethod--;
	          }
	          $scope.pageName = 'view & pay my bill';
	          $scope.omnitureErrorMsg = 'payment method expired';
	          console.log('!!omniture payment method expired : ' + $scope.event + ' Error msg : ' + $scope.omnitureErrorMsg);
	
	          _this.paymentAlertMsg = _this.currentAccount.defaultPaymentName + ' has expired.';
	        }
	      }
	    };
	  }
	
	  _createClass(ViewpaybillController, [{
	    key: 'focusItem',
	    value: function focusItem(id) {
	      var el = document.getElementById(id);
	      if (el) {
	        console.log('got it', el);
	        el.focus();
	      } else {
	        console.log('I am here in non-focus state.');
	        this.$timeout(this.focusItem.bind(this, id));
	      }
	    }
	  }, {
	    key: '_getTime',
	    value: function _getTime() {
	      var date = date = new Date();
	      var hours = date.getHours();
	      var minutes = date.getMinutes();
	      var ampm = hours >= 12 ? 'pm' : 'am';
	      hours = hours % 12;
	      hours = hours ? hours : 12;
	      minutes = minutes < 10 ? '0' + minutes : minutes;
	      var strTime = hours + ':' + minutes + ' ' + ampm;
	      return strTime;
	    }
	  }, {
	    key: 'createScheduledPayData',
	    value: function createScheduledPayData(date, amount) {
	      var time = date != null ? new Date(date).getTime() : null;
	      return {
	        date: date,
	        amount: amount,
	        isScheduled: function isScheduled() {
	          return this.date != null && this.amount != null;
	        },
	        time: time,
	        getFormattedDate: function getFormattedDate() {
	          if (time != null) {
	            var date = new Date(time);
	            var month = date.getMonth() + 1;
	            return (month < 10 ? "0" : "") + month + "/" + date.getDate();
	          }
	        }
	      };
	    }
	  }, {
	    key: 'getScheduledPay',
	    value: function getScheduledPay(autoPay, oTPay) {
	      var result = null;
	      if (autoPay.isScheduled() && !oTPay.isScheduled()) {
	        result = autoPay;
	      } else if (!autoPay.isScheduled() && oTPay.isScheduled()) {
	        result = oTPay;
	      } else if (autoPay.isScheduled() && oTPay.isScheduled()) {
	        result = autoPay.time > oTPay.time ? oTPay : autoPay.time < oTPay.time ? autoPay : autoPay.amount > oTPay.amount ? autoPay : oTPay;
	      }
	      return result;
	    }
	  }]);
	
	  return ViewpaybillController;
	})();
	
	ViewpaybillController.$inject = ['$timeout', '$scope', 'navigationManager', 'mockService', 'authService', 'billingService', '$filter', 'storage', '$state', '$rootScope', '$interval', '$window', 'analyticsService'];
	
	exports['default'] = ViewpaybillController;
	module.exports = exports['default'];

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(52);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./viewpaybill.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./viewpaybill.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".menu-name{position:absolute;top:6.45vh;left:17.7vw;font-style:normal;font-size:1.72vw;line-height:1}.menu-name .myAccount{color:#afb6b8;line-height:1;font-size:2.03vw}.date-section{position:absolute;margin-top:-14.82vh;margin-left:88.7vw;font-style:normal;font-weight:700;text-align:end;font-family:Open Sans Bold}.date-section .current-time{text-transform:lowercase}.date-section .current-time span{font-size:1.72vw;margin-right:.25vw}.date-section .current-date,.date-section .current-time sup{font-size:1.1vw}.msgAlertBox{font-size:1.72vw;text-align:left;min-height:1px;margin:0 9.2vw 6.63vh 8.97vw}.styleAlert{margin-top:3.4vh;margin-bottom:4.17vh}.viewpaymain{margin:0 9.2vw 0 8.97vw;background-color:rgba(0,0,0,.4);min-height:30.86vh;overflow:hidden}.viewpaymain .vpcontent-left{float:left;min-height:30.86vh;width:43.91vw}.viewpaymain .vpcontent-left .payinfo{overflow:hidden;padding:4vh 3.8vw 0 2.42vw}.viewpaymain .vpcontent-left .payinfo .tblamttext{width:100%;line-height:1.8;font-size:1.56vw;font-weight:700}.viewpaymain .vpcontent-left .payinfo .tbltdright{text-align:right}.viewpaymain .vpcontent-left .payinfoSchedule{overflow:hidden;padding:0 2.34vw 3vh 2.42vw;font-size:1.4vw}.viewpaymain .vpcontent-left .paymentbox{padding:2.8vh 2.34vw 4.2vh 2.42vw;overflow:hidden}.viewpaymain .vpcontent-left .paymentbox .amounduebox{background-color:#393a3a;padding:5.6vh 1.56vw 3.65vh 1.64vw;border-radius:5px 5px 0 0}.viewpaymain .vpcontent-left .paymentbox .amounduebox .textamountduebox{width:100%;font-size:2.5vw;font-weight:700;line-height:1.2}.viewpaymain .vpcontent-left .paymentbox .amounduebox #deorpastAmount,.viewpaymain .vpcontent-left .paymentbox .amounduebox #deorpastAmountDue,.viewpaymain .vpcontent-left .paymentbox .amounduebox .multiVersionDeauthandDue{color:#e22d02}.viewpaymain .vpcontent-left .paymentbox .amounduebox .dotdot{color:#fff}.viewpaymain .vpcontent-left .paymentbox .amounduebox .textamountdueboxright{text-align:right}.viewpaymain .vpcontent-left .paymentbox .amounduebox .textamtduedate{font-weight:400}.viewpaymain .vpcontent-left .paymentbox .amounduebox .date_due{color:#9ea6a8;font-weight:400;font-size:1.72vw}.viewpaymain .vpcontent-left .paymentbox .amounduebox .pastdueReplaceDate{color:#9ea6a8;font-weight:200;font-size:20px}.viewpaymain .vpcontent-left .paymentbox .amounduebox .amountdue{display:table-cell;white-space:nowrap;line-height:1.4;padding-right:5px}.viewpaymain .vpcontent-left .paymentbox .amounduebox .price{display:table-cell;text-align:right;white-space:nowrap;padding-left:5px}.viewpaymain .vpcontent-left .paymentbox .amounduebox .creditBal{white-space:nowrap}.viewpaymain .vpcontent-left .paymentbox .paymethodbox{min-height:6.4vh;overflow:hidden}.viewpaymain .vpcontent-left .paymentbox .paymethodbox .noPaymentMethod{font-size:1.72vw;font-weight:700;background-color:#757575;padding:1.4vh 1.56vw;color:#f1f1f1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important}.viewpaymain .vpcontent-left .paymentbox .paymethodbox .blockedUser{font-size:1.4vw;font-weight:500}.viewpaymain .vpcontent-left .paymentbox .paymethodbox .noPaymentDue{font-size:1.72vw;background-color:#757575;padding:1.4vh 1.56vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important;text-align:center}.viewpaymain .vpcontent-right .msgwithdue{font-size:1.65vw;margin-top:17.15vh;margin-right:3.12vw}.viewpaymain .vpcontent-right .noDuePay{margin-top:16.15vh}.viewpaymain .vpcontent-right .msgwithsuccess{font-size:1.6vw;margin-top:11.25vh;margin-right:3.12vw}.viewpaymain .vpcontent-right .msgwithnoPaymentDue{font-size:1.6vw;margin-top:9vh;margin-right:3.12vw}.viewpaymain .vpcontent-right .msgwithnoSavedPayment{font-size:1.6vw;margin-top:4.4vh;margin-right:3.12vw;margin-bottom:-14vh}.viewpaymain .vpcontent-right .msgwithnoSavedPayment span{color:#f1f1f1}.clearfix{visibility:hidden;display:block;content:\" \";clear:both;height:0}.paymentDue-bottom-text{margin:2.75vh 9.2vw 0 8.97vw;font-size:1.405vw}.paymentDue-bottom-text .managePayText{padding-bottom:15px}.payAmount,.payReceived{float:left}.successAlertBox{display:table}.successAlertBox .successSym{display:table-cell}.successAlertBox .successSym .successMsg{background:url(" + __webpack_require__(53) + ") no-repeat 50%}.successAlertBox .successMsgDesc{font-size:1.72vw;display:table-cell;padding-left:15px;vertical-align:middle}.errorAlertBox{display:table}.errorAlertBox .errorSym{display:table-cell}.errorAlertBox .errorSym .errorMsg{background:url(" + __webpack_require__(44) + ") no-repeat 50%}.errorAlertBox .errorMsgDesc{font-size:1.72vw;display:table-cell;padding-left:15px;vertical-align:middle}.payment-modal{position:absolute;left:0;top:0;width:100%;height:100%;animation-duration:1s;animation-name:slidein}.payment-modal .modal{width:100%;height:100%;overflow:auto;padding:0;background-color:rgba(40,40,40,.78);margin:0}.payment-modal .modal .modal-content{width:46.5vw;background-color:#101010;height:50vh;color:gray;margin:16% 0 0 30%;padding:0;font-size:2.8vmin;animation:animatetop .7s}.payment-modal .modal .modal-content .modal-wrapper{margin-top:-3%}.payment-modal .modal .modal-content .modal-wrapper .modal-header{height:5%;display:block;text-align:left;color:#f1f1f1;font-size:2vmin;padding:28px;background-color:#3a3a3a;font-family:Open Sans Bold}.payment-modal .modal .modal-content .modal-wrapper .modal-header h1{margin:0;font-size:26px}.payment-modal .modal .modal-content .modal-wrapper .payment-details{display:block}.payment-modal .modal .modal-content .modal-wrapper .payment-details .confirm-table{margin:3.1vw 2.35vw 0 2.25vw;color:#fff}.payment-modal .modal .modal-content .modal-wrapper .payment-details .confirm-table .payment-title{background-color:#5d5d5d;padding:.8vw;width:15vw;font-weight:400;border-right:2px solid #091b20}.payment-modal .modal .modal-content .modal-wrapper .payment-details .confirm-table .payment-value{background-color:#5d5d5d;padding:.8vw;width:23.5vw;float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important;text-align:center}.payment-modal .modal .modal-content .modal-wrapper .payment-details .confirm-table .payment-border{border-bottom:2px solid #091b20}.payment-modal .modal .modal-content .modal-wrapper .btn-group{float:right;margin:2.25vw;font-family:Open Sans Bold}.payment-modal .modal .modal-content .modal-wrapper .btn-group .cancel-payment-btn{border-radius:2px;background-color:#5d5d5d;width:16vw;color:#aeb4b5;height:5.65vh;border:#3b494d;margin-right:5px;font-size:20px;font-weight:700}.payment-modal .modal .modal-content .modal-wrapper .btn-group .cancel-payment-btn:focus,.payment-modal .modal .modal-content .modal-wrapper .btn-group .cancel-payment-btn:hover{background-color:#f1f1f1;color:#000;border:none}.payment-modal .modal .modal-content .modal-wrapper .btn-group .confirm-payment-btn{border-radius:2px;background-color:#5d5d5d;width:16vw;color:#aeb4b5;height:5.65vh;font-size:20px;border:#007cb4;font-weight:700}.payment-modal .modal .modal-content .modal-wrapper .btn-group .confirm-payment-btn:focus,.payment-modal .modal .modal-content .modal-wrapper .btn-group .confirm-payment-btn:hover{background-color:#f1f1f1;color:#000;border:none}.alert-modal{position:absolute;left:0;top:0;width:100%;height:100%;animation-duration:1s;animation-name:slidein}.alert-modal .modal{width:100%;height:100%;overflow:auto;padding:0;background-color:rgba(40,40,40,.78);margin:0}.alert-modal .modal .modal-content{width:46.5vw;background-color:#3a3a3a;height:50vh;color:gray;margin:16% 0 0 30%;padding:0;font-size:2.75vmin;animation:animatetop .7s}.alert-modal .modal .modal-content .modal-wrapper{margin-top:-3%}.alert-modal .modal .modal-content .modal-wrapper .modal-header{height:5%;display:block;text-align:left;color:#f1f1f1;font-size:2vmin;padding:30px;background-color:#5d5d5d;font-family:Open Sans Bold}.alert-modal .modal .modal-content .modal-wrapper .modal-header h1{margin:0;font-size:26px}.alert-modal .modal .modal-content .modal-wrapper .payment-details{display:block}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one{margin:3.1vw 2.35vw 0 2.25vw;color:#f1f1f1}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox{display:table}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorSym{display:table-cell;padding-right:1.5vw}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorSym .errorMsg{background:url(" + __webpack_require__(44) + ") no-repeat 50%}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorMsgOne{display:table-cell;vertical-align:middle}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorMsgTwo{padding-left:5.07813vw;padding-top:2vh;color:#f1f1f1}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .errorMsgTwo .linkText{color:#f1f1f1;text-decoration:underline}.alert-modal .modal .modal-content .modal-wrapper .btn-alert{margin-top:1vw;margin-right:2.35vw;text-align:right;font-family:Open Sans Bold}.alert-modal .modal .modal-content .modal-wrapper .btn-alert .confirm-payment-btn{border-radius:2px;background-color:#5d5d5d;width:12vw;color:#fff;height:5.65vh;border:#f1f1f1;font-size:20px;font-weight:700}.alert-modal .modal .modal-content .modal-wrapper .btn-alert .confirm-payment-btn:focus,.alert-modal .modal .modal-content .modal-wrapper .btn-alert .confirm-payment-btn:hover{background-color:#f1f1f1;border:none}.amountInred{color:red}@keyframes slidein{0%{opacity:0}to{opacity:1}}", ""]);
	
	// exports


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _scrollingListComponent = __webpack_require__(55);
	
	var _scrollingListComponent2 = _interopRequireDefault(_scrollingListComponent);
	
	var scrollingListModule = _angular2['default'].module('scrollingList', [_angularUiRouter2['default']]).component('scrollingList', _scrollingListComponent2['default']);
	
	exports['default'] = scrollingListModule;
	module.exports = exports['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _scrollingListHtml = __webpack_require__(56);
	
	var _scrollingListHtml2 = _interopRequireDefault(_scrollingListHtml);
	
	var _scrollingListController = __webpack_require__(57);
	
	var _scrollingListController2 = _interopRequireDefault(_scrollingListController);
	
	__webpack_require__(58);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {
	    items: '<',
	    onSelect: '&'
	  },
	  template: _scrollingListHtml2['default'],
	  controller: _scrollingListController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = "<button class=\"scrolling-list\" id=\"btn-scrolling-list\" ng-keydown=\"vm.onKeyDown($event)\" ng-if=\"vm.items.length>0\">\n\n  <div class=\"left-arrow\" ng-if=\"vm.items.length>1\">\n      <i class=\"fa fa-lg fa-chevron-left\"></i>\n  </div>\n\n  <div class=\"itemText\">{{vm.rotationItems[1].title}}</div>\n\n  <div class=\"right-arrow\" ng-if=\"vm.items.length>1\">\n    <i class=\"fa fa-lg fa-chevron-right\"></i>\n  </div>\n  <div class=\"clearfix\"></div>\n\n</button>\n"

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ScrollingListController = (function () {
	  function ScrollingListController($scope, laboxRemote) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollingListController);
	
	    this.name = 'scrollingList';
	    $scope.$watch('vm.items', function () {
	      _this.position = 0;
	      _this.rotationItems = [];
	      _this.generateRotationMenu();
	    });
	
	    //----------------//
	    //-----Events-----//
	    //----------------//
	
	    this.onKeyDown = function (e) {
	      switch (true) {
	        case laboxRemote.isLeft(e):
	          // ARROW_LEFT
	          _this.navigateLeft(event);
	          _this.generateRotationMenu();
	          break;
	        case laboxRemote.isRight(e):
	          // ARROW_RIGHT
	          _this.navigateRight(event);
	          _this.generateRotationMenu();
	          break;
	        case laboxRemote.isEnter(e):
	          // ENTER/OK
	          _this.selectCurrent();
	          break;
	      }
	    };
	  }
	
	  _createClass(ScrollingListController, [{
	    key: 'generateRotationMenu',
	    value: function generateRotationMenu() {
	      if (!this.items) {
	        this.items = [];
	        this.rotationItems = [];
	        return;
	      }
	      var count = this.items.length;
	      var pos = this.position;
	      var previousPos = (count + (pos - 1)) % count;
	      var nextPos = (pos + 1) % count;
	      this.rotationItems = [this.items[previousPos], this.items[pos], this.items[nextPos]];
	    }
	  }, {
	    key: 'navigateLeft',
	    value: function navigateLeft(event) {
	      var count = this.items.length;
	      this.position = (count + (this.position - 1)) % count;
	      event.preventDefault();
	    }
	  }, {
	    key: 'navigateRight',
	    value: function navigateRight(event) {
	      var count = this.items.length;
	      this.position = (this.position + 1) % count;
	      event.preventDefault();
	    }
	  }, {
	    key: 'getCurrentItem',
	    value: function getCurrentItem() {
	      return this.items[this.position];
	    }
	  }, {
	    key: 'selectCurrent',
	    value: function selectCurrent() {
	      this.onSelect({
	        item: this.getCurrentItem()
	      });
	    }
	  }]);
	
	  return ScrollingListController;
	})();
	
	ScrollingListController.$inject = ['$scope', 'laboxRemote'];
	
	exports['default'] = ScrollingListController;
	module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(59);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scrollingList.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./scrollingList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".scrolling-list{width:100%;height:100%;font-size:1.72vw;font-weight:700;position:relative;background-color:#347fa2;padding:1.4vh 1.56vw;border:none}.scrolling-list:focus,.scrolling-list:hover{background-color:#007cb4;border:none}.scrolling-list .left-arrow{width:5%;float:left;text-align:left}.scrolling-list .itemText{width:90%;float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important;color:#f1f1f1;font-family:Open Sans Bold}.scrolling-list .right-arrow{width:5%;float:left;text-align:right}", ""]);
	
	// exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _subnavComponent = __webpack_require__(61);
	
	var _subnavComponent2 = _interopRequireDefault(_subnavComponent);
	
	var subnavModule = _angular2['default'].module('subnav', [_angularUiRouter2['default']]).component('subnav', _subnavComponent2['default']);
	
	exports['default'] = subnavModule;
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _subnavHtml = __webpack_require__(62);
	
	var _subnavHtml2 = _interopRequireDefault(_subnavHtml);
	
	var _subnavController = __webpack_require__(63);
	
	var _subnavController2 = _interopRequireDefault(_subnavController);
	
	__webpack_require__(64);
	
	var subnavComponent = {
	  restrict: 'E',
	  bindings: {
	    btnClass: '@',
	    items: '=',
	    title: '=',
	    itemClickHandler: '=',
	    nextComponentHandler: '=',
	    prevComponentHandler: '=',
	    listId: '@',
	    labelField: '@',
	    statevalue: '@'
	  },
	  template: _subnavHtml2['default'],
	  controller: _subnavController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = subnavComponent;
	module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"list\">\n  <div class=\"up-arrow\" ng-show=\"vm.startIndex &gt; 0\">\n    <i class=\"fa fa-sort-up\"></i>\n  </div>\n  <button id=\"{{vm.listId + '_btn' + ($index + vm.startIndex)}}\"\n          ng-class=\"vm.btnClass\"\n          ng-repeat=\"item in vm.displayItems\"\n          ng-keypress=\"vm.keyPressHandler($index, $event)\"\n          ng-keydown=\"vm.keyDownHandler($index, $event)\"\n          ng-keyup=\"vm.keyUpHandler($index, $event)\"\n          ng-focus=\"vm.focusHandler($index, $event)\">\n    {{item.label}}\n  </button>\n  <div class=\"down-arrow\" ng-show=\"vm.startIndex + vm.maxItems &lt; vm.items.length\">\n    <i class=\"fa fa-sort-down\"></i>\n  </div>\n</div>\n"

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * The ListController class is designed to manage the navigation of a pageable sequence of items,
	 * like the video list.
	 *
	 * It displays all its elements using the same button classes in a vertical layout. It manages
	 * proper tabbing and arrow key navigation.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var SubnavController = (function () {
	  /*-----------------------------------*\
	   * Constructor
	  \*-----------------------------------*/
	
	  function SubnavController($window, $timeout, $scope, $state, $rootScope) {
	    var _this = this;
	
	    _classCallCheck(this, SubnavController);
	
	    this.name = 'subnav';
	
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.$rootScope = $rootScope;
	
	    this.$rootScope.subNavIndexItem = 0;
	
	    this._selectedIndex = 0;
	    this._labels = [];
	    this._datas = [];
	    this._maxItems = 7;
	    this._startIndex = 0;
	    this.listId = this.listId || 'NO_LIST_ID_PROVIDED';
	
	    this.ignoreNextUp = false;
	
	    this.labelField = 'label';
	    this.statevalue = 'state';
	    //console.log("this.statevalue=", this.statevalue);
	
	    $scope.$on('focus', function (event, args) {
	      //console.log("event:", event);
	      //console.log("args:", args);
	      if (args.id === _this.listId) {
	        //console.log('Focus', args.id, args.focusOnPopulate);
	        _this.focus(args.index, args.focusOnPopulate);
	      }
	    });
	  }
	
	  /*-----------------------------------*\
	   * Properties
	  \*-----------------------------------*/
	
	  _createClass(SubnavController, [{
	    key: 'focus',
	
	    /*-----------------------------------*\
	     * Methods
	    \*-----------------------------------*/
	    value: function focus(index, focusOnPopulate) {
	      index = index ? index : 0;
	
	      if (focusOnPopulate) {
	        this.focusOnPopulateIx = index;
	        return;
	      }
	
	      this.selectedIndex = this.startIndex + index;
	    }
	  }, {
	    key: 'focusSelectedIndex',
	    value: function focusSelectedIndex() {
	      var elId = this.listId + '_btn' + this._selectedIndex;
	      var el = document.getElementById(elId);
	
	      //console.log('Focusing', this._selectedIndex, el, elId, this._items[this._selectedIndex].state);
	
	      if (el) {
	        el.focus();
	        //el.go(this.state);
	        //el.nextComponentHandler();
	        this.$state.transitionTo(this._items[this._selectedIndex].state);
	      } else {
	        this.$timeout(this.focusSelectedIndex.bind(this));
	      }
	    }
	  }, {
	    key: 'pageDown',
	    value: function pageDown() {
	      var _this2 = this;
	
	      if (this.items && this.items.length > this.startIndex + this.maxItems) {
	        this.startIndex += this.maxItems;
	
	        this.$timeout(function (_) {
	          _this2.selectedIndex = _this2.startIndex;
	        });
	      }
	    }
	  }, {
	    key: 'pageUp',
	    value: function pageUp() {
	      var _this3 = this;
	
	      if (this.startIndex > 0) {
	        this.startIndex -= this.maxItems;
	
	        if (this.startIndex < 0) {
	          this.startIndex = 0;
	        }
	
	        this.$timeout(function (_) {
	          _this3.selectedIndex = _this3.startIndex + _this3.maxItems - 1;
	        });
	      }
	    }
	  }, {
	    key: 'isUp',
	    value: function isUp(event) {
	      return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
	    }
	  }, {
	    key: 'isDown',
	    value: function isDown(event) {
	      return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
	    }
	  }, {
	    key: 'isRight',
	    value: function isRight(event) {
	      return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
	    }
	  }, {
	    key: 'isLeft',
	    value: function isLeft(event) {
	      return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
	    }
	
	    /*-----------------------------------*\
	     * Events
	    \*-----------------------------------*/
	  }, {
	    key: 'focusHandler',
	    value: function focusHandler(ix, event) {
	      this.selectedIndex = this.startIndex + ix;
	    }
	  }, {
	    key: 'keyPressHandler',
	    value: function keyPressHandler($index, event) {
	      if (event.charCode === 13 || event.keyCode === 13) {
	        var ix = this.startIndex + $index;
	        if (this.itemClickHandler) {
	          this.itemClickHandler({
	            index: ix,
	            item: this._items[ix],
	            event: event
	          });
	        }
	      }
	    }
	  }, {
	    key: 'keyDownHandler',
	    value: function keyDownHandler($index, event) {
	      var _this4 = this;
	
	      var cancel = function cancel(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	        _this4.ignoreNextUp = true;
	      };
	
	      // Down arrow or tab key
	      if (event.code === 'Tab' && !event.shiftKey || this.isDown(event)) {
	        if ($index === this.maxItems - 1 && this.items.length - 1 > this.startIndex + $index) {
	          this.pageDown();
	          cancel(event);
	        } else if (this.selectedIndex + 1 < this.items.length) {
	          this.selectedIndex++;
	          cancel(event);
	        } else if (this.selectedIndex + 1 === this.items.length) {
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (event.code === 'Tab' && event.shiftKey || this.isUp(event)) {
	        console.log('Up!', $index, this.maxItems, this.startIndex);
	        // Up arrow or shift tab
	        if ($index % this.maxItems === 0 && this.startIndex > 0) {
	          this.pageUp();
	          cancel(event);
	        } else if (this.selectedIndex > 0) {
	          this.selectedIndex--;
	          cancel(event);
	        } else if (this.selectedIndex === 0) {
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      }
	
	      if (this.isRight(event)) {
	        if (this.nextComponentHandler) {
	          //console.log("here in nextComponentHandler");
	          console.log("here in nextComponentHandler", this.selectedIndex);
	          this.canNext = true;
	          if (this.$rootScope.accountPastdue === true || this.$rootScope.preDeauth === true || this.$rootScope.isPPVInhibit === true) {
	            document.getElementById('paynow-btn').focus();
	          } else {
	            console.log("button not available");
	          }
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (this.isLeft(event)) {
	        //sETTING UP THE ROOTSCOPE TO GET BACK TO THE SAME ELEMENT IN THE SUB-MENU
	        this.$rootScope.subNavIndexItem = this.selectedIndex;
	        if (this.prevComponentHandler) {
	          //pconsole.log("here in prevComponentHandler 2");
	          console.log("here in prevComponentHandler", this.selectedIndex);
	          this.canPrev = false;
	          /*if(this.listId === 'tv-navigation' || this.listId === 'phone-navigation' || this.listId === 'internet-navigation'){
	            document.getElementById('btn-videos').focus();
	          } else if(this.listId === 'spanish-tv-navigation' || this.listId === 'spanish-phone-navigation' || this.listId === 'spanish-internet-navigation') {
	            document.getElementById('btn-back-spanish').focus();
	          }*/
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (event.keyCode === 27 || event.keyCode === 461) {
	        console.log('Back or exit pressed, trying to close the window');
	        // window.opener = self;
	        window.close();
	      }
	    }
	  }, {
	    key: 'keyUpHandler',
	    value: function keyUpHandler($index, event) {
	      if (this.ignoreNextUp) {
	        this.ignoreNextUp = false;
	        return;
	      }
	
	      //if (this.canNext && ((this.isDown(event) && this.selectedIndex === this.items.length - 1) || this.isRight(event))) {
	      if (this.canNext && this.isRight(event)) {
	        if (this.nextComponentHandler) {
	          var nextIndex = this.isDown(event) ? 0 : this.selectedIndex - this.startIndex;
	          this.nextComponentHandler(nextIndex, this.isDown(event));
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (this.canPrev && (this.isUp(event) && this.selectedIndex === 0 || this.isLeft(event))) {
	        if (this.prevComponentHandler) {
	          var nextIndex = this.isUp(event) ? this.maxItems : this.selectedIndex - this.startIndex;
	          this.prevComponentHandler(nextIndex, this.isUp(event));
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      }
	
	      this.canNext = this.canPrev = false;
	    }
	  }, {
	    key: 'items',
	    set: function set(value) {
	      var _this5 = this;
	
	      this._items = value;
	
	      this._labels = [];
	      this._datas = [];
	
	      if (this._items && this._items.length) {
	        this._items.forEach(function (item) {
	          _this5._labels.push(item.label);
	          _this5._datas.push(item.data);
	        });
	      }
	
	      if (this.focusOnPopulateIx !== undefined) {
	        //console.log('Focusing after timeout', this.focusOnPopulateIx);
	        this.$timeout(function (_) {
	          return _this5.focus(_this5.focusOnPopulateIx);
	        });
	
	        this.focusOnPopulateIx = undefined;
	      }
	    },
	
	    //-----------------------------------
	    // items
	    //-----------------------------------
	    get: function get() {
	      return this._items;
	    }
	
	    //-----------------------------------
	    // displayItems
	    //-----------------------------------
	    /**
	     * Returns only the items that have been determined to be displayable based on the display
	     * startIndex and the maxItems.
	     *
	     * @returns {*}
	     */
	  }, {
	    key: 'displayItems',
	    get: function get() {
	      return this._items && this._items.length ? this._items.slice(this._startIndex, this._startIndex + this._maxItems) : [];
	    }
	
	    //-----------------------------------
	    // labels
	    //-----------------------------------
	  }, {
	    key: 'labels',
	    get: function get() {
	      return this._labels;
	    }
	
	    //-----------------------------------
	    // datas
	    //-----------------------------------
	  }, {
	    key: 'datas',
	    get: function get() {
	      return this._datas;
	    }
	
	    //-----------------------------------
	    // maxItems
	    //-----------------------------------
	  }, {
	    key: 'maxItems',
	    get: function get() {
	      return this._maxItems;
	    }
	
	    //-----------------------------------
	    // startIndex
	    //-----------------------------------
	  }, {
	    key: 'startIndex',
	    set: function set(value) {
	      this._startIndex = value;
	    },
	    get: function get() {
	      return this._startIndex;
	    }
	
	    //-----------------------------------
	    // selectedIndex
	    //-----------------------------------
	  }, {
	    key: 'selectedIndex',
	    get: function get() {
	      return this._selectedIndex;
	    },
	    set: function set(index) {
	      if (!this.items || this.items.length === 0) {
	        this._selectedIndex = 0;
	        return;
	      }
	
	      this._selectedIndex = index;
	
	      if (this._selectedIndex < 0) {
	        this._selectedIndex = 0;
	      } else if (this._selectedIndex > this.items.length - 1) {
	        this._selectedIndex = this.items.length - 1;
	      }
	
	      this.focusSelectedIndex();
	    }
	  }]);
	
	  return SubnavController;
	})();
	
	SubnavController.$inject = ['$window', '$timeout', '$scope', '$state', '$rootScope'];
	
	exports['default'] = SubnavController;
	module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(65);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./subnav.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./subnav.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".list{color:red}.list .list-button:focus{box-shadow:0 0 10px 2px #006639;outline:none}", ""]);
	
	// exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _viewpaybilllandingComponent = __webpack_require__(67);
	
	var _viewpaybilllandingComponent2 = _interopRequireDefault(_viewpaybilllandingComponent);
	
	var ViewpaybilllandingModule = _angular2['default'].module('viewpaybilllanding', [_angularUiRouter2['default']]).component('viewpaybilllanding', _viewpaybilllandingComponent2['default']);
	
	exports['default'] = ViewpaybilllandingModule;
	module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _viewpaybilllandingHtml = __webpack_require__(68);
	
	var _viewpaybilllandingHtml2 = _interopRequireDefault(_viewpaybilllandingHtml);
	
	var _viewpaybilllandingController = __webpack_require__(69);
	
	var _viewpaybilllandingController2 = _interopRequireDefault(_viewpaybilllandingController);
	
	__webpack_require__(70);
	
	var ViewpaybilllandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _viewpaybilllandingHtml2['default'],
	  controller: _viewpaybilllandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = ViewpaybilllandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = "<!-- This block will change based on amount due value -->\n<div class=\"landingDueBox textHigh\" ng-if=\"vm.isPastDue || vm.isPreDAuthTwo || vm.isPreDAuthOne\">\n  <div>\n    <div class=\"left-text\">Amount Due</div>\n    <div class=\"dottedc\">\n      <div class=\"dotted\"></div>\n    </div>\n    <div class=\"right-text\">{{vm.bpGlobalInfo.amountDue | currency}}</div>\n  </div>\n  <div class=\"other-info\">Your account is past due.</div>\n  <div class=\"paynow-div\">\n    <button id=\"paynow-btn\" ng-click=\"vm.onPayNow()\" class=\"btn paynow-btn\"> Pay Now </button>\n  </div>\n</div>\n<div class=\"landingDueBox textLow\" ng-if=\"vm.paymentDue\">\n  <div>\n    <div class=\"left-text\">Amount Due</div>\n    <div class=\"dottedc\">\n      <div class=\"dotted\"></div>\n    </div>\n    <div class=\"right-text\">{{vm.bpGlobalInfo.amountDue | currency}}</div>\n  </div>\n  <div class=\"date_due\">on {{vm.amountDueDate}}</div>\n</div>\n<div class=\"landingDueBox textHigh\" ng-if=\"vm.PPVInhibit\">\n  <div>\n    <div class=\"left-text\">Amount Due</div>\n    <div class=\"dottedc\">\n      <div class=\"dotted\"></div>\n    </div>\n    <div class=\"right-text\">{{vm.PPVAmountdue | currency}}</div>\n  </div>\n  <div class=\"other-info\">You have exceeded your order limit.</div>\n  <div class=\"paynow-div\">\n    <button id=\"paynow-btn\" ng-click=\"vm.onPayNow()\" class=\"btn paynow-btn\"> Pay Now </button>\n  </div>\n</div>\n<div class=\"landingDueBox textLow\" ng-show=\"vm.noPaymentDue\">\n  <div>\n    <div class=\"left-text\">Account balance</div>\n    <div class=\"dottedc\">\n      <div class=\"dotted\"></div>\n    </div>\n    <div class=\"right-text\" ng-show=\"!vm.negative_amountDue\" >{{vm.bpGlobalInfo.amountDue | currency}}</div>\n    <div class=\"right-text\" ng-show=\"vm.negative_amountDue\">$0.00</div>\n  </div>\n  <div class=\"other-info\">No payment is due at this time.</div>\n</div>\n<div class=\"landingDueBox textLow\" ng-show=\"vm.noPaymentDuewithAccBalance\">\n  <div>\n    <div class=\"left-text\">Amount Due</div>\n    <div class=\"dottedc\">\n      <div class=\"dotted\"></div>\n    </div>\n    <div class=\"right-text\">$0.00</div>\n  </div>\n  <div class=\"other-info\">No payment is due at this time.</div>\n</div>\n<div class=\"landingDueBox textLow\" ng-show=\"vm.creditBalance\">\n  <div>\n    <div class=\"left-text\">You have a credit of </div>\n    <div class=\"right-text\">{{vm.creditAmount | currency}}</div>\n  </div>\n  <div class=\"other-info\">No payment is due at this time.</div>\n</div>\n<div class=\"landingDueBox textLow\" ng-if=\"vm.bpGlobalFailed\">\n  Sorry, we can't access your billing information right now.<span class=\"other-info\"> Please try again later.</span>\n</div>\n\n<!-- This is loader will be true once customer defined and firest required call will be done.-->\n<div ng-show=\"vm.landingPageViewBillLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ViewpaybilllandingController = (function () {
	  function ViewpaybilllandingController($state, $scope, $window, storage, billingService, $rootScope, navigationManager, analyticsService) {
	    var _this = this;
	
	    _classCallCheck(this, ViewpaybilllandingController);
	
	    this.name = 'viewpaybilllanding';
	    this.state = $state;
	    this.$rootScope = $rootScope;
	    this.analyticsService = analyticsService;
	    //this.$scope = $scope;
	    this.$rootScope.accountPastdue = false;
	    this.$rootScope.isPPVInhibit = false;
	    this.$rootScope.preDeauth = false;
	    //customer cable-vision and suddenlink
	    this.isCablevision = false;
	    this.isSuddenlink = false;
	
	    //bp-global parameters
	    this.bpGlobalInfo = null;
	    this.amountTestDue = 0;
	    this.amountDueDate = '';
	    this.creditBalance = false;
	    this.creditAmount = 0;
	    this.noPaymentDuewithAccBalance = false;
	    this.noPaymentDue = false;
	    this.hasOptimumId = false;
	    this.currentAccount = null;
	    this.items = [];
	    this.deAuthInfo = null;
	    this.errorPay = false;
	    this.isPreDAuthTwo = false;
	    this.isPreDAuthOne = false;
	    this.paymentAlertMsg = '';
	    this.isPastDue = false;
	    this.paymentDue = false;
	    this.landingPageViewBillLoader = true;
	    this.bpGlobalFailed = false;
	
	    this.isPPVProd = false;
	    this.PPVInhibitBalance = 0;
	    this.PPVInhibit = false;
	    this.PPVAmountdue = 0;
	
	    //based on plant id will determine customer.
	    console.log("my previous state is:", this.$rootScope.previousState);
	
	    navigationManager.registerViewComponent(this, $scope, 'home.landingpage.viewpaybilllanding');
	
	    //getting bp global data for
	    billingService.getBpGlobalData().then(function (res) {
	      //console.log('this is bp global information from landing page.--> ', res);
	      if (res && res.data && res.data.status && res.data.status.statusCode === "00000") {
	        //console.log("view bpGlobalInfo on landing page: ", res.data);
	        _this.bpGlobalInfo = res.data;
	        _this.amountTestDue = res.data.amountDue;
	        _this.PPVInhibitBalance = res.data.billPayCache.ppvinhibitBalance;
	        _this.PPVAmountdue = _this.bpGlobalInfo.currentBalance + _this.PPVInhibitBalance;
	        console.log("this.PPVAmountdue is " + _this.PPVAmountdue);
	
	        if (_this.bpGlobalInfo.dueDate !== null) {
	          var myDate = _this.bpGlobalInfo.dueDate;
	          var parts = myDate.split('/');
	          myDate = parts[0] + '/' + parts[1];
	          _this.amountDueDate = myDate;
	        }
	
	        // checking amount due in different phases
	        if (_this.bpGlobalInfo.currentBalance < 0) {
	          _this.creditBalance = true;
	          _this.creditAmount = _this.bpGlobalInfo.currentBalance * -1;
	          ////this.landingPageLoader = false;
	          _this.landingPageViewBillLoader = false;
	        } else if (_this.bpGlobalInfo.amountDue <= 0) {
	          _this.negative_amountDue = true;
	          if (_this.bpGlobalInfo.currentBalance > 0) {
	            _this.noPaymentDuewithAccBalance = true;
	            ////this.landingPageLoader = false;
	          } else {
	              _this.noPaymentDue = true;
	              ////this.landingPageLoader = false;
	            }
	          _this.landingPageViewBillLoader = false;
	        } else if (_this.bpGlobalInfo.amountDue > 0) {
	
	          //verifying from where bp global coming
	          if (storage.getItem('session', 'hasOptimumId')) {
	            _this.hasOptimumId = true;
	          }
	          // first we will get list of cards by getCurracc
	          billingService.getCurrectAcc().then(function (resp) {
	            //console.log("resp of current account on landing page.:", resp);
	            if (resp && resp.paymentMethods) {
	              //console.log("This is Currect Account ebillInformationOutputs from landing page.---> ", resp.paymentMethods);
	              _this.currentAccount = resp;
	              _this.items = resp.paymentMethods;
	              //console.log("this.items in landing page:", this.items);
	            } else {
	                _this.items = [];
	                //console.log("this.items in landing page:", this.items);
	              }
	          }).then(function () {
	            //this block plays pre-de auth one or two
	            if (_this.bpGlobalInfo.billPayCache && _this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && _this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0) {
	              _this.deAuthInfo = billingService.deauthInfo(_this.bpGlobalInfo.billPayCache);
	              //here we know we have deauth so now determining one or two so set text for alert and other msg.
	              _this.errorPay = true;
	              document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
	              document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
	              /*document.getElementById('landingBg').style.marginTop = '0vh';*/
	              if (_this.deAuthInfo.isDeauthTwo) {
	                _this.isPreDAuthTwo = true;
	                _this.PPVInhibit = false;
	                _this.paymentAlertMsg = 'Your account is past due. Make a payment now to avoid service interruptions.';
	              } else if (_this.deAuthInfo.isDeauthOne) {
	                _this.PPVInhibit = false;
	                _this.isPreDAuthOne = true;
	                _this.paymentAlertMsg = 'Your account is past due. Please make a payment by ' + _this.deAuthInfo.startDate + ' to avoid late fees or service interruptions.';
	              }
	              //this.landingPageLoader = false;
	              _this.landingPageViewBillLoader = false;
	              _this.$rootScope.preDeauth = true;
	              _this.focus('navigation_btn0');
	
	              /*************************************************************************/
	              /*   The below block is to set the flagson the basis of bpglobal call    */
	              /*************************************************************************/
	              setTimeout(function () {
	                navigationManager.registerNavigate('paynow-btn', 'down');
	                navigationManager.registerNavigate('paynow-btn', 'left', 'navigation_btn0');
	                navigationManager.registerNavigate('paynow-btn', 'up');
	                navigationManager.registerNavigate('paynow-btn', 'right');
	              }, 1000);
	            }
	            ///this block plays pastdue stuff
	            else if (_this.bpGlobalInfo.pastDueAmount > 0) {
	                _this.PPVInhibit = false;
	                _this.errorPay = true;
	                _this.paymentAlertMsg = 'Your account is past due. Please make a payment to avoid late fees or service interruptions.';
	                document.getElementById('msgAlertBoxId').style.marginTop = '2vh';
	                document.getElementById('msgAlertBoxId').style.marginBottom = '3.7vh';
	                /*document.getElementById('landingBg').style.marginTop = '0vh';*/
	                _this.isPastDue = true;
	                _this.$rootScope.accountPastdue = true;
	                console.log("this.$rootScope.accountPastdue", _this.$rootScope.accountPastdue);
	                //this.landingPageLoader = false;
	                _this.landingPageViewBillLoader = false;
	                _this.focus('paynow-btn');
	
	                /*************************************************************************/
	                /*   The below block is to set the flagson the basis of bpglobal call    */
	                /*************************************************************************/
	
	                setTimeout(function () {
	                  navigationManager.registerNavigate('paynow-btn', 'down');
	                  navigationManager.registerNavigate('paynow-btn', 'left', 'navigation_btn0');
	                  navigationManager.registerNavigate('paynow-btn', 'up');
	                  navigationManager.registerNavigate('paynow-btn', 'right');
	                }, 1000);
	              }
	              //checks if there is a ppv inhibit
	              else if (_this.PPVInhibitBalance != null && _this.PPVInhibitBalance > 0 && _this.isPPVProd) {
	                  _this.PPVInhibit = true;
	                  _this.$rootScope.isPPVInhibit = true;
	                  _this.landingPageViewBillLoader = false;
	                  _this.focus('paynow-btn');
	                  setTimeout(function () {
	                    navigationManager.registerNavigate('paynow-btn', 'down');
	                    navigationManager.registerNavigate('paynow-btn', 'left', 'navigation_btn0');
	                    navigationManager.registerNavigate('paynow-btn', 'up');
	                    navigationManager.registerNavigate('paynow-btn', 'right');
	                  }, 1000);
	                  //if nothings remain and only amount due
	                } else {
	                    _this.paymentDue = true;
	                    //this.landingPageLoader = false;
	                    _this.landingPageViewBillLoader = false;
	                  }
	          });
	        }
	      } else {
	        _this.bpGlobalFailed = true;
	        _this.landingPageViewBillLoader = false;
	      }
	    }, function () {
	      _this.bpGlobalFailed = true;
	      _this.landingPageViewBillLoader = false;
	      //console.log('Something wrong with all call and bpglobal fail.');
	    });
	  }
	
	  _createClass(ViewpaybilllandingController, [{
	    key: 'onPayNow',
	    value: function onPayNow() {
	      console.log('!!omniture from landing pay Now');
	      console.log('paperless : ' + this.$rootScope.omniturePaperlessbill + ', billing status : ' + this.$rootScope.omnitureBillingStatus);
	      this.analyticsService.sendReport('home', 'my account', 'event2', null, null, null, 'Pay Now', this.$rootScope.analytics.omniturePath + '/viewpaybill', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath + '/landingpage/viewpaybilllanding');
	
	      this.state.go('home.viewpaybill');
	    }
	  }, {
	    key: 'focus',
	    value: function focus(id) {
	      console.log("id in focus:", id);
	      setTimeout(function () {
	        document.getElementById(id).focus();
	      }, 300);
	    }
	  }]);
	
	  return ViewpaybilllandingController;
	})();
	
	ViewpaybilllandingController.$inject = ['$state', '$scope', '$window', 'storage', 'billingService', '$rootScope', 'navigationManager', 'analyticsService'];
	
	exports['default'] = ViewpaybilllandingController;
	module.exports = exports['default'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(71);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./viewpaybilllanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./viewpaybilllanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".paynow-div{float:right;padding-top:20px}", ""]);
	
	// exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _videobilllandingComponent = __webpack_require__(73);
	
	var _videobilllandingComponent2 = _interopRequireDefault(_videobilllandingComponent);
	
	var videobilllandingModule = _angular2['default'].module('videobilllanding', [_angularUiRouter2['default']]).component('videobilllanding', _videobilllandingComponent2['default']);
	
	exports['default'] = videobilllandingModule;
	module.exports = exports['default'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _videobilllandingHtml = __webpack_require__(74);
	
	var _videobilllandingHtml2 = _interopRequireDefault(_videobilllandingHtml);
	
	var _videobilllandingController = __webpack_require__(75);
	
	var _videobilllandingController2 = _interopRequireDefault(_videobilllandingController);
	
	__webpack_require__(76);
	
	var VideoBillLandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _videobilllandingHtml2['default'],
	  controller: _videobilllandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = VideoBillLandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"landingDueBox\" ng-show=\"!vm.landingPageVideoBillLoader\" ng-if=\"!vm.landingPageVideoBillError\">\n  <p class=\"textLow\">Life can be complicated. Understanding your bill shouldn't be.</p>\n  <p class=\"textSecondVerbiage verbiagePadding\">We've created a personalized video to help you understand your latest Optimum bill.</p>\n</div>\n<div ng-show=\"vm.landingPageVideoBillLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n<div ng-show=\"!vm.landingPageVideoBillLoader\" ng-if=\"vm.landingPageVideoBillError\">\n<div class=\"landingDueBox textLow\">\n  Sorry, this feature is currently not available. <span class=\"other-info\"> Please try again later.</span>\n</div>\n  <!--<div class=\"right-text\">You can also view quick tips at: <div class=\"right-text-blue\">optimum.net/faq</div></div>-->\n</div>\n"

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var VideobilllandingController = function VideobilllandingController($state, $window, storage, laboxSSapi) {
	  var _this = this;
	
	  _classCallCheck(this, VideobilllandingController);
	
	  this.name = 'Video Bill Landing';
	  this.state = $state;
	  this.landingPageVideoBillLoader = true;
	
	  if (storage.getItem('session', 'home_id') == "36063655") {
	    console.log('specific case where it should polay the default video and get no api response');
	    this.landingPageVideoBillError = true;
	    this.landingPageVideoBillLoader = false;
	  } else if (storage.getItem('session', 'home_id') == "36071973") {
	    console.log('specific case where it should polay the default video and get no api response');
	    this.landingPageVideoBillError = true;
	    this.landingPageVideoBillLoader = false;
	  } else {
	    laboxSSapi.getVideoBill().then(function (res) {
	      if (res && res.data._links) {
	        _this.working_link = res.data._links['video-stream'][0].href;
	        console.log('res.data["_links"]["video-stream"].href is ' + res.data._links['video-stream'][0].href);
	        console.log('working link is ' + _this.working_link);
	        if (_this.working_link != null && storage.getItem('session', 'home_id') != "40520101") {
	          console.log('res.data is ' + res.data);
	          _this.landingPageVideoBillLoader = false;
	          _this.landingPageVideoBillError = false;
	        } else {
	          console.log('res.data is ' + res.data);
	          console.log('response works but has no link');
	          _this.landingPageVideoBillError = false;
	          _this.landingPageVideoBillLoader = false;
	        }
	      } else {
	        console.log('res.data is ' + res.data);
	        console.log('no response from videobill');
	        _this.landingPageVideoBillError = true;
	        _this.landingPageVideoBillLoader = false;
	      }
	    });
	  }
	};
	
	VideobilllandingController.$inject = ['$state', '$window', 'storage', 'laboxSSapi'];
	
	exports['default'] = VideobilllandingController;
	module.exports = exports['default'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(77);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./videobilllanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./videobilllanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".videobilllanding{color:red}", ""]);
	
	// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paperlessbillinglandingComponent = __webpack_require__(79);
	
	var _paperlessbillinglandingComponent2 = _interopRequireDefault(_paperlessbillinglandingComponent);
	
	var PaperlessbillinglandingModule = _angular2['default'].module('paperlessbillinglanding', [_angularUiRouter2['default']]).component('paperlessbillinglanding', _paperlessbillinglandingComponent2['default']);
	
	exports['default'] = PaperlessbillinglandingModule;
	module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _paperlessbillinglandingHtml = __webpack_require__(80);
	
	var _paperlessbillinglandingHtml2 = _interopRequireDefault(_paperlessbillinglandingHtml);
	
	var _paperlessbillinglandingController = __webpack_require__(81);
	
	var _paperlessbillinglandingController2 = _interopRequireDefault(_paperlessbillinglandingController);
	
	__webpack_require__(82);
	
	var PaperlessbillinglandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _paperlessbillinglandingHtml2['default'],
	  controller: _paperlessbillinglandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = PaperlessbillinglandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"landingDueBox\" ng-if=\"!vm.hasOptimumId && !vm.errorFetchingInfo\">\n  <p class=\"textLow\">Go Paperless</p>\n  <p class=\"textSecondVerbiage\">There isn't an Optimum ID associated with this account. Go to <span class=\"text-optimum-link\">optimum.net/profile</span> to create an Optimum ID.</p>\n</div>\n\n<div class=\"landingDueBox\" ng-if=\"vm.noEmail\">\n  <p class=\"textLow\">Go Paperless</p>\n  <p class=\"textSecondVerbiage\">Make life easier and enroll in paperless billing. It's quick, convenient, secure and free.</p>\n</div>\n\n<div class=\"landingDueBox\" ng-if=\"vm.emailButNotEnrolled\">\n  <p class=\"textLow\">Go Paperless</p>\n  <p class=\"textSecondVerbiage\">Make life easier and enroll in paperless billing. It's quick, convenient, secure and free.</p>\n</div>\n\n<div class=\"landingDueBox\" ng-if=\"vm.emailAndEnrolled\">\n  <p class=\"textLow\">You're Enrolled</p>\n  <p class=\"textSecondVerbiage\">Billing statement notifications are currently being emailed to: <span class=\"text-optimum-link\">{{vm.email}}</span></p>\n  <p class=\"textSecondVerbiage verbiagePadding\">To manage your paperless billing settings, visit: <span class=\"text-optimum-link\">optimum.net/pay-bill</span></p>\n</div>\n\n\n<div class=\"landingDueBox\" ng-if=\"vm.errorFetchingInfo\">\n  <p class=\"textLow\">There's an issue right now, please try again later.</p>\n  <p class=\"textSecondVerbiage verbiagePadding\">You can also enroll in paperless billing at: <span class=\"text-optimum-link\">optimum.net/pay-bill</span></p>\n</div>\n\n<!-- This is loader will be true once customer defined and firest required call will be done.-->\n<div ng-show=\"vm.landingPagePaperlessLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n"

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var PaperlessbillinglandingController = function PaperlessbillinglandingController($state, $window, storage, billingService) {
	  var _this = this;
	
	  _classCallCheck(this, PaperlessbillinglandingController);
	
	  this.name = 'Paperless Billing';
	  this.state = $state;
	
	  //variables
	  this.landingPagePaperlessLoader = true;
	  this.email = null;
	  this.emailButNotEnrolled = false;
	  this.emailAndEnrolled = false;
	  this.noEmail = false;
	  this.hasOptimumId = true;
	  this.errorFetchingInfo = false;
	
	  billingService.getCurrectAcc().then(function (res) {
	
	    if (!storage.getItem('session', 'hasOptimumId')) {
	      _this.hasOptimumId = false;
	      _this.landingPagePaperlessLoader = false;
	    } else if (res && !res.email) {
	      _this.noEmail = true;
	      _this.landingPagePaperlessLoader = false;
	    } else if (res && res.email && res.isPaperBill === "true") {
	      _this.emailButNotEnrolled = true;
	      storage.setItem('session', 'userEmail', res.email);
	      _this.landingPagePaperlessLoader = false;
	    } else if (res && res.email && res.isPaperBill === "false") {
	      _this.emailAndEnrolled = true;
	      storage.setItem('session', 'userEmail', res.email);
	      var preEmail = res.email;
	      var index = preEmail.indexOf("@");
	      var name = preEmail.substr(0, index); // Gets the first part
	      var nameLength = name.length;
	      console.log("name is " + name);
	      var domain = preEmail.substr(index + 1); // Gets the second part
	      var domainLength = domain.length;
	      var totalchar = domainLength + nameLength;
	      console.log("domain is " + domain);
	
	      if (totalchar <= 36) {
	        _this.email = res.email;
	        console.log("totalchar <= 36 and email is " + _this.email);
	      } else if (nameLength > 18 && domainLength > 18) {
	        _this.email = name.substring(0, 16) + "...@" + domain.substring(0, 16) + "...";
	        console.log("both large and email is " + _this.email);
	      } else if (nameLength > 18 && domainLength <= 18) {
	        var newnameLength = 34 - domainLength;
	        _this.email = name.substring(0, newnameLength) + "...@" + domain;
	        console.log("name large and email is " + _this.email);
	      } else if (nameLength <= 18 && domainLength > 18) {
	        var newdomainLength = 34 - nameLength;
	        _this.email = name.substring(0, nameLength) + "@" + domain.substring(0, newdomainLength) + "...";
	        console.log("domain large and email is " + _this.email);
	      } else {
	        _this.email = res.email;
	        console.log("no large and email is " + _this.email);
	      }
	      _this.landingPagePaperlessLoader = false;
	    } else {
	      _this.errorFetchingInfo = true;
	      _this.landingPagePaperlessLoader = false;
	    }
	  });
	};
	
	PaperlessbillinglandingController.$inject = ['$state', '$window', 'storage', 'billingService'];
	
	exports['default'] = PaperlessbillinglandingController;
	module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(83);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paperlessbillinglanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paperlessbillinglanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _optimumidslandingComponent = __webpack_require__(85);
	
	var _optimumidslandingComponent2 = _interopRequireDefault(_optimumidslandingComponent);
	
	var OptimumidslandingModule = _angular2['default'].module('optimumidslanding', [_angularUiRouter2['default']]).component('optimumidslanding', _optimumidslandingComponent2['default']);
	
	exports['default'] = OptimumidslandingModule;
	module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _optimumidslandingHtml = __webpack_require__(86);
	
	var _optimumidslandingHtml2 = _interopRequireDefault(_optimumidslandingHtml);
	
	var _optimumidslandingController = __webpack_require__(87);
	
	var _optimumidslandingController2 = _interopRequireDefault(_optimumidslandingController);
	
	__webpack_require__(88);
	
	var OptimumidslandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _optimumidslandingHtml2['default'],
	  controller: _optimumidslandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = OptimumidslandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"landingDueBox\" ng-if=\"vm.hasNoOptimumID\">\n  <p class=\"textLow\">Create an Optimum ID</p>\n  <p class=\"textSecondVerbiage verbPadding\">There isn’t an Optimum ID associated with this account. Go to <span class=\"textlink\">optimum.net/profile</span> to create an Optimum ID.</p>\n</div>\n\n<div class=\"landingDueBox\" ng-if=\"vm.hasOptimumID\">\n  <p class=\"textLow\">Optimum IDs</p>\n  <p class=\"textSecondVerbiage verbPadding\">\n    The primary ID is <span class=\"textlink\">{{vm.optPrimary}}</span>. You're using {{vm.currentOptIdCount}} out of {{vm.totalOptIdCount}} available Optimum IDs.\n  </p>\n  <p class=\"textSecondVerbiage verbPadding verbiagePadding\" ng-if=\"!vm.isMaxOptimum\">\n    To manage your Optimum IDs, visit <span class=\"textlink\">optimum.net/manageid</span> and sign in with the primary ID.\n  </p>\n  <p class=\"textSecondVerbiage verbPadding verbiagePadding\" ng-if=\"vm.isMaxOptimum\">\n    To manage your Optimum IDs, visit <span class=\"textlink\">optimum.net/manageid</span> and sign in with the primary ID.\n  </p>\n</div>\n\n\n<div class=\"landingDueBox\" ng-if=\"vm.errorWhileLoading\">\n  <p class=\"textLow\"> There's an issue right now, please try again later.</p>\n  <p class=\"textSecondVerbiage verbPadding\">To manage or view your Optimum IDs please visit <span class=\"textlink\">optimum.net/manageid</span></p>\n</div>\n\n<!-- This is loader will be true once customer defined and firest required call will be done.-->\n<div ng-show=\"vm.landingPageOptIDLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var OptimumidslandingController = function OptimumidslandingController($state, $window, storage, laboxSSapi) {
	  var _this = this;
	
	  _classCallCheck(this, OptimumidslandingController);
	
	  this.name = 'Optimum IDs';
	  this.state = $state;
	  this.landingPageOptIDLoader = true;
	  this.hasOptimumID = false;
	  this.hasNoOptimumID = false;
	  this.totalOptIdCount = 0;
	  this.errorWhileLoading = false;
	  this.currentOptIdCount = 0;
	  this.optPrimary = '';
	  this.isMaxOptimum = false;
	
	  laboxSSapi.accountInfo().then(function (res) {
	    if (res && res.data && !res.data.code) {
	      console.log("there is no error retrieving accountinfo data");
	      if (res.data.userIdsCreated !== 0) {
	        console.log("there are more than 0 user ids created");
	        if (res.data.primaryId != "") {
	          console.log("the primary id is not null");
	          _this.currentOptIdCount = res.data.userIdsCreated;
	          _this.totalOptIdCount = res.data.maxIdLimit;
	          if (_this.totalOptIdCount === _this.currentOptIdCount) {
	            _this.isMaxOptimum = true;
	          } else if (_this.currentOptIdCount != null && _this.currentOptIdCount > _this.totalOptIdCount) {
	            _this.totalOptIdCount = _this.currentOptIdCount;
	            _this.isMaxOptimum = true;
	          }
	          _this.optPrimary = res.data.primaryId;
	          storage.setItem('session', 'maxIdAvailable', _this.totalOptIdCount);
	          storage.setItem('session', 'currentOptIdCount', _this.currentOptIdCount);
	          _this.hasOptimumID = true;
	          _this.landingPageOptIDLoader = false;
	        } else {
	          console.log("there primary id is null");
	          _this.errorWhileLoading = true;
	          _this.landingPageOptIDLoader = false;
	        }
	      } else if (res.data.userIdsCreated === 0) {
	        _this.hasNoOptimumID = true;
	        _this.landingPageOptIDLoader = false;
	      }
	    } else {
	      _this.errorWhileLoading = true;
	      _this.landingPageOptIDLoader = false;
	    }
	  });
	};
	
	OptimumidslandingController.$inject = ['$state', '$window', 'storage', 'laboxSSapi'];
	
	exports['default'] = OptimumidslandingController;
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(89);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./optimumidslanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./optimumidslanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".verbPadding{margin-top:1vh}.verbPadding .textlink{color:#f1f1f1;text-decoration:underline;font-weight:300;font-size:1.8vw}", ""]);
	
	// exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tutorialslandingComponent = __webpack_require__(91);
	
	var _tutorialslandingComponent2 = _interopRequireDefault(_tutorialslandingComponent);
	
	var TutorialslandingModule = _angular2['default'].module('tutorialslanding', [_angularUiRouter2['default']]).component('tutorialslanding', _tutorialslandingComponent2['default']);
	
	exports['default'] = TutorialslandingModule;
	module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tutorialslandingHtml = __webpack_require__(92);
	
	var _tutorialslandingHtml2 = _interopRequireDefault(_tutorialslandingHtml);
	
	var _tutorialslandingController = __webpack_require__(93);
	
	var _tutorialslandingController2 = _interopRequireDefault(_tutorialslandingController);
	
	__webpack_require__(94);
	
	var TutorialslandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _tutorialslandingHtml2['default'],
	  controller: _tutorialslandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = TutorialslandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = "<videotutorials></videotutorials>\n"

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TutorialslandingController = function TutorialslandingController($state) {
	  _classCallCheck(this, TutorialslandingController);
	
	  this.name = 'Tutorials';
	  this.state = $state;
	};
	
	TutorialslandingController.$inject = ['$state'];
	
	exports['default'] = TutorialslandingController;
	module.exports = exports['default'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(95);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./tutorialslanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./tutorialslanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _suddenlinkidslandingComponent = __webpack_require__(97);
	
	var _suddenlinkidslandingComponent2 = _interopRequireDefault(_suddenlinkidslandingComponent);
	
	var SuddenlinkidslandingModule = _angular2['default'].module('suddenlinkidslanding', [_angularUiRouter2['default']]).component('suddenlinkidslanding', _suddenlinkidslandingComponent2['default']);
	
	exports['default'] = SuddenlinkidslandingModule;
	module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _suddenlinkidslandingHtml = __webpack_require__(98);
	
	var _suddenlinkidslandingHtml2 = _interopRequireDefault(_suddenlinkidslandingHtml);
	
	var _suddenlinkidslandingController = __webpack_require__(99);
	
	var _suddenlinkidslandingController2 = _interopRequireDefault(_suddenlinkidslandingController);
	
	__webpack_require__(100);
	
	var SuddenlinkidslandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _suddenlinkidslandingHtml2['default'],
	  controller: _suddenlinkidslandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = SuddenlinkidslandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"landingDueBox\" ng-if=\"vm.hasNoSuddenlinkID\">\n  <p class=\"textLow\">Create a Username</p>\n  <p class=\"textSecondVerbiage verbPadding\">There are no usernames associated with this account. Go to <span class=\"textlink\">suddenlink.net</span> to create a username and access email,\n    view and pay your bill, watch TV on the go and more. </p>\n</div>\n\n<div class=\"landingDueBox\" ng-if=\"vm.hasSuddenlinkID\">\n  <p class=\"textLow\">Usernames</p>\n  <p class=\"textSecondVerbiage verbPadding\">\n    The primary username is <span class=\"textlink\">{{vm.sdlPrimary}}</span>. You're using {{vm.currentSdlIdCount}} out of {{vm.totalSdlIdCount}} available usernames.\n  </p>\n  <p class=\"textSecondVerbiage verbPadding verbiagePadding\" ng-if=\"!vm.isMaxSuddenlink\">\n    To manage your usernames, visit <span class=\"textlink\">suddenlink.net</span> and sign in with the primary username.\n  </p>\n  <p class=\"textSecondVerbiage verbPadding verbiagePadding\" ng-if=\"vm.isMaxSuddenlink\">\n    To manage your usernames, visit <span class=\"textlink\">suddenlink.net</span> and sign in with the primary username.\n  </p>\n</div>\n\n\n<div class=\"landingDueBox\" ng-if=\"vm.errorWhileLoading\">\n  <p class=\"textLow\"> There's an issue right now, please try again later.</p>\n  <p class=\"textSecondVerbiage verbPadding\">To manage or view your Suddenlink usernames please visit <span class=\"textlink\">suddenlink.net</span></p>\n</div>\n\n<!-- This is loader will be true once customer defined and firest required call will be done.-->\n<div ng-show=\"vm.landingPageSdlIDLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var SuddenlinkidslandingController = function SuddenlinkidslandingController($state, storage, $scope, laboxSSapi) {
	  var _this = this;
	
	  _classCallCheck(this, SuddenlinkidslandingController);
	
	  this.name = 'Usernames';
	  this.state = $state;
	  this.landingPageSdlIDLoader = true;
	  this.hasSuddenlinkID = false;
	  this.hasNoSuddenlinkID = false;
	  this.totalSdlIdCount = 0;
	  this.errorWhileLoading = false;
	  this.currentSdlIdCount = 0;
	  this.sdlPrimary = '';
	  this.isMaxSuddenlink = false;
	
	  laboxSSapi.getAllSuddenlinkIds().then(function (res) {
	    console.log('res is ' + res);
	    console.log('res.data.accountSummaryResponse.statusDescription is ' + res.data.accountSummaryResponse.statusDescription);
	    if (res && res.data && res.data.accountSummaryResponse.statusDescription && res.data.accountSummaryResponse.statusDescription == "Success") {
	      console.log('res.data.accountSummaryResponse.userCount is ' + res.data.accountSummaryResponse.userCount);
	      _this.unregUser = res.data.accountSummaryResponse.users[0].userName.search("unreg:") + 1;
	      console.log('this.unregUser is ' + _this.unregUser);
	      if (res.data.accountSummaryResponse.userCount !== 0 && _this.unregUser !== 1) {
	        _this.currentSdlIdCount = res.data.accountSummaryResponse.userCount;
	        if (_this.currentSdlIdCount > 0) {
	          storage.setItem('session', 'hasSuddenlinkId', true);
	          _this.hasSuddenlinkId = storage.getItem('session', 'hasSuddenlinkId');
	          console.log('this.hasSuddenlinkId is ' + _this.hasSuddenlinkId);
	        }
	        console.log("this.currentSdlIdCount is " + _this.currentSdlIdCount);
	        if (res.data.accountSummaryResponse.maxIdsperAcct < res.data.accountSummaryResponse.userCount) {
	          _this.totalSdlIdCount = res.data.accountSummaryResponse.userCount;
	        } else {
	          _this.totalSdlIdCount = res.data.accountSummaryResponse.maxIdsperAcct;
	        }
	        console.log("this.totalSdlIdCount is " + _this.totalSdlIdCount);
	        if (parseInt(_this.totalSdlIdCount) === parseInt(_this.currentSdlIdCount)) {
	          _this.isMaxSuddenlink = true;
	        }
	        _this.sdlPrimary = res.data.accountSummaryResponse.primaryId;
	        console.log("this.sdlPrimary is " + _this.sdlPrimary);
	        storage.setItem('session', 'maxIdAvailable', _this.totalSdlIdCount);
	        storage.setItem('session', 'currentSdlIdCount', res.data.accountSummaryResponse.userCount);
	        _this.hasSuddenlinkID = true;
	        _this.landingPageSdlIDLoader = false;
	      } else if (_this.unregUser === 1) {
	        _this.hasNoSuddenlinkID = true;
	        _this.landingPageSdlIDLoader = false;
	      }
	    } else {
	      _this.errorWhileLoading = true;
	      _this.landingPageSdlIDLoader = false;
	    }
	  });
	};
	
	SuddenlinkidslandingController.$inject = ['$state', 'storage', '$scope', 'laboxSSapi'];
	
	exports['default'] = SuddenlinkidslandingController;
	module.exports = exports['default'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./suddenlinkidslanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./suddenlinkidslanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paperlessbillingComponent = __webpack_require__(103);
	
	var _paperlessbillingComponent2 = _interopRequireDefault(_paperlessbillingComponent);
	
	var PaperlessbillingModule = _angular2['default'].module('paperlessbilling', [_angularUiRouter2['default']]).component('paperlessbilling', _paperlessbillingComponent2['default']);
	
	exports['default'] = PaperlessbillingModule;
	module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _paperlessbillingHtml = __webpack_require__(104);
	
	var _paperlessbillingHtml2 = _interopRequireDefault(_paperlessbillingHtml);
	
	var _paperlessbillingController = __webpack_require__(105);
	
	var _paperlessbillingController2 = _interopRequireDefault(_paperlessbillingController);
	
	__webpack_require__(106);
	
	var PaperlessbillingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _paperlessbillingHtml2['default'],
	  controller: _paperlessbillingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = PaperlessbillingComponent;
	module.exports = exports['default'];

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name-paperless\" ng-show=\"!vm.paperlessLoader\">\n    <span class=\"myAccount\">/</span>\n    <span>{{vm.name}}</span>\n</div>\n<div id=\"paperlessbillingcontainer\">\n  <div id=\"mainInfoDiv\" ng-init=\"vm.keyWatch($event)\">\n    <div ng-show=\"!vm.paperlessLoader\">\n      <!-- this is based on amount dues -->\n      <div class=\"enroll-main\" ng-if=\"vm.noEmail\">\n          <div class=\"encontent-left encontent-left-extra\">\n            <p class=\"msg-enroll-tops\">{{vm.enrollmsgString}}</p>\n            <p class=\"msg-enroll-bottoms\">{{vm.msgString}}</p>\n          </div>\n          <div class=\"encontent-right\">\n            <button id=\"add-enroll-btn\" class=\"add-enroll-btn\" ui-sref=\"home.keyboard\">Add Email and Enroll</button>\n          </div>\n          <div class=\"clearfix\"></div>\n      </div>\n\n      <!-- this is based on amount dues -->\n      <div class=\"enroll-main\" ng-if=\"vm.emailButNotEnrolled\">\n          <div class=\"encontent-left\">\n            <div class=\"paymentbox\">\n              <div class=\"amounduebox\">\n                <div class=\"textamountduebox\">\n                  <div class=\"date_due\">Billing Email Address</div>\n                  <div class=\"amountdue\">{{vm.email}}</div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"encontent-right\">\n            <p class=\"msg-enroll-tops\">{{vm.enrollmsgString}}</p>\n            <p class=\"msg-enroll-bottoms\">{{vm.msgString}}</p>\n          </div>\n          <div class=\"btn-group-enroll\">\n            <button id=\"update-enroll-btn\" ng-click=\"vm.updateEmail()\" class=\"enroll-btn update-enroll-btn\">Update Email and Enroll</button>\n            <button id=\"enroll-btn\" class=\"enroll-btn\" ng-click=\"vm.enroll()\">Enroll Now</button>\n          </div>\n          <div class=\"clearfix\"></div>\n      </div>\n\n      <!-- this is based on amount dues -->\n      <div class=\"viewpaymain\" ng-if=\"vm.paymentDue\">\n          <div class=\"vpcontent-left\">\n              <div class=\"paymentbox\">\n                  <div class=\"amounduebox\">\n                      <div class=\"textamountduebox\">\n                        <div class=\"date_due\">Billing Email Address</div>\n                        <div class=\"amountdue\">Amount due</div>\n                      </div>\n                  </div>\n              </div>\n          </div>\n          <div class=\"vpcontent-right\">\n              <p class=\"msgwithnoSavedPayment\">{{vm.enrollmsgString}}</p>\n              <p class=\"msgwithdue\">{{vm.msgString}}</p>\n          </div>\n          <div class=\"btn-group\">\n            <button id=\"cancel-btn\" class=\"cancel-payment-btn\" ng-click=\"vm.cancel()\">Update Email and Enroll</button>\n            <button id=\"confirm-btn\" class=\"confirm-payment-btn\" ng-click=\"vm.confirm(vm.paymentMethodUsed, vm.bpGlobalInfo.amountDue)\">Enroll Now</button>\n          </div>\n          <div class=\"clearfix\"></div>\n      </div>\n    </div>\n    <div ng-show=\"vm.paperlessLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n    </div>\n\n  </div>\n\n  <div class=\"alert-modal\" ng-show=\"vm.displayAlertModal\">\n    <div id=\"alertModal\" class=\"modal\">\n      <div id=\"modalContent\" class=\"modal-content alert-content\" ng-show=\"vm.displayModalContent\">\n        <div class=\"modal-wrapper\">\n          <div class=\"modal-header\"><h1>An Error Has Occurred</h1></div>\n          <div class=\"payment-details\">\n\n            <div class=\"alert-msg-one\">\n              <div class=\"errorMsgAlertBox\">\n                <div class=\"errorSym\">\n                  <span class=\"fa-stack fa-lg errorMsg\"></span>\n                </div>\n                <div class=\"errorMsgOne\">\n                  <span>There's an issue right now.</span>\n                </div>\n              </div>\n              <div class=\"errorMsgAlertBox\">\n                <div class=\"errorMsgTwo keyboardErrorMsg\">\n                  <span>Please try again later.</span>\n                </div>\n                <div class=\"errorMsgTwo keyboardErrorMsg\">\n                  <span>You can also enroll in paperless billing at: <span class=\"linkText\">optimum.net/pay-bill</span></span>\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"btn-alert\">\n              <button id=\"alert-confirm-btn\" class=\"confirm-payment-btn\" ng-click=\"vm.alertDone()\">Ok</button>\n            </div>\n          </div>\n\n        </div>\n      </div>\n      <div ng-show=\"vm.loading\" style=\"margin-left: 45%;margin-top: 25%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var PaperlessbillingController = (function () {
	  function PaperlessbillingController($timeout, $scope, navigationManager, mockService, authService, billingService, $filter, storage, $state, $rootScope, $interval, $window, analyticsService) {
	    var _this = this;
	
	    _classCallCheck(this, PaperlessbillingController);
	
	    this.$timeout = $timeout;
	    this.state = $state;
	    this.$rootScope = $rootScope;
	    this.name = 'Go Paperless';
	    this.analyticsService = analyticsService;
	
	    /*console.log("AM or PM:", $filter('date')(now, 'a'));*/
	
	    //this.currunttime = this._getTime();
	    this.enrollmsgString = "By enrolling in paperless billing, you will no longer receive paper statements in the mail.";
	    this.msgString = "Instead, we'll send you an email and let you know when your statement is available for viewing online.";
	    //this.paymentSuccessString = "This is the most current information available to both our systems and customer service agents. It includes all credits and payments processed up through " + this.currunttime + ", today.";
	    this.lastPaymentDate = '';
	    this.paymentAlertMsg = 'ERROR!';
	
	    this.$scope = $scope;
	
	    console.log('checking paperlessbill : ' + this.$rootScope.omniturePaperlessbill + 'billing Status : ' + this.$rootScope.omnitureBillingStatus);
	    // omniture on view pay bill
	    $scope.linkURL = null;
	    $scope.event = null;
	    $scope.pageName = null;
	    $scope.linkName = null;
	    $scope.omnitureBillingStatus = this.$rootScope.omnitureBillingStatus;
	    $scope.omniturePaperlessbill = this.$rootScope.omniturePaperlessbill;
	
	    //!! omniture when paperless loads
	    console.log('!!omniture when paperless loads');
	    analyticsService.sendReport('go paperless', 'enroll review', 'event1', null, null, null, null, null, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill);
	
	    $scope.$watch('[event, pageName, linkName, linkURL]', function (newValue, oldValue) {
	      console.log('!! omniture watch variables from paperlessbilling, event : ' + $scope.event + ' pageName : ' + $scope.pageName + ' linkName : ' + $scope.linkName + ' linkURL : ' + $scope.linkURL);
	      if ($scope.pageName) {
	        console.log('inside if paperlessbilling watch variables');
	        analyticsService.sendReport('go paperless', $scope.pageName, $scope.event, $scope.omnitureErrorMsg, null, null, $scope.linkName, $scope.linkURL, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill);
	      }
	    });
	
	    /*************************************************************************/
	    /*   The below block is to set the flags on the basis of bpglobal call    */
	    /*************************************************************************/
	
	    /* */
	    this.displayModalContent = true;
	    this.bpGlobalDataLoader = true;
	
	    //this is for alert box
	    this.displayAlertModal = false;
	    this.alertMsgTwo = '';
	    this.alertMsgOne = '';
	    this.alertMsgTitle = '';
	    this.isTechFailureAlert = false;
	    this.isRoutingOne = false;
	    this.isValidDecline = false;
	    this.isInvalidCC = false;
	    this.isInvalidCCExDate = false;
	    this.onlyOnePaymentMethodAfterError = false;
	    this.multiVersionDeauth = false;
	
	    //scheduling
	    this.schedulePayment = null;
	
	    //bpglobal with or without optimumid
	    this.hasOptimumId = false;
	
	    /*************************************************************************/
	    /*   The below block is for the paperless billing                        */
	    /*************************************************************************/
	
	    //variables
	    this.paperlessLoader = true;
	    this.email = null;
	    this.emailButNotEnrolled = false;
	    this.emailAndEnrolled = false;
	    this.noEmail = false;
	    this.hasOptimumId = true;
	    this.errorFetchingInfo = false;
	
	    /*************************************************************************/
	    /*   The below block is to set the flagson the basis of bpglobal call    */
	    /*************************************************************************/
	
	    navigationManager.registerViewComponent(this, $scope, 'home.paperlessbilling');
	
	    this.keyWatch = function (event) {
	      var eventTarget = document.getElementById('paperlessbillingcontainer');
	      eventTarget.addEventListener('keydown', _this.keydown);
	    };
	
	    this.keydown = function (event) {
	      if (!_this.displayAlertModal) {
	        if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	          document.getElementById('paperlessbillingcontainer').removeEventListener('keydown', _this.keydown);
	          _this.$rootScope.fromPaperlessBillingPage = true;
	          _this.state.go('home.landingpage');
	        }
	      } else {
	        console.log("Back button should not work");
	      }
	    };
	
	    billingService.getCurrectAcc().then(function (res) {
	      //When you don't have optimum id
	      //console.log('Res for account on paperless :',res);
	      //console.log('Res for primary optimum id :',storage.getItem('session','hasOptimumId'));
	
	      if (!storage.getItem('session', 'hasOptimumId')) {
	        //this.hasOptimumId=false;
	        //this.landingPagePaperlessLoader = false;
	      } else if (res && !res.email) {
	          _this.noEmail = true;
	          _this.paperlessLoader = false;
	          _this.focusItem('add-enroll-btn');
	
	          setTimeout(function () {
	            //navigation setup
	            navigationManager.registerNavigate('add-enroll-btn', 'down');
	            navigationManager.registerNavigate('add-enroll-btn', 'left');
	            navigationManager.registerNavigate('add-enroll-btn', 'up');
	            navigationManager.registerNavigate('add-enroll-btn', 'right');
	          }, 500);
	        } else if (res && res.email && res.isPaperBill === "true") {
	          _this.emailButNotEnrolled = true;
	
	          storage.setItem('session', 'userEmail', res.email);
	          var preEmail = res.email;
	          var index = preEmail.indexOf("@");
	          var name = preEmail.substr(0, index); // Gets the first part
	          var nameLength = name.length;
	          console.log("name is " + name);
	          var domain = preEmail.substr(index + 1); // Gets the second part
	          var domainLength = domain.length;
	          var totalchar = domainLength + nameLength;
	          console.log("domain is " + domain);
	
	          if (totalchar <= 36) {
	            _this.email = res.email;
	            console.log("totalchar <= 36 and email is " + _this.email);
	          } else if (nameLength > 18 && domainLength > 18) {
	            _this.email = name.substring(0, 16) + "...@" + domain.substring(0, 16) + "...";
	            console.log("both large and email is " + _this.email);
	          } else if (nameLength > 18 && domainLength <= 18) {
	            var newnameLength = 34 - domainLength;
	            _this.email = name.substring(0, newnameLength) + "...@" + domain;
	            console.log("name large and email is " + _this.email);
	          } else if (nameLength <= 18 && domainLength > 18) {
	            var newdomainLength = 34 - nameLength;
	            _this.email = name.substring(0, nameLength) + "@" + domain.substring(0, newdomainLength) + "...";
	            console.log("domain large and email is " + _this.email);
	          } else {
	            _this.email = res.email;
	            console.log("no large and email is " + _this.email);
	          }
	          _this.paperBillInd = res.isPaperBill;
	          _this.paperlessLoader = false;
	          _this.focusItem('enroll-btn');
	          setTimeout(function () {
	            //navigation setup
	            navigationManager.registerNavigate('enroll-btn', 'down');
	            navigationManager.registerNavigate('enroll-btn', 'left', 'update-enroll-btn');
	            navigationManager.registerNavigate('enroll-btn', 'up');
	            navigationManager.registerNavigate('enroll-btn', 'right');
	
	            navigationManager.registerNavigate('update-enroll-btn', 'down');
	            navigationManager.registerNavigate('update-enroll-btn', 'right', 'enroll-btn');
	            navigationManager.registerNavigate('update-enroll-btn', 'up');
	            navigationManager.registerNavigate('update-enroll-btn', 'left');
	            var emailElement = document.getElementsByClassName("amountdue");
	            var emailWidth = emailElement[0].offsetWidth;
	          }, 500);
	        } else if (res && res.email && res.isPaperBill === "false") {
	          //this.emailAndEnrolled = true;
	          //storage.setItem('session','userEmail',res.email);
	          //this.email = res.email;
	        } else {
	            //this.errorFetchingInfo = true;
	            //this.landingPagePaperlessLoader = false;
	            _this.paperlessLoader = false;
	            _this.$rootScope.fromPaperlessBillingPage = true;
	            _this.state.go('home.landingpage');
	          }
	    });
	
	    this.paymentModalHandler = function (item) {
	      _this.displayPaymentModal = true;
	      _this.displayModalContent = true;
	      console.log("item:", item);
	      _this.paymentMethodUsed = item.payment_method;
	      setTimeout(function () {
	        document.getElementById('confirm-btn').focus();
	      }, 100);
	    };
	
	    this.enroll = function (_) {
	      // omniture when enroll now
	      console.log('!!omniture when enroll now!!');
	      $scope.pageName = 'enroll review';
	      $scope.linkName = 'Enroll Now';
	      $scope.linkURL = _this.$rootScope.analytics.omniturePath + '/landingpage/paperlessbilling';
	
	      var emailVal = _this.email;
	
	      console.log("Email to be enrolled:", emailVal);
	      _this.displayAlertModal = true;
	
	      _this.displayModalContent = false;
	      _this.loading = true;
	      billingService.enrollPaperlessBill(false, emailVal).then(function (res) {
	        console.log("Result in enroll api:", res);
	        if (res.data.responseInfo && res.data.responseInfo.statusCode === "00000") {
	          _this.loading = false;
	          _this.$rootScope.enrollValue = true;
	
	          //omniture paperless enrollment success
	          console.log('!!omniture paperless enrollment success');
	          _this.$rootScope.paperlessbilling = true;
	          _this.$rootScope.fromPaperlessBillingPage = true;
	          _this.analyticsService.sendReport('go paperless', 'paperless enrollment success', 'event7', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, true, _this.$rootScope.analytics.omniturePath + '/landingpage');
	
	          _this.state.go('home.landingpage', {}, { reload: true });
	        } else {
	          _this.loading = false;
	          _this.displayModalContent = true;
	          // omniture when enroll error
	          console.log('!!omniture when enrolled error!!');
	          $scope.pageName = 'enroll error';
	
	          setTimeout(function () {
	            document.getElementById('alert-confirm-btn').focus();
	            //this.focusItem('alert-confirm-btn');
	          }, 150);
	        }
	      });
	    };
	
	    this.updateEmail = function (_) {
	      console.log('coming in update email');
	      //omniture update email and enroll
	      _this.analyticsService.sendReport('go paperless', 'enroll review', $scope.event, $scope.omnitureErrorMsg, null, null, 'Update Email and Enroll', _this.$rootScope.analytics.omniturePath + '/keyboard', $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, _this.$rootScope.analytics.omniturePath + '/paperlessbilling');
	
	      _this.state.go('home.keyboard');
	    };
	
	    this.alertDone = function (_) {
	      _this.displayAlertModal = false;
	      _this.displayModalContent = false;
	      setTimeout(function () {
	        document.getElementById('enroll-btn').focus();
	      }, 150);
	    };
	  }
	
	  _createClass(PaperlessbillingController, [{
	    key: 'focusItem',
	    value: function focusItem(id) {
	      var el = document.getElementById(id);
	      if (el) {
	        console.log('got it', el);
	        el.focus();
	      } else {
	        console.log('I am here in non-focus state.');
	        this.$timeout(this.focusItem.bind(this, id));
	      }
	    }
	  }]);
	
	  return PaperlessbillingController;
	})();
	
	PaperlessbillingController.$inject = ['$timeout', '$scope', 'navigationManager', 'mockService', 'authService', 'billingService', '$filter', 'storage', '$state', '$rootScope', '$interval', '$window', 'analyticsService'];
	
	exports['default'] = PaperlessbillingController;
	module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(107);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./paperlessbilling.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./paperlessbilling.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".menu-name-paperless{position:absolute;top:6.45vh;left:17.7vw;font-style:normal;font-size:1.72vw;line-height:1}.menu-name-paperless .myAccount{color:#afb6b8;line-height:1;font-size:2.03vw}.enroll-main{margin:12vh 9.2vw 0 8.97vw;background-color:rgba(93,93,93,.4);overflow:hidden}.enroll-main .encontent-left{float:left;width:45.91vw}.enroll-main .encontent-left .encontent-left-extra{width:51.95vw!important}.enroll-main .encontent-left .msg-enroll-tops{font-size:1.6vw;margin-top:3.6vh;margin-left:2.35vw;margin-bottom:-16vh}.enroll-main .encontent-left .msg-enroll-bottoms{font-size:1.6vw;margin-top:18.25vh;margin-left:2.35vw;margin-bottom:4.2vh}.enroll-main .encontent-left .paymentbox{padding:4.2vh 2.34vw 2.75vh 2.42vw;overflow:hidden}.enroll-main .encontent-left .paymentbox .amounduebox{background-color:#37393a;padding:6.26vh 1.56vw 4.17vh 1.64vw}.enroll-main .encontent-left .paymentbox .amounduebox .textamountduebox{width:100%;font-size:22px;font-weight:700;line-height:1.2}.enroll-main .encontent-left .paymentbox .amounduebox #deorpastAmount,.enroll-main .encontent-left .paymentbox .amounduebox #deorpastAmountDue,.enroll-main .encontent-left .paymentbox .amounduebox .multiVersionDeauthandDue{color:#e22d02}.enroll-main .encontent-left .paymentbox .amounduebox .dotdot{color:#fff}.enroll-main .encontent-left .paymentbox .amounduebox .textamountdueboxright{text-align:right}.enroll-main .encontent-left .paymentbox .amounduebox .textamtduedate{font-weight:400}.enroll-main .encontent-left .paymentbox .amounduebox .date_due{color:#cfcfcf;font-size:22px;font-weight:400}.enroll-main .encontent-left .paymentbox .amounduebox .pastdueReplaceDate{color:#a1a1a1;font-weight:200;font-size:20px}.enroll-main .encontent-left .paymentbox .amounduebox .amountdue{display:table-cell;white-space:nowrap;line-height:1.4;padding-right:5px}.enroll-main .encontent-left .paymentbox .amounduebox .price{display:table-cell;text-align:right;white-space:nowrap;padding-left:5px}.enroll-main .encontent-left .paymentbox .amounduebox .creditBal{white-space:nowrap}.enroll-main .encontent-left .paymentbox .paymethodbox{min-height:6.4vh;overflow:hidden}.enroll-main .encontent-left .paymentbox .paymethodbox .noPaymentMethod{font-size:1.72vw;font-weight:700;background-color:rgba(53,60,69,.8);padding:1.4vh 1.56vw;color:#199ed8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important}.enroll-main .encontent-left .paymentbox .paymethodbox .blockedUser{font-size:1.4vw;font-weight:500}.enroll-main .encontent-left .paymentbox .paymethodbox .noPaymentDue{font-size:1.72vw;background-color:rgba(53,60,69,.8);padding:1.4vh 1.56vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important;text-align:center}.enroll-main .encontent-right .add-enroll-btn{color:#aeb4b5!important;text-decoration:none;font-weight:800;font-size:18px;margin-left:7vw;margin-top:16vh;margin-right:0;width:26.57vw!important;border-radius:2px;background-color:#5e6263;width:16vw;color:#fff;height:5.65vh;border:#3b494d;font-family:Open Sans Bold}.enroll-main .encontent-right .add-enroll-btn:focus,.enroll-main .encontent-right .add-enroll-btn:hover{overflow:hidden;background:#f1f1f1;color:#000!important}.enroll-main .encontent-right .msg-enroll-tops{font-size:1.5vw;margin-top:3.6vh;margin-right:3.12vw;margin-bottom:-16vh}.enroll-main .encontent-right .msg-enroll-bottoms{font-size:1.55vw;margin-top:19.25vh;margin-right:3.12vw}.enroll-main .btn-group-enroll{margin:5.65vh 0 4.2vh 30.5vw;font-family:Open Sans Bold}.enroll-main .btn-group-enroll .enroll-btn{text-decoration:none;font-weight:800;font-size:18px;border-radius:2px;background-color:#525556;color:hsla(197,9%,85%,.4)!important;width:19vw;color:#fff;height:6vh;border:#5e6263}.enroll-main .btn-group-enroll .enroll-btn:focus,.enroll-main .btn-group-enroll .enroll-btn:hover{overflow:hidden;background:#f1f1f1;color:#000!important}.enroll-main .btn-group-enroll .update-enroll-btn{width:29.3vw!important;margin-right:5px}.clearfix{visibility:hidden;display:block;content:\" \";clear:both;height:0}.amountInred{color:red}", ""]);
	
	// exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _keyboardComponent = __webpack_require__(109);
	
	var _keyboardComponent2 = _interopRequireDefault(_keyboardComponent);
	
	var keyboardModule = _angular2['default'].module('keyboard', [_angularUiRouter2['default']]).component('keyboard', _keyboardComponent2['default']);
	
	exports['default'] = keyboardModule;
	module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _keyboardHtml = __webpack_require__(110);
	
	var _keyboardHtml2 = _interopRequireDefault(_keyboardHtml);
	
	var _keyboardController = __webpack_require__(111);
	
	var _keyboardController2 = _interopRequireDefault(_keyboardController);
	
	__webpack_require__(112);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _keyboardHtml2['default'],
	  controller: _keyboardController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name-keyboard\" ng-show=\"!vm.paperlessLoader\">\n    <span class=\"myAccount\">/</span>\n    <span>{{vm.name}}</span>\n</div>\n<div id=\"keyBoardContainer\">\n  <div class=\"topVerbiageKeyBoard\">\n    <p>Enter the email address where you want your bill statement notification sent to. <br/> Automatic payment notification will also be sent to this address.</p>\n  </div>\n  <div class=\"keyboardMain\" ng-init=\"vm.keyWatch($event)\">\n\n    <div class=\"userEmailInfo\">\n      <div class=\"emailInput\">\n        <!--ng-change=\"vm.textChange(vm.enteredEmail)\" -->\n        <input type=\"text\" name=\"email\" id=\"userEmailId\" ng-model=\"vm.enteredEmail\" />\n      </div>\n      <div class=\"emailError\" ng-show=\"vm.showEmailError\">\n        <img src=\"../../../assets/Alert.png\" />&nbsp;    Please enter a valid email address.\n      </div>\n      <div class=\"clearfix\"></div>\n    </div>\n\n    <div class=\"keyBoardLayout\">\n      <div class=\"keyBoardLeft\">\n          <div class=\"keyLayout\">\n              <div class=\"specialFunction\" ng-show=\"!vm.special_characters\">\n                <button class=\"alphabets\" id=\"del\"></button>\n                <button class=\"alphabets\" id=\"inText\"></button>\n                <button class=\"alphabets\" id=\"outText\"></button>\n                <button class=\"alphabets\" id=\"clear\"></button>\n                <button class=\"alphabets\" id=\"special_characters\"></button>\n                <div class=\"clearfix\"></div>\n              </div>\n\n              <div class=\"specialFunction\" ng-show=\"vm.special_characters\">\n                <button class=\"alphabets\" id=\"del_special\"></button>\n                <button class=\"alphabets\" id=\"inText_special\"></button>\n                <button class=\"alphabets\" id=\"outText_special\"></button>\n                <button class=\"alphabets\" id=\"clear_special\"></button>\n                <button class=\"alphabets\" id=\"regular_characters\"></button>\n                <div class=\"clearfix\"></div>\n              </div>\n\n              <div class=\"alphaNumeric\">\n                <div class=\"alpha\" ng-show=\"!vm.special_characters\">\n                  <button class=\"alphabets\" id=\"a\" >a</button>\n                  <button class=\"alphabets\" id=\"b\" >b</button>\n                  <button class=\"alphabets\" id=\"c\" >c</button>\n                  <button class=\"alphabets\" id=\"d\" >d</button>\n                  <button class=\"alphabets\" id=\"e\" >e</button>\n                  <button class=\"alphabets\" id=\"f\" >f</button>\n                  <button class=\"alphabets\" id=\"g\" >g</button>\n                  <button class=\"alphabets\" id=\"h\" >h</button>\n                  <button class=\"alphabets\" id=\"i\" >i</button>\n\n                  <button class=\"alphabets\" id=\"j\" >j</button>\n                  <button class=\"alphabets\" id=\"k\" >k</button>\n                  <button class=\"alphabets\" id=\"l\" >l</button>\n                  <button class=\"alphabets\" id=\"m\" >m</button>\n                  <button class=\"alphabets\" id=\"n\" >n</button>\n                  <button class=\"alphabets\" id=\"o\" >o</button>\n                  <button class=\"alphabets\" id=\"p\" >p</button>\n                  <button class=\"alphabets\" id=\"q\" >q</button>\n                  <button class=\"alphabets\" id=\"r\" >r</button>\n\n                  <button class=\"alphabets\" id=\"s\" >s</button>\n                  <button class=\"alphabets\" id=\"t\" >t</button>\n                  <button class=\"alphabets\" id=\"u\" >u</button>\n                  <button class=\"alphabets\" id=\"v\" >v</button>\n                  <button class=\"alphabets\" id=\"w\" >w</button>\n                  <button class=\"alphabets\" id=\"x\" >x</button>\n                  <button class=\"alphabets\" id=\"y\" >y</button>\n                  <button class=\"alphabets\" id=\"z\" >z</button>\n                  <div class=\"clearfix\"></div>\n\n                  <button class=\"alphabets\" id=\"atThe\" >@</button>\n                  <button class=\"alphabets\" id=\"dot\" >.</button>\n                  <button class=\"alphabets\" id=\"dash\" >-</button>\n                  <button class=\"alphabets\" id=\"underscore\" >_</button>\n                  <div class=\"clearfix\"></div>\n\n                </div>\n\n                <div class=\"alpha special_character\" ng-show=\"vm.special_characters\">\n                  <button class=\"alphabets\" id=\"%\" >%</button>\n                  <button class=\"alphabets\" id=\"|\" >|</button>\n                  <button class=\"alphabets\" id=\"#\" >#</button>\n                  <button class=\"alphabets\" id=\"&\" >&</button>\n                  <button class=\"alphabets\" id=\"@\" >@</button>\n                  <button class=\"alphabets\" id=\"!\" >!</button>\n                  <button class=\"alphabets\" id=\"^\" >^</button>\n                  <div class=\"clearfix\"></div>\n\n                  <button class=\"alphabets\" id=\"`\" >`</button>\n                  <button class=\"alphabets\" id='\"' >\"</button>\n                  <button class=\"alphabets\" id=\"'\" >'</button>\n                  <button class=\"alphabets\" id=\";\" >;</button>\n                  <button class=\"alphabets\" id=\":\" >:</button>\n                  <button class=\"alphabets\" id=\"?\" >?</button>\n                  <button class=\"alphabets\" id=\">\" >></button>\n                  <button class=\"alphabets\" id=\"$\" >$</button>\n                  <div class=\"clearfix\"></div>\n\n                  <button class=\"alphabets\" id=\"=\" >=</button>\n                  <button class=\"alphabets\" id=\"*\" >*</button>\n                  <button class=\"alphabets\" id=\"+\" >+</button>\n                  <button class=\"alphabets\" id=\"_\" >_</button>\n                  <button class=\"alphabets\" id=\"-\" >-</button>\n                  <button class=\"alphabets\" id=\",\" >,</button>\n                  <button class=\"alphabets\" id='<' ><</button>\n                  <button class=\"alphabets\" id=\"~\" >~</button>\n                  <div class=\"clearfix\"></div>\n\n                  <button class=\"alphabets\" id=\"[\" >[</button>\n                  <button class=\"alphabets\" id=\"]\" >]</button>\n                  <button class=\"alphabets\" id=\"{\" >{</button>\n                  <button class=\"alphabets\" id=\"}\" >}</button>\n                  <button class=\"alphabets\" id=\"(\" >(</button>\n                  <button class=\"alphabets\" id=\")\" >)</button>\n                  <button class=\"alphabets\" id=\"&#92;\" >\\</button>\n                  <button class=\"alphabets\" id=\"/\" >/</button>\n                  <div class=\"clearfix\"></div>\n\n                </div>\n                <div ng-show=\"!vm.special_characters\">\n                  <div class=\"numeric\">\n                    <button class=\"alphabets\" id=\"1\" >1</button>\n                    <button class=\"alphabets\" id=\"2\" >2</button>\n                    <button class=\"alphabets\" id=\"3\" >3</button>\n                    <button class=\"alphabets\" id=\"4\" >4</button>\n                    <button class=\"alphabets\" id=\"5\" >5</button>\n                    <button class=\"alphabets\" id=\"6\" >6</button>\n                    <button class=\"alphabets\" id=\"7\" >7</button>\n                    <button class=\"alphabets\" id=\"8\" >8</button>\n                    <button class=\"alphabets\" id=\"9\" >9</button>\n                    <button class=\"alphabets hideITForSpace\"></button>\n                    <button class=\"alphabets\" id=\"0\">0</button>\n                  </div>\n                  <div class=\"clearfix\"></div>\n                </div>\n\n                <div ng-show=\"vm.special_characters\">\n                  <div class=\"numeric\" >\n                    <button class=\"alphabets\" id=\"1_special\" >1</button>\n                    <button class=\"alphabets\" id=\"2_special\" >2</button>\n                    <button class=\"alphabets\" id=\"3_special\" >3</button>\n                    <button class=\"alphabets\" id=\"4_special\" >4</button>\n                    <button class=\"alphabets\" id=\"5_special\" >5</button>\n                    <button class=\"alphabets\" id=\"6_special\" >6</button>\n                    <button class=\"alphabets\" id=\"7_special\" >7</button>\n                    <button class=\"alphabets\" id=\"8_special\" >8</button>\n                    <button class=\"alphabets\" id=\"9_special\" >9</button>\n                    <button class=\"alphabets hideITForSpace\"></button>\n                    <button class=\"alphabets\" id=\"0_special\" >0</button>\n                  </div>\n                  <div class=\"clearfix\"></div>\n                </div>\n              </div>\n\n\n          </div>\n      </div>\n\n      <div class=\"keyBoardRight\">\n        <div class=\"emailProviders\" ng-show=\"!vm.special_characters\">\n          <button class=\"providers\" id=\"optemail\" >@optimum.net</button>\n          <button class=\"providers\" id=\"gmailemail\" >@gmail.com</button>\n          <button class=\"providers\" id=\"yahooemail\" >@yahoo.com</button>\n          <button class=\"providers\" id=\"aolemail\" >@aol.com</button>\n          <button class=\"providers\" id=\"hotmailemail\">@hotmail.com</button>\n        </div>\n        <div class=\"emailProviders\" ng-show=\"vm.special_characters\">\n          <button class=\"providers\" id=\"optemail_special\" >@optimum.net</button>\n          <button class=\"providers\" id=\"gmailemail_special\" >@gmail.com</button>\n          <button class=\"providers\" id=\"yahooemail_special\" >@yahoo.com</button>\n          <button class=\"providers\" id=\"aolemail_special\" >@aol.com</button>\n          <button class=\"providers\" id=\"hotmailemail_special\">@hotmail.com</button>\n        </div>\n      </div>\n\n      <div class=\"clearfix\"></div>\n\n    </div>\n\n    <div class=\"validatingButtons\" ng-show=\"!vm.special_characters\">\n      <button class=\"btnCancel\" id=\"btnCancel\">Cancel</button>\n      <button class=\"btnEnroll\" id=\"btnEnroll\">Enroll</button>\n    </div>\n\n    <div class=\"validatingButtons\" ng-show=\"vm.special_characters\">\n      <button class=\"btnCancel\" id=\"btnCancel_special\">Cancel</button>\n      <button class=\"btnEnroll\" id=\"btnEnroll_special\">Enroll</button>\n    </div>\n\n  </div>\n  <div class=\"confirmation-modal\" ng-show=\"vm.displayModal\">\n    <div id=\"confirmModal\" class=\"modal\">\n      <div class=\"modal-content\" ng-show=\"vm.displayModalContent\">\n        <div class=\"modal-wrapper\">\n          <div class=\"modal-header\"><h1>Confirm Your Email Address</h1></div>\n          <div class=\"confirm-details\">\n            <div class=\"billing\">\n              <p>Billing statement notifications will be emailed to:</p>\n              <p><span class=\"link-text\">{{vm.enteredEmail}}</span></p>\n            </div>\n            <div class=\"btn-group\" ng-show=\"!vm.special_characters\">\n              <button id=\"btnBack\" class=\"back-btn\">Go Back</button>\n              <button id=\"btnConfirm\" class=\"confirm-btn\"\">Confirm</button>\n            </div>\n            <div class=\"btn-group\" ng-show=\"vm.special_characters\">\n              <button id=\"btnBack_special\" class=\"back-btn\">Go Back</button>\n              <button id=\"btnConfirm_special\" class=\"confirm-btn\"\">Confirm</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"vm.loading\" style=\"margin-left: 45%;margin-top: 25%;\">\n          <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"alert-modal\" ng-show=\"vm.displayAlertModal\">\n    <div id=\"alertModal\" class=\"modal\">\n      <div id=\"modalContent\" class=\"modal-content alert-content\">\n        <div class=\"modal-wrapper\">\n          <div class=\"modal-header\"><h1>An Error Has Occurred</h1></div>\n          <div class=\"payment-details\">\n            <div class=\"alert-msg-one\">\n              <div class=\"errorMsgAlertBox\">\n                <div class=\"errorSym\">\n                  <span class=\"fa-stack fa-lg errorMsg\"></span>\n                </div>\n                <div class=\"errorMsgOne\">\n                  <span>There's an issue right now.</span>\n                </div>\n              </div>\n\n              <div class=\"errorMsgAlertBox\">\n                <div class=\"errorMsgTwo keyboardErrorMsg\">\n                  <span>Please try again later.</span>\n                </div>\n                <div class=\"errorMsgTwo keyboardErrorMsg\">\n                  <span>You can also enroll in paperless billing at: <span class=\"linkText\">optimum.net/pay-bill</span></span>\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"btn-alert\">\n              <button id=\"btnOK\" class=\"confirm-payment-btn\">Ok</button>\n            </div>\n          </div>\n\n        </div>\n      </div>\n      <div ng-show=\"vm.loading\" style=\"margin-left: 45%;margin-top: 25%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var KeyboardController = (function () {
	  function KeyboardController(storage, $state, $scope, $rootScope, navigationManager, billingService, analyticsService) {
	    var _this = this;
	
	    _classCallCheck(this, KeyboardController);
	
	    this.name = 'Go Paperless';
	    this.$state = $state;
	    this.$scope = $scope;
	    this.$rootScope = $rootScope;
	    this.analyticsService = analyticsService;
	    this.focusChange = {};
	    this.special_characters = false;
	    this.keynavigation = [{ text: '', key: 'del', left: '', up: '', down: 'a', right: 'inText' }, { text: '', key: 'inText', left: 'del', up: '', down: 'b', right: 'outText' }, { text: '', key: 'outText', left: 'inText', up: '', down: 'c', right: 'clear' }, { text: '', key: 'clear', left: 'outText', up: '', down: 'd', right: 'special_characters' }, { text: '', key: 'special_characters', left: 'clear', up: '', down: 'e', right: 'optemail', next: 'regular_characters' }, { text: '@optimum.net', key: 'optemail', left: 'clear', up: '', down: 'gmailemail', right: '' }, { text: '@gmail.com', key: 'gmailemail', left: '3', up: 'optemail', down: 'yahooemail', right: '' }, { text: '@yahoo.com', key: 'yahooemail', left: '6', up: 'gmailemail', down: 'aolemail', right: '' }, { text: '@aol.com', key: 'aolemail', left: '9', up: 'yahooemail', down: 'hotmailemail', right: '' }, { text: '@hotmail.com', key: 'hotmailemail', left: '0', up: 'aolemail', down: 'btnEnroll', right: '' }, { text: '', key: 'btnEnroll', left: 'btnCancel', up: 'atThe', down: '', right: '' }, { text: '', key: 'btnCancel', left: '', up: 'atThe', down: '', right: 'btnEnroll' }, { text: '', key: 'btnConfirm', left: 'btnBack', up: '', down: '', right: '' }, { text: '', key: 'btnBack', left: '', up: '', down: '', right: 'btnConfirm' }, { text: '', key: 'btnOK', left: '', up: '', down: '', right: '' }, { text: 'a', key: 'a', left: '', up: 'del', down: 'j', right: 'b' }, { text: 'b', key: 'b', left: 'a', up: 'inText', down: 'k', right: 'c' }, { text: 'c', key: 'c', left: 'b', up: 'outText', down: 'l', right: 'd' }, { text: 'd', key: 'd', left: 'c', up: 'clear', down: 'm', right: 'e' }, { text: 'e', key: 'e', left: 'd', up: 'special_characters', down: 'n', right: 'f' }, { text: 'f', key: 'f', left: 'e', up: 'special_characters', down: 'o', right: 'g' }, { text: 'g', key: 'g', left: 'f', up: 'special_characters', down: 'p', right: 'h' }, { text: 'h', key: 'h', left: 'g', up: 'special_characters', down: 'q', right: 'i' }, { text: 'i', key: 'i', left: 'h', up: 'special_characters', down: 'r', right: '1' }, { text: 'j', key: 'j', left: '', up: 'a', down: 's', right: 'k' }, { text: 'k', key: 'k', left: 'j', up: 'b', down: 't', right: 'l' }, { text: 'l', key: 'l', left: 'k', up: 'c', down: 'u', right: 'm' }, { text: 'm', key: 'm', left: 'l', up: 'd', down: 'v', right: 'n' }, { text: 'n', key: 'n', left: 'm', up: 'e', down: 'w', right: 'o' }, { text: 'o', key: 'o', left: 'n', up: 'f', down: 'x', right: 'p' }, { text: 'p', key: 'p', left: 'o', up: 'g', down: 'y', right: 'q' }, { text: 'q', key: 'q', left: 'p', up: 'h', down: 'z', right: 'r' }, { text: 'r', key: 'r', left: 'q', up: 'i', down: 'z', right: '4' }, { text: 's', key: 's', left: '', up: 'j', down: 'atThe', right: 't' }, { text: 't', key: 't', left: 's', up: 'k', down: 'dot', right: 'u' }, { text: 'u', key: 'u', left: 't', up: 'l', down: 'dash', right: 'v' }, { text: 'v', key: 'v', left: 'u', up: 'm', down: 'underscore', right: 'w' }, { text: 'w', key: 'w', left: 'v', up: 'n', down: 'underscore', right: 'x' }, { text: 'x', key: 'x', left: 'w', up: 'o', down: 'underscore', right: 'y' }, { text: 'y', key: 'y', left: 'x', up: 'p', down: 'underscore', right: 'z' }, { text: 'z', key: 'z', left: 'y', up: 'q', down: 'underscore', right: '7' },
	
	    // special character keys starts here
	
	    { text: '@optimum.net', key: 'optemail_special', left: 'regular_characters', up: '', down: 'gmailemail_special', right: '' }, { text: '@gmail.com', key: 'gmailemail_special', left: '3_special', up: 'optemail_special', down: 'yahooemail_special', right: '' }, { text: '@yahoo.com', key: 'yahooemail_special', left: '6_special', up: 'gmailemail_special', down: 'aolemail_special', right: '' }, { text: '@aol.com', key: 'aolemail_special', left: '9_special', up: 'yahooemail_special', down: 'hotmailemail_special', right: '' }, { text: '@hotmail.com', key: 'hotmailemail_special', left: '0_special', up: 'aolemail_special', down: 'btnEnroll_special', right: '' }, { text: '', key: 'del_special', left: '', up: '', down: '%', right: 'inText_special' }, { text: '', key: 'inText_special', left: 'del_special', up: '', down: '|', right: 'outText_special' }, { text: '', key: 'outText_special', left: 'inText_special', up: '', down: '#', right: 'clear_special' }, { text: '', key: 'clear_special', left: 'outText_special', up: '', down: '&', right: 'regular_characters' }, { text: '', key: 'regular_characters', left: 'clear_special', up: '', down: '@', right: 'optemail_special', next: 'special_characters' }, { text: '%', key: '%', left: '', up: 'del_special', down: '`', right: '|' }, { text: '|', key: '|', left: '%', up: 'inText_special', down: '"', right: '#' }, { text: '#', key: '#', left: '|', up: 'outText_special', down: "'", right: '&' }, { text: '&', key: '&', left: '#', up: 'clear_special', down: ';', right: '@' }, { text: '@', key: '@', left: '&', up: 'regular_characters', down: ':', right: '!' }, { text: '!', key: '!', left: '@', up: 'regular_characters', down: '?', right: '^' }, { text: '^', key: '^', left: '!', up: 'regular_characters', down: '>', right: '1_special' }, { text: '`', key: '`', left: '', up: '%', down: '=', right: '"' }, { text: '"', key: '"', left: '`', up: '|', down: '*', right: "'" }, { text: "'", key: "'", left: '"', up: '#', down: '+', right: ';' }, { text: ';', key: ';', left: "'", up: '&', down: '_', right: ':' }, { text: ':', key: ':', left: ';', up: '@', down: '-', right: '?' }, { text: '?', key: '?', left: ':', up: '!', down: ',', right: '>' }, { text: '>', key: '>', left: '?', up: '^', down: "<", right: '$' }, { text: '$', key: '$', left: '>', up: '^', down: '~', right: '4_special' }, { text: '=', key: '=', left: '', up: '`', down: '[', right: '*' }, { text: '*', key: '*', left: '=', up: '"', down: ']', right: '+' }, { text: '+', key: '+', left: '*', up: "'", down: '{', right: '_' }, { text: '_', key: '_', left: '+', up: ';', down: '}', right: '-' }, { text: '-', key: '-', left: '_', up: ':', down: '(', right: ',' }, { text: ',', key: ',', left: '-', up: '?', down: ')', right: '<' }, { text: "<", key: "<", left: ',', up: '>', down: '\\', right: '~' }, { text: '~', key: '~', left: "<", up: '$', down: '/', right: '7_special' }, { text: '[', key: '[', left: '', up: '=', down: 'btnEnroll_special', right: ']' }, { text: ']', key: ']', left: '[', up: '*', down: 'btnEnroll_special', right: '{' }, { text: '{', key: '{', left: ']', up: '+', down: 'btnEnroll_special', right: '}' }, { text: '}', key: '}', left: '{', up: '_', down: 'btnEnroll_special', right: '(' }, { text: '(', key: '(', left: '}', up: '-', down: 'btnEnroll_special', right: ')' }, { text: ')', key: ')', left: '(', up: ',', down: 'btnEnroll_special', right: '\\' }, { text: '\\', key: '\\', left: ')', up: "<", down: 'btnEnroll_special', right: '/' }, { text: '/', key: '/', left: '\\', up: '~', down: 'btnEnroll_special', right: '0_special' }, { text: '1', key: '1_special', left: '^', up: 'regular_characters', down: '4_special', right: '2_special' }, { text: '2', key: '2_special', left: '1_special', up: 'regular_characters', down: '5_special', right: '3_special' }, { text: '3', key: '3_special', left: '2_special', up: 'regular_characters', down: '6_special', right: 'gmailemail_special' }, { text: '4', key: '4_special', left: '$', up: '1_special', down: '7_special', right: '5_special' }, { text: '5', key: '5_special', left: '4_special', up: '2_special', down: '8_special', right: '6_special' }, { text: '6', key: '6_special', left: '5_special', up: '3_special', down: '9_special', right: 'yahooemail_special' }, { text: '7', key: '7_special', left: '~', up: '4_special', down: '0_special', right: '8_special' }, { text: '8', key: '8_special', left: '7_special', up: '5_special', down: '0_special', right: '9_special' }, { text: '9', key: '9_special', left: '8_special', up: '6_special', down: '0_special', right: 'aolemail_special' }, { text: '0', key: '0_special', left: '/', up: '8_special', down: 'btnEnroll_special', right: 'hotmailemail_special' }, { text: '', key: 'btnEnroll_special', left: 'btnCancel_special', up: '[', down: '', right: '' }, { text: '', key: 'btnCancel_special', left: '', up: '[', down: '', right: 'btnEnroll_special' }, { text: '1', key: '1', left: 'i', up: 'clear', down: '4', right: '2' }, { text: '2', key: '2', left: '1', up: 'clear', down: '5', right: '3' }, { text: '3', key: '3', left: '2', up: 'clear', down: '6', right: 'gmailemail' }, { text: '4', key: '4', left: 'r', up: '1', down: '7', right: '5' }, { text: '5', key: '5', left: '4', up: '2', down: '8', right: '6' }, { text: '6', key: '6', left: '5', up: '3', down: '9', right: 'yahooemail' }, { text: '7', key: '7', left: 'z', up: '4', down: '0', right: '8' }, { text: '8', key: '8', left: '7', up: '5', down: '0', right: '9' }, { text: '9', key: '9', left: '8', up: '6', down: '0', right: 'aolemail' }, { text: '0', key: '0', left: 'underscore', up: '8', down: 'btnEnroll', right: 'hotmailemail' }, { text: '@', key: 'atThe', left: '', up: 's', down: 'btnEnroll', right: 'dot' }, { text: '.', key: 'dot', left: 'atThe', up: 't', down: 'btnEnroll', right: 'dash' }, { text: '-', key: 'dash', left: 'dot', up: 'u', down: 'btnEnroll', right: 'underscore' }, { text: '_', key: 'underscore', left: 'dash', up: 'v', down: 'btnEnroll', right: '0' }];
	    this.showEmailError = false;
	    this.cursorCnt = 0;
	    this.subStringOne = '';
	    this.subStringTwo = '';
	    this.displayModal = false;
	    this.displayModalContent = false;
	    this.loading = false;
	
	    navigationManager.registerViewComponent(this, $scope, 'home.keyboard');
	    //omniture when Enroll update email keyboard
	    console.log('!!omniture when Enroll update email keyboard');
	    this.analyticsService.sendReport('go paperless', 'email keyboard', 'event1', null, null, null, null, null, this.$rootScope.omnitureBillingStatus, $scope.omniturePaperlessbill);
	
	    this.getKeyNavigation = function (itemId) {
	      return _this.keynavigation.filter(function (item) {
	        return item.key === itemId;
	      });
	    };
	
	    this.textChange = function (value) {
	      var regEx = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/;
	      var result = regEx.test(value);
	      return !result;
	    };
	
	    this.enteredEmail = storage.getItem('session', 'userEmail') || '';
	    //this.enteredEmail = 'bhavindesai20@gmail.com';
	    this.startIndex = this.enteredEmail ? this.enteredEmail.length : 0;
	    this.subStringOne = this.enteredEmail;
	    this.doSelect(this.startIndex, this.startIndex);
	    if (this.enteredEmail === '') {
	      this.currentItem = this.getKeyNavigation('a');
	      this.addFocusClass('a');
	    } else {
	      this.currentItem = this.getKeyNavigation('del');
	      this.addFocusClass('del');
	    }
	
	    this.keyWatch = function (event) {
	      var eventTarget = document.getElementById('keyBoardContainer');
	      eventTarget.addEventListener('keydown', _this.keydown);
	      eventTarget.addEventListener('keyup', _this.keyup);
	    };
	
	    this.keyup = function () {
	      //console.log({"subStringOne":this.subStringOne,"subStringTwo":this.subStringTwo,
	      //  "enteredEmail":this.enteredEmail,"startIndex":this.startIndex,"cursorCnt":this.cursorCnt});
	    };
	
	    this.keydown = function (event) {
	      var navItem = _this.currentItem[0];
	      _this.eventPropFocus(event);
	      if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	        _this.eventPropFocus(event);
	        if (!_this.displayAlertModal && !_this.displayModal) {
	          document.getElementById('keyBoardContainer').removeEventListener('keydown', _this.keydown);
	          _this.$state.go('home.paperlessbilling');
	        } else {
	          console.log("Back button should not work here");
	        }
	      } else if (event.keyCode === 13) {
	        if (navItem.key === 'btnCancel' || navItem.key === 'btnCancel_special') {
	          _this.eventPropFocus(event);
	          document.getElementById('keyBoardContainer').removeEventListener('keydown', _this.keydown);
	          _this.$state.go('home.paperlessbilling');
	        } else if (navItem.key === 'btnEnroll' || navItem.key === 'btnEnroll_special') {
	          //omniture when Enroll update email keyboard button select
	          console.log('!!omniture when Enroll update email keyboard button select');
	          _this.analyticsService.sendReport('go paperless', 'email keyboard', null, null, null, null, 'Enroll', _this.$rootScope.analytics.omniturePath + '/paperlessbilling', _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	          if (_this.enteredEmail) {
	            _this.$scope.$apply(function () {
	              _this.showEmailError = _this.textChange(_this.enteredEmail);
	              if (!_this.showEmailError) {
	                _this.displayModal = true;
	                //omniture when Enroll update email keyboard confirmation popup
	                console.log('!!omniture when Enroll update email keyboard confirmation popup');
	                _this.analyticsService.sendReport('go paperless', 'email keyboard review', 'event1', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	                _this.displayModalContent = true;
	                _this.removeFocusClass(navItem.key);
	                if (_this.special_characters = false) {
	                  _this.currentItem = _this.getKeyNavigation('btnConfirm_special');
	                } else {
	                  _this.currentItem = _this.getKeyNavigation('btnConfirm');
	                }
	                _this.addFocusClass(_this.currentItem[0].key);
	                _this.eventPropFocus(event);
	              } else {
	                //omniture when email keyboard error
	                console.log('!!omniture when email keyboard error');
	                _this.analyticsService.sendReport('go paperless', 'email keyboard error', null, 'invalid email error', null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	              }
	            });
	          } else {
	            _this.$scope.$apply(function () {
	              _this.showEmailError = _this.textChange(_this.enteredEmail);
	            });
	          }
	        } else if (navItem.key === 'btnBack') {
	          console.log("i am coming here in keycode 13");
	          _this.$scope.$apply(function () {
	            _this.displayModal = false;
	            _this.displayModalContent = false;
	            _this.removeFocusClass(navItem.key);
	            _this.currentItem = _this.getKeyNavigation('btnEnroll');
	            _this.addFocusClass(_this.currentItem[0].key);
	            _this.addFocusClass('btnEnroll');
	            _this.eventPropFocus(event);
	          });
	        } else if (navItem.key === 'btnBack_special') {
	          console.log("i am coming here in keycode 13");
	          _this.$scope.$apply(function () {
	            _this.displayModal = false;
	            _this.displayModalContent = false;
	            _this.removeFocusClass(navItem.key);
	            _this.currentItem = _this.getKeyNavigation('btnEnroll_special');
	            _this.addFocusClass(_this.currentItem[0].key);
	            _this.addFocusClass('btnEnroll');
	            _this.eventPropFocus(event);
	          });
	        } else if (navItem.key === 'btnConfirm' || navItem.key === 'btnConfirm_special') {
	          console.log("i am coming here in keycode 13");
	          //omniture when Enroll update email keyboard confirmation popup button select
	          console.log('!!omniture when Enroll update email keyboard confirmation popup button select');
	          _this.analyticsService.sendReport('go paperless', 'email keyboard review', null, null, null, null, 'confirm', _this.$rootScope.analytics.omniturePath + '/landingpage/paperlessbillinglanding', _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	          _this.$scope.$apply(function () {
	            _this.removeFocusClass(navItem.key);
	            _this.displayModalContent = false;
	            _this.loading = true;
	            var emailVal = _this.enteredEmail;
	            billingService.enrollPaperlessBill(false, emailVal).then(function (res) {
	              console.log("Result in enroll api:", res);
	              if (res.data.responseInfo !== null && res.data.responseInfo.statusCode === "00000") {
	                _this.loading = false;
	                _this.$rootScope.enrollValue = true;
	
	                //omniture paperless enrollment success
	                console.log('!!omniture paperless enrollment success');
	                _this.$rootScope.paperlessbilling = true;
	                _this.analyticsService.sendReport('go paperless', 'paperless enrollment success', 'event7', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, true, _this.$rootScope.analytics.omniturePath + '/landingpage');
	
	                _this.eventPropFocus(event);
	                document.getElementById('keyBoardContainer').removeEventListener('keydown', _this.keydown);
	                _this.$rootScope.fromPaperlessBillingPage = true;
	                _this.$state.go('home.landingpage', {}, { reload: true });
	              } else {
	                _this.loading = false;
	                _this.displayModal = false;
	                _this.displayAlertModal = true;
	                _this.currentItem = _this.getKeyNavigation('btnOK');
	                _this.addFocusClass(_this.currentItem[0].key);
	                _this.eventPropFocus(event);
	              }
	            });
	          });
	        } else if (navItem.key === 'btnOK') {
	          console.log("i am coming here in keycode 13 of button OK");
	          _this.$scope.$apply(function () {
	            _this.displayAlertModal = false;
	            _this.removeFocusClass(navItem.key);
	            _this.currentItem = _this.getKeyNavigation('btnEnroll');
	            _this.addFocusClass(_this.currentItem[0].key);
	            _this.addFocusClass('btnEnroll');
	            _this.eventPropFocus(event);
	          });
	        } else if (navItem.key === 'del') {
	          //if something available to delete
	          if (_this.subStringOne) {
	            _this.$scope.$apply(function () {
	              _this.subStringOne = _this.subStringOne.slice(0, -1);
	              _this.enteredEmail = _this.subStringOne + _this.subStringTwo;
	              _this.startIndex = _this.startIndex != 0 ? _this.startIndex - 1 : 0;
	              _this.showEmailError = false;
	            });
	            _this.doSelect(_this.subStringOne.length, _this.subStringOne.length);
	          }
	        } else if (navItem.key === 'del_special') {
	          //if something available to delete
	          if (_this.subStringOne) {
	            _this.$scope.$apply(function () {
	              _this.subStringOne = _this.subStringOne.slice(0, -1);
	              _this.enteredEmail = _this.subStringOne + _this.subStringTwo;
	              _this.startIndex = _this.startIndex != 0 ? _this.startIndex - 1 : 0;
	              _this.showEmailError = false;
	            });
	            _this.doSelect(_this.subStringOne.length, _this.subStringOne.length);
	          }
	        } else if (navItem.key === 'inText') {
	          if (_this.enteredEmail && _this.enteredEmail.length != _this.cursorCnt) {
	            _this.showEmailError = false;
	            _this.cursorCnt = _this.cursorCnt + 1;
	            _this.startIndex = _this.startIndex - 1;
	            _this.subStringOne = _this.enteredEmail.substr(0, _this.startIndex);
	            _this.subStringTwo = _this.enteredEmail.substr(_this.startIndex);
	            console.log(_this.subStringOne + ' String change ' + _this.subStringTwo);
	            _this.doSelect(_this.startIndex, _this.startIndex);
	          }
	        } else if (navItem.key === 'inText_special') {
	          if (_this.enteredEmail && _this.enteredEmail.length != _this.cursorCnt) {
	            _this.showEmailError = false;
	            _this.cursorCnt = _this.cursorCnt + 1;
	            _this.startIndex = _this.startIndex - 1;
	            _this.subStringOne = _this.enteredEmail.substr(0, _this.startIndex);
	            _this.subStringTwo = _this.enteredEmail.substr(_this.startIndex);
	            console.log(_this.subStringOne + ' String change ' + _this.subStringTwo);
	            _this.doSelect(_this.startIndex, _this.startIndex);
	          }
	        } else if (navItem.key === 'outText') {
	          if (_this.enteredEmail && _this.cursorCnt >= 0) {
	            _this.showEmailError = false;
	            _this.cursorCnt = _this.cursorCnt != 0 ? _this.cursorCnt - 1 : 0;
	            _this.startIndex = _this.startIndex + 1;
	            _this.subStringOne = _this.enteredEmail.substr(0, _this.startIndex);
	            _this.subStringTwo = _this.enteredEmail.substr(_this.startIndex);
	            console.log(_this.subStringOne + ' String change ' + _this.subStringTwo);
	            _this.doSelect(_this.startIndex, _this.startIndex);
	          }
	        } else if (navItem.key === 'outText_special') {
	          if (_this.enteredEmail && _this.cursorCnt >= 0) {
	            _this.showEmailError = false;
	            _this.cursorCnt = _this.cursorCnt != 0 ? _this.cursorCnt - 1 : 0;
	            _this.startIndex = _this.startIndex + 1;
	            _this.subStringOne = _this.enteredEmail.substr(0, _this.startIndex);
	            _this.subStringTwo = _this.enteredEmail.substr(_this.startIndex);
	            console.log(_this.subStringOne + ' String change ' + _this.subStringTwo);
	            _this.doSelect(_this.startIndex, _this.startIndex);
	          }
	        } else if (navItem.key === 'clear') {
	          _this.$scope.$apply(function () {
	            _this.enteredEmail = '';
	            _this.subStringOne = '';
	            _this.subStringTwo = '';
	            _this.startIndex = 0;
	            //this.showEmailError =  this.textChange(this.enteredEmail);
	          });
	          _this.doSelect(_this.startIndex, _this.startIndex);
	        } else if (navItem.key === 'clear_special') {
	          _this.$scope.$apply(function () {
	            _this.enteredEmail = '';
	            _this.subStringOne = '';
	            _this.subStringTwo = '';
	            _this.startIndex = 0;
	            //this.showEmailError =  this.textChange(this.enteredEmail);
	          });
	          _this.doSelect(_this.startIndex, _this.startIndex);
	        } else if (navItem.key === 'special_characters') {
	          console.log('you clicked on the special characters');
	          _this.special_characters = true;
	          console.log("this.special_characters is " + _this.special_characters);
	          _this.removeFocusClass(navItem.key);
	          _this.currentItem = _this.getKeyNavigation(navItem.next);
	          _this.addFocusClass(_this.currentItem[0].key);
	          _this.$scope.$apply(function () {
	            _this.enteredEmail = _this.subStringOne + navItem.text + _this.subStringTwo;
	            _this.showEmailError = false;
	            //this.showEmailError = this.textChange(this.enteredEmail);
	          });
	        } else if (navItem.key === 'regular_characters') {
	            console.log('you clicked on the regular characters');
	            _this.special_characters = false;
	            console.log("this.special_characters is " + _this.special_characters);
	            _this.removeFocusClass(navItem.key);
	            _this.currentItem = _this.getKeyNavigation(navItem.next);
	            _this.addFocusClass(_this.currentItem[0].key);
	            _this.$scope.$apply(function () {
	              _this.enteredEmail = _this.subStringOne + navItem.text + _this.subStringTwo;
	              _this.showEmailError = false;
	              //this.showEmailError = this.textChange(this.enteredEmail);
	            });
	          } else {
	              _this.$scope.$apply(function () {
	                _this.enteredEmail = _this.subStringOne + navItem.text + _this.subStringTwo;
	                _this.showEmailError = false;
	                //this.showEmailError = this.textChange(this.enteredEmail);
	              });
	              _this.startIndex = _this.startIndex + navItem.text.length;
	              _this.subStringOne = _this.enteredEmail.substr(0, _this.startIndex);
	              _this.subStringTwo = _this.enteredEmail.substr(_this.startIndex);
	              console.log(_this.subStringOne + ' String change ' + _this.subStringTwo);
	              _this.doSelect(_this.subStringOne.length, _this.subStringOne.length);
	            }
	      } else if (event.code === 'ArrowRight' || event.keyIdentifier === 'Right' || event.keyCode === 39) {
	        if (navItem.right) {
	          _this.removeFocusClass(navItem.key);
	          _this.currentItem = _this.getKeyNavigation(navItem.right);
	          _this.addFocusClass(_this.currentItem[0].key);
	          _this.eventPropFocus(event);
	        } else {
	          _this.eventPropFocus(event);
	        }
	      } else if (event.code === 'ArrowLeft' || event.keyIdentifier === 'Left' || event.keyCode === 37) {
	        if (navItem.left) {
	          _this.removeFocusClass(navItem.key);
	          _this.currentItem = _this.getKeyNavigation(navItem.left);
	          _this.addFocusClass(_this.currentItem[0].key);
	          _this.eventPropFocus(event);
	        } else {
	          _this.eventPropFocus(event);
	        }
	      } else if (event.code === 'ArrowUp' || event.keyIdentifier === 'Up' || event.keyCode === 38) {
	        if (navItem.up) {
	          _this.removeFocusClass(navItem.key);
	          _this.currentItem = _this.getKeyNavigation(navItem.up);
	          _this.addFocusClass(_this.currentItem[0].key);
	          _this.eventPropFocus(event);
	        } else {
	          _this.eventPropFocus(event);
	        }
	      } else if (event.code === 'ArrowDown' || event.keyIdentifier === 'Down' || event.keyCode === 40) {
	        if (navItem.down) {
	          _this.removeFocusClass(navItem.key);
	          _this.currentItem = _this.getKeyNavigation(navItem.down);
	          _this.addFocusClass(_this.currentItem[0].key);
	          _this.eventPropFocus(event);
	        } else {
	          _this.eventPropFocus(event);
	        }
	      }
	    };
	  }
	
	  _createClass(KeyboardController, [{
	    key: 'addFocusClass',
	    value: function addFocusClass(id) {
	      document.getElementById(id).classList.add('focusKey');
	    }
	  }, {
	    key: 'removeFocusClass',
	    value: function removeFocusClass(id) {
	      document.getElementById(id).classList.remove('focusKey');
	    }
	  }, {
	    key: 'focusElement',
	    value: function focusElement(elementId) {
	      var ele = document.getElementById(elementId);
	      if (ele) {
	        ele.focus();
	      } else {
	        setTimeout(this.focusElement.bind(this, elementId));
	      }
	    }
	  }, {
	    key: 'eventPropFocus',
	    value: function eventPropFocus(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    }
	  }, {
	    key: 'doSelect',
	    value: function doSelect(start, end) {
	      var input = document.getElementById("userEmailId");
	      input.focus();
	      this.setSelectionRange(input, start, end);
	    }
	  }, {
	    key: 'setSelectionRange',
	    value: function setSelectionRange(input, start, end) {
	      input.setSelectionRange(start, end);
	    }
	  }, {
	    key: 'getSplit',
	    value: function getSplit(str, cnt) {}
	  }]);
	
	  return KeyboardController;
	})();
	
	KeyboardController.$inject = ['storage', '$state', '$scope', '$rootScope', 'navigationManager', 'billingService', 'analyticsService'];
	
	exports['default'] = KeyboardController;
	module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(113);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./keyboard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./keyboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".menu-name-keyboard{position:absolute;top:6.45vh;left:17.7vw;font-style:normal;font-size:1.72vw;line-height:1}.menu-name-keyboard .myAccount{color:#afb6b8;line-height:1;font-size:2.03vw}.topVerbiageKeyBoard{margin:-.75vh 9.2vw 5vh 8.97vw;font-size:22px;color:#f1f1f1;line-height:1.2}.keyboardMain{margin:0 9.2vw 0 8.97vw;background-color:rgba(93,93,93,.4);min-height:62.5vh;overflow:hidden}.keyboardMain .userEmailInfo{margin:3.25vh 2.7vw 0 3.13vw}.keyboardMain .userEmailInfo .emailInput{float:left;width:58%;font-size:22px;color:#f1f1f1;font-weight:700;line-height:2}.keyboardMain .userEmailInfo .emailInput #userEmailId{outline:none;border:none;width:98%;background-color:transparent;color:#199ed8;text-shadow:0 0 0 #fff;-webkit-text-fill-color:transparent}.keyboardMain .userEmailInfo .emailInput #userEmailId:focus{outline:none}.keyboardMain .userEmailInfo .emailError{float:left;width:42%;font-size:22px;color:#f1f1f1;line-height:2}.keyboardMain .userEmailInfo .emailError img{width:32px;height:32px;display:inline-block;vertical-align:middle}.keyboardMain .focusKey{background-color:#f1f1f1!important;color:#000!important}.keyboardMain .keyBoardLayout{margin:2vh 3.5vw 0 3.7vw;min-height:40vh}.keyboardMain .keyBoardLayout .keyBoardLeft{float:left;min-height:35vh;border-right:1px solid #fff;width:67%;padding-top:2.2vh}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .alphaNumeric,.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .specialFunction{width:100%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #del,.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #del_special{background:transparent url(" + __webpack_require__(114) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #inText,.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #inText_special{background:transparent url(" + __webpack_require__(115) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #outText,.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #outText_special{background:transparent url(" + __webpack_require__(116) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #clear,.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #clear_special{background:transparent url(" + __webpack_require__(117) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #special_characters{background:transparent url(" + __webpack_require__(118) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #del.focusKey{background:transparent url(" + __webpack_require__(119) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #inText.focusKey{background:transparent url(" + __webpack_require__(120) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #outText.focusKey{background:transparent url(" + __webpack_require__(121) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #clear.focusKey{background:transparent url(" + __webpack_require__(122) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #special_characters.focusKey{background:transparent url(" + __webpack_require__(123) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout #regular_characters{background:transparent url(" + __webpack_require__(124) + ") no-repeat 50%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .alphaNumeric .alpha{float:left;width:70%}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .alphaNumeric .numeric{float:left;width:25%;margin:0 auto}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .hideITForSpace{visibility:hidden}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .alphabets{float:left;font-size:22px;background-color:transparent;border:none;text-align:center;width:46px;height:46px;align-items:center}.keyboardMain .keyBoardLayout .keyBoardLeft .keyLayout .alphabets:focus{background-color:#f1f1f1;color:#000}.keyboardMain .keyBoardLayout .keyBoardRight{float:left;min-height:38vh;width:32.8%}.keyboardMain .keyBoardLayout .keyBoardRight .emailProviders{width:78%;margin-left:11%;margin-top:-10px}.keyboardMain .keyBoardLayout .keyBoardRight .emailProviders .providers{background-color:transparent;border:none;font-size:22px;line-height:2;vertical-align:middle;padding:5px 25px;margin-bottom:5px;width:16vw;text-align:left}.keyboardMain .keyBoardLayout .keyBoardRight .emailProviders .providers:focus{background-color:#f1f1f1;color:#000}.keyboardMain .validatingButtons{margin:0 3.5vw 0 3.13vw;text-align:left;font-family:Open Sans Bold}.keyboardMain .validatingButtons .btnCancel,.keyboardMain .validatingButtons .btnEnroll{font-size:18px;color:#aeb4b5;font-weight:700;text-transform:none;line-height:2.056;border-radius:2px;border:none;background-color:#5e6263;height:40px;width:190px;text-align:center;align-items:center}.keyboardMain .validatingButtons .btnCancel:focus,.keyboardMain .validatingButtons .btnEnroll:focus{background-color:#f1f1f1;color:#000}.keyboardMain .validatingButtons .btnEnroll{margin-left:4px}.confirmation-modal{position:absolute;left:0;top:0;width:100%;height:100%;animation-duration:.5s;animation-name:slidein}.confirmation-modal .focusKey{background-color:#f1f1f1!important;color:#000!important}.confirmation-modal .modal{width:100%;height:100%;overflow:auto;padding:0;background-color:rgba(40,40,40,.95);margin:0}.confirmation-modal .modal .modal-content{width:46.5vw;background-color:#091b20;height:45.7vh;color:gray;margin:16% 0 0 28%;padding:0;font-size:2.8vmin;animation:animatetop .7s}.confirmation-modal .modal .modal-content .modal-wrapper{margin-top:-3%}.confirmation-modal .modal .modal-content .modal-wrapper .modal-header{height:5%;display:block;text-align:left;color:#fff;font-size:2vmin;padding:28px;background-color:#001319;font-family:Open Sans Bold}.confirmation-modal .modal .modal-content .modal-wrapper .modal-header h1{margin:0;font-size:26px}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details{display:block}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .billing{padding:30px}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .billing p{color:#f1f1f1}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .billing p .link-text{text-decoration:underline;color:#000}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group{float:right;margin:2.35vw;font-family:Open Sans Bold}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group .back-btn{border-radius:2px;background-color:#3b494d;width:16vw;color:#f1f1f1;height:5.65vh;border:#3b494d;margin-right:5px;font-size:20px;font-weight:700}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group .back-btn:focus,.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group .back-btn:hover{background-color:#f1f1f1;color:#000}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group .confirm-btn{border-radius:2px;background-color:#3b494d;width:16vw;color:#f1f1f1;height:5.65vh;border:#f1f1f1;margin-right:5px;font-size:20px;font-weight:700}.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group .confirm-btn:focus,.confirmation-modal .modal .modal-content .modal-wrapper .confirm-details .btn-group .confirm-btn:hover{background-color:#f1f1f1;color:#000;border:none}.alert-modal .modal .modal-content .modal-wrapper .payment-details .alert-msg-one .errorMsgAlertBox .keyboardErrorMsg{padding-left:5.7507813vw;padding-top:1vh}@keyframes slidein{0%{opacity:0}to{opacity:1}}", ""]);
	
	// exports


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _optimumidsComponent = __webpack_require__(126);
	
	var _optimumidsComponent2 = _interopRequireDefault(_optimumidsComponent);
	
	var optimumidsModule = _angular2['default'].module('optimumids', [_angularUiRouter2['default']]).component('optimumids', _optimumidsComponent2['default']);
	
	exports['default'] = optimumidsModule;
	module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _optimumidsHtml = __webpack_require__(127);
	
	var _optimumidsHtml2 = _interopRequireDefault(_optimumidsHtml);
	
	var _optimumidsController = __webpack_require__(128);
	
	var _optimumidsController2 = _interopRequireDefault(_optimumidsController);
	
	__webpack_require__(129);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _optimumidsHtml2['default'],
	  controller: _optimumidsController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name\" ng-show=\"!vm.optimumidsLoader\">\n    <span class=\"myAccount\">/</span>\n    <span>{{vm.name}}</span>\n</div>\n<div id=\"optimumidcontainer\">\n\t<div id=\"mainInfoDiv\" ng-init=\"vm.keyWatch($event)\">\n\t\t<div ng-show=\"!vm.optimumidsLoader\">\n\t\t\t<div class=\"optimumid-main\">\n\t\t\t\t<p class=\"msg-optid-tops\">You are using {{vm.currentOptIdCount}} out of {{vm.totalOptIdCount}} available Optimum IDs.</p>\n\t\t        <div class=\"encontent-left encontent-left-extra\">\n\t\t          <div class=\"optid-list\">\n\t\t          \t<optimumidlist\n\t\t\t\t        class=\"optimumid\"\n\t\t\t\t        up-is-prev=\"false\"\n\t\t\t\t        list-id=\"optimumids-list\"\n\t\t\t\t        btn-class=\"btn btn-nav-optimumids\"\n\t\t\t\t        items=\"vm.items\"\n\t\t\t\t        itemsLength=\"vm.itemsLength\"\n\t\t\t\t        item-click-handler=\"vm.itemClickHandler\"\n\t\t\t\t        prev-component-handler=\"vm.prevComponentHandler\"\n\t\t\t\t    />\n\t\t          </div>\n\t\t        </div>\n\t\t        <div class=\"encontent-right\">\n\t\t          <p class=\"msg-right-text\">\n\t\t          \tTo manage your Optimum IDs, visit <span class=\"link-text\">optimum.net/manageid</span> and sign in with the primary ID.\n\t\t          </p>\n\t\t          <div class=\"account-header\">\n\t\t          \t<span class=\"link-text\">The primary ID is {{vm.items[0].label}}.</span>\n\t\t          </div>\n\t\t        </div>\n\t\t        <div class=\"clearfix\"></div>\n\t\t    </div>\n\t\t</div>\n\t\t<div ng-show=\"vm.optimumidsLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n\t      <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
			value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var OptimumidsController = function OptimumidsController($state, $window, $rootScope, storage, laboxSSapi, analyticsService) {
			var _this = this;
	
			_classCallCheck(this, OptimumidsController);
	
			this.name = 'Optimum IDs';
			this.$state = $state;
			this.$rootScope = $rootScope;
			this.optimumidsLoader = true;
			this.hasOptimumID = storage.getItem('session', 'hasOptimumId') ? true : false;
			this.totalOptIdCount = storage.getItem('session', 'maxIdAvailable');
			this.errorWhileLoading = false;
			this.primaryIndex = 0;
			this.primaryObj = null;
	
			this.keyWatch = function (event) {
					window.addEventListener('keydown', _this.keydown, false);
			};
	
			this.keydown = function (event) {
					event.stopPropagation();
					if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
							window.removeEventListener('keydown', _this.keydown);
							_this.$rootScope.fromOptimumIdPage = true;
							_this.$state.go('home.landingpage');
					}
			};
	
			laboxSSapi.getAllOptimumIds().then(function (res) {
					if (res && res.data && res.data.status === 'Success') {
							// omniture when IDs load successfully
							console.log('!!omniture when IDs load successfully!!');
							analyticsService.sendReport('optimum ids', 'ids', 'event1', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
							/*console.log("result from optimum ids:", res.data);
	         var optids = [{
	             optimumid: "159755",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "true"
	         }, {
	             optimumid: "159751",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "false"
	         }, {
	             optimumid: "testoptsecid",
	             firstName: "optid",
	             lastName: "sec",
	             primary: "false"
	         }, {
	             optimumid: "lauren2733",
	             firstName: "Lauren",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "millie9755",
	             firstName: "Millie",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "allison2733",
	             firstName: "Allison",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "corptesting80",
	             firstName: "Corptesting80",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "159756",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "false"
	         }, {
	             optimumid: "159752",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "false"
	         }, {
	             optimumid: "testsecid",
	             firstName: "test",
	             lastName: "secid",
	             primary: "false"
	         }, {
	             optimumid: "nancy2733",
	             firstName: "Nancy",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "aubrey2733",
	             firstName: "Aubrey",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "ramtest5090",
	             firstName: "biu",
	             lastName: "test",
	             primary: "false"
	         }, {
	             optimumid: "corptesting79",
	             firstName: "Corptesting79",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "159755",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "true"
	         }, {
	             optimumid: "159751",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "false"
	         }, {
	             optimumid: "testoptsecid",
	             firstName: "optid",
	             lastName: "sec",
	             primary: "false"
	         }, {
	             optimumid: "lauren2733",
	             firstName: "Lauren",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "millie9755",
	             firstName: "Millie",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "allison2733",
	             firstName: "Allison",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "corptesting80",
	             firstName: "Corptesting80",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "159756",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "false"
	         }, {
	             optimumid: "159752",
	             firstName: "QA",
	             lastName: "Test",
	             primary: "false"
	         }, {
	             optimumid: "testsecid",
	             firstName: "test",
	             lastName: "secid",
	             primary: "false"
	         }, {
	             optimumid: "nancy2733",
	             firstName: "Nancy",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "aubrey2733",
	             firstName: "Aubrey",
	             lastName: "EmailMigration",
	             primary: "false"
	         }, {
	             optimumid: "ramtest5090",
	             firstName: "biu",
	             lastName: "test",
	             primary: "false"
	         }, {
	             optimumid: "corptesting79",
	             firstName: "Corptesting79",
	             lastName: "EmailMigration",
	             primary: "false"
	         }];*/
	
							_this.items = res.data.optimumIdInfo.map(function (item) {
									//this.items = optids.map(item => {
									return {
											isPrimary: item.userIDType,
											label: item.loginID,
											data: item.firstName + ' ' + item.lastName
									};
							});
							for (var i = 0; i < _this.items.length; i++) {
									if (_this.items[i].isPrimary === "true") {
											console.log("i is " + i);
											_this.primaryIndex = i;
									}
									console.log("there is no primary id");
							}
							console.log("this.primaryIndex is " + _this.primaryIndex);
							_this.primaryObj = _this.items[_this.primaryIndex];
							_this.items[_this.primaryIndex] = _this.items[0];
							_this.items[0] = _this.primaryObj;
	
							_this.currentOptIdCount = storage.getItem('session', 'optimum_ids').length;
							_this.itemsLength = _this.currentOptIdCount;
							if (_this.itemsLength != null && _this.itemsLength > _this.totalOptIdCount) {
									_this.totalOptIdCount = _this.itemsLength;
							}
							_this.optPrimary = storage.getItem('session', 'primary_id');
							_this.hasOptimumID = true;
							_this.optimumidsLoader = false;
							setTimeout(function () {
									document.getElementById('next-btn').focus();
							}, 100);
					} else if (res && res.data && res.data.status === 'FAILURE') {
							// omniture when IDs with API error
							console.log('!!omniture when IDs with API error!!');
							analyticsService.sendReport('optimum ids', 'optimum ids', 'event1', 'api error', null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
							_this.hasOptimumID = false;
							_this.optimumidsLoader = false;
					} else {
							_this.errorWhileLoading = true;
							_this.optimumidsLoader = false;
					}
			});
	};
	
	OptimumidsController.$inject = ['$state', '$window', '$rootScope', 'storage', 'laboxSSapi', 'analyticsService'];
	
	exports['default'] = OptimumidsController;
	module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(130);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./optimumids.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./optimumids.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".optimumid-main{margin:0 9.2vw 0 8.97vw;background-color:hsla(193,4%,50%,.4);min-height:30.86vh;height:77.5vh;overflow:hidden}.optimumid-main .msg-optid-tops{margin-top:2.75vh;margin-left:2.35vw;font-weight:800;font-size:2.032vw}.optimumid-main .encontent-left{float:left;min-height:30.86vh;width:45.5vw}.optimumid-main .encontent-left .encontent-left-extra{width:51.95vw!important}.optimumid-main .encontent-left .optid-list{margin-top:4.5vh;margin-left:2.35vw}.optimumid-main .encontent-left .msg-enroll-tops{font-size:1.7vw;margin-top:1.6vh;margin-left:3.12vw;margin-bottom:-16vh}.optimumid-main .encontent-left .msg-enroll-bottoms{font-size:1.75vw;margin-top:19.16vh;margin-left:3.12vw;margin-bottom:5vh}.optimumid-main .encontent-left .paymentbox{padding:6.2vh 2.34vw 2.75vh 2.42vw;overflow:hidden}.optimumid-main .encontent-left .paymentbox .amounduebox{background-color:#37393a;padding:6.26vh 1.56vw 4.17vh 1.64vw}.optimumid-main .encontent-left .paymentbox .amounduebox .textamountduebox{width:100%;font-size:2.5vw;font-weight:700;line-height:1.2}.optimumid-main .encontent-left .paymentbox .amounduebox #deorpastAmount,.optimumid-main .encontent-left .paymentbox .amounduebox #deorpastAmountDue,.optimumid-main .encontent-left .paymentbox .amounduebox .multiVersionDeauthandDue{color:#e22d02}.optimumid-main .encontent-left .paymentbox .amounduebox .dotdot{color:#fff}.optimumid-main .encontent-left .paymentbox .amounduebox .textamountdueboxright{text-align:right}.optimumid-main .encontent-left .paymentbox .amounduebox .textamtduedate{font-weight:400}.optimumid-main .encontent-left .paymentbox .amounduebox .date_due{color:#707678;font-weight:400}.optimumid-main .encontent-left .paymentbox .amounduebox .pastdueReplaceDate{color:#a1a1a1;font-weight:200;font-size:20px}.optimumid-main .encontent-left .paymentbox .amounduebox .amountdue{display:table-cell;white-space:nowrap;line-height:1.4;padding-right:5px}.optimumid-main .encontent-left .paymentbox .amounduebox .price{display:table-cell;text-align:right;white-space:nowrap;padding-left:5px}.optimumid-main .encontent-left .paymentbox .amounduebox .creditBal{white-space:nowrap}.optimumid-main .encontent-left .paymentbox .paymethodbox{min-height:6.4vh;overflow:hidden}.optimumid-main .encontent-left .paymentbox .paymethodbox .noPaymentMethod{font-size:1.72vw;font-weight:700;background-color:rgba(53,60,69,.8);padding:1.4vh 1.56vw;color:#199ed8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important}.optimumid-main .encontent-left .paymentbox .paymethodbox .blockedUser{font-size:1.4vw;font-weight:500}.optimumid-main .encontent-left .paymentbox .paymethodbox .noPaymentDue{font-size:1.72vw;background-color:rgba(53,60,69,.8);padding:1.4vh 1.56vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important;text-align:center}.optimumid-main .encontent-right{margin-right:2vw;margin-top:4vh}.optimumid-main .encontent-right .add-enroll-btn{color:#aeb4b5!important;text-decoration:none;font-weight:800;font-size:18px;margin-left:6vw;margin-top:18.16vh;margin-right:3.12vw;width:26.57vw!important;border-radius:2px;background-color:#3b494d;width:16vw;color:#fff;height:5.65vh;border:#3b494d}.optimumid-main .encontent-right .add-enroll-btn:focus,.optimumid-main .encontent-right .add-enroll-btn:hover{overflow:hidden;background:#199ed8;color:#fff!important}.optimumid-main .encontent-right .msg-enroll-tops{font-size:1.5vw;margin-top:5.6vh;margin-right:3.12vw;margin-bottom:-16vh}.optimumid-main .encontent-right .msg-enroll-bottoms{font-size:1.55vw;margin-top:19.16vh;margin-right:3.12vw}.optimumid-main .encontent-right .account-header{margin-top:2vh;margin-bottom:2vh}.optimumid-main .encontent-right .account-header .link-text{color:#f1f1f1;font-size:22px;font-weight:700;font-family:Open Sans Bold}.optimumid-main .encontent-right .msg-right-text{font-weight:500;font-size:22px}.optimumid-main .encontent-right .msg-right-text .link-text{color:#f1f1f1;text-decoration:underline}.optimumid-main .btn-group-enroll{margin:5.65vh 0 4.2vh 27vw}.optimumid-main .btn-group-enroll .enroll-btn{color:#aeb4b5!important;text-decoration:none;font-weight:800;font-size:18px;border-radius:2px;background-color:#3b494d;width:19vw;color:#fff;height:6vh;border:#3b494d}.optimumid-main .btn-group-enroll .enroll-btn:focus,.optimumid-main .btn-group-enroll .enroll-btn:hover{overflow:hidden;background-color:#f1f1f1;color:#000!important}.optimumid-main .btn-group-enroll .update-enroll-btn{width:29.3vw!important;margin-right:10px}#optimumids-list_btn0{padding-left:3.5%!important;padding-right:0!important}", ""]);
	
	// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _suddenlinkidsComponent = __webpack_require__(132);
	
	var _suddenlinkidsComponent2 = _interopRequireDefault(_suddenlinkidsComponent);
	
	var suddenlinkidsModule = _angular2['default'].module('suddenlinkids', [_angularUiRouter2['default']]).component('suddenlinkids', _suddenlinkidsComponent2['default']);
	
	exports['default'] = suddenlinkidsModule;
	module.exports = exports['default'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _suddenlinkidsHtml = __webpack_require__(133);
	
	var _suddenlinkidsHtml2 = _interopRequireDefault(_suddenlinkidsHtml);
	
	var _suddenlinkidsController = __webpack_require__(134);
	
	var _suddenlinkidsController2 = _interopRequireDefault(_suddenlinkidsController);
	
	__webpack_require__(135);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _suddenlinkidsHtml2['default'],
	  controller: _suddenlinkidsController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name\" ng-show=\"!vm.optimumidsLoader\">\n  <span class=\"myAccount\">/</span>\n  <span>{{vm.name}}</span>\n</div>\n<div id=\"optimumidcontainer\">\n  <div id=\"mainInfoDiv\" ng-init=\"vm.keyWatch($event)\">\n    <div ng-show=\"!vm.suddenlinkidsLoader\">\n      <div class=\"optimumid-main\">\n        <p class=\"msg-optid-tops\">You are using {{vm.currentOptIdCount}} out of {{vm.totalOptIdCount}} available usernames.</p>\n        <div class=\"encontent-left encontent-left-extra\">\n          <div class=\"optid-list\">\n            <optimumidlist\n              class=\"optimumid\"\n              up-is-prev=\"false\"\n              list-id=\"optimumids-list\"\n              btn-class=\"btn btn-nav-optimumids\"\n              items=\"vm.items\"\n              itemsLength=\"vm.itemsLength\"\n              item-click-handler=\"vm.itemClickHandler\"\n              prev-component-handler=\"vm.prevComponentHandler\"\n            />\n          </div>\n        </div>\n        <div class=\"encontent-right\">\n          <p class=\"msg-right-text\">\n            To manage your usernames, visit <span class=\"link-text\">suddenlink.net</span> and sign in with the primary username.\n          </p>\n          <div class=\"account-header\">\n            <span class=\"link-text\">The primary username is {{vm.items[0].label}}.</span>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n    <div ng-show=\"vm.suddenlinkidsLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n      <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var SuddenlinkidsController = function SuddenlinkidsController($state, $rootScope, storage, laboxSSapi) {
	  var _this = this;
	
	  _classCallCheck(this, SuddenlinkidsController);
	
	  this.name = 'Usernames';
	  this.$state = $state;
	  this.$rootScope = $rootScope;
	  this.suddenlinkidsLoader = true;
	  this.totalOptIdCount = storage.getItem('session', 'maxIdAvailable');
	  this.errorWhileLoading = false;
	
	  this.keyWatch = function (event) {
	    window.addEventListener('keydown', _this.keydown, false);
	  };
	
	  this.keydown = function (event) {
	    event.stopPropagation();
	    if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	      window.removeEventListener('keydown', _this.keydown);
	      _this.$rootScope.fromSuddenlinkIdPage = true;
	      _this.$state.go('home.landingpage');
	    }
	  };
	
	  laboxSSapi.getAllSuddenlinkIds().then(function (res) {
	    if (res && res.data && res.data.accountSummaryResponse.statusDescription && res.data.accountSummaryResponse.statusDescription == "Success") {
	      _this.unregUser = res.data.accountSummaryResponse.users[0].userName.search("unreg:") + 1;
	      console.log('this.unregUser is ' + _this.unregUser);
	      if (_this.unregUser !== 1) {
	
	        console.log('get all suddenlink id response --> ', res.users);
	        storage.setItem('session', 'suddenlink_ids', res.data.accountSummaryResponse.users);
	        storage.setItem('session', 'suddenlink_primary_id', res.data.accountSummaryResponse.primaryId);
	        console.log('suddenlink primary id is set up in session storage');
	        _this.items = res.data.accountSummaryResponse.users.map(function (item) {
	          //this.items = optids.map(item => {
	          return {
	            label: item.userName,
	            data: item.firstName + ' ' + item.lastName
	          };
	        });
	
	        _this.currentOptIdCount = storage.getItem('session', 'suddenlink_ids').length;
	        _this.itemsLength = _this.currentOptIdCount;
	        _this.optPrimary = storage.getItem('session', 'suddenlink_primary_id');
	        _this.hasSuddenlinkId = storage.getItem('session', 'hasSuddenlinkId');
	        _this.suddenlinkidsLoader = false;
	        setTimeout(function () {
	          document.getElementById('next-btn').focus();
	        }, 100);
	      } else {
	        _this.errorWhileLoading = true;
	        _this.hasSuddenlinkId = false;
	        _this.$rootScope.fromSuddenlinkIdPage = true;
	        _this.$state.go('home.landingpage');
	      }
	    } else {
	      _this.hasSuddenlinkId = false;
	      _this.suddenlinkidsLoader = false;
	      _this.$rootScope.fromSuddenlinkIdPage = true;
	      _this.$state.go('home.landingpage');
	      _this.errorWhileLoading = true;
	    }
	  });
	};
	
	SuddenlinkidsController.$inject = ['$state', '$rootScope', 'storage', 'laboxSSapi'];
	
	exports['default'] = SuddenlinkidsController;
	module.exports = exports['default'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(136);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./suddenlinkids.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./suddenlinkids.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".suddenlinkids{color:red}", ""]);
	
	// exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _optimumidlistComponent = __webpack_require__(138);
	
	var _optimumidlistComponent2 = _interopRequireDefault(_optimumidlistComponent);
	
	var optimumidlistModule = _angular2['default'].module('optimumidlist', [_angularUiRouter2['default']]).component('optimumidlist', _optimumidlistComponent2['default']);
	
	exports['default'] = optimumidlistModule;
	module.exports = exports['default'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _optimumidlistHtml = __webpack_require__(139);
	
	var _optimumidlistHtml2 = _interopRequireDefault(_optimumidlistHtml);
	
	var _optimumidlistController = __webpack_require__(140);
	
	var _optimumidlistController2 = _interopRequireDefault(_optimumidlistController);
	
	__webpack_require__(141);
	
	var optimumidlistComponent = {
	  restrict: 'E',
	  bindings: {
	    btnClass: '@',
	    items: '=',
	    itemsLength: '@',
	    title: '=',
	    itemClickHandler: '=',
	    nextComponentHandler: '=',
	    prevComponentHandler: '=',
	    listId: '@',
	    labelField: '@',
	    upIsPrev: '@',
	    downIsNext: '@'
	  },
	  template: _optimumidlistHtml2['default'],
	  controller: _optimumidlistController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = optimumidlistComponent;
	module.exports = exports['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"list\">\n  <!--<div class=\"up-arrow\" ng-show=\"vm.startIndex &gt; 0\">\n    <i class=\"fa fa-sort-up\"></i>\n  </div>-->\n  <button id=\"{{vm.listId + '_btn' + ($index + vm.startIndex)}}\"\n          ng-class=\"vm.btnClass\"\n          ng-repeat=\"item in vm.displayItems\"\n          ng-keypress=\"vm.keyPressHandler($index, $event)\"\n          ng-keydown=\"vm.keyDownHandler($index, $event)\"\n          ng-keyup=\"vm.keyUpHandler($index, $event)\"\n          ng-focus=\"vm.focusHandler($index, $event)\">\n    <p class=\"opt-id\"><span class=\"star-icon\" ng-show=\"{{($index + vm.startIndex)}} == 0\"><i class=\"fa fa-star fa-lg\" aria-hidden=\"true\"></i></span><span class=\"optimumid\">{{item[vm.labelField]}}</span></p> <p class=\"opt-name\"><span class=\"user_name\">{{item[vm.userField]}}</span></p>\n  </button>\n  <!--<div class=\"down-arrow\" ng-show=\"vm.startIndex + vm.maxItems &lt; vm.items.length\">\n    <i class=\"fa fa-sort-down\"></i>\n  </div>-->\n</div>\n<div class=\"clearfix\"></div>\n<div class=\"pagination-block\">\n  <span ng-show=\"vm.fromSuddenlink\" class=\"star-icon\"><i class=\"fa fa-star fa-lg\" aria-hidden=\"true\"></i>Primary username</span>\n  <span ng-show=\"vm.fromOPtimum\" class=\"star-icon\"><i class=\"fa fa-star fa-lg\" aria-hidden=\"true\"></i>primary ID</span>\n  <div class=\"pagination\" ng-show=\"vm.maxItems &lt; vm.items.length\">\n    <button id=\"prev-btn\" class=\"pag-btns prev-btn\" ng-click=\"vm.pageUp()\"><i class=\"fa fa-lg fa-chevron-left\" aria-hidden=\"true\"></i></button>\n    <button class=\"pag-ind\">{{vm.page_num}}/{{vm.total_page_num}}</button>\n    <button id=\"next-btn\" class=\"pag-btns next-btn\" ng-click=\"vm.pageDown()\"><i class=\"fa fa-lg fa-chevron-right\" aria-hidden=\"true\"></i></button>\n  </div>\n</div>\n"

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	/**
	 * The OptimumidlistController class is designed to manage the navigation of a pageable sequence of items,
	 * like the video list.
	 *
	 * It displays all its elements using the same button classes in a vertical layout. It manages
	 * proper tabbing and arrow key navigation.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var OptimumidlistController = (function () {
	  /*-----------------------------------*\
	   * Constructor
	  \*-----------------------------------*/
	
	  function OptimumidlistController($window, $timeout, $scope, $state) {
	    var _this = this;
	
	    _classCallCheck(this, OptimumidlistController);
	
	    this.name = 'optimumidlist';
	
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$state = $state;
	    this.currentState = $state.current.name;
	
	    if (this.currentState === 'home.suddenlinkids') {
	      this.fromSuddenlink = true;
	      this.fromOPtimum = false;
	    } else {
	      this.fromSuddenlink = false;
	      this.fromOPtimum = true;
	    };
	
	    this._selectedIndex = 0;
	    this._labels = [];
	    this._datas = [];
	    this._maxItems = 8;
	    this._startIndex = 0;
	    this.listId = this.listId || 'NO_LIST_ID_PROVIDED';
	
	    this.ignoreNextUp = false;
	    this.itemsLength = this.itemsLength || 0;
	
	    this.page_num = 1;
	
	    this.labelField = 'label';
	    this.userField = 'data';
	
	    this._upIsPrev = this._upIsPrev === undefined ? true : this._upIsPrev;
	    this._downIsNext = this._downIsNext === undefined ? true : this._downIsNext;
	
	    //this._totalPageNum = this._totalPageNum === undefined ? true : this._totalPageNum;
	
	    $scope.$on('focus', function (event, args) {
	      if (args.id === _this.listId) {
	        _this.focus(args.index, args.focusOnPopulate, args.zeroIndex !== undefined ? args.zeroIndex : false);
	      }
	    });
	  }
	
	  /*-----------------------------------*\
	   * Properties
	  \*-----------------------------------*/
	
	  _createClass(OptimumidlistController, [{
	    key: 'focus',
	
	    /*-----------------------------------*\
	     * Methods
	    \*-----------------------------------*/
	    value: function focus(index, focusOnPopulate, zeroIndex) {
	      index = index || 0;
	
	      if (focusOnPopulate) {
	        this.focusOnPopulateIx = index;
	        return;
	      }
	
	      this.selectedIndex = (zeroIndex ? 0 : this.startIndex) + index;
	    }
	  }, {
	    key: 'focusSelectedIndex',
	    value: function focusSelectedIndex() {
	      var elId = this.listId + '_btn' + this._selectedIndex;
	      var el = document.getElementById(elId);
	
	      //console.log('Focusing', this._selectedIndex, el);
	
	      if (el) {
	        el.focus();
	      } else {
	        this.$timeout(this.focusSelectedIndex.bind(this));
	      }
	    }
	  }, {
	    key: 'pageDown',
	    value: function pageDown() {
	      if (this.items && this.items.length > this.startIndex + this.maxItems) {
	        this.startIndex += this.maxItems;
	
	        /*this.$timeout(_ => {
	          this.selectedIndex = this.startIndex;
	        });*/
	        this.page_num = this.page_num + 1;
	
	        //console.log('total number of ids:', this.itemsLength);
	        //console.log("this._totalPageNum:", this.total_page_num);
	        if (this.page_num === this.total_page_num) {
	          document.getElementById('prev-btn').focus();
	        } else {
	          document.getElementById('next-btn').focus();
	        }
	      }
	    }
	  }, {
	    key: 'pageUp',
	    value: function pageUp() {
	      if (this.startIndex > 0) {
	        this.startIndex -= this.maxItems;
	
	        if (this.startIndex < 0) {
	          this.startIndex = 0;
	        }
	        this.page_num = this.page_num - 1;
	        if (this.page_num === 1) {
	          document.getElementById('next-btn').focus();
	        }
	        /*this.$timeout(_ => {
	          this.selectedIndex = this.startIndex + this.maxItems - 1;
	        });*/
	      }
	    }
	  }, {
	    key: 'isUp',
	    value: function isUp(event) {
	      return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
	    }
	  }, {
	    key: 'isDown',
	    value: function isDown(event) {
	      return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
	    }
	  }, {
	    key: 'isRight',
	    value: function isRight(event) {
	      return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
	    }
	  }, {
	    key: 'isLeft',
	    value: function isLeft(event) {
	      return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
	    }
	
	    /*-----------------------------------*\
	     * Events
	    \*-----------------------------------*/
	  }, {
	    key: 'focusHandler',
	    value: function focusHandler(ix, event) {
	      this.selectedIndex = this.startIndex + ix;
	    }
	  }, {
	    key: 'keyPressHandler',
	    value: function keyPressHandler($index, event) {
	      if (event.charCode === 13) {
	        var ix = this.startIndex + $index;
	        if (this.itemClickHandler) {
	          this.itemClickHandler({
	            index: ix,
	            item: this._items[ix],
	            event: event
	          });
	        }
	      }
	    }
	  }, {
	    key: 'keyDownHandler',
	    value: function keyDownHandler($index, event) {
	      var _this2 = this;
	
	      var cancel = function cancel(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	        _this2.ignoreNextUp = true;
	      };
	
	      // Down arrow or tab key
	      if (event.code === 'Tab' && !event.shiftKey || this.isDown(event)) {
	        if ($index === this.maxItems - 1 && this.items.length - 1 > this.startIndex + $index) {
	          this.pageDown();
	          cancel(event);
	        } else if (this.selectedIndex + 1 < this.items.length) {
	          this.selectedIndex++;
	          cancel(event);
	        } else if (this.selectedIndex + 1 === this.items.length) {
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (event.code === 'Tab' && event.shiftKey || this.isUp(event)) {
	        //console.log('Up!', $index, this.maxItems, this.startIndex);
	        // Up arrow or shift tab
	        if ($index % this.maxItems === 0 && this.startIndex > 0) {
	          this.pageUp();
	          cancel(event);
	        } else if (this.selectedIndex > 0) {
	          this.selectedIndex--;
	          cancel(event);
	        } else if (this.selectedIndex === 0) {
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      }
	
	      if (this.downIsNext && this.isDown(event) && this.selectedIndex === this.items.length - 1 || this.isRight(event)) {
	        if (this.nextComponentHandler) {
	          this.canNext = true;
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (this.isLeft(event)) {
	        if (this.prevComponentHandler) {
	          this.canPrev = false;
	          if (this.listId === 'optimumids-list') {
	            document.getElementById('btn-videos').focus();
	          } else if (this.listId === 'spanish-optimumids-list') {
	            document.getElementById('btn-back-spanish').focus();
	          }
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      }
	    }
	  }, {
	    key: 'keyUpHandler',
	    value: function keyUpHandler($index, event) {
	      if (this.ignoreNextUp) {
	        this.ignoreNextUp = false;
	        return;
	      }
	
	      if (this.canNext && (this.downIsNext && this.isDown(event) && this.selectedIndex === this.items.length - 1 || this.isRight(event))) {
	        if (this.nextComponentHandler) {
	          var nextIndex = this.isDown(event) ? 0 : this.selectedIndex - this.startIndex;
	          this.nextComponentHandler(nextIndex, this.isDown(event));
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      } else if (this.canPrev && this.isLeft(event)) {
	        if (this.prevComponentHandler) {
	          var nextIndex = this.isUp(event) ? this.maxItems : this.selectedIndex - this.startIndex;
	          this.prevComponentHandler(nextIndex, this.isUp(event));
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      }
	
	      this.canNext = this.canPrev = false;
	    }
	  }, {
	    key: 'upIsPrev',
	    set: function set(value) {
	      this._upIsPrev = value !== 'false';
	    },
	    get: function get() {
	      return this._upIsPrev;
	    }
	  }, {
	    key: 'downIsNext',
	    set: function set(value) {
	      this._downIsNext = value !== 'false';
	    },
	    get: function get() {
	      return this._downIsNext;
	    }
	  }, {
	    key: 'items',
	    set: function set(value) {
	      var _this3 = this;
	
	      this._items = value;
	
	      this._labels = [];
	      this._datas = [];
	
	      if (this._items && this._items.length) {
	        this._items.forEach(function (item) {
	          _this3._labels.push(item.label);
	          _this3._datas.push(item.data);
	        });
	        this.itemsLength = this._items.length;
	        //console.log("this.itemsLength = ",this.itemsLength);
	        this.total_page_num = Math.floor(this.itemsLength / this._maxItems) + 1;
	      }
	
	      if (this.focusOnPopulateIx !== undefined) {
	        //console.log('Focusing after timeout', this.focusOnPopulateIx);
	        this.$timeout(function (_) {
	          return _this3.focus(_this3.focusOnPopulateIx);
	        });
	
	        this.focusOnPopulateIx = undefined;
	      }
	    },
	
	    //-----------------------------------
	    // items
	    //-----------------------------------
	    get: function get() {
	      return this._items;
	    }
	
	    //-----------------------------------
	    // displayItems
	    //-----------------------------------
	    /**
	     * Returns only the items that have been determined to be displayable based on the display
	     * startIndex and the maxItems.
	     *
	     * @returns {*}
	     */
	  }, {
	    key: 'displayItems',
	    get: function get() {
	      return this._items && this._items.length ? this._items.slice(this._startIndex, this._startIndex + this._maxItems) : [];
	    }
	
	    //-----------------------------------
	    // labels
	    //-----------------------------------
	  }, {
	    key: 'labels',
	    get: function get() {
	      return this._labels;
	    }
	
	    //-----------------------------------
	    // datas
	    //-----------------------------------
	  }, {
	    key: 'datas',
	    get: function get() {
	      return this._datas;
	    }
	
	    //-----------------------------------
	    // maxItems
	    //-----------------------------------
	  }, {
	    key: 'maxItems',
	    get: function get() {
	      return this._maxItems;
	    }
	
	    //-----------------------------------
	    // startIndex
	    //-----------------------------------
	  }, {
	    key: 'startIndex',
	    set: function set(value) {
	      this._startIndex = value;
	    },
	    get: function get() {
	      return this._startIndex;
	    }
	
	    //-----------------------------------
	    // selectedIndex
	    //-----------------------------------
	  }, {
	    key: 'selectedIndex',
	    get: function get() {
	      return this._selectedIndex;
	    },
	    set: function set(index) {
	      if (!this.items || this.items.length === 0) {
	        this._selectedIndex = 0;
	        return;
	      }
	
	      this._selectedIndex = index;
	
	      if (this._selectedIndex < 0) {
	        this._selectedIndex = 0;
	      } else if (this._selectedIndex > this.items.length - 1) {
	        this._selectedIndex = this.items.length - 1;
	      }
	
	      this.focusSelectedIndex();
	    }
	  }]);
	
	  return OptimumidlistController;
	})();
	
	OptimumidlistController.$inject = ['$window', '$timeout', '$scope', '$state'];
	
	exports['default'] = OptimumidlistController;
	module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./optimumidlist.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./optimumidlist.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".list .list-button:focus{outline:none}.list .opt-id{color:#f1f1f1}.list .opt-id,.list .opt-name{float:left;min-width:47.5%;max-width:47.5%;text-align:left;outline:none;overflow:hidden;white-space:nowrap;text-overflow:ellipsis!important}.list .opt-name{padding-right:7px;color:#afb6b8}.list .down-arrow,.list .up-arrow{width:91%;text-align:center;color:#000;font-size:30px}.list .down-arrow i,.list .up-arrow i{color:#00acd1;font-size:8vmin}.list .optimumid{padding-left:5px}.list .user_name{color:#afb6b8;font-weight:500}.pagination-block{margin-top:2.75vh;margin-bottom:4.5vh}.pagination-block .star-icon{color:#999;margin-left:2vmin;margin-right:1vmin;font-size:20px}.pagination-block .star-icon i{margin-right:10px}.pagination-block .pagination{float:right;color:#fff;display:inline-flex;margin-right:3vw}.pagination-block .pagination .pag-btns{width:5vh;height:5vh;background-color:#525556;border:none;color:hsla(197,9%,85%,.4)}.pagination-block .pagination .pag-btns:focus,.pagination-block .pagination .pag-btns:hover{background-color:#f1f1f1;color:#000}.pagination-block .pagination .next-btn{border-top-right-radius:5px;border-bottom-right-radius:5px}.pagination-block .pagination .prev-btn{border-top-left-radius:5px;border-bottom-left-radius:5px}.pagination-block .pagination .pag-ind{width:7.5vh;height:5vh;background-color:#525556;border:none;color:#f1f1f1;font-weight:700;font-size:1.45vw;margin-left:2px;margin-right:2px}.clearfix{visibility:hidden;display:block;content:\" \";clear:both;height:0}", ""]);
	
	// exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tutorialsComponent = __webpack_require__(144);
	
	var _tutorialsComponent2 = _interopRequireDefault(_tutorialsComponent);
	
	var tutorialsModule = _angular2['default'].module('tutorials', [_angularUiRouter2['default']]).component('tutorials', _tutorialsComponent2['default']);
	
	exports['default'] = tutorialsModule;
	module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tutorialsHtml = __webpack_require__(145);
	
	var _tutorialsHtml2 = _interopRequireDefault(_tutorialsHtml);
	
	var _tutorialsController = __webpack_require__(146);
	
	var _tutorialsController2 = _interopRequireDefault(_tutorialsController);
	
	__webpack_require__(147);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _tutorialsHtml2['default'],
	  controller: _tutorialsController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name-tutorial\" id=\"mainInfoTutorialDiv\" ng-init=\"vm.keyWatch($event)\">\n  <span class=\"myAccount-grey\"> /</span>\n  <span>{{vm.name}}</span>\n</div>\n\n<div ng-if=\"vm.menuitemsLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n\n<div ng-if=\"!vm.menuitemsLoader\" class=\"tutorials-landingbg\" id=\"tutorial-landingBg\">\n  <tutoriallist list-id=\"navigation\" items=\"vm.menuitems\" btn-class=\"btn btn-tutorial btn-main-nav\"></tutoriallist>\n</div>\n"

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var deps = {};
	
	var TutorialsController = function TutorialsController($state, $rootScope, $timeout, laboxSSapi, navigationManager, $scope, $window, analyticsService, storage) {
	  var _this = this;
	
	  _classCallCheck(this, TutorialsController);
	
	  this.$timeout = $timeout;
	  this.name = 'Tutorials';
	  this.$rootScope = $rootScope;
	  this.menuitems = [];
	  this.menuitemsLoader = true;
	  this.$state = $state;
	  deps.$state = $state;
	  navigationManager.registerViewComponent(this, $scope, 'home.tutorials');
	
	  if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
	    laboxSSapi.getOptVideoTutorials().then(function (res) {
	      if (res && res.data && !res.data.labox_video_tutorials.length == 0) {
	        var tutorialarray = [];
	        // omniture when tutorials load successfully		
	        console.log('!!omniture when tutorials load successfully!!');
	        analyticsService.sendReport('tutorials', 'tutorials', 'event1', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	        var groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, function (subgroup) {
	          return subgroup.position_id;
	        });
	        for (var key in groups) {
	          tutorialarray.push({
	            title: groups[key][0].title,
	            link: groups[key][0].video_image,
	            url: groups[key][0].video
	          });
	          _this.menuitems = tutorialarray;
	          _this.menuitemsLoader = false;
	        }
	        // this.menuitems[0].url = "http://static.tvlistings.optimum.net/laboxfaq/stage/labox-videos/EO_Channel900introRevisionOct2016.mp4";
	        // this.menuitems[1].url = "https://vid-west-online.web.sundaysky.com/amz1/w2s67/flvstreamer?jobId=836cab55-910e-4f03-8e8a-479ddb6cca12&authToken=0b5a01b06ddd42108028f15a57178f23&videoId=webm&reqId=089fc028-65a3-4cb6-88d2-412d68d42ca5";
	        // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_2509201707550300000AB.mp4";
	        // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_20170924182553303AB.mp4";
	        // this.menuitems[2].url = "http://stage.avn.cv.net/static/samples/NEWS12LI_20170924182553303AB.mp4";
	        // this.menuitems[3].url = "http://media.exploreoptimum.iptv.optimum.net/EO_Channel900introRevisionOct2016.mp4"
	        // this.menuitems[3].url = "https://www.optimum.net/cdn/img.optimum.net/video/laboxfaq/stage/labox-videos/4977_Optimum_Voice_Remote_test.mp4";
	      } else {
	          // omniture when tutorials load successfully
	          console.log('!!omniture when tutorials with API error!!');
	          analyticsService.sendReport('tutorials', 'tutorials', 'event1', 'api error', null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	          _this.$rootScope.fromTutorialPage = true;
	          _this.menuitemsLoader = false;
	          _this.$state.go('home.landingpage');
	        }
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	      _this.$rootScope.fromTutorialPage = true;
	      _this.menuitemsLoader = false;
	      _this.$state.go('home.landingpage');
	    });
	  } else if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 2) {
	    laboxSSapi.getSdlVideoTutorials().then(function (res) {
	      if (res && res.data && !res.data.labox_video_tutorials.length == 0) {
	        var tutorialarray = [];
	        // omniture when tutorials load successfully   
	        console.log('!!omniture when tutorials load successfully!!');
	        analyticsService.sendReport('tutorials', 'tutorials', 'event1', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	        var groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, function (subgroup) {
	          return subgroup.position_id;
	        });
	        for (var key in groups) {
	          tutorialarray.push({
	            title: groups[key][0].title,
	            link: groups[key][0].video_image,
	            url: groups[key][0].video
	          });
	          _this.menuitems = tutorialarray;
	          _this.menuitemsLoader = false;
	        }
	        // this.menuitems[0].url = "http://static.tvlistings.optimum.net/laboxfaq/stage/labox-videos/EO_Channel900introRevisionOct2016.mp4";
	        // this.menuitems[1].url = "https://vid-west-online.web.sundaysky.com/amz1/w2s67/flvstreamer?jobId=836cab55-910e-4f03-8e8a-479ddb6cca12&authToken=0b5a01b06ddd42108028f15a57178f23&videoId=webm&reqId=089fc028-65a3-4cb6-88d2-412d68d42ca5";
	        // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_2509201707550300000AB.mp4";
	        // this.menuitems[1].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_20170924182553303AB.mp4";
	        // this.menuitems[2].url = "http://news12li.videodownload.worldnow.com/NEWS12LI_2109201713205200000AB.mp4";
	      } else {
	          // omniture when tutorials load successfully
	          console.log('!!omniture when tutorials with API error!!');
	          analyticsService.sendReport('tutorials', 'tutorials', 'event1', 'api error', null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	          _this.$rootScope.fromTutorialPage = true;
	          _this.menuitemsLoader = false;
	          _this.$state.go('home.landingpage');
	        }
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	      _this.$rootScope.fromTutorialPage = true;
	      _this.menuitemsLoader = false;
	      _this.$state.go('home.landingpage');
	    });
	  } else {
	    this.$rootScope.fromTutorialPage = true;
	    this.menuitemsLoader = false;
	    this.$state.go('home.landingpage');
	  }
	};
	
	TutorialsController.$inject = ['$state', '$rootScope', '$timeout', 'laboxSSapi', 'navigationManager', '$scope', '$window', 'analyticsService', 'storage'];
	
	exports['default'] = TutorialsController;
	module.exports = exports['default'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(148);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tutorials.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tutorials.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".tutorials{color:red}.menu-name-tutorial{position:absolute;left:17.7vw;font-style:normal;font-size:1.72vw;line-height:1;top:6.65vh}.menu-name-tutorial span{margin-right:3px}.menu-name-tutorial .myAccount-grey{color:#f1f1f1}.tutorials-landingbg{margin:3.63vh 3.2vw 0 6.5vw;min-height:30.86vh;overflow:hidden;padding-top:5vh}.tutorials-landingbg .tf-content-left{float:left;width:37vw}", ""]);
	
	// exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _tutoriallistComponent = __webpack_require__(150);
	
	var _tutoriallistComponent2 = _interopRequireDefault(_tutoriallistComponent);
	
	var tutoriallistModule = _angular2['default'].module('tutoriallist', [_angularUiRouter2['default']]).component('tutoriallist', _tutoriallistComponent2['default']);
	
	exports['default'] = tutoriallistModule;
	module.exports = exports['default'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tutoriallistHtml = __webpack_require__(151);
	
	var _tutoriallistHtml2 = _interopRequireDefault(_tutoriallistHtml);
	
	var _tutoriallistController = __webpack_require__(152);
	
	var _tutoriallistController2 = _interopRequireDefault(_tutoriallistController);
	
	__webpack_require__(153);
	
	var tutoriallistComponent = {
	  restrict: 'E',
	  bindings: {
	    btnClass: '@',
	    items: '=',
	    itemsLength: '@'
	  },
	  template: _tutoriallistHtml2['default'],
	  controller: _tutoriallistController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = tutoriallistComponent;
	module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"tf-landingbg\">\n  <div ng-if=\"vm.fromTutorial\">\n    <div class=\"tf-content-left\">\n      <div ng-show=\"vm.menuitemsLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n      <button id=\"{{vm.listId + '_btn' + ($index + vm.startIndex)}}\"\n              ng-class=\"vm.btnClass\"\n              ng-repeat=\"item in vm.displayItems\"\n              ng-keydown=\"vm.keyDownHandler($event)\">\n        <p class=\"tf-label\">\n          <span>{{item.title}}</span>\n        </p>\n      </button>\n      <div class=\"clearfix\"></div>\n      <div class=\"pagination-block\">\n        <div class=\"pagination-tf\" ng-show=\"vm.maxItems &lt; vm.menuitems.length\">\n          <button id=\"prev-btn\" class=\"pag-btns\" ng-click=\"vm.pageUp()\" ng-keydown=\"vm.prevKeyHandler($event)\"><</button>\n          <button class=\"pag-ind\">{{vm.page_num}}/{{vm.total_page_num}}</button>\n          <button id=\"next-btn\" class=\"pag-btns\" ng-click=\"vm.pageDown()\" ng-keydown=\"vm.nextKeyHandler($event)\">></button>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"tutorial-content-right\">\n      <div class=\"tutorial-image\">\n        <img src={{vm.displayImage}} height=\"100%\" width=\"100%\">\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"vm.fromFaq\">\n    <div ng-show=\"vm.menuitemsLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n      <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n    </div>\n\n    <div ng-show=\"!vm.menuitemsLoader\" class=\"faq-landingbg\" id=\"faq-landingBg\">\n      <div class=\"tf-content-left\">\n        <div ng-show=\"vm.menuitemsLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n          <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n        </div>\n        <button id=\"{{vm.listId + '_btn' + ($index + vm.startIndex)}}\"\n                ng-class=\"vm.btnClass\"\n                ng-repeat=\"item in vm.displayItems\"\n                ng-keydown=\"vm.keyDownHandler($event)\">\n          <p class=\"tf-label\">\n            <span>{{item.title}}</span>\n          </p>\n        </button>\n        <div class=\"clearfix\"></div>\n        <div class=\"pagination-block\">\n          <div class=\"pagination-tf\" ng-show=\"vm.maxItems &lt; vm.menuitems.length\">\n            <button id=\"prev-btn\" class=\"pag-btns\" ng-click=\"vm.pageUp()\" ng-keydown=\"vm.prevKeyHandler($event)\"><</button>\n            <button class=\"pag-ind\">{{vm.page_num}}/{{vm.total_page_num}}</button>\n            <button id=\"next-btn\" class=\"pag-btns\" ng-click=\"vm.pageDown()\" ng-keydown=\"vm.nextKeyHandler($event)\">></button>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"faq-content-right\">\n        <div ng-show=\"vm.loader\" style=\"margin-left: 45%;margin-top: 29%;\">\n          <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n        </div>\n        <div ng-show=\"!vm.loader\" class=\"faq-text\">\n          <div class=\"faq-left-title\">{{vm.displayTitle}}</div>\n          <div class=\"faq-subtitle\">{{vm.displaySubTitle}}</div>\n          <div ng-if=\"vm.displayLayout == 'summary_without_image'\" id=\"template_one\">\n            <div class=\"faq-summary\">\n              <div ng-show=\"vm.loader\">\n                <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.displayLayout == 'summary_with_image'\" id=\"template_two\">\n            <div class=\"faq-image\">\n              <div ng-show=\"vm.loader\"><span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span></div>\n              <img src=\"{{vm.displayFaqImage}}\">\n            </div>\n            <div class=\"faq-summary\">\n              <div ng-show=\"vm.loader\">\n                <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	/**
	 * The TutoriallistController class is designed to manage the navigation of a pageable sequence of items,
	 * like the video list.
	 *
	 * It displays all its elements using the same button classes in a vertical layout. It manages
	 * proper tabbing and arrow key navigation.
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TutoriallistController = (function () {
	  /*-----------------------------------*\
	   * Constructor
	  \*-----------------------------------*/
	
	  function TutoriallistController($timeout, $state, $rootScope, analyticsService) {
	    var _this = this;
	
	    _classCallCheck(this, TutoriallistController);
	
	    this.name = 'tutoriallist';
	    this.$timeout = $timeout;
	    this.$rootScope = $rootScope;
	    this.analyticsService = analyticsService;
	
	    this.listId = 'navigation';
	    this.selectedIndex = this.$rootScope.selectedIndex || 0;
	    if (this.$rootScope.previousState === 'home.landingpage.faqlanding' || this.$rootScope.previousState === 'home.landingpage.tutorialslanding') {
	      this.selectedIndex = 0;
	    }
	    this.maxItems = 8;
	    this.startIndex = 0;
	    this.page_num = 1;
	    this.ix = 0;
	    this.menuitemsLoader = true;
	
	    this.$state = $state;
	    this.currentState = $state.current.name;
	
	    this.$timeout(function () {
	      if (_this.currentState === 'home.tutorials') {
	        _this.fromTutorial = true;
	        _this.fromFaq = false;
	        _this.tutorialData();
	        _this.menuitemsLoader = false;
	      } else {
	        _this.fromFaq = true;
	        _this.fromTutorial = false;
	        _this.faqData();
	        _this.menuitemsLoader = false;
	      }
	      _this.total_page_num = Math.floor(_this.menuitems.length / _this.maxItems) + 1;
	      _this.focusSelectedIndex();
	    }, 500);
	  }
	
	  _createClass(TutoriallistController, [{
	    key: 'tutorialData',
	    value: function tutorialData() {
	      this.displayImage = this.menuitems[this.selectedIndex] ? this.menuitems[this.selectedIndex].link : this.menuitems[0].link;
	    }
	  }, {
	    key: 'faqData',
	    value: function faqData() {
	      var _this2 = this;
	
	      this.loader = true;
	      this.$timeout(function () {
	        if (document.getElementsByClassName('faq-summary')[0]) {
	          if (_this2.menuitems[_this2.selectedIndex].layout === 'summary_without_image') {
	            _this2.menuitems[_this2.selectedIndex].summary.length > 300 ? document.getElementsByClassName('faq-summary')[0].innerHTML = _this2.menuitems[_this2.selectedIndex].summary.substring(0, 300).concat('...') : document.getElementsByClassName('faq-summary')[0].innerHTML = _this2.menuitems[_this2.selectedIndex].summary;
	          } else if (_this2.menuitems[_this2.selectedIndex].layout === 'summary_with_image') {
	            _this2.menuitems[_this2.selectedIndex].summary_with_image.length > 135 ? document.getElementsByClassName('faq-summary')[0].innerHTML = _this2.menuitems[_this2.selectedIndex].summary_with_image.substring(0, 135).concat('...') : document.getElementsByClassName('faq-summary')[0].innerHTML = _this2.menuitems[_this2.selectedIndex].summary_with_image;
	          }
	        }
	        _this2.displayFaqImage = _this2.menuitems[_this2.selectedIndex].summary_image;
	        _this2.loader = false;
	      }, 750);
	
	      this.displayTitle = this.menuitems[this.selectedIndex].title;
	      this.displaySubTitle = this.menuitems[this.selectedIndex].sub_title;
	      this.displayLayout = this.menuitems[this.selectedIndex].layout;
	    }
	  }, {
	    key: 'isUp',
	    value: function isUp(event) {
	      return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
	    }
	  }, {
	    key: 'isDown',
	    value: function isDown(event) {
	      return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
	    }
	  }, {
	    key: 'isRight',
	    value: function isRight(event) {
	      return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
	    }
	  }, {
	    key: 'isLeft',
	    value: function isLeft(event) {
	      return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
	    }
	  }, {
	    key: 'keyDownHandler',
	    value: function keyDownHandler(event) {
	      var _this3 = this;
	
	      var cancel = function cancel(event) {
	        event.preventDefault();
	        event.stopImmediatePropagation();
	        _this3.ignoreNextUp = true;
	      };
	      if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	        window.removeEventListener('keydown', this.keydown);
	        this.currentState === 'home.faq' ? this.$rootScope.fromFaqPage = true : this.$rootScope.fromTutorialPage = true;
	        this.$rootScope.selectedIndex = 0;
	        this.$state.go('home.landingpage');
	      } else if ((event.code === 'Enter' || event.keyCode === 13) && this.currentState === 'home.faq') {
	        //omniture Faq item click
	        console.log('omniture Faq item click' + this.displayTitle);
	
	        this.analyticsService.sendReport('quick tips', 'quick tips', null, null, null, this.displayTitle, this.displayTitle, this.$rootScope.analytics.omniturePath + '/faqtemplate', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath + '/faq');
	
	        this.$rootScope.selectedIndex = this.selectedIndex;
	        this.$state.go('home.faqtemplate');
	      } else if ((event.code === 'Enter' || event.keyCode === 13) && this.currentState === 'home.tutorials') {
	        //omniture tutorial item click
	        console.log('omniture Tutorial item click : ' + this.menuitems[this.selectedIndex].title);
	        this.analyticsService.sendReport('tutorials', 'tutorials', null, null, this.menuitems[this.selectedIndex].title, null, this.menuitems[this.selectedIndex].title, this.$rootScope.analytics.omniturePath + '/videoplayer', this.$rootScope.omnitureBillingStatus, this.$rootScope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath + '/tutorials');
	
	        console.log('this.menuitems[this.selectedIndex].url is ' + this.menuitems[this.selectedIndex].url);
	        this.$rootScope.selectedIndex = this.selectedIndex;
	        this.$rootScope.title = this.menuitems[this.selectedIndex].title;
	        this.$state.go('videoplayer', {
	
	          back: true,
	
	          url: this.menuitems[this.selectedIndex].url
	
	        });
	      } else if (event.code === 'Tab' && !event.shiftKey || this.isDown(event)) {
	        // Down arrow or tab key
	        if ((this.startIndex + this.selectedIndex - this.ix) % (this.maxItems - 1) === 0 && this.selectedIndex !== 0 || this.selectedIndex + 1 === this.menuitems.length) {
	          //if it is last or first item
	          this.pageDown();
	          cancel(event);
	        } else if (this.selectedIndex + 1 < this.menuitems.length) {
	          //if it is any item
	          this.selectedIndex++;
	          this.fromTutorial ? this.tutorialData() : this.faqData();
	          this.focusSelectedIndex();
	          cancel(event);
	        }
	      } else if (event.code === 'Tab' && event.shiftKey || this.isUp(event)) {
	        // Up arrow or shift tab
	        if ((this.selectedIndex - 1) % (this.maxItems - 1) === 0 && this.selectedIndex !== 1) {
	          cancel(event);
	        } else if (this.selectedIndex > 0) {
	          this.selectedIndex--;
	          this.focusSelectedIndex();
	          this.fromTutorial ? this.tutorialData() : this.faqData();
	          cancel(event);
	        } else if (this.selectedIndex === 0) {
	          this.pageUp();
	          event.preventDefault();
	          event.stopImmediatePropagation();
	        }
	      }
	    }
	  }, {
	    key: 'focusSelectedIndex',
	    value: function focusSelectedIndex() {
	      if (this.selectedIndex > this.menuitems.length - 1) {
	        this.selectedIndex = 0;
	      }
	      var elId = this.listId + '_btn' + this.selectedIndex;
	      var el = document.getElementById(elId);
	
	      if (el) {
	        el.focus();
	      } else {
	        this.$timeout(this.focusSelectedIndex.bind(this));
	      }
	    }
	  }, {
	    key: 'pageDown',
	    value: function pageDown() {
	      if (this.page_num === this.total_page_num) {
	        document.getElementById('prev-btn').focus();
	      } else {
	        document.getElementById('next-btn').focus();
	      }
	    }
	  }, {
	    key: 'pageUp',
	    value: function pageUp() {
	      if (this.page_num === 1) {
	        document.getElementById('next-btn').focus();
	      } else {
	        document.getElementById('prev-btn').focus();
	      }
	    }
	  }, {
	    key: 'nextKeyHandler',
	    value: function nextKeyHandler(event) {
	      if (this.isLeft(event) && this.page_num != this.total_page_num && this.page_num != 1) {
	        document.getElementById('prev-btn').focus();
	      }
	      if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	        window.removeEventListener('keydown', this.keydown);
	        this.$rootScope.selectedIndex = 0;
	        this.fromFaq ? this.$rootScope.fromFaqPage = true : this.$rootScope.fromTutorialPage = true;
	        this.$rootScope.selectedIndex = 0;
	        this.$state.go('home.landingpage');
	      }
	      if (event.code === 'Enter') {
	        this.ix++;
	        this.startIndex += this.maxItems;
	        this.selectedIndex += this.ix;
	        this.page_num = this.page_num + 1;
	        this.focusSelectedIndex();
	      }
	    }
	  }, {
	    key: 'prevKeyHandler',
	    value: function prevKeyHandler(event) {
	      if (this.isRight(event) && this.page_num != this.total_page_num && this.page_num != 1) {
	        document.getElementById('next-btn').focus();
	      }
	      if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	        window.removeEventListener('keydown', this.keydown);
	        this.$rootScope.selectedIndex = 0;
	        this.fromFaq ? this.$rootScope.fromFaqPage = true : this.$rootScope.fromTutorialPage = true;
	        this.$rootScope.selectedIndex = 0;
	        this.$state.go('home.landingpage');
	      }
	      if (event.code === 'Enter') {
	        this.ix--;
	        this.startIndex -= this.maxItems;
	        this.selectedIndex -= this.maxItems;
	        if (this.selectedIndex % this.startIndex !== 0) {
	          this.temp = this.selectedIndex % this.maxItems;
	          this.selectedIndex -= this.temp;
	        }
	        this.page_num = this.page_num - 1;
	        this.focusSelectedIndex();
	      }
	    }
	  }, {
	    key: 'items',
	    set: function set(value) {
	      this.menuitems = value;
	    },
	    get: function get() {
	      return this.menuitems;
	    }
	  }, {
	    key: 'displayItems',
	    get: function get() {
	      return this.menuitems && this.menuitems.length ? this.menuitems.slice(this.startIndex, this.startIndex + this.maxItems) : [];
	    }
	  }]);
	
	  return TutoriallistController;
	})();
	
	TutoriallistController.$inject = ['$timeout', '$state', '$rootScope', 'analyticsService'];
	
	exports['default'] = TutoriallistController;
	module.exports = exports['default'];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(154);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tutoriallist.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./tutoriallist.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".tutorials{color:red}.tf-label{float:left;min-width:91%;max-width:91%;text-align:left;outline:none;overflow:hidden;white-space:nowrap;text-overflow:ellipsis!important}.tf-landingbg{min-height:60.86vh}.tf-landingbg .tutorial-content-right{float:left;width:52vw;min-height:52vh;padding-top:3px;position:relative}.tf-landingbg .tutorial-content-right .tutorial-image{position:absolute;float:left;width:100%;padding-left:21px}.tf-landingbg .tutorial-content-right .tutorial-image-text{background-color:rgba(0,19,25,.4);width:110%;line-height:5vh;text-align:left;position:absolute;bottom:0;font-size:3.1vmin;font-weight:700;padding-left:1vw}.tf-landingbg .faq-landingbg{background-color:rgba(97,97,97,.4);margin:3.63vh 3.2vw 0 9.5vw;min-height:30.86vh;overflow:hidden}.tf-landingbg .faq-landingbg .tf-content-left{float:left;width:40vw;margin-top:5vh}.tf-landingbg .faq-content-right{float:left;width:43vw;min-height:52.5vh;position:relative;margin-top:5vh;margin-left:24px;color:#f1f1f1}.tf-landingbg .faq-content-right .faq-text{position:absolute;float:left;font-weight:500}.tf-landingbg .faq-content-right .faq-left-title{color:#fff;font-size:2.5vw;font-weight:800;line-height:2.9vw;position:relative;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;font-family:Open Sans Bold}.tf-landingbg .faq-content-right .faq-subtitle{font-weight:700;font-size:26px;line-height:1.4em;min-height:1.4em;max-width:500px;overflow:hidden;text-overflow:ellipsis!important;white-space:nowrap;font-family:Open Sans Bold;margin-top:20px}.tf-landingbg .faq-content-right #template_two{min-height:34vh}.tf-landingbg .faq-content-right #template_two .faq-image{padding-top:21px;width:47%;float:left}.tf-landingbg .faq-content-right #template_two .faq-image img{width:100%}.tf-landingbg .faq-content-right #template_two .faq-summary{padding-left:24px;float:left;padding-top:14px;width:48%;position:relative;margin-right:-1em;padding-right:1em;font-size:22px;line-height:1.4em;overflow:hidden;font-family:Open Sans Regular}.tf-landingbg .faq-content-right #template_one{min-height:59vh;font-size:1.2em}.tf-landingbg .faq-content-right #template_one .faq-summary{float:left;padding-top:30px;width:100%;position:relative;margin-right:-1em;padding-right:1em;font-size:22px;overflow:hidden;line-height:1.4em;font-family:Open Sans Regular}.tf-landingbg .faq-content-right p{margin-bottom:20px}.tf-landingbg .faq-content-right b{color:#f1f1f1!important;font-family:Open Sans Bold}.tf-landingbg .faq-content-right ul{list-style:none}.tf-landingbg .faq-content-right li:before{content:\"\\2022\";color:#f1f1f1!important;display:inline-block;list-style-position:outside;text-indent:-1em}.tf-landingbg .faq-content-right li{list-style:none;margin-left:4vw;margin-bottom:20px}.tf-landingbg .pagination-block{margin-top:2.75vh;margin-bottom:4.5vh}.tf-landingbg .pagination-block .pagination-tf{float:right;color:#fff;display:inline-flex;margin-right:3vw}.tf-landingbg .pagination-block .pagination-tf .pag-btns{width:5vh;height:5vh;background-color:#3b494d;border:none;color:rgba(0,19,25,.4)}.tf-landingbg .pagination-block .pagination-tf .pag-btns:focus,.tf-landingbg .pagination-block .pagination-tf .pag-btns:hover{background-color:#007cb4;color:#f1f1f1}.tf-landingbg .pagination-block .pagination-tf .next-btn{border-top-right-radius:5px;border-bottom-right-radius:5px}.tf-landingbg .pagination-block .pagination-tf .prev-btn{border-top-left-radius:5px;border-bottom-left-radius:5px}.tf-landingbg .pagination-block .pagination-tf .pag-ind{width:7.5vh;height:5vh;background-color:#3b494d;border:none;color:#f1f1f1;font-weight:700;font-size:1.45vw;margin-left:2px;margin-right:2px}.tf-landingbg .alert-modal{z-index:100}", ""]);
	
	// exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _videotutorialsComponent = __webpack_require__(156);
	
	var _videotutorialsComponent2 = _interopRequireDefault(_videotutorialsComponent);
	
	var videotutorialsModule = _angular2['default'].module('videotutorials', [_angularUiRouter2['default']]).component('videotutorials', _videotutorialsComponent2['default']);
	
	exports['default'] = videotutorialsModule;
	module.exports = exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _videotutorialsHtml = __webpack_require__(157);
	
	var _videotutorialsHtml2 = _interopRequireDefault(_videotutorialsHtml);
	
	var _videotutorialsController = __webpack_require__(158);
	
	var _videotutorialsController2 = _interopRequireDefault(_videotutorialsController);
	
	__webpack_require__(159);
	
	var VideoTutorialsComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _videotutorialsHtml2['default'],
	  controller: _videotutorialsController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = VideoTutorialsComponent;
	module.exports = exports['default'];

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!vm.videotutorialslandingerror\">\n  <div ng-show=\"vm.tutoriallandingLoader\">\n  <div>\n    <div class=\"landingDueBox textLow\">\n      <div class=\"left-text\">{{vm.name}}</div>\n    </div>\n  </div>\n  <div class=\"carousel\">\n    <div class=\"carousel-calculator\">\n      <div class=\"carousel-inner\">\n        <div class=\"carousel-inner-small\">\n          <div ng-repeat=\"n in vm.tutorialarray\" class=\"carousel-item\">\n            <div class=\"carousel-image\"><img src=\"{{n.link}}\"></div>\n            <div class=\"carousel-caption\"><span style=\"padding-left: 1vw\">{{n.label}}</span></div>\n          </div>\n        </div>\n        <div class=\"carousel-inner-small\" ng-if=\"vm.remove_carousel == true\">\n          <div ng-repeat=\"n in vm.tutorialarray\" class=\"carousel-item\">\n            <div class=\"carousel-image\"><img src=\"{{n.link}}\"></div>\n            <div class=\"carousel-caption\"><span style=\"padding-left: 1vw\">{{n.label}}</span></div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"carousel-description\">Learn tips and tricks about your service</div>\n  </div>\n\n  <div ng-show=\"!vm.tutoriallandingLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n    <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n  </div>\n</div>\n\n<div ng-if=\"vm.videotutorialslandingerror\">\n<div class=\"landingDueBox textLow\">\n  There's an issue right now. <span class=\"other-info\"> Please try again later.</span>\n</div>\n<div class=\"right-text\">You can also view tutorials at: <div class=\"right-text-blue\">optimum.net/tutorials</div></div>\n</div>\n"

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var VideotutorialsController = function VideotutorialsController($state, $window, storage, billingService, $timeout, laboxSSapi) {
	  var _this = this;
	
	  _classCallCheck(this, VideotutorialsController);
	
	  this.name = 'Tutorials';
	  this.state = $state;
	  this.$timeout = $timeout;
	  this.videotutorialslandingerror = false;
	  this.tutorialarray = [];
	  //initializing loader
	  this.tutoriallandingLoader = false;
	  this.remove_carousel = true;
	
	  //calling api
	  if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 1) {
	    laboxSSapi.getOptVideoTutorials().then(function (res) {
	      console.log('res.data.labox_video_tutorials is ' + res.data.labox_video_tutorials);
	      if (res && res.data && !res.data.labox_video_tutorials.length == 0) {
	        var groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, function (subgroup) {
	          return subgroup.position_id;
	        });
	
	        for (var key in groups) {
	          // adding ellipses for longer captions
	          if (groups[key][0].title.length > 20) {
	            _this.tutorialarray.push({
	              label: groups[key][0].title.substring(0, 20) + '...',
	              link: groups[key][0].video_image
	            });
	          } else {
	            _this.tutorialarray.push({
	              label: groups[key][0].title,
	              link: groups[key][0].video_image
	            });
	          }
	        }
	        console.log("alex result from api/tutorial:", res.data);
	
	        // setting variables for elements
	        _this.carousell = document.getElementsByClassName("carousel-calculator")[0];
	        _this.carousell_inner = document.getElementsByClassName("carousel-inner")[0];
	
	        // setting width of carousel
	        var carousel_item_width = _this.tutorialarray.length * 460;
	        _this.carousell.style.width = carousel_item_width + "px";
	
	        if (_this.tutorialarray.length < 3) {
	          console.log('this.tutorialarray.length3 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	          _this.remove_carousel = false;
	        } else if (_this.tutorialarray.length == 3) {
	          console.log('this.tutorialarray.length5 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	
	            _this.carousell_inner.className += " active3";
	          }, 500);
	        } else if (_this.tutorialarray.length == 4) {
	          console.log('this.tutorialarray.length5 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	
	            _this.carousell_inner.className += " active4";
	          }, 500);
	        } else if (_this.tutorialarray.length == 5) {
	          console.log('this.tutorialarray.length7 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active5";
	          }, 500);
	        } else if (_this.tutorialarray.length == 6) {
	          console.log('this.tutorialarray.length7 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active6";
	          }, 500);
	        } else if (_this.tutorialarray.length == 7) {
	          console.log('this.tutorialarray.length9 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active7";
	          }, 500);
	        } else if (_this.tutorialarray.length == 8) {
	          console.log('this.tutorialarray.length9 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active8";
	          }, 500);
	        } else {
	          console.log('this.tutorialarray.length9 is ' + _this.tutorialarray.length);
	          _this.videotutorialslandingerror = true;
	          _this.tutoriallandingLoader = true;
	        }
	      } else {
	        _this.videotutorialslandingerror = true;
	        _this.tutoriallandingLoader = true;
	      }
	    }, function (reserr) {
	      _this.tutoriallandingLoader = true;
	      _this.videotutorialslandingerror = true;
	    });
	  } else if (storage.getItem('session', 'plant_id') && storage.getItem('session', 'plant_id') == 2) {
	    laboxSSapi.getSdlVideoTutorials().then(function (res) {
	      console.log('res.data.labox_video_tutorials is ' + res.data.labox_video_tutorials);
	      if (res && res.data && !res.data.labox_video_tutorials.length == 0) {
	        var groups = _.groupBy(res.data.labox_video_tutorials[0].labox_videos, function (subgroup) {
	          return subgroup.position_id;
	        });
	
	        for (var key in groups) {
	          // adding ellipses for longer captions
	          if (groups[key][0].title.length > 20) {
	            _this.tutorialarray.push({
	              label: groups[key][0].title.substring(0, 20) + '...',
	              link: groups[key][0].video_image
	            });
	          } else {
	            _this.tutorialarray.push({
	              label: groups[key][0].title,
	              link: groups[key][0].video_image
	            });
	          }
	        }
	        console.log("alex result from api/tutorial:", res.data);
	
	        // setting variables for elements
	        _this.carousell = document.getElementsByClassName("carousel-calculator")[0];
	        _this.carousell_inner = document.getElementsByClassName("carousel-inner")[0];
	
	        // setting width of carousel
	        var carousel_item_width = _this.tutorialarray.length * 460;
	        _this.carousell.style.width = carousel_item_width + "px";
	
	        if (_this.tutorialarray.length < 3) {
	          console.log('this.tutorialarray.length3 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	          _this.remove_carousel = false;
	        } else if (_this.tutorialarray.length == 3) {
	          console.log('this.tutorialarray.length5 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	
	            _this.carousell_inner.className += " active3";
	          }, 500);
	        } else if (_this.tutorialarray.length == 4) {
	          console.log('this.tutorialarray.length5 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	
	            _this.carousell_inner.className += " active4";
	          }, 500);
	        } else if (_this.tutorialarray.length == 5) {
	          console.log('this.tutorialarray.length7 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active5";
	          }, 500);
	        } else if (_this.tutorialarray.length == 6) {
	          console.log('this.tutorialarray.length7 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active6";
	          }, 500);
	        } else if (_this.tutorialarray.length == 7) {
	          console.log('this.tutorialarray.length9 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active7";
	          }, 500);
	        } else if (_this.tutorialarray.length == 8) {
	          console.log('this.tutorialarray.length9 is ' + _this.tutorialarray.length);
	          //removing loader
	          _this.tutoriallandingLoader = true;
	
	          // starting carousel
	          _this.$timeout(function () {
	            _this.remove_carousel = true;
	            _this.carousell_inner.className += " active8";
	          }, 500);
	        } else {
	          console.log('this.tutorialarray.length9 is ' + _this.tutorialarray.length);
	          _this.videotutorialslandingerror = true;
	          _this.tutoriallandingLoader = true;
	        }
	      } else {
	        _this.videotutorialslandingerror = true;
	        _this.tutoriallandingLoader = true;
	      }
	    }, function (reserr) {
	      _this.tutoriallandingLoader = true;
	      _this.videotutorialslandingerror = true;
	    });
	  } else {
	    this.videotutorialslandingerror = true;
	    this.tutoriallandingLoader = true;
	  }
	};
	
	VideotutorialsController.$inject = ['$state', '$window', 'storage', 'billingService', '$timeout', 'laboxSSapi'];
	
	exports['default'] = VideotutorialsController;
	module.exports = exports['default'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(160);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./videotutorials.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./videotutorials.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "videotutorials .right-text{font-size:1.3vw;font-weight:500;padding-top:3vh}videotutorials .right-text .right-text-blue{color:#f1f1f1;text-decoration:underline}videotutorials .carousel{width:100%;margin-top:17px;height:18vh;overflow:hidden}videotutorials .carousel .carousel-inner{position:relative;width:100%;height:18vh;float:left}videotutorials .carousel .carousel-inner .carousel-item{position:relative;width:230px;height:18vh;float:left}videotutorials .carousel .carousel-inner .carousel-item img{width:100%;position:absolute;bottom:0}videotutorials .carousel .carousel-inner .carousel-item .carousel-caption{width:100%;height:5vh;line-height:5vh;text-align:left;position:absolute;bottom:0;background-color:rgba(0,0,0,.5);font-size:2.1vmin;font-weight:700}videotutorials .carousel .active3{animation:righttoleft 11.25s infinite;-webkit-animation:righttoleft 11.25s infinite;animation-timing-function:linear}videotutorials .carousel .active4{animation:righttoleft 15s infinite;-webkit-animation:righttoleft 15s infinite;animation-timing-function:linear}videotutorials .carousel .active5{animation:righttoleft 18.75s infinite;-webkit-animation:righttoleft 18.75s infinite;animation-timing-function:linear}videotutorials .carousel .active6{animation:righttoleft 22.5s infinite;-webkit-animation:righttoleft 22.5s infinite;animation-timing-function:linear}videotutorials .carousel .active7{animation:righttoleft 26.25s infinite;-webkit-animation:righttoleft 26.25s infinite;animation-timing-function:linear}videotutorials .carousel .active8{animation:righttoleft 30s infinite;-webkit-animation:righttoleft 30s infinite;animation-timing-function:linear}videotutorials .carousel-description{margin-top:2vh;font-size:2.66vmin}@keyframes righttoleft{0%{margin-left:0;margin-top:0}to{margin-left:-50%;margin-top:0}}", ""]);
	
	// exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _faqComponent = __webpack_require__(162);
	
	var _faqComponent2 = _interopRequireDefault(_faqComponent);
	
	var faqModule = _angular2['default'].module('faq', [_angularUiRouter2['default']]).component('faq', _faqComponent2['default']);
	
	exports['default'] = faqModule;
	module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _faqHtml = __webpack_require__(163);
	
	var _faqHtml2 = _interopRequireDefault(_faqHtml);
	
	var _faqController = __webpack_require__(164);
	
	var _faqController2 = _interopRequireDefault(_faqController);
	
	__webpack_require__(165);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _faqHtml2['default'],
	  controller: _faqController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name-faq\" id=\"mainInfoFaqDiv\" ng-init=\"vm.keyWatch($event)\">\n  <span class=\"myAccount-grey\"> /</span>\n  <span>{{vm.name}}</span>\n</div>\n\n<div>\n  <tutoriallist list-id=\"navigation\" items=\"vm.menuitems\" btn-class=\"btn btn-faq btn-main-nav\"></tutoriallist>\n</div>\n"

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var deps = {};
	
	var FaqController = function FaqController($state, $rootScope, $timeout, laboxSSapi, navigationManager, $scope, $window, analyticsService) {
	  var _this = this;
	
	  _classCallCheck(this, FaqController);
	
	  this.$timeout = $timeout;
	  this.name = 'Quick Tips';
	  this.$rootScope = $rootScope;
	  this.$state = $state;
	  deps.$state = $state;
	  this.isCablevision = this.$rootScope.isCablevision;
	  this.isSuddenlink = this.$rootScope.isSuddenlink;
	  this.menuitemsLoader = true;
	
	  navigationManager.registerViewComponent(this, $scope, 'home.faq');
	
	  if (this.isCablevision == true) {
	    laboxSSapi.getOptFaq().then(function (res) {
	      // omniture when faq load successfully
	      console.log('!!omniture when faq load successfully!!');
	      analyticsService.sendReport('quick tips', 'quick tips', 'event1', null, null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	      var faqOpt = [];
	      var groups = _.groupBy(res.data.labox_faq.quick_tips, function (subgroup) {
	        return subgroup.position_id;
	      });
	      for (var key in groups) {
	        faqOpt.push({
	          layout: groups[key][0].summary_template,
	          title: groups[key][0].title,
	          footer: groups[key][0].footer_text,
	          summary: groups[key][0].summary_desc,
	          summary_with_image: groups[key][0].summary_desc_with_img,
	          main_content: groups[key][0].main_content,
	          summary_image: groups[key][0].summary_image,
	          primary_image: groups[key][0].primary_image,
	          sub_title: groups[key][0].sub_title
	        });
	        _this.menuitems = faqOpt;
	      }
	    }, function (reserr) {
	      // omniture when faq with API error
	      console.log('!!omniture when faq with API error!!');
	      analyticsService.sendReport('quick tips', 'quick tips', 'event1', 'api error', null, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill, _this.$rootScope.analytics.omniturePath + '/faq');
	
	      console.log('fail ---> ', reserr);
	      _this.$rootScope.fromFaqPage = true;
	      _this.$state.go('home.landingpage');
	    });
	  } else if (this.isSuddenlink == true) {
	    laboxSSapi.getSdlFaq().then(function (res) {
	      var faqSdl = [];
	      var groups = _.groupBy(res.data.labox_faq.quick_tips, function (subgroup) {
	        return subgroup.position_id;
	      });
	      for (var key in groups) {
	        faqSdl.push({
	          layout: groups[key][0].summary_template,
	          title: groups[key][0].title,
	          footer: groups[key][0].footer_text,
	          summary: groups[key][0].summary_desc,
	          summary_with_image: groups[key][0].summary_desc_with_img,
	          main_content: groups[key][0].main_content,
	          summary_image: groups[key][0].summary_image,
	          primary_image: groups[key][0].primary_image,
	          sub_title: groups[key][0].sub_title
	        });
	        _this.menuitems = faqSdl;
	      }
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	      _this.$rootScope.fromFaqPage = true;
	      _this.$state.go('home.landingpage');
	    });
	  }
	};
	
	FaqController.$inject = ['$state', '$rootScope', '$timeout', 'laboxSSapi', 'navigationManager', '$scope', '$window', 'analyticsService'];
	
	exports['default'] = FaqController;
	module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(166);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./faq.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./faq.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".faq{color:red}.menu-name-faq{position:absolute;left:17.7vw;font-style:normal;font-size:1.72vw;line-height:1;top:6.65vh;max-width:69vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-height:2.5vw}.menu-name-faq span{margin-right:3px}.menu-name-faq .myAccount-grey{color:#9ea6a8}", ""]);
	
	// exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _faqlandingComponent = __webpack_require__(168);
	
	var _faqlandingComponent2 = _interopRequireDefault(_faqlandingComponent);
	
	var faqlandingModule = _angular2['default'].module('faqlanding', [_angularUiRouter2['default']]).component('faqlanding', _faqlandingComponent2['default']);
	
	exports['default'] = faqlandingModule;
	module.exports = exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _faqlandingHtml = __webpack_require__(169);
	
	var _faqlandingHtml2 = _interopRequireDefault(_faqlandingHtml);
	
	var _faqlandingController = __webpack_require__(170);
	
	var _faqlandingController2 = _interopRequireDefault(_faqlandingController);
	
	__webpack_require__(171);
	
	var FaqLandingComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _faqlandingHtml2['default'],
	  controller: _faqlandingController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = FaqLandingComponent;
	module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports = "<div ng-if=\"!vm.faqlandingerror\" ng-show=\"!vm.faqlandingLoader\">\n  <div class=\"landingDueBox textLow\">\n    <div class=\"left-text\">{{vm.name}}</div>\n  </div>\n  <div class=\"right-side_container\">\n    <div class=\"left\">\n      <img src=\"/assets/QuickTips-Icon.png\">\n    </div>\n    <div class=\"right right-text1\">\n      Learn how to get the most out of your Altice One experience.\n    </div>\n  </div>\n</div>\n<div ng-show=\"vm.faqlandingLoader\" style=\"margin-left: 45%;margin-top: 23%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n<div ng-show=\"!vm.faqlandingLoader\" ng-if=\"vm.faqlandingerror\">\n<div class=\"landingDueBox textLow\">\n  There's an issue right now. <span class=\"other-info\"> Please try again later.</span>\n</div>\n  <div class=\"right-text\">You can also view quick tips at: <div class=\"right-text-blue\">optimum.net/faq</div></div>\n</div>\n"

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FaqlandingController = function FaqlandingController($state, $rootScope, $timeout, laboxSSapi) {
	  var _this = this;
	
	  _classCallCheck(this, FaqlandingController);
	
	  this.name = 'Quick Tips';
	  this.faqlandingLoader = true;
	  this.faqlandingerror = true;
	
	  this.$rootScope = $rootScope;
	  this.$timeout = $timeout;
	  this.isCablevision = this.$rootScope.isCablevision;
	  this.isSuddenlink = this.$rootScope.isSuddenlink;
	
	  if (this.isCablevision == true) {
	    laboxSSapi.getOptFaq().then(function (res) {
	      _this.faqlandingerror = false;
	      _this.faqlandingLoader = false;
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	      _this.faqlandingerror = true;
	      _this.faqlandingLoader = false;
	    });
	  } else if (this.isSuddenlink == true) {
	    laboxSSapi.getSdlFaq().then(function (res) {
	      _this.faqlandingerror = false;
	      _this.faqlandingLoader = false;
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	      _this.faqlandingerror = true;
	      _this.faqlandingLoader = false;
	    });
	  }
	
	  this.state = $state;
	};
	
	FaqlandingController.$inject = ['$state', '$rootScope', '$timeout', 'laboxSSapi'];
	
	exports['default'] = FaqlandingController;
	module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(172);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./faqlanding.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./faqlanding.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "faqlanding .right-side_container{margin-top:3vh}faqlanding .right-side_container .left{float:left;width:16%}faqlanding .right-side_container .right{float:left;width:83%;font-size:1.72vw}faqlanding .right-text,faqlanding .right-text1{font-size:1.3vw;font-weight:500}faqlanding .right-text{padding-top:3vh}faqlanding .right-text .right-text-blue{color:#f1f1f1;text-decoration:underline}", ""]);
	
	// exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _faqtemplateComponent = __webpack_require__(174);
	
	var _faqtemplateComponent2 = _interopRequireDefault(_faqtemplateComponent);
	
	var faqtemplateModule = _angular2['default'].module('faqtemplate', [_angularUiRouter2['default']]).component('faqtemplate', _faqtemplateComponent2['default']);
	
	exports['default'] = faqtemplateModule;
	module.exports = exports['default'];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _faqtemplateHtml = __webpack_require__(175);
	
	var _faqtemplateHtml2 = _interopRequireDefault(_faqtemplateHtml);
	
	var _faqtemplateController = __webpack_require__(176);
	
	var _faqtemplateController2 = _interopRequireDefault(_faqtemplateController);
	
	__webpack_require__(177);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _faqtemplateHtml2['default'],
	  controller: _faqtemplateController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"menu-name-faq\" id=\"mainInfoFaqDiv\" ng-init=\"vm.keyWatch($event)\">\n  <span class=\"myAccount\">/</span>\n  <span class=\"faded_bread\">{{vm.name}} / </span><span>{{ vm.faqcontent[vm.selectedIndex].title }}</span>\n</div>\n\n<div class=\"faq-landingbg\" ng-show=\"!vm.faqtemplateLoader\" ng-init=\"vm.keyWatch($event)\" id=\"faq-landingBg\">\n  <div>\n    <h1 class=\"faq_title\">{{ vm.faqcontent[vm.selectedIndex].title }}</h1>\n    <h2 class=\"faq_subtitle\">{{ vm.faqcontent[vm.selectedIndex].sub_title }}</h2>\n  </div>\n  <div ng-if=\"vm.templateLayout == 'small_image_template'\" id=\"template_one\">\n    <div class=\"faq_image\"><img src=\"{{ vm.faqcontent[vm.selectedIndex].image }}\"></div>\n    <div class=\"faq_summary\">\n      <div ng-show=\"vm.faqtemplatecontentLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n      <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"vm.templateLayout == 'large_image_template'\" id=\"template_two\">\n    <div class=\"faq_image\"><img src=\"{{ vm.faqcontent[vm.selectedIndex].image }}\"></div>\n    <div class=\"faq_summary\">\n      <div ng-show=\"vm.faqtemplatecontentLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n      <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n    <div class=\"faq_subsummary\"></div>\n  </div>\n  <div ng-if=\"vm.templateLayout == 'no_image_template' || vm.templateLayout == null\" id=\"template_three\">\n    <div class=\"faq_summary\">\n      <div ng-show=\"vm.faqtemplatecontentLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n        <span><i class=\"fa fa-circle-o-notch fa-spin fa-2x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div ng-show=\"vm.faqtemplateLoader\" style=\"margin-left: 45%;margin-top: 12%;\">\n  <span><i class=\"fa fa-circle-o-notch fa-spin fa-3x fa-fw\"></i><span class=\"sr-only\">Loading...</span></span>\n</div>\n"

/***/ }),
/* 176 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var FaqtemplateController = function FaqtemplateController($timeout, $rootScope, $state, laboxSSapi, analyticsService) {
	  var _this = this;
	
	  _classCallCheck(this, FaqtemplateController);
	
	  this.name = 'Quick Tips';
	  this.$state = $state;
	  this.$timeout = $timeout;
	  this.$rootScope = $rootScope;
	  this.faqcontent = [];
	  this.faqtemplateLoader = true;
	  this.faqtemplatecontentLoader = true;
	  this.isCablevision = this.$rootScope.isCablevision;
	  this.isSuddenlink = this.$rootScope.isSuddenlink;
	  this.selectedIndex = this.$rootScope.selectedIndex;
	  console.log("index is " + this.$rootScope.selectedIndex);
	
	  this.keyWatch = function (event) {
	    window.addEventListener('keydown', _this.keydown, false);
	  };
	  this.keydown = function (event) {
	    if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	      window.removeEventListener('keydown', _this.keydown);
	      console.log("you clicked!");
	      _this.$rootScope.selectedIndex = _this.selectedIndex;
	      _this.$state.go('home.faq');
	    }
	  };
	
	  if (this.isCablevision == true) {
	    laboxSSapi.getOptFaq().then(function (res) {
	      var faqOpt = [];
	      var groups = _.groupBy(res.data.labox_faq.quick_tips, function (subgroup) {
	        return subgroup.position_id;
	      });
	      for (var key in groups) {
	        faqOpt.push({
	          layout: groups[key][0].template_name,
	          title: groups[key][0].title,
	          sub_summary: groups[key][0].footer_text,
	          summary: groups[key][0].summary_desc,
	          main_content: groups[key][0].main_content,
	          summary_image: groups[key][0].summary_image,
	          image: groups[key][0].primary_image,
	          sub_title: groups[key][0].sub_title
	        });
	        _this.faqcontent = faqOpt;
	        _this.$timeout(function () {
	          _this.templateLayout = _this.faqcontent[_this.selectedIndex].layout;
	        }, 200);
	
	        _this.faqtemplateLoader = false;
	      }
	      // omniture when faq template loaded successfully
	      console.log('!!omniture when faq template!!');
	      analyticsService.sendReport('quick tips', 'quick tips template', null, null, null, _this.faqcontent[_this.selectedIndex].title, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	
	      // omniture when faq template loaded with error
	      console.log('!!omniture when faq template!!');
	      analyticsService.sendReport('quick tips', 'quick tips template', null, 'api error', null, _this.faqcontent[_this.selectedIndex].title, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	
	      _this.$rootScope.fromFaqPage = true;
	      _this.$state.go('home.landingpage');
	    });
	  } else if (this.isSuddenlink == true) {
	    laboxSSapi.getSdlFaq().then(function (res) {
	      var faqSdl = [];
	      var groups = _.groupBy(res.data.labox_faq.quick_tips, function (subgroup) {
	        return subgroup.position_id;
	      });
	      for (var key in groups) {
	        faqSdl.push({
	          layout: groups[key][0].template_name,
	          title: groups[key][0].title,
	          sub_summary: groups[key][0].footer_text,
	          summary: groups[key][0].summary_desc,
	          main_content: groups[key][0].main_content,
	          summary_image: groups[key][0].summary_image,
	          image: groups[key][0].primary_image,
	          sub_title: groups[key][0].sub_title
	        });
	        _this.faqcontent = faqSdl;
	        _this.$timeout(function () {
	          _this.templateLayout = _this.faqcontent[_this.selectedIndex].layout;
	        }, 200);
	        _this.faqtemplateLoader = false;
	      }
	    }, function (reserr) {
	      console.log('fail ---> ', reserr);
	      _this.$rootScope.fromFaqPage = true;
	      _this.$state.go('home.landingpage');
	    });
	  }
	  this.$timeout(function () {
	    // this.templateLayout = this.faqcontent[this.selectedIndex].layout;
	    console.log('this.templateLayout ' + _this.templateLayout);
	
	    // setting summary
	    if (_this.faqcontent[_this.selectedIndex].main_content === null) {
	      console.log('nothing here');
	    } else {
	      console.log('this.faqcontent[this.selectedIndex].main_content ' + _this.faqcontent[_this.selectedIndex].main_content);
	      console.log('document.getElementsByClassName(faq_summary)[0] ' + document.getElementsByClassName('faq_summary')[0]);
	      document.getElementsByClassName('faq_summary')[0].innerHTML = _this.faqcontent[_this.selectedIndex].main_content;
	    }
	
	    // setting sub summary
	    if (_this.faqcontent[_this.selectedIndex].sub_summary === null) {
	      console.log('nothing here');
	    } else {
	      console.log('this.faqcontent[this.selectedIndex].sub_summary ' + _this.faqcontent[_this.selectedIndex].sub_summary);
	      console.log('document.getElementsByClassName(faq_subsummary)[0] ' + document.getElementsByClassName('faq_subsummary')[0]);
	      document.getElementsByClassName('faq_subsummary')[0].innerHTML = _this.faqcontent[_this.selectedIndex].sub_summary;
	    }
	    _this.faqtemplatecontentLoader = false;
	  }, 600);
	};
	
	FaqtemplateController.$inject = ['$timeout', '$rootScope', '$state', 'laboxSSapi', 'analyticsService'];
	
	exports['default'] = FaqtemplateController;
	module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(178);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./faqtemplate.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./faqtemplate.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "faqtemplate .faq-landingbg{background-color:rgba(97,97,97,.4);margin:0 4.4vw 0 9.5vw;min-height:30.86vh;overflow:hidden}faqtemplate .faq_title{color:#f1f1f1;margin-left:2.35vw;margin-bottom:0;font-family:Open Sans Bold}faqtemplate .faq_subtitle{padding-top:.234vh;margin-left:2.35vw;font-family:Open Sans Bold;font-weight:700;font-size:26px}faqtemplate #template_two{min-height:57vh}faqtemplate #template_two .faq_image{padding-top:3vh;width:44.4%;float:left;margin-left:2.35vw}faqtemplate #template_two .faq_image img{width:100%;max-height:38.3vh}faqtemplate #template_two .faq_summary{padding-left:2.3vw;font-size:1.375em;float:left;padding-top:3vh;width:44%;overflow-y:hidden;max-height:44.7vh}faqtemplate #template_two .faq_summary p{padding-bottom:2vh;line-height:1.1em}faqtemplate #template_two .faq_summary ul{list-style:none;margin-bottom:1vh}faqtemplate #template_two .faq_summary li:before{content:\"\\2022\";color:#fff;display:inline-block;list-style-position:outside;text-indent:-1em}faqtemplate #template_two .faq_summary li{margin-left:4vw;padding-bottom:1vh;list-style:none}faqtemplate #template_two .faq_summary b{color:#fff;font-family:Open Sans Bold}faqtemplate #template_two .faq_subsummary{clear:both;padding-top:2vh;margin-left:2.35vw;font-size:1.375em;width:95%;max-height:12vh;overflow:hidden;padding-bottom:3.3vh}faqtemplate #template_two .faq_subsummary p{padding-bottom:2vh;line-height:1.1em}faqtemplate #template_two .faq_subsummary b{color:#fff;font-family:Open Sans Bold}faqtemplate #template_one{min-height:57vh}faqtemplate #template_one .faq_image{padding-top:2vh;width:24%;float:left;margin-left:2.35vw}faqtemplate #template_one .faq_image img{width:100%;max-height:54vh}faqtemplate #template_one .faq_summary{padding-left:2.3vw;width:66%;float:left;padding-top:3vh;font-size:1.375em;overflow-y:hidden}faqtemplate #template_one .faq_summary p{padding-bottom:2vh;line-height:1.1em}faqtemplate #template_one .faq_summary ul{list-style:none;margin-bottom:1vh}faqtemplate #template_one .faq_summary li:before{content:\"\\2022\";color:#fff;display:inline-block;list-style-position:outside;text-indent:-1em}faqtemplate #template_one .faq_summary li{margin-left:4vw;padding-bottom:1vh;list-style:none}faqtemplate #template_one .faq_summary b{color:#fff;font-family:Open Sans Bold}faqtemplate #template_one .faq_subsummary{display:none}faqtemplate #template_three{min-height:57vh}faqtemplate #template_three .faq_summary{padding-left:31px;float:left;padding-top:2vh;font-size:1.375em;overflow:hidden;width:93%;min-height:50vh}faqtemplate #template_three .faq_summary p{padding-top:3vh;padding-bottom:0!important;line-height:1.1em}faqtemplate #template_three .faq_summary ul{list-style:none;margin-bottom:1vh}faqtemplate #template_three .faq_summary ui{display:block;padding-top:2.4vh;padding-bottom:1.5vh}faqtemplate #template_three .faq_summary li:before{content:\"\\2022\";color:#fff;display:inline-block;list-style-position:outside;text-indent:-1em}faqtemplate #template_three .faq_summary li{margin-left:4vw;padding-bottom:1vh;list-style:none}faqtemplate #template_three .faq_summary b{color:#000;font-family:Open Sans Bold}faqtemplate p{padding-bottom:2vh;line-height:1.1em}.faded_bread{color:#9ea6a8}", ""]);
	
	// exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _videoplayerComponent = __webpack_require__(180);
	
	var _videoplayerComponent2 = _interopRequireDefault(_videoplayerComponent);
	
	var videoplayerModule = _angular2['default'].module('videoplayer', [_angularUiRouter2['default'], 'navigation']).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('videoplayer', {
	    url: '/videoplayer',
	    params: {
	      url: undefined,
	      label: undefined,
	      externalId: undefined,
	      previousPage: undefined,
	      index: undefined
	    },
	    template: '<videoplayer></videoplayer>'
	  });
	}]).component('videoplayer', _videoplayerComponent2['default']);
	
	exports['default'] = videoplayerModule;
	module.exports = exports['default'];

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _videoplayerHtml = __webpack_require__(181);
	
	var _videoplayerHtml2 = _interopRequireDefault(_videoplayerHtml);
	
	var _videoplayerController = __webpack_require__(182);
	
	var _videoplayerController2 = _interopRequireDefault(_videoplayerController);
	
	__webpack_require__(183);
	
	var videoplayerComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _videoplayerHtml2['default'],
	  controller: _videoplayerController2['default'],
	  controllerAs: 'vm'
	};
	
	exports['default'] = videoplayerComponent;
	module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	module.exports = "<videogular ng-show=\"!vm.videoerror\"\n  ng-init=\"vm.keyWatch($event)\"\n  vg-player-ready=\"vm.onPlayerReady($API)\"\n  vg-theme=\"vm.config.theme.url\"\n  vg-auto-play=\"vm.config.autoPlay\"\n  vg-plays-inline=\"vm.config.playsInline\"\n  vg-native-fullscreen=true\n  vg-complete=\"vm.playback()\"\n  vg-error=\"vm.onError()\">\n  <vg-media vg-src=\"vm.config.sources\"></vg-media>\n\n  <vg-controls class='show-animation' id='controls-animation'>\n    <div style=\"display: table-row\">\n      <my-button ng-if=\"!vm.playPause\"><img src={{ffImage}}></my-button>\n      <vg-play-pause-button ng-if=\"vm.playPause\"></vg-play-pause-button>\n      <vg-time-display>{{ currentTime | date:'mm:ss' }}</vg-time-display>\n      <vg-time-display class=\"totalTime\">( {{ totalTime | date:'mm:ss' }} )</vg-time-display>\n      <vg-scrub-bar>\n        <vg-scrub-bar-current-time><vg-scrub-bar-current-time-2></vg-scrub-bar-current-time-2></vg-scrub-bar-current-time>\n      </vg-scrub-bar>\n      <div class=\"displayTitle\">{{vm.title}}</div>\n      <div class=\"controlImage\"></div>\n    </div>\n  </vg-controls>\n  <vg-buffering></vg-buffering>\n</videogular>\n<div class=\"alert-modal\" ng-show=\"vm.videoerror\">\n  <div id=\"alertModal\" class=\"modal\">\n    <div id=\"modalContent\" class=\"modal-content alert-content\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-header\"><h1>Video Tutorial Error</h1></div>\n        <div class=\"payment-details\">\n          <div class=\"alert-msg-one\">\n            <div class=\"errorMsgAlertBox\">\n              <div class=\"errorSym\">\n                <span class=\"fa-stack fa-lg errorMsg\"></span>\n              </div>\n              <div class=\"errorMsgOne\">\n                <span>There's an issue right now. Please try again later.</span>\n              </div>\n            </div>\n            <div class=\"errorMsgAlertBox\">\n              <div class=\"errorMsgTwo\">\n                <span>You can also view tutorials at: </span>\n                <span class=\"linkText\">optimum.net/tutorials</span>\n              </div>\n            </div>\n          </div>\n          <div class=\"btn-alert\">\n            <button id=\"alert-confirm-btn\" class=\"confirm-payment-btn\" ng-click=\"vm.alertDone()\">OK</button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var VideoplayerController = (function () {
	  function VideoplayerController($rootScope, $scope, $state, $sce, $stateParams, $timeout, $interval, analyticsService, laboxSSapi, storage) {
	    var _this = this;
	
	    _classCallCheck(this, VideoplayerController);
	
	    this.name = 'videoplayer';
	    this.API = null;
	    this.$scope = $scope;
	    this.$state = $state;
	    this.$stateParams = $stateParams;
	    this.$timeout = $timeout;
	    this.$interval = $interval;
	    this.$rootScope = $rootScope;
	    this.playPause = true;
	    this.currentPlayerState = 'Stop';
	    this.timer = 0;
	    this.videoerror = false;
	    this.controls = document.getElementById('controls-animation');
	
	    this.$timeout(function () {
	      _this.title = _this.$rootScope.title;
	      console.log("title is :: " + _this.title);
	    }, 150);
	
	    this.timer = this.$timeout(function () {
	      _this.controls.className = 'hide-animation';
	    }, 5000);
	
	    if (this.$rootScope.fromLandingPage == true) {
	      this.config = {
	        sources: [{
	          src: $sce.trustAsResourceUrl(this.$stateParams.url),
	          type: 'video/webm'
	        }],
	        theme: {
	          url: '../../../assets/videogular.css'
	        },
	        autoPlay: true,
	        playsInline: false
	      };
	    } else {
	      this.config = {
	        sources: [{
	          src: $sce.trustAsResourceUrl(this.$stateParams.url),
	          type: 'video/mp4'
	        }],
	        theme: {
	          url: '../../../assets/videogular.css'
	        },
	        autoPlay: true,
	        playsInline: false
	      };
	    }
	
	    if (this.$rootScope.fromLandingPage == true) {
	      if (storage.getItem('session', 'home_id') == "40520101") {
	        console.log('specific case where it should play the default video and get the api response');
	      } else if (storage.getItem('session', 'home_id') == "36063655") {
	        this.$rootScope.fromVideoBillPage = true;
	        this.$rootScope.fromLandingPage = false;
	        this.$state.go('home.landingpage');
	      } else if (storage.getItem('session', 'home_id') == "36071973") {
	        console.log('specific case where it should play the default video and get the api response');
	      } else if (storage.getItem('session', 'home_id') == "65489856") {
	        console.log('specific case where it should play the default video and get the api response');
	      } else {
	        laboxSSapi.getVideoBill().then(function (res) {
	          if (res && res.data._links) {
	            _this.working_link = res.data._links['video-stream'][0].href;
	            if (_this.working_link != null) {
	              console.log('in video player video bill works and you came from landing page');
	            } else {
	              console.log('in video player video bill works but it has no link');
	              // this.$rootScope.fromVideoBillPage = true;
	              // this.$rootScope.fromLandingPage = false;
	              // this.$state.go('home.landingpage');
	            }
	          } else {
	              console.log('no response from videobill');
	              _this.$rootScope.fromVideoBillPage = true;
	              _this.$rootScope.fromLandingPage = false;
	              _this.$state.go('home.landingpage');
	            }
	        });
	      }
	    } else {
	      console.log('you are not from video bill');
	    }
	
	    // this.timer = this.$timeout(() => {
	    //   this.controls.className = 'hide-animation';
	    // },5000);
	
	    this.onPlayerReady = function (API) {
	      _this.API = API;
	      _this.API.playsInline = true;
	
	      _this.$timeout(function () {
	        // omniture when video playing
	        console.log('!!omniture when video playing!!');
	        analyticsService.sendReport('tutorials', 'vod play', null, null, _this.title, null, null, null, _this.$rootScope.omnitureBillingStatus, _this.$rootScope.omniturePaperlessbill);
	      }, 150);
	    };
	
	    this.alertDone = function (_) {
	      _this.videoerror = false;
	      _this.$timeout(function () {
	        window.removeEventListener('keydown', _this.keydown);
	        if (_this.$rootScope.fromLandingPage == true) {
	          _this.$rootScope.fromVideoBillPage = true;
	          _this.$rootScope.fromLandingPage = false;
	          _this.$state.go('home.landingpage');
	        } else {
	          //set up conditional to differentiate between tutorials and video bill
	          _this.$rootScope.fromTutorialPage = true;
	          _this.$state.go('home.tutorials');
	        }
	      }, 150);
	    };
	
	    this.keyWatch = function (event) {
	      window.addEventListener('keydown', _this.keydown, false);
	    };
	
	    this.$scope.$on('$destroy', function () {
	      _this.$interval.cancel(_this.promise);
	    });
	
	    this.scrubSpeed = 0;
	
	    this.keydown = function (event) {
	      if (event.keyCode !== 27 && event.keyCode !== 8 && event.keyCode !== 461 && event.keyCode !== 463 && event.keyCode !== 80 && event.keyCode !== 417 && event.keyCode !== 70 && event.keyCode !== 412 && event.keyCode !== 82) {
	        return;
	      }
	
	      if (_angular2['default'].isDefined(_this.promise)) {
	        _this.$interval.cancel(_this.promise);
	      }
	      // you clicked back
	      if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	        window.removeEventListener('keydown', _this.keydown);
	        console.log("you clicked!");
	        if (_this.$rootScope.fromLandingPage == true) {
	          _this.$rootScope.fromVideoBillPage = true;
	          _this.$rootScope.fromLandingPage = false;
	          _this.$state.go('home.landingpage');
	        } else {
	          //set up conditional to differentiate between tutorials and video bill
	          _this.$rootScope.fromTutorialPage = true;
	          _this.$state.go('home.tutorials');
	        }
	
	        // you clicked pause
	      } else if (event.keyCode === 463 || event.keyCode === 80) {
	          console.log('you clicked play or pause!');
	          _this.playPause = true;
	          _this.scrubSpeed = 0;
	          _this.controls.className = 'show-animation';
	          $timeout.cancel(_this.timer);
	          if (_this.action === true) {
	            _this.API.play();
	            _this.action = false;
	          } else {
	            _this.API.playPause();
	          }
	          _this.timer = _this.$timeout(function () {
	            _this.controls.className = 'hide-animation';
	          }, 5000);
	        } else if (event.keyCode === 417 || event.keyCode === 70) {
	          console.log('you clicked fast forward!');
	          $timeout.cancel(_this.timer);
	          _this.controls.className = 'show-animation';
	          _this.action = true;
	          _this.scrubSpeed = _this.scrubSpeed < 0 ? 0 : _this.scrubSpeed;
	
	          if (_this.scrubSpeed < 2) {
	            _this.scrubSpeed++;
	            _this.playPause = false;
	            $scope.ffImage = "assets/video_player/FF" + _this.scrubSpeed + ".png";
	          }
	          _this.promise = _this.$interval(function () {
	            _this.seekRepeat('forward', _this.scrubspeed);
	          }, 100);
	          _this.API.play();
	          // you clicked fast rewind
	        } else if (event.keyCode === 412 || event.keyCode === 82) {
	            $timeout.cancel(_this.timer);
	            _this.controls.className = 'show-animation';
	            _this.API.play();
	            console.log('you clicked fast rewind!');
	            _this.action = true;
	            _this.scrubSpeed = _this.scrubSpeed > 0 ? 0 : _this.scrubSpeed;
	
	            if (_this.scrubSpeed > -2) {
	              _this.scrubSpeed--;
	              _this.playPause = false;
	              $scope.ffImage = "assets/video_player/RR" + Math.abs(_this.scrubSpeed) + ".png";
	            }
	            _this.promise = _this.$interval(function () {
	              _this.seekRepeat('rewind', _this.scrubspeed);
	            }, 100);
	            // this.controls.className = 'show-animation';
	            // this.timer = this.$timeout(() => {
	            //     this.controls.className = 'hide-animation';
	            //   },5000);
	          }
	    };
	
	    $scope.$on('videogularStateChange', function (event, state) {
	      if (state === 'play' || state === 'pause') {
	        _this.scrubSpeed = 0;
	      }
	    });
	  }
	
	  _createClass(VideoplayerController, [{
	    key: 'onError',
	    value: function onError() {
	      var _this2 = this;
	
	      this.videoerror = true;
	      this.$timeout(function () {
	        _this2.focusItem('alert-confirm-btn');
	        // // document.getElementById('alert-confirm-btn').focus();
	      }, 150);
	      // // this.$state.go('home.tutorials');
	    }
	  }, {
	    key: 'focus',
	    value: function focus(id) {
	      console.log("id in focus:", id);
	      setTimeout(function () {
	        document.getElementById(id).focus();
	      }, 150);
	    }
	  }, {
	    key: 'focusItem',
	    value: function focusItem(id) {
	      var el = document.getElementById(id);
	      if (el) {
	        setTimeout(function () {
	          el.focus();
	        }, 150);
	        // el.focus();
	      } else {
	          this.$timeout(this.focusItem.bind(this, id));
	        }
	    }
	  }, {
	    key: 'playback',
	    value: function playback() {
	      if (this.$rootScope.fromLandingPage == true) {
	        this.$rootScope.fromVideoBillPage = true;
	        this.$rootScope.fromLandingPage = false;
	        this.$state.go('home.landingpage');
	      } else {
	        // set up conditional to differentiate between tutorials and video bill
	        this.API.stop();
	        this.$rootScope.fromTutorialPage = true;
	        this.$state.go('home.tutorials');
	      }
	    }
	  }, {
	    key: 'seekRepeat',
	    value: function seekRepeat(option, scroll) {
	      var _this3 = this;
	
	      var totalTime = this.API.totalTime / 1000;
	      // const totalTime = 127.00000000002;
	      var currentTime = this.API.currentTime / 1000;
	      console.log('current time is ' + currentTime);
	      var frameTime = totalTime / 1000 * 3 * Math.abs(this.scrubSpeed);
	      console.log('frameTime is ' + frameTime + 'and scrubspeed is ' + Math.abs(this.scrubSpeed));
	
	      if (option === 'forward') {
	        if (totalTime >= currentTime + frameTime) {
	          var scrollSpeed = scroll ? 1 : 2;
	          this.API.seekTime(currentTime + frameTime);
	          console.log('currentTime + frameTime is ' + currentTime + frameTime);
	        } else {
	          this.API.seekTime(totalTime);
	          this.$interval.cancel(this.promise);
	          window.removeEventListener('keydown', this.keydown);
	          if (this.$rootScope.fromLandingPage == true) {
	            this.$rootScope.fromVideoBillPage = true;
	            this.$rootScope.fromLandingPage = false;
	            this.$state.go('home.landingpage');
	          } else {
	            //set up conditional to differentiate between tutorials and video bill
	            this.API.stop();
	            this.$state.go('home.tutorials');
	          }
	        }
	      } else if (option === 'rewind') {
	        if (currentTime - 3 > 0) {
	          var scrollSpeed = scroll ? 1 : -2;
	          this.API.seekTime(currentTime - frameTime);
	        } else {
	          this.$interval.cancel(this.promise);
	          this.API.stop();
	          this.API.setPlayback(1);
	          this.API.seekTime(0);
	          this.scrubSpeed = 0;
	          this.playPause = true;
	          this.$timeout(function () {
	            _this3.controls.className = 'show-animation';
	            _this3.API.play();
	            _this3.timer = _this3.$timeout(function () {
	              _this3.controls.className = 'hide-animation';
	            }, 5000);
	          }, 50);
	        }
	      }
	    }
	  }]);
	
	  return VideoplayerController;
	})();
	
	VideoplayerController.$inject = ['$rootScope', '$scope', '$state', '$sce', '$stateParams', '$timeout', '$interval', 'analyticsService', 'laboxSSapi', 'storage'];
	
	exports['default'] = VideoplayerController;
	module.exports = exports['default'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(184);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./videoplayer.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./videoplayer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "videoplayer{height:100%;width:100%}videoplayer [videogular] vg-controls,videoplayer videogular vg-controls{width:100%;height:100%;display:block;position:absolute;z-index:3;bottom:3px}videoplayer [videogular] vg-controls .controls-container,videoplayer videogular vg-controls .controls-container{width:70%;height:70px;bottom:100px;left:175px;position:absolute;display:table;zoom:1}videoplayer [videogular] vg-scrub-bar [role=slider],videoplayer videogular vg-scrub-bar [role=slider]{margin-top:7px;height:7px;background-color:hsla(0,0%,55%,.5);position:relative}videoplayer [videogular] vg-scrub-bar .container,videoplayer videogular vg-scrub-bar .container{position:absolute;width:100%;height:7px;top:-7px;padding-left:0;display:table}videoplayer [videogular] vg-scrub-bar :focus vg-scrub-bar-current-time,videoplayer videogular vg-scrub-bar :focus vg-scrub-bar-current-time{border-right:6px groove #000}videoplayer [videogular] vg-scrub-bar-current-time,videoplayer videogular vg-scrub-bar-current-time{position:absolute;background-color:#fff!important;width:100%;height:107%;display:block;cursor:pointer}videoplayer [videogular] vg-scrub-bar-current-time-2,videoplayer videogular vg-scrub-bar-current-time-2{position:absolute;width:100%;height:100%;min-height:15px;min-width:13px;margin-top:-4px;display:block;cursor:pointer;background:url(" + __webpack_require__(185) + ") no-repeat 100%}videoplayer [videogular] vg-play-pause-button,videoplayer videogular vg-play-pause-button{display:table-cell;width:50px;height:50px;vertical-align:middle;text-align:center;cursor:pointer;padding-right:10px}videoplayer [videogular] vg-play-pause-button .play,videoplayer videogular vg-play-pause-button .play{background:url(" + __webpack_require__(186) + ");min-width:34px!important;min-height:34px!important;background-position:50%!important;background-repeat:no-repeat!important}videoplayer [videogular] vg-play-pause-button .pause,videoplayer videogular vg-play-pause-button .pause{background:url(" + __webpack_require__(187) + ");min-width:34px!important;min-height:34px!important;background-position:50%!important;background-repeat:no-repeat!important}videoplayer videogular my-button{display:table-cell;width:50px;height:50px;vertical-align:middle;text-align:center;cursor:pointer;padding-right:10px}videoplayer [videogular] my-button,videoplayer videogular my-button{min-width:34px!important;min-height:34px!important;background-position:50%!important;background-repeat:no-repeat!important}videoplayer [videogular] vg-time-display,videoplayer videogular vg-time-display{color:#fff;font-family:Arial;font-size:18px;width:75px;vertical-align:middle;text-align:center;cursor:default}videoplayer [videogular] vg-scrub-bar,videoplayer videogular vg-scrub-bar{width:auto;cursor:pointer;vertical-align:middle;position:relative}videoplayer videogular .totalTime{margin-left:10px;color:#f1f1f1}videoplayer videogular .displayTitle{font-weight:800;margin-top:10px}videoplayer videogular .controlImage{width:100%;height:100%;background-image:linear-gradient(180deg,transparent,rgba(0,0,0,.9) 85%,#000),linear-gradient(357deg,#000,rgba(0,0,0,.5) 10%,transparent 50%);position:fixed;bottom:0;left:0;z-index:-1}videoplayer .hide-animation{animation:hideControlsAnimationFrames ease-out .5s;animation-iteration-count:1;animation-fill-mode:forwards;-webkit-animation:hideControlsAnimationFrames ease-out .5s;-webkit-animation-iteration-count:1;-webkit-animation-fill-mode:forwards}@keyframes hideControlsAnimationFrames{0%{opacity:.5}to{opacity:0}}videoplayer .show-animation{animation:showControlsAnimationFrames ease-out .5s;animation-iteration-count:1;animation-fill-mode:forwards;-webkit-animation:showControlsAnimationFrames ease-out .5s;-webkit-animation-iteration-count:1;-webkit-animation-fill-mode:forwards}@keyframes showControlsAnimationFrames{0%{background-color:transparent}to{background-color:rgba(0,0,0,.5)}}.alert-modal{z-index:100}", ""]);
	
	// exports


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAOCAYAAAD0f5bSAAAACXBIWXMAAAsSAAALEgHS3X78AAAAoElEQVQoz52SsQnEMAxFf24CjZARMsKNoJEykIdI59bgDVKlCbgKuHrXxJAL4eD84TeSHogvDYBumiS9JZmkImmRlL4mgOYJWHjWcvYF6AoUfqs0UIBdgZzz5u6M44i7k3PebqAJmFslhLBL4u4Qwn4BZwEJoNZ6mBlPkJlRaz1OKKnhMcb1CWiOMa5t9qUe9a7XFURX5F3H/fuNhp6H/QB0hrmf9xmNSwAAAABJRU5ErkJggg=="

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsSAAALEgHS3X78AAABeUlEQVRYw82Y0W2DMBRFD6j/ZYO6E5QNygbNBs0IdIIyQkegGzAC3SCdoMkGZILbH1tyEEkMAsyV/IMEHD+e33uXRBITlAG5XZl3vQWOdo2TpNBlJFWSDrqvTlItqQh9fihArelqQ4DuQZR2d3OokZRNAak1vw6S8jEgrZZTNwSzViSGYC4+U9o7RCXwzvJ6BJprx9fMmJihKt37E6+g1StFw9cZMEDnQAzwF3Djj62eTsaDP9nN+PoMeOYH8OU+SxUYyqqX2EWvcPUTP0RHP1l3xNMTYFLbtF6Iq11qO2hsma2A5GlvnoimlI1oUyDtBjiO6aT5ckGQc2SQ1uVIExHiDLQPIzuvAQr//PcsRjEBpAEuxoAWeI0QkWeXI05VBIhvd1iSntNrgLe1h6KhgrYHftfquA7imuXMV5hd96G+ZkmY/Vinl81stLpbHjjEhM/hf+tbvjcUxEWntIPumAjU1i/dfUcy4UeNsRlvBqa7DjjY4jiqq/8Dnvpr0bVG974AAAAASUVORK5CYII="

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAACXBIWXMAAAsSAAALEgHS3X78AAABr0lEQVRYw8WY31GDQBCHPxjfQwdeKpAOjBWYDsQOKAFLsIKcHWAFYgXGDrADUsH6sjgkQ5K748DfzL0wc8fH/rtdEhEhQBmQ68oGzxug1eUnEXFdRkQqEdnLdXUiYkVk43q+K4CVcDUuQNcgSv26GKpFJAsBsRJfexHJfUAamU/dGMxSlhiDOXJTepJEJfDE/FoB9bn0NRED01Vl//5kUNDsQtYY6gAYoOtdYzwgfnTFclEB/MVI4bHZaml/iQRTDkG2nps7oALWwPtEkFvApHpp3QUe0upHPADfE2C2qZp5qho951kD0FcmFsgwfgzw6rkvT0/6iRjqNADXwKfrpnTGGtGqhf4VZAPsgZ0PSBMRwOgd8uGZie1NUH853sOWulYhbuxBDoEH9FW50sIUnP59jNQBm3N1624ixGEIYj0BLPAF3Edwaw0ctQFNpIN9tQbaYfpW/wDx1idLcjLp1cDj0k3RWEErJt6iXjduD3Fu5MwX6F0L17lmTpjCd9LLIg9a3aUZ2GUIjzH/2ktzrytIb51SRFpPC1idl66+Iwn4UWM04s1Id9fp9d/43uq/9jP+1cEWgg4AAAAASUVORK5CYII="

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerComponent = __webpack_require__(189);
	
	var _playerComponent2 = _interopRequireDefault(_playerComponent);
	
	var playerModule = _angular2['default'].module('player', [_angularUiRouter2['default'], 'navigation']).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  'ngInject';
	
	  $stateProvider.state('player', {
	    url: '/player',
	    params: {
	      url: undefined,
	      label: undefined,
	      externalId: undefined,
	      previousPage: undefined,
	      index: undefined
	    },
	    template: '<player></player>'
	  });
	}]).component('player', _playerComponent2['default']);
	
	exports['default'] = playerModule;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _playerHtml = __webpack_require__(190);
	
	var _playerHtml2 = _interopRequireDefault(_playerHtml);
	
	var _playerController = __webpack_require__(191);
	
	var _playerController2 = _interopRequireDefault(_playerController);
	
	__webpack_require__(192);
	
	exports['default'] = {
	  restrict: 'E',
	  bindings: {},
	  template: _playerHtml2['default'],
	  controller: _playerController2['default'],
	  controllerAs: 'vm'
	};
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"player\" ng-init=\"vm.keyWatch($event)\">\n\t<p style=\"margin-top: 20px\">{{vm.source}}</p>\n\t<!-- <video class=\"video\" id=\"video\" controls autoplay width=\"1280\" height=\"650\">\n\t\t<source ng-src={{vm.source}} type=\"video/mp4\">\n\t</video> -->\n<!-- \n\t<div class='show-animation' id='controls-animation'>\n\t\t<div class='player-controls' id='player-controls'>\n\t\t\t<div class='player-controls-container'>\n\t\t\t\t<div class='action-button' id='player-play-pause-button'><img id='action-button' src={{ffImage}}></div>\n\t\t\t\t<div class='time-display' id='currTime'>0:00 </div>\n\t\t\t\t<div class='time-display' id='totalTime'>( 0:00 )</div>\n\t\t\t\t<div class='player-scrub-bar-container'>\n\t\t\t\t\t<div class=\"progress-container\">\n\t  \t\t\t\t\t<div id='progress-bar' class=\"progressbar\" style=\"width:0%\"></div>\n\t  \t\t\t\t\t<div id='progress-bar-img' class=\"progressbar-img\" style=\"width:0%\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"displayTitle\">{{vm.title}}</div>\n\t\t\t</div>\n\t\t\t<div class=\"controlImage\"></div>\n\t\t</div>\n\t</div> -->\n\t<div id=\"sundayskyDiv\"></div>\n\t<script src=\"https://play.sundaysky.com/main/sundaysky-player.grey.en-us.min.js\"></script>\n\t<!-- <sundaysky-video id=\"sskyplayer\" endpoint-url=\"https://optimum.web.sundaysky.com/create_video_session?id=A0N3R_akOtCtQohonnlU8zs8Xv3Yniwp&amp;statement=6&amp;archetype=0&amp;pon=0&amp;poff=0&amp;theme=2&amp;lang=en&amp;ref=web\" pre-roll=\"https://play.sundaysky.com/resources/loading.gif\" poster=\"\" session-parameters=\"{}\" style=\"position: relative;\"></sundaysky-video>  -->\n</div>\n"

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var PlayerController = (function () {
	  function PlayerController($sce, $stateParams, $rootScope, $timeout, $state, $interval, $scope, laboxSSapi) {
	    var _this = this;
	
	    _classCallCheck(this, PlayerController);
	
	    this.name = 'player';
	    this.$stateParams = $stateParams;
	    this.$rootScope = $rootScope;
	    this.$timeout = $timeout;
	    this.timer = 0;
	    this.$state = $state;
	    this.$interval = $interval;
	    this.$scope = $scope;
	    this.scrubSpeed = 0;
	
	    this.source = $sce.trustAsResourceUrl(this.$stateParams.url);
	    var datex = "hvjvkjkkj";
	    laboxSSapi.logData(datex);
	    // this.title = this.$rootScope.title;
	    // var player1;
	    // var sskyreload;
	
	    this.reloadPlayer();
	    // this.video = document.getElementById('video');
	    // this.controls = document.getElementById('controls-animation');
	    // this.btn = document.getElementById('player-play-pause-button');
	    // this.totalTime = document.getElementById('totalTime');
	    // this.currTime = document.getElementById('currTime');
	    // this.progressBar = document.getElementById('progress-bar');
	    // this.progressBarImg = document.getElementById('progress-bar-img');
	    // $scope.ffImage = "assets/video_player/Play_button.png";
	
	    // this.timer = this.$timeout(() => {
	    //   this.controls.className = 'hide-animation';
	    // },5000);
	
	    // this.$onInit = function () {
	    //   // progress = setInterval(function(){ this.timeRepeat() }, 200);
	    //   this.progressinit = this.$interval(() => {
	    //     this.timeRepeat();
	    //   }, 200);
	    // }
	
	    // this.video.onended = () => {
	    //   console.log('!! player on ended');
	    //   window.removeEventListener('keydown', this.keydown);
	    //   this.$interval.cancel(this.progressinit);
	    //   this.$interval.cancel(this.progress);
	    //   this.$interval.cancel(this.promise);
	    //   this.$rootScope.fromVideoBillPage = true;
	    //   this.$rootScope.fromLandingPage = false;
	    //   this.$state.go('home.landingpage');
	    // }
	
	    // this.video.onplaying = () => {
	    //   console.log('!!player on playing');
	    //   if (this.fromrewind) {
	    //     this.fromrewind = false;
	    //     $scope.ffImage = "assets/video_player/Play_button.png";
	    //   }
	    // }
	
	    this.keyWatch = function (event) {
	      window.addEventListener('keydown', _this.keydown, false);
	    };
	
	    this.keydown = function (e) {
	      if (event.keyCode === 463 || event.keyCode === 80) {
	        // // console.log('playPause');
	        // //stop all intervarls
	        // this.$interval.cancel(this.progress);
	        // this.$interval.cancel(this.progressinit);
	        // this.$interval.cancel(this.promise);
	
	        // this.scrubSpeed = 0;
	        // this.controls.className = 'show-animation';
	        // $timeout.cancel(this.timer);
	        // this.video.playbackRate = 1.0;
	
	        // if(this.action === true) {
	        //   this.video.play();
	        //   this.action = false;
	        // } else {
	        _this.video.paused ? _this.video.play() : _this.video.pause();
	        // }
	        // this.video.paused ? $scope.ffImage = "assets/video_player/Pause_button.png" : $scope.ffImage = "assets/video_player/Play_button.png";
	
	        // if(!this.video.paused) {
	        //   this.progress = this.$interval(() => {
	        //     this.timeRepeat();
	        //   }, 200);
	        // }
	        // this.timer = this.$timeout(() => {
	        //   this.controls.className = 'hide-animation';
	        // },5000);
	        // } else if (event.keyCode === 417 || event.keyCode === 70) {
	        //   // console.log('you clicked fast forward!');
	
	        //   this.$interval.cancel(this.progress);
	        //   this.$interval.cancel(this.progressinit);
	        //   this.$interval.cancel(this.promise);
	        //   $timeout.cancel(this.timer);
	
	        //   this.controls.className = "show-animation";
	        //   this.action = true;
	        //   this.scrubSpeed = this.scrubSpeed < 0 ? 0 : this.scrubSpeed;
	        //   if (this.scrubSpeed < 2) {
	        //     this.scrubSpeed++;
	        //     $scope.ffImage = "assets/video_player/FF"+this.scrubSpeed+".png";
	        //   }
	        //   this.promise = this.$interval(() => {
	        //     this.seekRepeat('forward', this.scrubSpeed);
	        //     this.timeRepeat();
	        //   }, 100);
	        // } else if (event.keyCode === 412 || event.keyCode === 82) {
	        //   // console.log('you clicked fast rewind!');
	
	        //   this.$interval.cancel(this.progress);
	        //   this.$interval.cancel(this.progressinit);
	        //   this.$interval.cancel(this.promise);
	        //   $timeout.cancel(this.timer);
	
	        //   this.controls.className = "show-animation";
	        //   this.action = true;
	        //   this.scrubSpeed = this.scrubSpeed > 0 ? 0 : this.scrubSpeed;
	        //   if (this.scrubSpeed > -2) {
	        //     this.scrubSpeed--;
	        //     $scope.ffImage = "assets/video_player/RR"+Math.abs(this.scrubSpeed)+".png";
	        //   }
	        //   this.promise = this.$interval(() => {
	        //     this.seekRepeat('rewind', this.scrubSpeed);
	        //     this.timeRepeat();
	        //   }, 100);
	      } else if (event.keyCode === 27 || event.keyCode === 8 || event.keyCode === 461) {
	          console.log("you clicked! back");
	
	          // this.$interval.cancel(this.progress);
	          // this.$interval.cancel(this.progressinit);
	          // this.$interval.cancel(this.promise);
	
	          window.removeEventListener('keydown', _this.keydown);
	          _this.$rootScope.fromVideoBillPage = true;
	          _this.$rootScope.fromLandingPage = false;
	          _this.$state.go('home.landingpage');
	        }
	    };
	
	    // this.$onDestroy = function () {
	    //   console.log('!! player on destroy');
	    //   window.removeEventListener('keydown', this.keydown);
	    //   this.$interval.cancel(this.progress);
	    //   this.$interval.cancel(this.progressinit);
	    //   this.$interval.cancel(this.promise);
	    // };
	  }
	
	  // timeRepeat() {
	  //   console.log('!! player on time repeat with set');
	  //   if(this.video.readyState > 0) {
	  //     this.totalMinutes = parseInt(this.video.duration / 60, 10);
	  //     this.totalSeconds = parseInt(this.video.duration % 60, 10);
	  //     this.totalSecond = ("0" + this.totalSeconds).slice(-2);
	  //     this.totalTime.innerHTML = '( ' + this.totalMinutes + ' : ' + this.totalSecond + ' )';
	  //     this.totalTimeInSeconds = (this.totalMinutes*60) + this.totalSeconds;
	
	  //     this.currMinutes = parseInt(this.video.currentTime / 60, 10);
	  //     this.currSeconds = parseInt(this.video.currentTime % 60, 10);
	  //     this.currSecond = ("0" + this.currSeconds).slice(-2);
	  //     this.currTime.innerHTML = this.currMinutes + ' : ' + this.currSecond + ' ';
	  //     this.currTimeInSeconds = (this.currMinutes*60) + this.currSeconds;
	
	  //     this.percentage = Math.floor((100 / this.video.duration) * this.video.currentTime);
	  //     this.progressBar.value = this.percentage;
	  //     this.progressBar.style.width = this.percentage + '%';
	  //     this.progressBarImg.value = this.percentage;
	  //     this.progressBarImg.style.width = this.percentage + '%';
	  //   }
	  // }
	  // seekRepeat(option, scroll) {
	  //   console.log('!! player on seek repeat');
	  //   const totalTime = this.video.duration;
	  //   const currTime = this.video.currentTime;
	  //   const frameTime = .2*Math.abs(scroll);
	  //   if (option === 'forward') {
	  //     if ((currTime + frameTime*Math.abs(scroll)) <= totalTime) {
	  //       this.video.playbackRate = 1.0;
	  //       this.video.currentTime = this.video.currentTime + frameTime*Math.abs(scroll);
	  //     } else {
	  //       this.$interval.cancel(this.promise);
	  //       this.$interval.cancel(this.progress);
	  //       window.removeEventListener('keydown', this.keydown);
	  //       this.$rootScope.fromVideoBillPage = true;
	  //       this.$rootScope.fromLandingPage = false;
	  //       this.$state.go('home.landingpage');
	  //     }
	  //   } else if (option === 'rewind') {
	  //     if ((currTime - frameTime*Math.abs(scroll)) >= 0) {
	  //       this.video.playbackRate = 1.0;
	  //       this.video.currentTime += -frameTime*Math.abs(scroll);
	  //     } else {
	  //       this.fromrewind = true;
	  //       this.$interval.cancel(this.promise);
	  //       this.$interval.cancel(this.progress);
	  //       this.video.playbackRate = 1.0;
	  //       this.video.currentTime = 0;
	  //       this.scrubSpeed = 0;
	  //       this.$timeout(() => {
	  //         this.controls.className = 'show-animation';
	  //         this.video.play();
	  //         this.progress = this.$interval(() => {
	  //           this.timeRepeat();
	  //         }, 200);
	  //         this.timer = this.$timeout(() => {
	  //           this.controls.className = 'hide-animation';
	  //         },5000);
	  //       },50);
	  //     }
	  //   }
	  // }
	
	  _createClass(PlayerController, [{
	    key: 'createPlayer',
	    value: function createPlayer() {
	      console.log('create player');
	      // var player1 = document.createElement('video');
	      // player1.setAttribute('class', 'video');
	      // player1.setAttribute('src', this.source);
	      // player1.setAttribute('type','video/webm');
	      // player1.setAttribute('controls','true');
	      // player1.setAttribute('autoplay','true');
	      // player1.setAttribute('width','1280');
	      // player1.setAttribute('height','650');
	
	      var player1 = document.createElement('sundaysky-video');
	      player1.setAttribute('id', 'sskyplayer');
	      player1.setAttribute('endpoint-url', 'https://optimum.web.sundaysky.com/create_video_session?id=A0N3R_akOtCtQohonnlU8zs8Xv3Yniwp&amp;statement=6&amp;archetype=0&amp;pon=0&amp;poff=0&amp;theme=2&amp;lang=en&amp;ref=web');
	      player1.setAttribute('analytics-token', 'optimum');
	      player1.setAttribute('session-parameters', '{}');
	      player1.setAttribute('poster', 'https://play.sundaysky.com/resources/invitation.png');
	      player1.setAttribute('pre-roll', 'https://play.sundaysky.com/resources/loading.gif');
	      player1.setAttribute('autoplay', 'true');
	      document.getElementById('sundayskyDiv').appendChild(player1);
	    }
	  }, {
	    key: 'reloadPlayer',
	    value: function reloadPlayer() {
	      console.log('reload player');
	      // var sskyreload = document.getElementById('video');
	      var sskyreload = document.getElementById('sundayskyDiv');
	      sskyreload.innerHTML = "";
	      this.createPlayer();
	      // sskyreload.appendChild(this.player1);
	    }
	  }]);
	
	  return PlayerController;
	})();
	
	PlayerController.$inject = ['$sce', '$stateParams', '$rootScope', '$timeout', '$state', '$interval', '$scope', 'laboxSSapi'];
	
	exports['default'] = PlayerController;
	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(193);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./player.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./player.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var RemoteService = angular.module('remote', []).service('laboxRemote', ['$http', function ($http) {
	
	  this.isUp = function (event) {
	    return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
	  };
	
	  this.isDown = function (event) {
	    return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
	  };
	
	  this.isRight = function (event) {
	    return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
	  };
	
	  this.isLeft = function (event) {
	    return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
	  };
	
	  this.isEnter = function (event) {
	    return event.code === 'Enter' || event.keyIdentifier === 'Enter' || event.charCode === 13;
	  };
	
	  this.isTab = function (event) {
	    return event.code === 'Tab' && !event.shiftKey;
	  };
	
	  this.isShiftTab = function (event) {
	    return event.code === 'Tab' && event.shiftKey === true;
	  };
	
	  this.isBack = function (event) {
	    return event.keyCode === 8 || event.keyCode === 27 || event.code === 'Backspace' || event.keyCode === 461;
	  };
	}]);
	
	exports['default'] = RemoteService;
	module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cryptoJs = __webpack_require__(196);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	var LaboxSSAPI = _angular2['default'].module('labox.sse.api', ['storage']).service('laboxSSapi', ['$http', '$q', 'storage', function ($http, $q, storage) {
	  var _this = this;
	
	  this.config = {
	    dev: {
	      "cassservice": "http://dev.casservices.cv.net/optimum-support/services/v1/",
	      "bpKeySecretID": "gsB74usx8n",
	      "bpKeySecret": "663C1D571ED5DD6858D8DFBA89CC2"
	    },
	    stage: {
	      "cassservice": "http://stage2.casservices.cv.net/optimum-support2/services/v1/",
	      "bpKeySecretID": "gsB74usx8n",
	      "bpKeySecret": "663C1D571ED5DD6858D8DFBA89CC2"
	    },
	    prod: {
	      "cassservice": "http://casservices.cv.net/optimum-support/services/v1/",
	      "bpKeySecretID": "ho4w482t7U",
	      "bpKeySecret": "5D34622EAA5D931EB3BB6B4A918A8"
	    }
	    //stage:{
	    //"cassservice":"http://stage2.casservices.cv.net/optimum-support2/services/v1/",
	    //"bpKeySecretID": "gsB74usx8n",
	    //"bpKeySecret": "663C1D571ED5DD6858D8DFBA89CC2"
	    //}
	  };
	
	  var GET = 'get';
	  var POST = 'post';
	
	  this.wrap = function (url, config, resultName, method, data) {
	
	    var handleWaiters = function handleWaiters(resultName) {
	      if (_this[resultName + 'Waiters']) {
	        _this[resultName + 'Waiters'].forEach(function (waiterCallback) {
	          _this[resultName + 'Promise'].then(waiterCallback.bind(undefined, undefined));
	          _this[resultName + 'Promise']['catch'](waiterCallback.bind(undefined));
	        });
	      }
	    };
	
	    // console.log('## DATA ## API REQUEST ' + resultName);
	
	    var promise = undefined;
	
	    if (method.toLowerCase() === GET) {
	      promise = $http.get(url, config);
	    } else if (method.toLowerCase() === POST) {
	      promise = $http.post(url, data, config);
	    }
	
	    promise.then(function (result) {
	      // console.log('## DATA ## API RESULT ' + resultName, url, result);
	      if (resultName) {
	        _this[resultName + 'Result'] = result;
	      }
	    });
	
	    promise['catch'](function (error) {
	      console.error('## DATA ## API ERROR ' + resultName, url, error);
	      if (resultName) {
	        _this[resultName + 'Error'] = error;
	      }
	    });
	
	    _this[resultName + 'Promise'] = promise;
	
	    handleWaiters(resultName);
	
	    return promise;
	  };
	
	  this.waitFor = function (name, callback) {
	    if (_this[name + 'Result']) {
	      callback(undefined, _this[name + 'Result']);
	    } else if (_this[name + 'Error']) {
	      callback(_this[name + 'Error']);
	    } else if (_this[name + 'Promise']) {
	      _this[name + 'Promise'].then(callback.bind(undefined, undefined));
	    } else {
	      _this[name + 'Waiters'] = _this[name + 'Waiters'] || [];
	      _this[name + 'Waiters'].push(callback);
	    }
	  };
	
	  //------------------Direct API CALLS------------------------------------------//
	
	  this.getAllOptimumIds = function () {
	    var cidx = storage.getItem('session', 'home_id');
	    return _this.wrap('/api/getalloptimumids/cidx=' + cidx, {}, 'getAllOptimumIds', 'GET');
	  };
	
	  this.getAllSuddenlinkIds = function () {
	    var cidx = storage.getItem('session', 'home_id');
	    return _this.wrap('/api/getallsdlids/cidx=' + cidx, {}, 'getAllSuddenlinkIds', 'GET');
	  };
	
	  this.accountInfo = function () {
	    var cidx = storage.getItem('session', 'home_id');
	    return _this.wrap('/api/opt/acctinfo/cidx=' + cidx, {}, 'accountInfoProfile', 'GET');
	  };
	
	  this.getOptVideoTutorials = function () {
	    return _this.wrap('/api/tutorial/opt', {}, 'getVideoTutorials', 'GET');
	  };
	
	  this.getSdlVideoTutorials = function () {
	    return _this.wrap('/api/tutorial/sdl', {}, 'getVideoTutorials', 'GET');
	  };
	
	  this.getVideoBill = function () {
	    var cidx = storage.getItem('session', 'accno');
	    return _this.wrap('/api/videobill/accountnumber=' + cidx, {}, 'getVideoBill', 'GET');
	  };
	
	  this.getOptFaq = function () {
	    return _this.wrap('api/quicktips/opt', {}, 'getOptFaq', 'GET');
	  };
	
	  this.getSdlFaq = function () {
	    return _this.wrap('api/quicktips/sdl', {}, 'getSdlFaq', 'GET');
	  };
	
	  this.logData = function (dataval) {
	    // var dataval = storage.getItem('session','home_id');
	    return _this.wrap('api/logs/data=' + dataval, {}, 'logData', 'GET');
	  };
	}]);
	
	exports['default'] = LaboxSSAPI;
	module.exports = exports['default'];

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angularUiRouter = __webpack_require__(7);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	angular.module('navigation', [_angularUiRouter2['default']]).service('navigationManager', ['$state', '$stateParams', '$rootScope', '$window', function ($state, $stateParams, $rootScope, $window) {
	  var map = {};
	
	  this.registerViewComponent = function (controller, $scope, state) {
	    console.log('Registering', controller);
	
	    map[state] = map[controller.name] = {
	      controller: controller,
	      $scope: $scope,
	      state: state
	    };
	
	    $scope.$on('focus', function (event, obj) {
	      //console.log(" event:", event);
	      //console.log("obj:", obj);
	      if (obj.id === state) {
	        controller.focus();
	      }
	    });
	  };
	
	  this.registerNavigate = function (elementId, direction, callbackOrId) {
	    var el = document.getElementById(elementId);
	
	    //console.log("element in registernavigate:", el);
	    if (el) {
	      el.addEventListener('keydown', function (event) {
	        //console.log("i m coming here", event);
	        var hit = false;
	
	        //console.log('Button', direction, event.code);
	        switch (direction) {
	          case 'up':
	            if (event.code === 'ArrowUp' || event.keyIdentifier === 'Up') {
	              hit = true;
	            }
	            break;
	          case 'down':
	            if (event.code === 'ArrowDown' || event.keyIdentifier === 'Down') {
	              hit = true;
	            }
	            break;
	          case 'right':
	            if (event.code === 'ArrowRight' || event.keyIdentifier === 'Right') {
	              hit = true;
	            }
	            break;
	          case 'left':
	            if (event.code === 'ArrowLeft' || event.keyIdentifier === 'Left') {
	              hit = true;
	            }
	            break;
	        }
	
	        if (hit) {
	          if (typeof callbackOrId === 'function') {
	            callbackOrId();
	          } else if (typeof callbackOrId === 'string') {
	            document.getElementById(callbackOrId).focus();
	          }
	
	          event.preventDefault();
	        }
	      });
	    } else {
	      console.error('Could not find element by id:', elementId);
	    }
	  };
	
	  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
	    var cancel = $rootScope.$on('$viewContentLoaded', function (_) {
	      var navItem = map[toState.name];
	
	      //console.log("fromState:", fromState);
	      //console.log("toState:", toState);
	      /*if(fromState.name === 'home.landingpage.viewpaybilllanding' && toState.name === 'home.landingpage'){
	        console.log("$window:",$window.history);
	        //$window.history.go(1);
	        //window.location.replace('');
	        event.preventDefault();
	        //$state.go(toState, {}, { location: 'replace' });
	      }*/
	
	      if (toState.redirectTo) {
	        event.preventDefault();
	        $state.go(toState.redirectTo, { location: 'replace' });
	      }
	
	      //console.log("toState.redirectTo:", toState.redirectTo);
	
	      if (navItem) {
	        //navItem.controller.focus();
	      } else if (toState.redirectTo === undefined) {
	          //console.error('Controller could not be found', toState, map);
	        }
	
	      cancel();
	    });
	  });
	}]);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	var Storage = _angular2['default'].module('storage', []).service('storage', function () {
	
	  this.setItem = function (storageType, key, value) {
	    try {
	      if (value !== undefined) {
	        if (storageType === 'local') {
	          localStorage.setItem(key, JSON.stringify(value));
	        } else if (storageType === 'session') {
	          sessionStorage.setItem(key, JSON.stringify(value));
	        }
	      }
	    } catch (e) {
	      return undefined;
	    }
	  };
	
	  this.getItem = function (storageType, key) {
	    var value;
	    try {
	      if (storageType === 'local') {
	        value = localStorage.getItem(key);
	      } else if (storageType === 'session') {
	        value = sessionStorage.getItem(key);
	      }
	      return value ? JSON.parse(value) : null;
	    } catch (e) {
	      return undefined;
	    }
	  };
	});
	
	exports['default'] = Storage;
	module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	        value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var ApiMocks = _angular2['default'].module('mockservices', []).service('mockService', ['$sce', function ($sce) {
	
	        this.getTruevalue = function () {
	                return true;
	        };
	        this.getFalsevalue = function () {
	                return false;
	        };
	}]);
	
	exports['default'] = ApiMocks;
	module.exports = exports['default'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _userauth = __webpack_require__(234);
	
	var _userauth2 = _interopRequireDefault(_userauth);
	
	var _userbilling = __webpack_require__(235);
	
	var _userbilling2 = _interopRequireDefault(_userbilling);
	
	var _appanalytics = __webpack_require__(236);
	
	var _appanalytics2 = _interopRequireDefault(_appanalytics);
	
	var serviceModule = _angular2['default'].module('app.services', [_userauth2['default'].name, _userbilling2['default'].name, _appanalytics2['default'].name]);
	
	exports['default'] = serviceModule;
	module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cryptoJs = __webpack_require__(196);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	/*---------------------------------------------------------*\
	 * userauthService
	 \*---------------------------------------------------------*/
	
	function authService(laboxSSapi, storage) {
	
	  var currenttimestamp = new Date().getTime();
	  var loginPayload = {};
	  var secretAndKey = getConfig();
	  console.log('Secret and Key -->', secretAndKey);
	  console.log('Secret and Key -->', storage.getItem('session', 'env'));
	
	  function generateMessage(primaryId, secretID) {
	    return "/login/trustedLogin?id=" + primaryId + "&requestTime=" + currenttimestamp + "&secretKeyId=" + secretID;
	  }
	
	  function setPrimaryId() {
	    return laboxSSapi.getAllOptimumIds().then(function (res) {
	      if (res && res.data.optimumIdInfo !== null && res.data.status === 'Success') {
	        console.log('get all optimum id response --> ', res);
	        var primaryidObj = _lodash2['default'].find(res.data.optimumIdInfo, function (o) {
	          return o.userIDType == "true";
	        });
	        storage.setItem('session', 'optimum_ids', res.data.optimumIdInfo);
	        storage.setItem('session', 'primary_id', primaryidObj.loginID);
	        return true;
	        console.log('primary id is set up in session storage');
	      } else {
	        console.log('primary id  not set up in session storage and res.data is--> ', res.data);
	        return null;
	      }
	    }, function (reserr) {
	      return null;
	    });
	  }
	
	  function generateHMAC(primaryid) {
	    var validMsg = generateMessage(primaryid, secretAndKey.bpKeySecretID);
	    return _cryptoJs2['default'].HmacSHA256(validMsg, secretAndKey.bpKeySecret).toString();
	  }
	
	  function setPayload(payload) {
	    loginPayload = payload;
	    console.log('id hmac timestamp and secret id : ' + loginPayload);
	  }
	
	  function getPayload() {
	    return loginPayload;
	  }
	
	  function generateLoginPayload() {
	    return setPrimaryId().then(function (res) {
	      if (!res) {
	        console.log('primary id not set up and res is null');
	        setPayload(null);
	      } else {
	        console.log('this is primary id setting response-->', res);
	        var primaryID = storage.getItem('session', 'primary_id');
	        console.log('Got primary ID for generate payload', primaryID);
	        var generatedHmac = generateHMAC(primaryID);
	        var logindata = {
	          "id": primaryID,
	          "secretKeyId": secretAndKey.bpKeySecretID,
	          "requestTime": currenttimestamp,
	          "hmac": generatedHmac
	        };
	        setPayload(JSON.stringify(logindata));
	      }
	    }, function (reserr) {
	      setPayload(null);
	    });
	  }
	
	  this.trustedLogin = function () {
	    return generateLoginPayload().then(function () {
	      console.log('Start Login with payload --> ', getPayload());
	      if (getPayload() && getPayload() != null) {
	        var data = { "payload": getPayload() };
	        console.log('generateLoginPayload is success. payload is not null and it is---> ', getPayload());
	        //return laboxSSapi.wrap(laboxSSapi.config.dev.cassservice+"login/trustedLogin", {},'trustedLogin','POST',getPayload());
	        return laboxSSapi.wrap("/api/bpglobal/login", {}, 'trustedLogin', 'POST', data);
	      } else {
	        console.log('generateLoginPayload is success. payload is null and it is---> ', getPayload());
	        return null;
	      }
	    }, function () {
	      return null;
	    });
	  };
	
	  function getConfig() {
	    if (storage.getItem('session', 'env') === 'prod') {
	      return laboxSSapi.config.prod;
	    } else if (storage.getItem('session', 'env') === 'stage') {
	      return laboxSSapi.config.stage;
	    } else {
	      return laboxSSapi.config.dev;
	    }
	  }
	}
	
	authService.$inject = ['laboxSSapi', 'storage'];
	
	var api = _angular2['default'].module('userauthService', ['labox.sse.api', 'storage']).service('authService', authService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/*---------------------------------------------------------*\
	 * Imports
	 \*---------------------------------------------------------*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cryptoJs = __webpack_require__(196);
	
	var _cryptoJs2 = _interopRequireDefault(_cryptoJs);
	
	/*---------------------------------------------------------*\
	 * userbillingService
	 \*---------------------------------------------------------*/
	
	function billingService(laboxSSapi, storage, authService) {
	  var _this = this;
	
	  this.setOOLSession = function () {
	    return authService.trustedLogin().then(function (res) {
	      if (res && res != null) {
	        console.log('Login done and response is ', res);
	        storage.setItem('session', 'loginInfo', res.data);
	        storage.setItem('session', 'oolsession', 'oolsession=' + res.data.oolsession);
	        storage.setItem('session', 'accno', res.data.accountNumber);
	        storage.setItem('session', 'hasOptimumId', true);
	        return true;
	      } else {
	        console.log('login done with failure with resp---> ', res);
	        //calling mallik api for account
	        return laboxSSapi.accountInfo().then(function (res) {
	          console.log('response of account info from mallik when primary id not available from login API --> ', res);
	          if (res && res.data && res.data.accountNumber) {
	            storage.setItem('session', 'accno', res.data.accountNumber);
	            storage.setItem('session', 'hasOptimumId', false);
	            console.log('account number with mallik api', res.data.accountNumber);
	            return true;
	          } else {
	            console.log('account info fail from mallik api also.');
	            return null;
	          }
	        }, function (reserr) {
	          console.log('account info also fail ---> ', reserr);
	          return null;
	        });
	      }
	    }, function (reserr) {
	      console.log('Trusted Login fail with response----> ', reserr);
	      return null;
	    });
	  };
	
	  this.getbpebillData = function () {
	    var checkOOLSession = storage.getItem('session', 'oolsession');
	    console.log('available ', checkOOLSession);
	    if (checkOOLSession) {
	      return _this.getbpebillinfo(checkOOLSession);
	    } else {
	      return _this.setOOLSession().then(function () {
	        var getOOLSession = storage.getItem('session', 'oolsession');
	        console.log('not available', getOOLSession);
	        return _this.getbpebillinfo(getOOLSession);
	      });
	    }
	  };
	
	  this.getbpebillinfo = function (oolsessionId) {
	    var data = { "sessionCookie": oolsessionId };
	    return laboxSSapi.wrap("/api/ebill/info", {}, 'getbpebillinfo', 'POST', data);
	  };
	
	  this.getCurrectAcc = function () {
	    return _this.getbpebillData().then(function (res) {
	      var account = null;
	      console.log('this is ebill info --> ', res);
	      if (res && res.data.ebillInformationOutputs) {
	        var accounts = res.data.ebillInformationOutputs;
	        for (var i in accounts) {
	          var temp = accounts[i];
	          if (temp.accountNum == storage.getItem('session', 'accno')) {
	            storage.setItem('session', 'curr_acc', temp);
	            account = temp;
	          }
	        }
	      }
	      return account;
	    });
	  };
	
	  this.generatePayloadBpGlobal = function () {
	    var accno = storage.getItem('session', 'accno');
	    var homeid = storage.getItem('session', 'home_id');
	    var rtime = new Date().getTime();
	    var secretAndKey = _this.getConfig();
	    // var secretKeyId = laboxSSapi.config.dev.bpKeySecretID;
	    var secretKeyId = secretAndKey.bpKeySecretID;
	    var query = "accountNumber=" + accno + "&homeId=" + homeid + "&requestTime=" + rtime + "&secretKeyId=" + secretKeyId;
	    var path = "/billpay/bpGlobalNoSession?" + query;
	    var hmac = _cryptoJs2['default'].HmacSHA256(path, secretAndKey.bpKeySecret).toString();
	    var payload = query + "&hmac=" + hmac;
	    return payload;
	  };
	
	  this.getBpGlobalData = function () {
	    if (storage.getItem('session', 'accno')) {
	      var generatePayload = _this.generatePayloadBpGlobal();
	      console.log('payload', generatePayload);
	      return _this.getBpGlobalInfo(generatePayload);
	    } else {
	      return _this.setOOLSession().then(function () {
	        if (storage.getItem('session', 'accno')) {
	          var generatePayload = _this.generatePayloadBpGlobal();
	          console.log('payload', generatePayload);
	          return _this.getBpGlobalInfo(generatePayload);
	        } else {
	          console.log('trusted login and mallik call are failed to load account number and so no bp global..');
	          return null;
	        }
	      });
	    }
	  };
	
	  this.getBpGlobalInfo = function (data) {
	    /*return laboxSSapi.wrap(laboxSSapi.config.dev.cassservice+"billpay/bpGlobalNoSession", {headers: {
	        'Content-Type': 'application/x-www-form-urlencoded'}
	    },'getBpGlobalInfo','POST',data); */
	    var dataPayload = { "payload": data };
	    return laboxSSapi.wrap('/api/bpglobal/nosession', {}, 'getBpGlobalInfo', 'POST', dataPayload);
	  };
	
	  this.submitotpayment = function (pmName, amount) {
	    if (storage.getItem('session', 'oolsession')) {
	      var account = _this.getCurrectAcc();
	      if (account) {
	        var now = new Date();
	        var data = "payNickname=" + encodeURI(pmName);
	        data += "&payAmount=" + amount;
	        data += "&payDate=" + (now.getMonth() + 1 + "/" + now.getDate() + "/" + now.getFullYear());
	        data += "&isImmediate=1&isTCAccepted=true&system=laBox";
	        var dataObj = {
	          "sessionCookie": storage.getItem('session', 'oolsession'),
	          "payload": data
	        };
	        return _this.submitPayment(dataObj);
	      }
	    } else {
	      _this.setOOLSession().then(function () {
	        var account = _this.getCurrectAcc();
	        if (account) {
	          var now = new Date();
	          var data = "payNickname=" + encodeURI(pmName);
	          data += "&payAmount=" + amount;
	          data += "&payDate=" + (now.getMonth() + 1 + "/" + now.getDate() + "/" + now.getFullYear());
	          data += "&isImmediate=1&isTCAccepted=true&system=laBox";
	          var dataObj = {
	            "sessionCookie": storage.getItem('session', 'oolsession'),
	            "payload": data
	          };
	          return _this.submitPayment(dataObj);
	        }
	      });
	    }
	  };
	
	  this.submitPayment = function (data) {
	    return laboxSSapi.wrap("/api/submit/payment", {}, 'submitPayment', 'POST', data);
	  };
	
	  this.deauthInfo = function (billPayCache) {
	    var result = {};
	    result.deAuthStartDate = billPayCache.deAuthStartDate;
	    result.deAuthBalanceDue = billPayCache.deAuthBalanceDue;
	    result.isDeauth = false;
	    result.isDeauthOne = false;
	    result.isDeauthTwo = false;
	    if (result.deAuthStartDate != null && result.deAuthBalanceDue != null && result.deAuthBalanceDue != 0) {
	      result.isDeauth = result.deAuthBalanceDue > 0;
	      var deauthDate = new Date(result.deAuthStartDate);
	      var month = deauthDate.getMonth() + 1;
	      var date = deauthDate.getDate();
	      result.startDate = (month > 9 ? "" : "0") + month + "/" + (date > 9 ? "" : "0") + date;
	      result.isDeauthStarted = result.deAuthStartDate < new Date().getTime();
	      if (result.isDeauth && !result.isDeauthStarted) {
	        result.isDeauthOne = true;
	      }
	      if (result.isDeauth && result.isDeauthStarted) {
	        result.isDeauthTwo = true;
	      }
	    }
	    return result;
	  };
	
	  this.enrollPaperlessBill = function (paperBillInd, email) {
	    return _this.getCurrectAcc().then(function (resp) {
	      if (resp) {
	        var data = "origPaperBillInd=" + resp.isPaperBill;
	        data += "&origMailNotifyInd=" + resp.mailNotifyInd;
	        data += "&origEmail=" + resp.email;
	        data += "&paperBillInd=" + paperBillInd;
	        data += "&mailNotifyInd=" + resp.mailNotifyInd;
	        data += "&email=" + (email == null ? resp.email : email.toLowerCase());
	        data += "&system=laBox";
	
	        var dataObj = {
	          "sessionCookie": storage.getItem('session', 'oolsession'),
	          "payload": data
	        };
	        return laboxSSapi.wrap("/api/enroll/paperless", {}, 'enrollPaperless', 'POST', dataObj);
	      } else {
	        return null;
	      }
	    });
	  };
	
	  this.getConfig = function () {
	    if (storage.getItem('session', 'env') === 'prod') {
	      return laboxSSapi.config.prod;
	    } else if (storage.getItem('session', 'env') === 'stage') {
	      return laboxSSapi.config.stage;
	    } else {
	      return laboxSSapi.config.dev;
	    }
	  };
	}
	
	billingService.$inject = ['laboxSSapi', 'storage', 'authService'];
	
	var api = _angular2['default'].module('userbillingService', ['labox.sse.api', 'storage']).service('billingService', billingService);
	
	exports['default'] = api;
	module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _angular = __webpack_require__(5);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function analyticsService(laboxSSapi, storage, $rootScope) {
	  var _this = this;
	
	  this.isHomePage = true;
	
	  this.$rootScope = $rootScope;
	  this.sendReport = function (channel, pageName, events, errorMsg, vodTitle, faqTitle, linkName, linkUrl, billingStatus, paperlessbill, pageUrl) {
	
	    var payload = {
	      "channel": channel,
	      "pageName": pageName,
	      "plantId": parseInt(storage.getItem('session', 'plant_id'), 10),
	      "homeId": storage.getItem('session', 'home_id'),
	      "homePage": _this.isHomePage,
	      "casn": storage.getItem('session', 'casn'),
	      "accountNumber": storage.getItem('session', 'accno')
	    };
	    _this.isHomePage = false;
	    if (pageUrl) {
	      payload.pageUrl = pageUrl;
	    } else {
	      setTimeout(function () {
	        payload.pageUrl = window.location.href.split('?')[0];
	      }, 150);
	    }
	    if (events) {
	      payload.events = events;
	    }
	    if (vodTitle) {
	      payload.vodTitle = vodTitle;
	    }
	    if (faqTitle) {
	      payload.faqTitle = faqTitle;
	    }
	    if (errorMsg) {
	      payload.errorMsg = errorMsg;
	    }
	    if (linkName && linkUrl) {
	      payload.link = {
	        "name": linkName,
	        "url": linkUrl,
	        "exit": false
	      };
	    }
	    if (billingStatus) {
	      payload.billingStatus = billingStatus;
	    }
	    if (paperlessbill !== null && paperlessbill !== 'undefined') {
	      payload.paperlessbill = paperlessbill;
	    }
	    console.log("sendAnalyticReport paylaod :", payload);
	
	    setTimeout(function () {
	      return laboxSSapi.wrap('/api/report', {}, 'sendAnalyticReport', 'POST', payload);
	    }, 200);
	  };
	}
	
	analyticsService.$inject = ['laboxSSapi', 'storage', '$rootScope'];
	
	var api = _angular2["default"].module('analyticsService', ['labox.sse.api', 'storage']).service('analyticsService', analyticsService);
	
	exports["default"] = api;
	module.exports = exports["default"];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appHtml = __webpack_require__(238);
	
	var _appHtml2 = _interopRequireDefault(_appHtml);
	
	__webpack_require__(239);
	
	var appComponent = {
	  template: _appHtml2['default'],
	  restrict: 'E'
	};
	
	exports['default'] = appComponent;
	module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"app\">\n  <div ui-view></div>\n</div>\n"

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(240);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".btn,button{outline:none;overflow:hidden;white-space:nowrap;text-overflow:ellipsis!important}.btn{width:100%;display:inline-block;margin-bottom:0;font-size:14px;font-weight:800;padding-left:30px;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none}.btn-inner-menu,.btn-main-nav,.btn-nav-expanded,.btn-nav-pagination,.btn-regular{font-weight:500}.btn-inner-menu,.btn-main-nav,.btn-nav-expanded,.btn-pagination{color:#aeb4b5;border:none;text-decoration:none;font-weight:800;height:7vh;display:inline-block;float:left;margin-left:30px;margin-top:2px;width:104%;font-size:2.76vmin;font-family:Open Sans Bold}.btn-tutorial{width:32vw!important}.btn-faq,.btn-tutorial{height:6.25vh!important;text-transform:none;background:#445a65}.btn-faq{width:37vw!important;padding-left:1.56vw!important}.btn-subnav{width:88.25%;height:45px;font-size:18px}.btn-nav-optimumids{color:#f1f1f1;border:none;text-decoration:none;font-weight:800;height:6.25vh;display:inline-block;float:left;margin-top:2px;width:40.25vw;font-size:20px;font-weight:700;background:#000;padding-right:5%;padding-left:7.75%}.btn-espanol{width:19.5vmin;height:6.65vmin;font-size:2.65vmin;font-weight:500;margin-right:8.26vmin;margin-top:-8.45vmin;border-radius:0}.btn-espanol,.btn-submain-nav{color:#fff;text-align:center;padding-left:0}.btn-submain-nav{border:none;text-decoration:none;font-weight:800;height:5.5vh;display:inline-block;float:left;margin:-3%;width:32.5vmin;font-size:3.06vmin;font-weight:500;background-color:#167488;font-family:Open Sans Bold}.paynow-btn{height:5.7vh;width:16.1vw;padding-left:0;font-size:1.5vw;text-align:center;color:#fff;background-color:#3b494d;border:none}.paynow-btn:focus,.paynow-btn:hover{background-color:#f1f1f1;color:#000;border:none}.btn-nav-expanded{padding-left:5%;font-size:2.75vmin}.btn-main-nav{background:#000;text-align:left}.btn-espanol:focus,.btn-inner-menu:focus,.btn-main-nav:focus,.btn-nav-expanded:focus,.btn-nav-optimumids:focus,.btn-submain-nav:focus{overflow:hidden;background:#fff;color:#000}.btn-nav-expanded{text-align:center;background:#333}.btn-pagination{background:#a0e838}.btn-selection-btn{border-radius:0}.btn-group{display:inline-block;list-style:none;padding:0;margin:0;zoom:1}.btn-inner-menu{font-weight:700;height:7vh;display:inline-block;float:left;margin:1%;width:98%;font-size:2.5vmin;background:#1e1e1f;background-image:linear-gradient(180deg,#424143,#424143,#1e1e1f)}.btn-subnav:first-child{margin-top:4.2vh}.btn-subnav:last-child{margin-bottom:4.2vh}.btn-group>button:first-child{margin-left:0;border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>button:last-child{margin-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>button{margin:0;padding:0}.btn-expanded-double{width:50%;float:right}*{margin:0;padding:0;-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0}@font-face{font-family:Open Sans Regular;src:url(" + __webpack_require__(241) + ") format(\"truetype\")}@font-face{font-family:Open Sans Bold;src:url(" + __webpack_require__(242) + ") format(\"truetype\")}body,html{margin:0;padding:0;overflow:hidden;background-color:rgba(0,0,0,.7);background-image:linear-gradient(-180deg,transparent,rgba(0,0,0,.36) 47%,rgba(0,0,0,.4));background-image:linear-gradient(-180deg,hsla(0,0%,100%,0),transparent 50%,#000);color:#f1f1f1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Open Sans Regular}.app{width:100vw;height:100vh}header{height:16vh}header,main{display:block;width:100%;overflow:auto}main{height:80vh}footer{height:4vh;display:block;width:100%;overflow:auto}.container{margin:0;padding:0;width:100%}.dottedc{display:table-cell;width:100%}.dotted{width:99%;border-color:#9ea6a8;border-bottom:2px dotted #9ea6a8}", ""]);
	
	// exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "629a55a7e793da068dc580d184cc0e31.ttf";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "50145685042b4df07a1fd19957275b81.ttf";

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js